import {
  checkCampaignFromMockRows
} from './new-rt-system.js'
import { loadDefaultJapaneseParser } from 'budoux'
import { emitter, emitGlobalVarPopupDialog } from './emitter'

// バックエンド med_qualification_list の str に完全一致させる送信用エイリアス（permission_type 準拠）
// canonical = 送信する文字列（バックエンドと完全一致）, matchForms = 経歴に含まれていれば canonical を送る文言（エイリアス含む）
const SKILL_CATEGORY_RULES = {
  // permission_type 1: 看護
  kango: {
    canonicalSkills: [
      { canonical: '正看護師', matchForms: ['正看護師', '看護師資格', '看護師免許', '看護師'] },
      { canonical: '准看護師', matchForms: ['准看護師'] },
      { canonical: '助産師', matchForms: ['助産師'] }
    ]
  },
  // permission_type 2: 介護
  kaigo: {
    canonicalSkills: [
      { canonical: '介護職員初任者研修/ホームヘルパー2級', matchForms: ['初任者研修', 'ホームヘルパー2級', 'ヘルパー2級', '介護職員初任者研修'] },
      { canonical: '介護福祉士実務者研修/ホームヘルパー1級', matchForms: ['実務者研修', 'ホームヘルパー1級', 'ヘルパー1級', '介護福祉士実務者研修'] },
      { canonical: '介護福祉士', matchForms: ['介護福祉士', '介護士', 'ヘルパー'] },
      { canonical: '社会福祉士', matchForms: ['社会福祉士'] },
      { canonical: '社会福祉主事', matchForms: ['社会福祉主事'] },
      { canonical: '精神保健福祉士', matchForms: ['精神保健福祉士'] },
      { canonical: '介護支援専門員（ケアマネジャー）', matchForms: ['介護支援専門員', 'ケアマネージャー', 'ケアマネジャー'] }
    ]
  },
  // permission_type 3: リハビリ
  rihabiri: {
    canonicalSkills: [
      { canonical: '理学療法士（PT）', matchForms: ['理学療法士', 'PT'] },
      { canonical: '作業療法士（OT）', matchForms: ['作業療法士', 'OT'] },
      { canonical: '言語聴覚士（ST）', matchForms: ['言語聴覚士', 'ST'] }
    ]
  },
  // permission_type 4: 保育
  hoikushi: {
    canonicalSkills: [
      { canonical: '保健師', matchForms: ['保健師'] },
      { canonical: '保育士', matchForms: ['保育士', '保育士資格', '保育士免許'] },
      { canonical: '幼稚園教諭', matchForms: ['幼稚園教諭'] }
    ]
  }
}

const globalVar = {
  install: function (Vue, options) {
    const main = new Vue({
      data: function () {
        return {
          targetJobChangeIds: [
            'rirekisho_job_change',
            'rirekisho_ai_career',
            'rirekisho_job_change2',
            'rirekisho_job_change_old',
            'rirekisho_single',
            'rirekisho_nophoto_double',
            'rirekisho_nophoto',
            'rirekisho_hukugyo'],
          targetNewIds: [
            'rirekisho_job_new',
            'rirekisho_job_new_single',
            'entrysheet',
            'internship'],
          autoRTInfo: {
            logoImage: '',
            clientId: '',
            dialogName: '',
            clientName: '',
            termurl: '',
            privacyurl: '',
            occupationurl: '',
            clientServiceName: '',
            permissionType: 0,
            oldPermissionType: 0
          },
          qmailRirekishoHtml: '',
          deviceToken: '',
          dn_flag: 'dn',
          count_repeat: 0,
          isYagiPrime: false,
          isRoxxable: false,
          isRoxx4Rtable: false,
          isRecruitMcable: false,
          isRecruitMc4Rtable: false,
          isNeocareerable: false,
          isNeocareer4Rtable: false,
          isXMileable: false,
          isXMile4Rtable: false,
          isPharmateable: false,
          isPharmate4Rtable: false,
          isRecurrent: false,
          isRecreeable: false,
          isRecree4Rtable: false,
          isAutoRTable: false,
          isAutoRT4Rtable: false,
          permissionType4RT: 0,
          oldPermissionType4RT: 0,
          isYagiPrimeCancel: false,
          isYagiPrimeQuickmailcount: 0,
          isShogai: false,
          in_app_payments: true,
          google_ads_tag: [
            { id: 'jobs919_mail', ptype: 5 },
            { id: 'jobs919_mail', ptype: 1 },
            { id: 'jobs919_mail', ptype: 2 },
            { id: 'krasys_mail', ptype: 1 },
            { id: 'hrcareer_mail', ptype: 5 },
            { id: 'hrcareer_mail', ptype: 6 },
            { id: 'hrcareer_mail', ptype: 7 },
            { id: 'hrcareer_mail', ptype: 8 },
            { id: 'hrcareer_mail', ptype: 9 },
            { id: 'hrcareer_mail', ptype: 10 },
            { id: 'hrcareer_mail', ptype: 11 },
            { id: 'hrcareer_mail', ptype: 12 },
            { id: 'hrcareer_mail', ptype: 15 },
            { id: 'recree_mail', ptype: 2 },
            { id: 'recree_mail', ptype: 3 },
            { id: 'recree_mail', ptype: 4 },
            { id: 'hitotech_admin', ptype: 1 },
            { id: 'hitotech_admin', ptype: 2 },
            { id: 'hitotech_admin', ptype: 3 },
            { id: 'hitotech_admin', ptype: 4 },
            { id: 'sms_admin', ptype: 1 },
            { id: 'sms_admin_eiyoshi', ptype: 2 },
            { id: 'sms_admin_hoiku', ptype: 3 },
            { id: 'hitoshia_admin', ptype: 3 },
            { id: 'hitoshia_admin', ptype: 4 },
            { id: 'pleiades_mail', ptype: 2 },
            { id: 'pleiades_mail', ptype: 10 },
            { id: 'pleiades_mail', ptype: 18 },
            { id: 'pleiades_mail', ptype: 11 },
            { id: 'pleiades_mail', ptype: 12 },
            { id: 'pleiades_mail', ptype: 13 },
            { id: 'pleiades_mail', ptype: 16 },
            { id: 'pleiades_mail', ptype: 17 },
            { id: 'neocareer_admin', ptype: 1 },
            { id: 'neocareer_admin', ptype: 2 },
            { id: 'neocareer_admin', ptype: 5 },
            { id: 'neocareer_admin', ptype: 6 },
            { id: 'peacekaigo_mail', ptype: 2 },
            { id: 'peacekaigo_mail', ptype: 4 },
            { id: 'kikkakeagent_mail', ptype: 1 },
            { id: 'noajpn_mail', ptype: 1 },
            { id: 'noajpn_mail', ptype: 2 },
            { id: 'medley_link', ptype: 5 },
            { id: 'medley_link', ptype: 6 },
            { id: 'reaching_mail', ptype: 1 },
            { id: 'reaching_mail', ptype: 2 },
            { id: 'persolinnovation_admin', ptype: 1 },
            { id: 'persolinnovation_admin', ptype: 2 },
            { id: 'persolinnovation_admin', ptype: 4 },
            { id: 'cookbiz_mail', ptype: 1 },
            { id: 'roxx_api', ptype: 1 },
            { id: 'roxx_api', ptype: 2 },
            { id: 'roxx_api', ptype: 3 },
            { id: 'roxx_api', ptype: 6 },
            { id: 'roxx_api', ptype: 7 },
            { id: 'roxx_api', ptype: 13 },
            { id: 'roxx_api', ptype: 14 },
            { id: 'roxx_api', ptype: 15 },
            { id: 'roxx_api', ptype: 16 },
            { id: 'persolinnovation_admin', ptype: 2 },
            { id: 'neocareer_new_mail', ptype: 1 },
            { id: 'careerdraft_mail', ptype: 3 },
            { id: 'mitzmitz_mail', ptype: 5 },
            { id: 'recurrent_api', ptype: 1 },
            { id: 'recurrent_api', ptype: 2 },
            { id: 'recurrent_api', ptype: 3 },
            { id: 'recurrent_api', ptype: 4 },
            { id: 'rozas_mail', ptype: 1 },
            { id: 'tsace_mail', ptype: 1 },
            { id: 'tsace_mail', ptype: 2 },
            { id: 'tsace_mail', ptype: 3 },
            { id: 'parable_mail', ptype: 1 },
            { id: 'peacekaigo_mail', ptype: 5 },
            { id: 'pharmacareer_mail', ptype: 2 },
            { id: 'pharmacareer_mail', ptype: 3 },
            { id: 'truspo_mail', ptype: 1 },
            { id: 'cloudlink_mail', ptype: 1 },
            { id: 'geekly_mail', ptype: 1 },
            { id: 'secondgame_mail', ptype: 1 },
            { id: 'secondgame_mail', ptype: 2 },
            { id: 'pharmate_mail', ptype: 1 },
            { id: 'plexjob_mail', ptype: 1 },
            { id: 'plexjob_mail', ptype: 2 },
            { id: 'plexjob_mail', ptype: 3 },
            { id: 'plexjob_mail', ptype: 4 },
            { id: 'plexjob_mail', ptype: 5 },
            { id: 'plexjob_mail', ptype: 6 },
            { id: 'ciw_mail', ptype: 1 },
            { id: 'witc_mail', ptype: 1 },
            { id: 'bizreach_mail', ptype: 1 }
          ],
          joblistKeyword20240415: ['施工管理', '看護師', '薬剤師', '作業療法士', '理学療法士', '言語聴覚士', '視能訓練士', '保育士', '歯科衛生士', '介護職', 'ヘルパー', '栄養士', '歯科助手', '販促物の製作業務', '福岡私立精華女子高等学校', '畜産農家', 'Webマーケティング', 'ペット業界', '医療法人社団三木会 花まる歯科クリニック 入社', 'CAD製図', 'アコースティックギター演奏', 'ビジネス工科専門学校', 'webライター', '高齢の母親と一緒に暮らしているため、転勤は避けたい', '高速道路', 'スポーツ国際開発', '写植', '岡山商科大学', '宿泊業', '残業', 'ダンスインストラクター', '回送', 'セールスドライバー', 'バスケ', '教育福祉', '熊本市立帯山中学校卒業', '鈑金塗装', '3Dデザイン', 'データ整理', '自動車関連の仕事', 'グランドハンドリング', '接客販売業', '接客サービス業', '電話受付', '在宅の仕事', '中古車販売', 'マーケティングリサーチ', '総務労務', '配送業務', '鍼灸', 'パン職人', '工業高校', 'ITサポート', 'ヤマト運輸', '郵便局', '化学工学', 'キッチンスタッフ', 'ファッションビジネス', '日本語学科', '自然環境専門高校入学', '給与計算', 'パソコン操作', '塾講師', '猫カフェ', '接客経験', '不動産事務', '溶接', 'ライター', '不動産営業', '通関士', 'アパレル販売', '幼児教育', '保険営業', '在宅勤務', '英語教育', '運輸', 'パソコン', '社会福祉士', '法学', '保険', '法律事務所', '電気工事士', '大学', '電気工事', 'UI', '教育', '営業事務', '製造業', '一般事務', '旅行', '医療事務', '営業職', '教員', '経済学部', '接客販売', '医療', 'マネジメント', '自動車', 'IT', '日本語教師', 'マーケティング', '経理', '医薬', 'ホテル', '調理師', '総務', 'フォークリフト', '飲食業', '建設', '軽作業', '農業', 'ゲーム', '工場', '未経験', '企画', 'インテリア', '役所', '化学', 'デザイン', '美容師', '広告', '美容', '営業', '土木', '警備', '管理', '事務', '飲食', '事務職', 'コールセンター', 'エンジニア', 'インターネット', 'SE', 'NPO', '福祉', '映像', '学校法人', '介護', '講師', '医師', '接客', '不動産', '接客業', '看護', '受付', '交通', '公務員', '動物', 'サービス', '製造', '配送', '販売', 'データ入力', 'アパレル', 'スポーツ', '印刷', '制作', '人事', 'クリニック', '開発', '保育', 'サポート', '機械', '運営', '食品', 'プラスチック成形', '土日勤務', '運動経験', 'データ検査', 'アニメ声優', '東大阪市立日新高等学校', '土木施工管理', '情報環境科', '洋服販売', 'エリアマネジャー', 'ビジネススクール', '中古ジュエリー販売', '岡山', 'お寿司の製造', '期間工', '教育関係', '接客応対', '舞台設備工事', '倉庫オペレータ', '会計税務アシスタント', '売り場づくり', '保育士補助', 'ECサイトの運営業務', '障害者移動支援', 'バル', '小学校通訳', '経理総務事務', 'アミューズメントパーク', '材料技術', '陸送業務', 'IT職種', '総合受付業務', '損保事務', 'ITインフラエンジニア', '医療技術短期大学部', '保育園看護師', '軽貨物運送事業', '漫画家', 'エアジャパン', '成田国際空港', 'アトラクションメンテナンス', 'オンライン決済代行業', '総務部', '建設用軽仮設機材', '子育て支援員', '回収車', '尾瀬高等学校', '洗車', 'フィギュア買い取り', '広島県立安西高等学校', '日立エレベーターサービス株式会社', '大型ダンプ運転手', '損害保険調査', 'プロダクトデザイナー', '熊本県立八代高等学校', 'コンタクトセンター', '物流倉庫内のクール便の仕分け作業', '鮮魚部門', '事務調達職', '千葉県立市原高等学校', '日本化粧品検定2級合格', '千葉県立成田北高等学校', '美容外科 受付 サポート 事務', '財務事務', '医療IT業界', '金属プレス', '営業経験', '土地仕入業務', '医療・保育・介護', '事務リーダー', '人材営業', 'MR', '文章構成', '子供英語講師', '筋力トレーニング', '大型自動車免許', '生産技術業務', '化学生命工学', 'スフォリアテッラ専門店', 'トラブル解決', 'ネットショップ', '事務一般', '短大', '大阪大学人間科学部人間科学科', '製造ライン', 'アプリケーション開発', '石油化学プラント オペレーター', 'Web', '医学技術', '福祉心理', '法務事務', '技術専門', '競走馬', '郵便配達', '飲食サービス', '提案営業', '茨城県立ルネサンス高等学校', '製造工場', 'インテリア業界', '弁護士', '成田空港地上職', '広島市立舟入高等学校', '大学事務員', 'リユース業', '文化財学科', '短期アルバイト', 'EC店鋪運営', '医療サービス業', '医師事務作業補助者', '製袋機オペレーター', '物流企画', '給排水処理設備の運転管理', '通信', '物流倉庫スタッフ', '第二種電気工事士', 'カバーディーラー', '国際英語学科', 'アトラクション運営', '横浜駅周辺', '送電線業界の建設土木', 'データマネージャー', '美術科', '介護施設', '総合事務', '東洋大学', '食物調理', '理学療法', '会計・税務知識', '生活支援員', '旅行業界', '生活相談員', 'パソコン作業', '土木建設業', 'ロボット工学', '施工管理アシスタント', '食品栄養学', '教育支援', '情報専門学校', '設備メンテナンス', 'PC業務', '買取営業', '介護事務', '医療従事者', 'インテリア・住宅関連', '工事現場管理', 'ネットワーク', '訪問介護', '不動産管理', '医療機関', '配達ドライバー', 'メンテナンス', '日本の仕事', '航空貨物', 'インサイドセールス', 'サッカー', 'システムエンジニア・プログラマ', '佐賀県立佐賀農業高等学校', '国際関係学', '社長秘書', '英語力', 'カラオケ', '総務職', '副業', '文学', '経営コンサルタント', '喫茶店', '総務経理事務', 'キッチン', '人材紹介', '工業化学', '病棟クラーク', '指導員', 'テクニカルスタッフ', '音楽講師', '倉庫内作業', 'デンソー', '組立', 'セレクトショップ', '障がい者支援', '警備員', '国際営業', '美容室受付', '心理カウンセリング', '鮮魚', '文学部', '倉庫', '営業サポート', '普通自動車第一種運転免許取得', '外国語学部', 'ビジネスマネジメント', '受付兼助手', '医学部', '映像編集', '建築設備点検', '鉄道', '経営学科', '英会話講師', '営業事務職', '人事職', 'デジタルマーケティング', 'SNSマーケティング', '獣医', '自衛隊', '養護教諭', '短期バイト', 'Web開発', 'ホテル業界', '事務・秘書・受付', '看護助手', 'トラック運転手', '国際経済学', 'ルート営業', 'webデザイナー', '調剤薬局事務', '金融業務', '法政大学', '携帯電話販売', 'プログラマー', '設備管理', '仕分け', 'ゲーム業界', '臨床検査技師', 'CADオペレーター', 'WEBデザイン', '陸上自衛隊', '動物看護', '製造業務', '神社', '経理業務', '倉庫作業', '地理学', '医療機器', '事務業務', '物流業', 'システムエンジニア', '建築設計', '英米文学', '製造オペレーター', '歯科技工士', '高校生', '司書', '日本文学', '歯科', '国際経営', 'ITエンジニア', 'カウンセラー', '運転', '人材コーディネーター', '機械工学', '運送業', 'ファッションデザイン', '新卒', 'インフラエンジニア', '製造職', '工場勤務', '製菓', '販売業務', '経営学部', '日本文化', '整備士', '料理', '法人営業', 'パティシエ', 'DTPオペレーター', '法務', '自動車整備士', '早稲田大学', '飲食店', '医療法人', '経理事務', '事務作業', '倉庫管理', '総務事務', 'システム開発', 'ものづくり', '受付業務', '調剤事務', '介護福祉士', 'グラフィックデザイン', '情報処理', '調理', '財務', '自動車販売', 'ドライバー', '接客業務', 'データ分析', '食品製造', '経営学', '管理栄養士', '士業', 'ゲーム開発', '品質管理', '社会福祉', '銀行', '法律', '生産管理', 'IT業界', '受付事務', '販売員', '建設業', '不動産業', '心理学', 'レジャー', '大学卒業後', 'コンサルタント', '翻訳', '物流', '通訳', '販売職', '編集', '工事', '経済学', '会計', 'デザイナー', 'プログラミング', '理容', '音楽', 'ブライダル', '建築', '映画', 'マネージャー', '点検', '設計', '化粧品', 'エステ', 'フード', '清掃', '金融', 'イベント', 'プロジェクトマネージャー', 'クリエイティブ'],
          // Tier 1: 国家資格・専門免許（最優先）
          joblistKeywordTier1: [
            '施工管理', '看護師', '薬剤師', '作業療法士', '理学療法士', '言語聴覚士',
            '視能訓練士', '保育士', '歯科衛生士', '介護福祉士', '社会福祉士',
            '臨床検査技師', '管理栄養士', '栄養士', '歯科技工士', '電気工事士',
            '第二種電気工事士', '自動車整備士', '土木施工管理', 'MR', '養護教諭',
            '調理師', '通関士', '歯科助手'
          ],
          // Tier 2: 専門職種名
          joblistKeywordTier2: [
            'システムエンジニア', 'ITエンジニア', 'インフラエンジニア', 'Webマーケティング',
            'Webデザイナー', 'プログラマー', 'グラフィックデザイン', 'CAD製図',
            'CADオペレーター', '溶接', '鈑金塗装', 'フォークリフト',
            '訪問介護', '介護職', 'ヘルパー', '経理事務', '営業事務',
            '医療事務', '調剤薬局事務', 'ルート営業', '法人営業', '人材営業',
            'インサイドセールス', '医師', '弁護士', '獣医', '司書',
            '塾講師', '英会話講師', 'ダンスインストラクター',
            '施工管理アシスタント', '保育士補助', 'DTPオペレーター'
          ],
          // Tier 3: 業界・職種カテゴリ
          joblistKeywordTier3: [
            'IT', '医療', '介護', '建設', '不動産', '飲食業', '物流', '保険',
            '金融', '製造業', 'アパレル', 'ホテル', '旅行業界', '教育',
            '農業', '警備', '運輸', '電気工事', 'ゲーム業界', '鍼灸',
            '鮮魚', '軽作業', 'ピッキング', '梱包', '検品'
          ],
          // Tier 4: 汎用カテゴリ（フォールバック）
          joblistKeywordTier4: [
            '営業', '事務', '製造', 'エンジニア', 'ドライバー', '販売', '配送',
            '経理', '総務', '人事', '企画', '開発', '設計', '品質管理',
            'デザイン', '編集', '翻訳', 'コールセンター', '受付',
            'プログラミング', 'ライター', '調理', '清掃'
          ],
          joblistPrefs: ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県', '海外'],
          getMessageBoxresult: [],
          RecurrentWords: []
        }
      },
      computed: {
      },
      methods: {
        initAutoRT: function () {
          this.isRoxxable = false
          this.isRoxx4Rtable = false
          this.isRecruitMcable = false
          this.isRecruitMc4Rtable = false
          this.isNeocareerable = false
          this.isNeocareer4Rtable = false
          this.isXMileable = false
          this.isXMile4Rtable = false
          this.isPharmateable = false
          this.isPharmate4Rtable = false
          this.isPharmateable = false
          this.isPharmate4Rtable = false
          this.isRecreeable = false
          this.isRecree4Rtable = false
          this.isAutoRTable = false
          this.isAutoRT4Rtable = false
        },
        is_BehindRT: function () {
          // ヤマト住建向けの判定
          try {
            const cookies = this.$cookies || (typeof Vue !== 'undefined' ? Vue.prototype.$cookies : null)
            if (!cookies) return false

            const flag = cookies.get('_YAGISH_ATHLETE_UNIVID')
            // undefined, nullの判定のため以下の様に返す
            return flag != null
          } catch (error) {
            console.error(error)
            return false
          }
        },
        isNewFormat: function (_id) {
          return this.targetNewIds.includes(_id)
        },
        isJobChangeFormat: function (_id) {
          return this.targetJobChangeIds.includes(_id)
        },
        isJobChangeShokumukeirekiFormat: function (_id) {
          return this.targetJobChangeIds.includes(_id) || _id.includes('shokumukeirekisho')
        },
        isShokumukeirekiFormat: function (_id) {
          return _id.includes('shokumukeirekisho')
        },
        eventTag: function () {
          // alert('pdf_' + this.dn_flag + '_rt_completed')
          this.invokeNative('pdf_' + this.dn_flag + '_rt_completed')
        },
        invokeNative: function (_id) {
          console.error(_id)
          if (this.$site.appFlag == 'b' || true) {
            try {
              MessageInvoker.postMessage(_id)
            } catch (error) {
              console.warn(`Error occurred while calling postMessage: ${error.message}`)
            }
          }
        },
        checkRoxx4RT: function (basicData, formatId, formatData, otherFormatData) {
          let isRoxx = false
          const roxxaddressArray = ['東京都', '埼玉県', '千葉県', '神奈川県', '愛知県']
          if (this.addressCheck(basicData, roxxaddressArray)) {
            if (basicData.age >= 19 && basicData.age <= 30) {
              isRoxx = true
            }
          }
          if (!(basicData.tel1) ||
            !(basicData.tel2) ||
            !(basicData.tel3)) {
            isRoxx = false
          }
          return isRoxx
        },
        checkRoxx27: function (basicData, formatId, formatData) {
          let isRoxx = false
          if (formatData.gradeYear == 27) {
            if (this.keywordCheck(formatId, formatData, '大学')) {
              if (basicData.age >= 19 && basicData.age <= 25) {
                isRoxx = true
              }
            }
          }
          return isRoxx
        },
        getRecurrentSkillList: function (formatData) {
          if (!formatData) return []
          const collected = []
          const pushDescriptions = function (histories) {
            if (!histories) return
            const arr = Array.isArray(histories) ? histories : Object.values(histories)
            arr.forEach(function (item) {
              const s = item && item.description ? item.description.trim() : ''
              if (s !== '') collected.push(s)
            })
          }
          pushDescriptions(formatData.educationalHistories)
          pushDescriptions(formatData.jobHistories)
          pushDescriptions(formatData.licenseHistories)
          return collected.filter(function (s, i, self) { return self.indexOf(s) === i })
        },
        getCategoryKeyByRecurrentPermission: function (permissionType) {
          const map = { 1: 'kango', 2: 'kaigo', 3: 'rihabiri', 4: 'hoikushi' }
          return map[permissionType] || null
        },
        keywordCheckFormatOrShokumu: function (targetData, keywordlist) {
          if (!targetData) return false
          return this.keywordCheckRirekisho(targetData, keywordlist) || this.keywordCheckShokumukeirekisho(targetData, keywordlist)
        },
        getMatchedCanonicalSkillList: function (formatData, categoryKey) {
          const rule = SKILL_CATEGORY_RULES[categoryKey]
          if (!rule || !rule.canonicalSkills || !formatData) return []
          const list = []
          for (let i = 0; i < rule.canonicalSkills.length; i++) {
            const entry = rule.canonicalSkills[i]
            if (this.keywordCheckFormatOrShokumu(formatData, entry.matchForms)) {
              list.push(entry.canonical)
            }
          }
          // 同一 canonical が複数エントリでマッチした場合の重複を排除
          return list.filter(function (s, i, self) { return self.indexOf(s) === i })
        },
        checkRecurrentRT: function (keywordlist, formatData) {
          const getWords = []
          for (const keyword in keywordlist) {
            for (const key in formatData.educationalHistories) {
              // 見出し
              const item = formatData.educationalHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                getWords.push(item.description)
              }
            }
            for (const key in formatData.jobHistories) {
              // 見出し
              const item = formatData.jobHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                getWords.push(item.description)
              }
            }
            for (const key in formatData.licenseHistories) {
              // 見出し
              const item = formatData.licenseHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                getWords.push(item.description)
              }
            }
          }
          return getWords
        },
        checkRecruitMc4RT: function (basicData, formatId, formatData, otherFormatData) {
          let isRecruitMc = false

          // ① 氏名チェック（どちらかがあればOK）
          const hasName = !!basicData.lastName || !!basicData.firstName

          // ② 電話番号チェック（全ての桁に値があり、数字のみ）
          const tel = [basicData.tel1, basicData.tel2, basicData.tel3].join('')
          const isTelValid = basicData.tel1 && basicData.tel2 && basicData.tel3 && /^[0-9０-９]+$/.test(tel)

          // ③ 生年月日チェック（birthYear が4桁）
          const isBirthYearValid = /^[0-9]{4}$/.test(basicData.birthYear)
          // 最終判定：すべてOKなら true、それ以外は false
          if (hasName && isTelValid && isBirthYearValid) {
            console.error('RT対象')
          } else {
            return false
          }
          const keywords = ['薬剤師']

          if (this.keywordCheckRirekisho(formatData, keywords)) {
            if (basicData.age >= 23 && basicData.age <= 50) {
              isRecruitMc = true
            }
          }

          return isRecruitMc
        },
        checkNeocareer4RT: function (basicData, formatId, formatData, otherFormatData) {
          let isNeocareer_1 = false

          if (formatData.gradeYear == 26) {
            if (basicData.email &&
              basicData.tel1 &&
              basicData.tel2 &&
              basicData.tel3 &&
              basicData.lastName &&
              basicData.firstName) {
              const isNeocareerAddressArray2 = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '山梨県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県']

              // console.error("RT対象")
              // console.error("RT対象")
              // console.error("RT対象")
              // console.error(formatData)
              // console.error(otherFormatData)
              // console.error("RT対象")
              // console.error("RT対象")
              // console.error("RT対象")
              // console.error("RT対象")
              if (true) {
                if (basicData.age <= 25 && !formatData.foreignStudent) {
                  isNeocareer_1 = true
                }
              }
            }
          }
          return isNeocareer_1
        },
        checkXMile4RT: function (basicData, formatId, formatData, otherFormatData, permissionType) {
          let isXmile = false
          if (permissionType == 29) {
            const isXmile_28KeywordArray = ['1級建築施工管理技士', '１級建築施工管理技士', '一級建築施工管理技士', '1級土木施工管理技士', '１級土木施工管理技士', '一級土木施工管理技士', '1級管工事施工管理技士', '１級電気工事施工管理技士', '一級電気工事施工管理技士', '1級管工事施工管理技士', '１級管工事施工管理技士', '一級管工事施工管理技士']
            const isXmile_28AddressArray = ['']
            if (true) {
              if (basicData.age >= 20 && basicData.age <= 65) {
                if (this.keywordCheckRirekisho(formatData, isXmile_28KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isXmile_28KeywordArray)) {
                  isXmile = true
                }
              }
            }
          } else if (permissionType == 30) {
            const isXmile_5AddressArray = ['']
            const isXmile_5KeywordArray = ['施工管理']
            if (basicData.age >= 20 && basicData.age <= 49) {
              if (this.addressCheck(basicData, isXmile_5AddressArray) || true) {
                if (this.keywordCheckRirekisho(formatData, isXmile_5KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isXmile_5KeywordArray)) {
                  isXmile = true
                }
              }
            }
          } else if (permissionType == 31) {
            const isXmile_26KeywordArray = ['施工管理']
            const isXmile_26AddressArray = ['']
            if (true) {
              if (basicData.age >= 50 && basicData.age <= 65) {
                if (this.keywordCheckRirekisho(formatData, isXmile_26KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isXmile_26KeywordArray)) {
                  isXmile = true
                }
              }
            }
          } else if (permissionType == 32) {
            const isXmile_20AddressArray = ['']
            const isXmile_20KeywordArray = ['電気主任', '電気工事']
            if (basicData.age >= 20 && basicData.age <= 49) {
              if (this.addressCheck(basicData, isXmile_20AddressArray) || true) {
                if (this.keywordCheckRirekisho(formatData, isXmile_20KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isXmile_20KeywordArray)) {
                  isXmile = true
                }
              }
            }
          } else if (permissionType == 33) {
            const isXmile_8AddressArray = ['']
            const isXmile_8KeywordArray = ['自動車検査員', '整備士']
            if (basicData.age >= 20 && basicData.age <= 49) {
              if (this.addressCheck(basicData, isXmile_8AddressArray) || true) {
                if (this.keywordCheckRirekisho(formatData, isXmile_8KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isXmile_8KeywordArray)) {
                  isXmile = true
                }
              }
            }
          } else if (permissionType == 34) {
            const isXmile_6AddressArray = ['三重県', '京都府', '佐賀県', '兵庫県', '千葉県', '埼玉県', '大分県', '大阪府', '奈良県', '宮崎県', '岐阜県', '岡山県', '島根県', '広島県', '徳島県', '愛媛県', '愛知県', '東京都', '栃木県', '滋賀県', '熊本県', '神奈川県', '福岡県', '茨城県', '香川県', '高知県', '鳥取県', '鹿児島県']
            const isXmile_6KeywordArray = ['中型自動車第二種運転免許', '中型自動車運転免許', '準中型自動車運転免許', '大型自動車第二種運転免許', '大型特殊自動車免許', '牽引自動車第一種運転免許', '大型特殊免許', '大型二種免許', '第二種運転免許', 'けん引免許', '玉掛け免許', 'フォークリフト運転技能者', '大型自動車免許', '第二種自動車運転免許', '大型自動車二種免許', 'トラックドライバー', '配送ドライバー', '長距離ドライバー', 'バスドライバー', '長距離輸送', '特殊車両', '軽貨物', 'タンクローリー', '長距離運転', '倉庫管理主任者', 'ルート配送', '準中型自動車免許', '運行管理者', '大型自動車第一種運転免許', '中型自動車第一種運転免許']
            if (basicData.age >= 20 && basicData.age <= 54) {
              if (this.addressCheck(basicData, isXmile_6AddressArray)) {
                if (this.keywordCheckRirekisho(formatData, isXmile_6KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isXmile_6KeywordArray)) {
                  isXmile = true
                }
              }
            }
          } else if (permissionType == 35) {
            const isXmile_7AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '茨城県', '大阪府', '福岡県', '広島県', '京都府', '兵庫県']
            const isXmile_7KeywordArray = ['タクシードライバー', '普通自動車第二種運転免許', '普通二種免許', '一般乗用旅客', '普通自動車二種免許', '普通自動車第二種免許', '旅客運送']
            if (basicData.age >= 20 && basicData.age <= 54) {
              if (this.addressCheck(basicData, isXmile_7AddressArray)) {
                if (this.keywordCheckRirekisho(formatData, isXmile_7KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isXmile_7KeywordArray)) {
                  isXmile = true
                }
              }
            }
          } else if (permissionType == 36) {
            const isXmile_16AddressArray = ['東京都', '神奈川県', '愛知県', '大阪府']
            const isXmile_16KeywordArray = ['法人営業', 'ルート営業', '訪問販売', '営業職', 'セールス', '新規開拓', 'カスタマーサクセス']
            if (basicData.age >= 20 && basicData.age <= 35) {
              if (this.addressCheck(basicData, isXmile_16AddressArray)) {
                if (this.keywordCheckRirekisho(formatData, isXmile_16KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isXmile_16KeywordArray)) {
                  isXmile = true
                }
              }
            }
          } else if (permissionType == 37) {
            const isXmile_17AddressArray = ['東京都', '神奈川県', '愛知県', '大阪府']
            const isXmile_17KeywordArray = ['不動産営業', '宅地建物取引士', '賃貸不動産経営管理士', '管理業務主任者', '賃貸', '売買', '仲介', '宅建']
            if (basicData.age >= 20 && basicData.age <= 35) {
              if (this.addressCheck(basicData, isXmile_17AddressArray)) {
                if (this.keywordCheckRirekisho(formatData, isXmile_17KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isXmile_17KeywordArray)) {
                  isXmile = true
                }
              }
            }
          }
          return isXmile
        },
        checkPharmate4RT: function (basicData, formatId, formatData, otherFormatData, permissionType) {
          let isPharmate = false
          if (permissionType == 2) {
            const isPharmate1KeywordArray = ['薬剤師']
            const isPharmate1AddressArray = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '大分県', '宮崎県', '鹿児島県', '沖縄県']
            if (this.addressCheck(basicData, isPharmate1AddressArray)) {
              if (basicData.age >= 23 && basicData.age <= 59) {
                if (this.keywordCheckRirekisho(formatData, isPharmate1KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isPharmate1KeywordArray)) {
                  isPharmate = true
                }
              }
            }
          }
          return isPharmate
        },
        checkRecree4RT: function (basicData, formatId, formatData, otherFormatData, permissionType) {
          let isRecree = false
          if (permissionType == 6) {
            const recree2KeywordArray = ['施工管理']
            const recree2addressArray = ['東京都', '千葉県', '埼玉県', '神奈川県']
            if (this.addressCheck(basicData, recree2addressArray)) {
              if (basicData.age >= 20 && basicData.age <= 59) {
                if (this.keywordCheckRirekisho(formatData, recree2KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, recree2KeywordArray)) {
                  isRecree = true
                }
              }
            }
          }
          return isRecree
        },
        checkAutoRT: function (basicData, formatId, formatData, otherFormatData, permissionType, clientID) {
          let isAutoRT = false

          // ヤマト住建向けには表示しない
          if (this.is_BehindRT && this.is_BehindRT()) {
            return false
          }

          if (clientID === 'recree_mail' && permissionType === 6) {
            const recree2KeywordArray = ['施工管理']
            const recree2addressArray = ['東京都', '千葉県', '埼玉県', '神奈川県']
            if (this.addressCheck(basicData, recree2addressArray)) {
              if (basicData.age >= 20 && basicData.age <= 59) {
                if (this.keywordCheckRirekisho(formatData, recree2KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, recree2KeywordArray)) {
                  isAutoRT = true
                }
              }
            }
          } else if (clientID === 'pleiades_mail' && permissionType === 19) {
            const isPleiades_2KeywordArray = ['栄養士']
            const isPleiades_2NotKeywordArray = ['事務', '助手', '営業']
            const isPleiades_2AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府']
            // if (this.addressCheck(basicData, isPleiades_2AddressArray) || true) {
            if (true) {
              if (this.keywordCheckRirekisho(formatData, isPleiades_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isPleiades_2KeywordArray)) {
                if (basicData.age >= 23 && basicData.age <= 54) {
                  isAutoRT = true
                }
              }
              if (this.keywordCheckRirekisho(formatData, isPleiades_2NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isPleiades_2NotKeywordArray)) {
                isAutoRT = false
              }
            }
          } else if (clientID === 'pleiades_mail' && permissionType === 20) {
            const isPleiades_12KeywordArray = ['自動車整備士']
            const isPleiades_12NotKeywordArray = ['事務職', 'IT', 'アルバイト']
            if (basicData.age >= 20 && basicData.age <= 65) {
              if (this.keywordCheckRirekisho(formatData, isPleiades_12KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isPleiades_12KeywordArray)) {
                isAutoRT = true
              }
              if (this.keywordCheckRirekisho(formatData, isPleiades_12NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isPleiades_12NotKeywordArray)) {
                isAutoRT = false
              }
            }
          } else if (clientID === 'nineearth_mail' && permissionType === 6) {
            const isNineearth_6KeywordArray = ['介護福祉士', '初任者研修', '実務者研修', '介護士業務', '介護業務']
            const isNineearth_6NotKeywordArray = ['事務職', '営業職', '物流', '工場']
            const isNineearth_6AddressArray = ['愛知県', '岐阜県']
            if (this.addressCheck(basicData, isNineearth_6AddressArray)) {
              if (basicData.age >= 23 && basicData.age <= 60) {
                if (this.keywordCheckRirekisho(formatData, isNineearth_6KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isNineearth_6KeywordArray)) {
                  isAutoRT = true
                }
                if (this.keywordCheckShokumukeirekisho(formatData, isNineearth_6NotKeywordArray) ||
                  this.keywordCheckRirekisho(formatData, isNineearth_6NotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }
          } else if (clientID === 'nineearth_mail' && permissionType === 7) {
            const isNineearth_7KeywordArray = ['介護福祉士', '初任者研修', '実務者研修']
            const isNineearth_7NotKeywordArray = ['事務職', '営業職', '物流', '工場']
            const isNineearth_7AddressArray = ['東京都', '埼玉県']
            if (this.addressCheck(basicData, isNineearth_7AddressArray)) {
              if (basicData.age >= 23 && basicData.age <= 60) {
                if (this.keywordCheckRirekisho(formatData, isNineearth_7KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isNineearth_7KeywordArray)) {
                  isAutoRT = true
                }
                if (this.keywordCheckShokumukeirekisho(formatData, isNineearth_7NotKeywordArray) ||
                  this.keywordCheckRirekisho(formatData, isNineearth_7NotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }
          } else if (clientID === 'nineearth_mail' && permissionType === 8) {
            const isNineearth_8KeywordArray = ['看護師', '助産師']
            const isNineearth_8NotKeywordArray = ['動物', 'リモート', 'オンライン']
            const isNineearth_8AddressArray = ['愛知県', '岐阜県']
            if (this.addressCheck(basicData, isNineearth_8AddressArray)) {
              if (basicData.age >= 23 && basicData.age <= 60) {
                if (this.keywordCheckRirekisho(formatData, isNineearth_8KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isNineearth_8KeywordArray)) {
                  isAutoRT = true
                }
                if (this.keywordCheckRirekisho(formatData, isNineearth_8NotKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isNineearth_8NotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }
          } else if (clientID === 'peacekaigo_mail' && permissionType === 6) {
            const isPeacekaigo6KeywordArray = ['正看護師']
            const isPeacekaigo6AddressArray = ['埼玉県', '千葉県', '東京都', '神奈川県', '大阪府', '兵庫県', '奈良県']
            if (this.addressCheck(basicData, isPeacekaigo6AddressArray)) {
              if (basicData.age >= 23 && basicData.age <= 65) {
                if (this.keywordCheckRirekisho(formatData, isPeacekaigo6KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isPeacekaigo6KeywordArray)) {
                  isAutoRT = true
                }
              }
            }
          } else if (clientID === 'medley_link' && permissionType === 23) {
            const isMedley_Link_5KeywordArray = ['看護師']
            if (this.keywordCheckRirekisho(formatData, isMedley_Link_5KeywordArray)) {
              isAutoRT = true
            }
            if (this.$firebase.user.email.includes('privaterelay.appleid')) {
              isAutoRT = false
            }
          } else if (clientID === 'careerdraft_mail' && permissionType === 4) {
            if (formatData.gradeYear == 27) {
              if (!formatData.foreignStudent) {
                if (this.keywordCheck(formatId, formatData, '大学')) {
                  if (basicData.age >= 20 && basicData.age <= 28) {
                    isAutoRT = true
                  }
                }
              }
            }
          } else if (clientID === 'cmindcareer_mail' && permissionType === 2) {
            const isCmindcareer2KeywordArray = ['大学']
            const isCmindcareer2NotKeywordArray = ['短期大学', '短大', '大学院']
            if (formatData.gradeYear == 27) {
              if (basicData.age >= 21 && basicData.age <= 23) {
                if (this.keywordCheckRirekisho(formatData, isCmindcareer2KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isCmindcareer2KeywordArray)) {
                  isAutoRT = true
                }
                if (this.keywordCheckRirekisho(formatData, isCmindcareer2NotKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isCmindcareer2NotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }
          } else if (clientID === 'jobs919_mail' && permissionType === 10) {
            if (this.keywordCheck(formatId, formatData, '施工管理')) {
              if (basicData.age <= 65 && basicData.age >= 20) {
                isAutoRT = true
              }
            }
          } else if (clientID === 'jobs919_mail' && permissionType === 11) {
            if (this.keywordCheck(formatId, formatData, '監理技術者')) {
              if (basicData.age <= 65 && basicData.age >= 20) {
                isAutoRT = true
              }
            }
          } else if (clientID === 'jobs919_mail' && permissionType === 12) {
            const job919addressArray = ['和歌山県', '北海道', '兵庫県', '福島県', '福岡県', '福井県', '富山県', '奈良県', '栃木県', '東京都', '長野県', '大分県', '大阪府', '千葉県', '石川県', '静岡県', '青森県', '神奈川県', '新潟県', '秋田県', '鹿児島県', '滋賀県', '山梨県', '山形県', '三重県', '埼玉県', '香川県', '広島県', '群馬県', '熊本県', '京都府', '宮城県', '岐阜県', '岩手県', '沖縄県', '岡山県', '茨城県', '愛媛県', '愛知県']
            if (this.keywordCheck(formatId, formatData, '自動車整備士')) {
              if (this.addressCheck(basicData, job919addressArray)) {
                if (basicData.age <= 54 && basicData.age >= 20) {
                  isAutoRT = true
                }
              }
            }
          } else if (clientID === 'jobs919_mail' && permissionType === 13) {
            const job919addressArray = ['和歌山県', '北海道', '兵庫県', '福島県', '福岡県', '福井県', '富山県', '奈良県', '栃木県', '東京都', '長野県', '大分県', '大阪府', '千葉県', '石川県', '静岡県', '青森県', '神奈川県', '新潟県', '秋田県', '鹿児島県', '滋賀県', '山梨県', '山形県', '三重県', '埼玉県', '香川県', '広島県', '群馬県', '熊本県', '京都府', '宮城県', '岐阜県', '岩手県', '沖縄県', '岡山県', '茨城県', '愛媛県', '愛知県']
            if (this.keywordCheck(formatId, formatData, '自動車検査員')) {
              if (this.addressCheck(basicData, job919addressArray)) {
                if (basicData.age <= 54 && basicData.age >= 20) {
                  isAutoRT = true
                }
              }
            }
          } else if (clientID === 'jobs919_mail' && permissionType === 14) {
            const job919addressArray = ['和歌山県', '北海道', '兵庫県', '福島県', '福岡県', '福井県', '富山県', '奈良県', '栃木県', '東京都', '長野県', '大分県', '大阪府', '千葉県', '石川県', '静岡県', '青森県', '神奈川県', '新潟県', '秋田県', '鹿児島県', '滋賀県', '山梨県', '山形県', '三重県', '埼玉県', '香川県', '広島県', '群馬県', '熊本県', '京都府', '宮城県', '岐阜県', '岩手県', '沖縄県', '岡山県', '茨城県', '愛媛県', '愛知県']
            if (this.keywordCheck(formatId, formatData, '板金塗装') ||
              this.keywordCheck(formatId, formatData, 'ジーゼル整備士') ||
              this.keywordCheck(formatId, formatData, 'ガソリン整備士') ||
              this.keywordCheck(formatId, formatData, '自動車整備工')) {
              if (this.addressCheck(basicData, job919addressArray)) {
                if (basicData.age <= 54 && basicData.age >= 20) {
                  isAutoRT = true
                }
              }
            }
          } else if (clientID === 'jobs919_mail' && permissionType === 15) {
            if (this.keywordCheck(formatId, formatData, '電気主任技術者')) {
              if (basicData.age <= 65 && basicData.age >= 20) {
                isAutoRT = true
              }
            }
          } else if (clientID === 'primalwork_mail' && permissionType === 2) {
            const isPrimalwork_1addressArray = ['東京都']
            // let isPrimalwork_1Array = []
            const isPrimalwork_1NotArray = ['N1', 'N2', 'N3', 'N4', 'N5', '日本語能力試験', 'JLPT']
            if (this.addressCheck(basicData, isPrimalwork_1addressArray)) {
              if (basicData.age >= 1008 && basicData.age <= 26) {
                // if (this.keywordCheckRirekisho(formatData, isPrimalwork_1Array)
                //      || this.keywordCheckShokumukeirekisho(formatData, isPrimalwork_1Array)) {
                //      isAutoRT = true
                //  }
                isAutoRT = true
                if (this.keywordCheckRirekisho(formatData, isPrimalwork_1NotArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isPrimalwork_1NotArray)) {
                  isAutoRT = false
                }
              }
            }
          } else if (clientID === 'kikkakeagent_mail' && permissionType === 2) {
            const isKikkakeagent_2KeywordArray = ['Java', 'PHP', 'C#', 'システムアーキテクト', 'システムエンジニア', 'バックエンドエンジニア', 'インフラエンジニア', 'フロントエンドエンジニア', 'GCP', 'Linux', 'TypeScript', 'Python', 'Go言語', 'COBOL', 'Angular', 'Laravel', 'React', 'Vue.js', 'Apache', 'Nginx', 'MariaDB', 'MongoDB', 'MySQL', 'Postgre', 'SES']
            const isKikkakeagent_2NotKeywordArray = ['営業']
            const isKikkakeagent_2AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府', '愛知県', '福岡県']
            if (this.addressCheck(basicData, isKikkakeagent_2AddressArray)) {
              if (basicData.age >= 24 && basicData.age <= 40) {
                if (this.keywordCheckRirekisho(formatData, isKikkakeagent_2KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isKikkakeagent_2KeywordArray)) {
                  isAutoRT = true
                }
                if (this.keywordCheckRirekisho(formatData, isKikkakeagent_2NotKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isKikkakeagent_2NotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }

            if (formatId == 'engineer_shokumukeirekisho') {
              isAutoRT = true
            }
          } else if (clientID === 'onecareer_mail' && permissionType === 2) {
            if (formatData.gradeYear == 26) {
              const isOnecareer_1KeywordArray = ['大学']
              const isOnecareer_1AddressArray = ['東京都', '千葉県', '埼玉県', '神奈川県', '茨城県', '栃木県', '群馬県', '大阪府', '京都府', '兵庫県', '奈良県', '和歌山県', '滋賀県', '三重県']
              if (this.addressCheck(basicData, isOnecareer_1AddressArray)) {
                if (basicData.age >= 20 && basicData.age <= 28) {
                  if (this.keywordCheckRirekisho(formatData, isOnecareer_1KeywordArray) ||
                    this.keywordCheckShokumukeirekisho(formatData, isOnecareer_1KeywordArray)) {
                    isAutoRT = true
                  }
                }
              }
            }
          } else if (clientID === 'neocareer_admin' && permissionType === 6) {
            if (formatData.gradeYear == 27) {
              if (basicData.age <= 25) {
                isAutoRT = true
              }
            }
          } else if (clientID === 'terracia_mail' && permissionType === 8) {
            const isTerracia_8NotKeywordArray = ['キャリアアドバイザー', 'エージェント', '人材業界', '転職斡旋', '転職サポート']
            const isTerracia_8AddressArray = ['東京都']
            // gradeYearのダックタイピングをIntegerに揃える必要がある。後日、入力がわを修正する。
            if (formatData.gradeYear == 27) {
              if (this.addressCheck(basicData, isTerracia_8AddressArray)) {
                if (this.keywordCheck(formatId, formatData, '保育士')) {
                  isAutoRT = true
                }
                for (let ni = 0; ni < isTerracia_8NotKeywordArray.length; ni++) {
                  if (this.keywordCheck(formatId, formatData, isTerracia_8NotKeywordArray[ni])) {
                    isAutoRT = false
                    break
                  }
                }
              }
            }
          } else if (clientID === 'hrteam_mail' && permissionType === 2) {
            if (formatData.gradeYear == 27) {
              if (basicData.age <= 25) {
                isAutoRT = true
              }
            }
          } else if (clientID === 'plexjob_mail' && permissionType === 7) {
            const isPlexjob_2KeywordArray = ['自動車検査員', '自動車整備士']
            const isPlexjob_2AddressArray = ['沖縄県']
            if (!this.addressCheck(basicData, isPlexjob_2AddressArray)) {
              if (basicData.age >= 23 && basicData.age <= 49) {
                if (this.keywordCheckRirekisho(formatData, isPlexjob_2KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isPlexjob_2KeywordArray)) {
                  isAutoRT = true
                }
              }
            }
          } else if (clientID === 'tryt_api' && permissionType === 5) {
            const isTryt_4KeywordArray = ['看護師', '助産師', '保健師']
            const isTryt_4NotAddressArray = ['東京都']
            const isTryt_4NotKeywordArray = ['動物看護士', '介護士', '営業', '事務']
            if (this.addressCheck(basicData, isTryt_4NotAddressArray)) {
              // NOT
            } else {
              if (basicData.age >= 23 && basicData.age <= 54) {
                if (this.keywordCheckRirekisho(formatData, isTryt_4KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isTryt_4KeywordArray)) {
                  isAutoRT = true
                }
                if (this.keywordCheckRirekisho(formatData, isTryt_4NotKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isTryt_4NotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }
          } else if (clientID === 'terracia_mail' && permissionType === 7) {
            const isTerracia_1KeywordArray = ['保育士']
            const isTerracia_1NotKeywordArray = ['キャリアアドバイザー', 'エージェント', '人材業界', '転職斡旋', '転職サポート']
            const isTerracia_1AddressArray = ['東京都']
            if (this.addressCheck(basicData, isTerracia_1AddressArray)) {
              if (basicData.age >= 20 && basicData.age <= 29) {
                if (this.keywordCheckRirekisho(formatData, isTerracia_1KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isTerracia_1KeywordArray)) {
                  isAutoRT = true
                }
                if (this.keywordCheckRirekisho(formatData, isTerracia_1NotKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isTerracia_1NotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }
          } else if (clientID === 'terracia_mail' && permissionType === 5) {
            const isTerracia_3KeywordArray = ['保育士']
            const isTerracia_3NotKeywordArray = ['キャリアアドバイザー', 'エージェント', '人材業界', '転職斡旋', '転職サポート']
            const isTerracia_3AddressArray = ['沖縄県']
            if (this.addressCheck(basicData, isTerracia_3AddressArray)) {
              if (basicData.age >= 20 && basicData.age <= 55) {
                if (this.keywordCheckRirekisho(formatData, isTerracia_3KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isTerracia_3KeywordArray)) {
                  isAutoRT = true
                }
                if (this.keywordCheckRirekisho(formatData, isTerracia_3NotKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isTerracia_3NotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }
          } else if (clientID === 'terracia_mail' && permissionType === 6) {
            const isTerracia_4KeywordArray = ['保育士']
            const isTerracia_4NotKeywordArray = ['キャリアアドバイザー', 'エージェント', '人材業界', '転職斡旋', '転職サポート']
            const isTerracia_4AddressArray = ['長崎県', '熊本県']
            if (this.addressCheck(basicData, isTerracia_4AddressArray)) {
              if (basicData.age >= 20 && basicData.age <= 29) {
                if (this.keywordCheckRirekisho(formatData, isTerracia_4KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isTerracia_4KeywordArray)) {
                  isAutoRT = true
                }
              }
            }
          } else if (clientID === 'sms_admin_new' && permissionType === 1) {
            const isKeywordArray = ['介護士', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員', 'ケアマネジャー', '児童発達支援管理責任者', 'サービス管理責任者', '相談員支援専門員']
            const isNotKeywordArray = ['事務', 'ライター']
            const isAddressArray = ['']
            if (true) {
              if (basicData.age >= 20 && basicData.age <= 59) {
                if (this.keywordCheckRirekisho(formatData, isKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isKeywordArray)) {
                  isAutoRT = true
                }
                if (this.keywordCheckRirekisho(formatData, isNotKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isNotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }
          } else if (clientID === 'sms_admin_new' && permissionType === 2) {
            const isKeywordArray = ['看護助手']
            const isNotKeywordArray = ['事務', 'ライター']
            const isAddressArray = ['']
            if (true) {
              if (basicData.age >= 20 && basicData.age <= 59) {
                if (this.keywordCheckRirekisho(formatData, isKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isKeywordArray)) {
                  isAutoRT = true
                }
                if (this.keywordCheckRirekisho(formatData, isNotKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isNotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }
          } else if (clientID === 'sms_admin_new' && permissionType === 3) {
            const isKeywordArray = ['保育士']
            const isNotKeywordArray = ['事務', 'ライター', '御社', '未経験', '保育士時代', '新しい業務', '貴社', '前職とは異なる', '在宅', '看護師', 'デザイン', 'アルバイト', '美容']
            const isAddressArray = ['']
            if (true) {
              if (basicData.age >= 20 && basicData.age <= 59) {
                if (this.keywordCheckRirekisho(formatData, isKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isKeywordArray)) {
                  isAutoRT = true
                }
                if (this.keywordCheckRirekisho(formatData, isNotKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isNotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }
          } else if (clientID === 'sms_admin_new' && permissionType === 4) {
            const isKeywordArray = ['児童指導員']
            const isNotKeywordArray = ['事務', 'ライター', '御社', '未経験', '保育士時代', '新しい業務', '貴社', '前職とは異なる', '在宅', '看護師', 'デザイン', 'アルバイト', '美容']
            const isAddressArray = ['']
            if (true) {
              if (basicData.age >= 20 && basicData.age <= 59) {
                if (this.keywordCheckRirekisho(formatData, isKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isKeywordArray)) {
                  isAutoRT = true
                }
                if (this.keywordCheckRirekisho(formatData, isNotKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isNotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }
          } else if (clientID === 'sms_admin_new' && permissionType === 5) {
            const isKeywordArray = ['看護師']
            const isNotKeywordArray = ['動物', '看護師と連携', '看護師と一緒に', '看護職員と', '事務', 'ライター']
            const isAddressArray = ['']
            if (true) {
              if (basicData.age >= 20 && basicData.age <= 59) {
                if (this.keywordCheckRirekisho(formatData, isKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isKeywordArray)) {
                  isAutoRT = true
                }
                // 除外キーワードチェック
                if (this.keywordCheckRirekisho(formatData, isNotKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isNotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }
          } else if (clientID === 'sms_admin_new' && permissionType === 6) {
            const isKeywordArray = ['理学療法士']
            const isNotKeywordArray = ['事務', 'ライター']
            const isAddressArray = ['']
            if (true) {
              if (basicData.age >= 20 && basicData.age <= 59) {
                if (this.keywordCheckRirekisho(formatData, isKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isKeywordArray)) {
                  isAutoRT = true
                }
                if (this.keywordCheckRirekisho(formatData, isNotKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isNotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }
          } else if (clientID === 'sms_admin_new' && permissionType === 7) {
            const isKeywordArray = ['作業療法士']
            const isNotKeywordArray = ['事務', 'ライター']
            const isAddressArray = ['']
            if (true) {
              if (basicData.age >= 20 && basicData.age <= 59) {
                if (this.keywordCheckRirekisho(formatData, isKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isKeywordArray)) {
                  isAutoRT = true
                }
                if (this.keywordCheckRirekisho(formatData, isNotKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isNotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }
          } else if (clientID === 'sms_admin_new' && permissionType === 8) {
            const isKeywordArray = ['言語聴覚士']
            const isNotKeywordArray = ['事務', 'ライター']
            const isAddressArray = ['']
            if (true) {
              if (basicData.age >= 20 && basicData.age <= 59) {
                if (this.keywordCheckRirekisho(formatData, isKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isKeywordArray)) {
                  isAutoRT = true
                }
                if (this.keywordCheckRirekisho(formatData, isNotKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isNotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }
          } else if (clientID === 'sms_admin_new' && permissionType === 9) {
            const isKeywordArray = ['臨床検査技師']
            const isNotKeywordArray = ['事務', 'ライター']
            const isAddressArray = ['']
            if (true) {
              if (basicData.age >= 20 && basicData.age <= 59) {
                if (this.keywordCheckRirekisho(formatData, isKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isKeywordArray)) {
                  isAutoRT = true
                }
                if (this.keywordCheckRirekisho(formatData, isNotKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isNotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }
          } else if (clientID === 'sms_admin_new' && permissionType === 10) {
            const isKeywordArray = ['診療放射線技師']
            const isNotKeywordArray = ['事務', 'ライター']
            const isAddressArray = ['']
            if (true) {
              if (basicData.age >= 20 && basicData.age <= 59) {
                if (this.keywordCheckRirekisho(formatData, isKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isKeywordArray)) {
                  isAutoRT = true
                }
                if (this.keywordCheckRirekisho(formatData, isNotKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isNotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }
          } else if (clientID === 'sms_admin_new' && permissionType === 11) {
            const isKeywordArray = ['臨床工学技士']
            const isNotKeywordArray = ['事務', 'ライター']
            const isAddressArray = ['']
            if (true) {
              if (basicData.age >= 20 && basicData.age <= 59) {
                if (this.keywordCheckRirekisho(formatData, isKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isKeywordArray)) {
                  isAutoRT = true
                }
                if (this.keywordCheckRirekisho(formatData, isNotKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isNotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }
          } else if (clientID === 'sms_admin_new' && permissionType === 12) {
            const isKeywordArray = ['柔道整復師']
            const isNotKeywordArray = ['事務', 'ライター', 'アルバイト', 'パート', '非常勤', '時短', '営業事務', '物流', '事務', 'マーケティング', '一般企業', '庶務・秘書経験', '副業', '福祉用具専門相談員', '営業', 'バックオフィス業務', 'ピッキング・検品・梱包の軽作業', '在宅可能', 'Webライター', '受付業務', '一般事務', 'パーソナルトレーナー', 'リユース業界']
            const isAddressArray = ['']
            if (true) {
              if (basicData.age >= 20 && basicData.age <= 59) {
                if (this.keywordCheckRirekisho(formatData, isKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isKeywordArray)) {
                  isAutoRT = true
                }
                if (this.keywordCheckRirekisho(formatData, isNotKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isNotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }
          } else if (clientID === 'terracia_mail' && permissionType === 9) {
            const isTerracia_12KeywordArray = ['保育士']
            const isTerracia_12NotKeywordArray = ['キャリアアドバイザー', 'エージェント', '人材業界', '転職斡旋', '転職サポート']
            const isTerracia_12AddressArray = ['東京都', '千葉県', '沖縄県']
            if (this.addressCheck(basicData, isTerracia_12AddressArray)) {
              if (basicData.age >= 22 && basicData.age <= 66) {
                if (this.keywordCheckRirekisho(formatData, isTerracia_12KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isTerracia_12KeywordArray)) {
                  isAutoRT = true
                }
                if (this.keywordCheckRirekisho(formatData, isTerracia_12NotKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isTerracia_12NotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }
          } else if (clientID === 'terracia_mail' && permissionType === 10) {
            const isKeywordArray = ['保育士']
            const isNotKeywordArray = ['キャリアアドバイザー', 'エージェント', '人材業界', '転職斡旋', '転職サポート']
            const isAddressArray = ['熊本県', '長崎県']
            if (this.addressCheck(basicData, isAddressArray)) {
              if (basicData.age >= 22 && basicData.age <= 66) {
                if (this.keywordCheckRirekisho(formatData, isKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isKeywordArray)) {
                  isAutoRT = true
                }
                if (this.keywordCheckRirekisho(formatData, isNotKeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isNotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }
          } else if (clientID === 'roxx_api' && permissionType === 12) {
            if (true) {
              if (formatData.gradeYear == 27) {
                if (this.keywordCheck(formatId, formatData, '大学')) {
                  if (basicData.age >= 19 && basicData.age <= 25) {
                    isAutoRT = true
                  }
                }
              }
            }
          } else if (clientID === 'roxx_api' && permissionType === 17) {
            const isRoxx17NotKeywordArray = ['看護師', '保育士', '栄養士', '施工管理', '自動車整備士', '電気主任技術者', '介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
            const isRoxx17AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
            if (this.addressCheck(basicData, isRoxx17AddressArray)) {
              if (basicData.age >= 20 && basicData.age <= 35) {
                isAutoRT = true
                if (this.keywordCheckRirekisho(formatData, isRoxx17NotKeywordArray) || this.keywordCheckShokumukeirekisho(formatData, isRoxx17NotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }
          } else if (clientID === 'roxx_api' && permissionType === 18) {
            const isRoxx18NotKeywordArray = ['看護師', '保育士', '栄養士', '施工管理', '自動車整備士', '電気主任技術者', '介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
            const isRoxx18AddressArray = ['茨城県', '栃木県', '群馬県']
            if (this.addressCheck(basicData, isRoxx18AddressArray)) {
              if (basicData.age >= 20 && basicData.age <= 35) {
                isAutoRT = true
                if (this.keywordCheckRirekisho(formatData, isRoxx18NotKeywordArray) || this.keywordCheckShokumukeirekisho(formatData, isRoxx18NotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }
          } else if (clientID === 'roxx_api' && permissionType === 19) {
            const isRoxx19NotKeywordArray = ['看護師', '保育士', '栄養士', '施工管理', '自動車整備士', '電気主任技術者', '介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
            const isRoxx19AddressArray = ['大阪府']
            if (this.addressCheck(basicData, isRoxx19AddressArray)) {
              if (basicData.age >= 20 && basicData.age <= 35) {
                isAutoRT = true
                if (this.keywordCheckRirekisho(formatData, isRoxx19NotKeywordArray) || this.keywordCheckShokumukeirekisho(formatData, isRoxx19NotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }
          } else if (clientID === 'roxx_api' && permissionType === 20) {
            const isRoxx20NotKeywordArray = ['看護師', '保育士', '栄養士', '施工管理', '自動車整備士', '電気主任技術者', '介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
            const isRoxx20AddressArray = ['兵庫県', '京都府']
            if (this.addressCheck(basicData, isRoxx20AddressArray)) {
              if (basicData.age >= 20 && basicData.age <= 35) {
                isAutoRT = true
                if (this.keywordCheckRirekisho(formatData, isRoxx20NotKeywordArray) || this.keywordCheckShokumukeirekisho(formatData, isRoxx20NotKeywordArray)) {
                  isAutoRT = false
                }
              }
            }
          }
          return isAutoRT
        },
        googleAdsTagCheck: function (client_id, permission_type) {
          console.error('googleAdsTagCheck')
          // google_ads_tag のリストを検索して一致する項目を探す
          const matchedTags = this.google_ads_tag.filter(tag => {
            return tag.id === client_id && tag.ptype === permission_type
          })
          // 結果に応じた処理
          if (matchedTags.length > 0) {
            console.log('一致するタグが見つかりました:', matchedTags)
            return true
          } else {
            console.log('一致するタグが見つかりません')
            return false
          }
        },
        keywordCheck: function (formatId, formatData, keyword) {
          let _check = false
          if (formatId == 'shokumukeirekisho') {
            return false
          }
          // 本人希望欄（最も明示的な希望記述）
          if (formatData.request && formatData.request.indexOf(keyword) >= 0) {
            _check = true
          }
          for (const key in formatData.educationalHistories) {
            // 見出し
            const item = formatData.educationalHistories[key]
            if (item.description && item.description.indexOf(keyword) >= 0) {
              _check = true
            }
          }
          for (const key in formatData.jobHistories) {
            // 見出し
            const item = formatData.jobHistories[key]
            if (item.description && item.description.indexOf(keyword) >= 0) {
              _check = true
            }
          }
          for (const key in formatData.licenseHistories) {
            // 見出し
            const item = formatData.licenseHistories[key]
            if (item.description && item.description.indexOf(keyword) >= 0) {
              _check = true
            }
          }
          return _check
        },
        keywordCheckOnlyLicense: function (formatId, formatData, keyword) {
          let _check = false
          if (formatId == 'shokumukeirekisho') {
            return false
          }
          for (const key in formatData.licenseHistories) {
            // 見出し
            const item = formatData.licenseHistories[key]
            if (item.description && item.description.indexOf(keyword) >= 0) {
              _check = true
            }
          }
          return _check
        },
        keywordCheck2: function (formatId, formatData, keyword) {
          let _check = false
          if (formatId == 'shokumukeirekisho') {
            return false
          }
          for (const key in formatData.educationalHistories) {
            // 見出し
            const item = formatData.educationalHistories[key]
            if (item.description) {
              if (item.description.indexOf(keyword) >= 0) {
                _check = true
              }
            }
          }
          for (const key in formatData.licenseHistories) {
            // 見出し
            const item = formatData.licenseHistories[key]
            if (item.description) {
              if (item.description.indexOf(keyword) >= 0) {
                _check = true
              }
            }
          }
          return _check
        },
        keywordCheck3: function (formatData, keyword) {
          let _check = false

          if (formatData.prMessage && formatData.prMessage.indexOf(keyword) >= 0) {
            _check = true
          }
          if (formatData.jobSummary && formatData.jobSummary.indexOf(keyword) >= 0) {
            _check = true
          }
          if (formatData.jobHistories) {
            for (const key in formatData.jobHistories) {
              // 見出し
              const item = formatData.jobHistories[key]
              if (item && item.businessArea && item.businessArea.indexOf(keyword) >= 0) {
                _check = true
              }
              if (item && item.projects) {
                for (const subkey in item.projects) {
                  const subitem = item.projects[subkey]
                  if (subitem && subitem.contentsOfProject && subitem.contentsOfProject.indexOf(keyword) >= 0) {
                    _check = true
                  }
                  if (subitem && subitem.projectTitle && subitem.projectTitle.indexOf(keyword) >= 0) {
                    _check = true
                  }
                  if (subitem && subitem.position && subitem.position.indexOf(keyword) >= 0) {
                    _check = true
                  }
                }
              }
            }
          }
          return _check
        },
        _keywordCheckRirekisho: function (targetData, keywordlist) {
          for (const keyword in keywordlist) {
            for (const key in targetData.educationalHistories) {
              // 見出し
              const item = targetData.educationalHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
            }
            for (const key in targetData.jobHistories) {
              // 見出し
              const item = targetData.jobHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
            }
            for (const key in targetData.licenseHistories) {
              // 見出し
              const item = targetData.licenseHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
            }
          }
          // targetData.reasonが存在しない場合はfalseを返す
          if (!targetData.reason || typeof targetData.reason !== 'string') {
            return false
          }
          const parser = loadDefaultJapaneseParser()
          const parsedText = parser.parse(targetData.reason)
          // parseの結果が配列でない場合はfalseを返す
          if (!Array.isArray(parsedText)) {
            return false
          }

          for (const textData in parsedText) {
            for (const keyword in keywordlist) {
              if (textData.includes(keyword)) {
                return true
              }
            }
          }
          return false
        },
        keywordCheckRirekisho: function (targetData, keywordlist) {
          for (const keyword in keywordlist) {
            for (const key in targetData.educationalHistories) {
              // 見出し
              const item = targetData.educationalHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
            }
            for (const key in targetData.jobHistories) {
              // 見出し
              const item = targetData.jobHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
            }
            for (const key in targetData.licenseHistories) {
              // 見出し
              const item = targetData.licenseHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
            }
          }
          return false
        },
        /**
         * RT 再表示チェーン（displayPopup4Repeat）用の「特定 KW 該当」判定。
         * keywordCheckRirekisho だけだと本人希望（request）にだけある場合が取りこぼされ、
         * 上限が 2 件のまま（4 件に伸びない）になる。keywordCheck や志望動機（reason）も見る。
         * @param {string} formatId
         * @param {object} [formatData] 履歴書フォーマット Data
         * @param {string[]} keywordlist
         * @param {object} [shokumuFromOther] otherFormatData 内の職務経歴書（マイページ等）
         */
        checkRepeatRTChainExtendedKeywords: function (formatId, formatData, keywordlist, shokumuFromOther) {
          if (!keywordlist || !keywordlist.length) return false
          if (formatData) {
            if (this.keywordCheckRirekisho(formatData, keywordlist)) return true
            if (this.keywordCheckShokumukeirekisho(formatData, keywordlist)) return true
            if (typeof formatData.reason === 'string' && formatData.reason) {
              for (let i = 0; i < keywordlist.length; i++) {
                if (formatData.reason.indexOf(keywordlist[i]) >= 0) return true
              }
            }
          }
          if (shokumuFromOther && typeof shokumuFromOther === 'object' && this.keywordCheckShokumukeirekisho(shokumuFromOther, keywordlist)) {
            return true
          }
          if (formatId && formatId !== 'shokumukeirekisho' && formatData) {
            for (let i = 0; i < keywordlist.length; i++) {
              if (this.keywordCheck(formatId, formatData, keywordlist[i])) return true
            }
          }
          return false
        },
        keywordCheckBizreach1: function (targetData, basicData) {
          // ビズリーチ送信条件を満たすかどうかを判断する
          // 各種パラメータvalidation
          try {
            // 各種パラメータvalidation
            if (!basicData.lastName || !basicData.firstName || !basicData.email || !basicData.birthYear || !basicData.birthMonth || !basicData.birthDay || !basicData.sex) {
              throw new Error('ユーザー情報が未設定です')
            }
            if (!basicData.postNumber || !basicData.address1 || !basicData.tel1 || !basicData.tel2 || !basicData.tel3) {
              throw new Error('住所・電話番号が未設定です')
            }

            // 職歴の確認
            if (targetData.jobHistories.length == 0) {
              throw new Error('職歴がありません')
            }

            // 学歴
            if (targetData.educationalHistories.length == 0) {
              throw new Error('学歴がありません')
            }

            // 年収・希望年収・奇病職種・希望業種
            if (!targetData.nowNensyu || !targetData.kibouNensyu || !basicData.kibouShokushuCd || !basicData.kibouGyoushuCd) {
              throw new Error('年収・希望年収・奇病職種・希望業種がありません')
            }
          } catch (error) {
            console.log(error)
            return false
          }
          return true
        },
        LegacyKeywordCheckRirekisho: function (targetData, keywordlist) {
          for (const keyword in keywordlist) {
            for (const key in targetData.educationalHistories) {
              // 見出し
              const item = targetData.educationalHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
            }
            for (const key in targetData.jobHistories) {
              // 見出し
              const item = targetData.jobHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
            }
            for (const key in targetData.licenseHistories) {
              // 見出し
              const item = targetData.licenseHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
            }
          }
          return false
        },
        keywordCheckShokumukeirekishoOnlyLicense: function (targetData, keyword) {
          if (targetData.skillsToUse) {
            for (const key in targetData.skillsToUse) {
              const item = targetData.skillsToUse[key]
              if (item && item.skillname && item.skillname.indexOf(keyword) >= 0) {
                return true
              }
            }
          }
          return false
        },
        _keywordCheckShokumukeirekisho: function (targetData, keywordlist) {
          for (const keyword in keywordlist) {
            if (targetData.prMessage && targetData.prMessage.indexOf(keywordlist[keyword]) >= 0) {
              return true
            }
            if (targetData.jobSummary && targetData.jobSummary.indexOf(keywordlist[keyword]) >= 0) {
              return true
            }
            if (targetData.skillsToUse) {
              for (const key in targetData.skillsToUse) {
                const item = targetData.skillsToUse[key]
                if (item && item.skillname && item.skillname.indexOf(keywordlist[keyword]) >= 0) {
                  return true
                }
              }
            }
            if (targetData.jobHistories) {
              for (const key in targetData.jobHistories) {
                // 見出し
                const item = targetData.jobHistories[key]
                if (item && item.businessArea && item.businessArea.indexOf(keywordlist[keyword]) >= 0) {
                  return true
                }
                for (const subkey in item.projects) {
                  const subitem = item.projects[subkey]
                  if (subitem && subitem.contentsOfProject && subitem.contentsOfProject.indexOf(keywordlist[keyword]) >= 0) {
                    return true
                  }
                  if (subitem && subitem.projectTitle && subitem.projectTitle.indexOf(keywordlist[keyword]) >= 0) {
                    return true
                  }
                  if (subitem && subitem.position && subitem.position.indexOf(keywordlist[keyword]) >= 0) {
                    return true
                  }
                }
              }
            }
          }

          const parser = loadDefaultJapaneseParser()
          const text = [targetData.prMessage || '', targetData.jobSummary || ''].join(' ').trim()
          // テキストが空の場合はfalseを返す
          if (!text) {
            return false
          }
          const parsedText = parser.parse(text)
          // parseの結果が配列でない場合はfalseを返す
          if (!Array.isArray(parsedText)) {
            return false
          }

          for (const textData in parsedText) {
            for (const keyword in keywordlist) {
              if (textData.includes(keyword)) {
                return true
              }
            }
          }
          return false
        },
        keywordCheckShokumukeirekisho: function (targetData, keywordlist) {
          for (const keyword in keywordlist) {
            if (targetData.prMessage && targetData.prMessage.indexOf(keywordlist[keyword]) >= 0) {
              return true
            }
            if (targetData.jobSummary && targetData.jobSummary.indexOf(keywordlist[keyword]) >= 0) {
              return true
            }
            if (targetData.skillsToUse) {
              for (const key in targetData.skillsToUse) {
                const item = targetData.skillsToUse[key]
                if (item && item.skillname && item.skillname.indexOf(keywordlist[keyword]) >= 0) {
                  return true
                }
              }
            }
            if (targetData.jobHistories) {
              for (const key in targetData.jobHistories) {
                // 見出し
                const item = targetData.jobHistories[key]
                if (item && item.businessArea && item.businessArea.indexOf(keywordlist[keyword]) >= 0) {
                  return true
                }
                for (const subkey in item.projects) {
                  const subitem = item.projects[subkey]
                  if (subitem && subitem.contentsOfProject && subitem.contentsOfProject.indexOf(keywordlist[keyword]) >= 0) {
                    return true
                  }
                  if (subitem && subitem.projectTitle && subitem.projectTitle.indexOf(keywordlist[keyword]) >= 0) {
                    return true
                  }
                  if (subitem && subitem.position && subitem.position.indexOf(keywordlist[keyword]) >= 0) {
                    return true
                  }
                }
              }
            }
          }
          return false
        },
        LegacyKeywordCheckShokumukeirekisho: function (targetData, keywordlist) {
          for (const keyword in keywordlist) {
            if (targetData.prMessage && targetData.prMessage.indexOf(keywordlist[keyword]) >= 0) {
              return true
            }
            if (targetData.jobSummary && targetData.jobSummary.indexOf(keywordlist[keyword]) >= 0) {
              return true
            }
            if (targetData.skillsToUse) {
              for (const key in targetData.skillsToUse) {
                const item = targetData.skillsToUse[key]
                if (item && item.skillname && item.skillname.indexOf(keywordlist[keyword]) >= 0) {
                  return true
                }
              }
            }
            if (targetData.jobHistories) {
              for (const key in targetData.jobHistories) {
                // 見出し
                const item = targetData.jobHistories[key]
                if (item && item.businessArea && item.businessArea.indexOf(keywordlist[keyword]) >= 0) {
                  return true
                }
                for (const subkey in item.projects) {
                  const subitem = item.projects[subkey]
                  if (subitem && subitem.contentsOfProject && subitem.contentsOfProject.indexOf(keywordlist[keyword]) >= 0) {
                    return true
                  }
                  if (subitem && subitem.projectTitle && subitem.projectTitle.indexOf(keywordlist[keyword]) >= 0) {
                    return true
                  }
                  if (subitem && subitem.position && subitem.position.indexOf(keywordlist[keyword]) >= 0) {
                    return true
                  }
                }
              }
            }
          }
          return false
        },
        checkJoblistKeyword: function (formatId, formatData) {
          const isShokumu = (formatId === 'shokumukeirekisho')
          const tiers = [
            this.joblistKeywordTier1,
            this.joblistKeywordTier2,
            this.joblistKeywordTier3,
            this.joblistKeywordTier4
          ]

          // Step 0: 希望職種ドロップダウン（hopeJobcategory）が設定されていれば逆方向マッチ
          // JIS規格では未設定だが、AI履歴書・新書式では設定される
          const hopeJob = formatData.hopeJobcategory
          if (hopeJob) {
            const hopeStr = Array.isArray(hopeJob) ? hopeJob.join('') : hopeJob
            for (let t = 0; t < tiers.length; t++) {
              for (let i = 0; i < tiers[t].length; i++) {
                if (hopeStr.indexOf(tiers[t][i]) >= 0) return tiers[t][i]
              }
            }
          }

          // Step 1: request（本人希望欄）/ description 等をスキャン
          for (let t = 0; t < tiers.length; t++) {
            const tier = tiers[t]
            for (let i = 0; i < tier.length; i++) {
              const keyword = tier[i]
              const hit = isShokumu
                ? this.keywordCheck3(formatData, keyword)
                : this.keywordCheck(formatId, formatData, keyword)
              if (hit) return keyword
            }
          }
          return ''
        },
        getPrefJoblist: function (basicData) {
          let _pref = ''
          for (const key in this.joblistPrefs) {
            if (basicData.address1.indexOf(this.joblistPrefs[key]) >= 0) {
              _pref = this.joblistPrefs[key]
            }
          }
          return _pref
        },
        addressCheck: function (basicData, addresslist) {
          for (const key in addresslist) {
            if (basicData.address1 && basicData.address1.indexOf(addresslist[key]) >= 0) {
              return true
            }
          }
          return false
        },
        /**
         * auto-rt バナー表示済みのとき、同一クライアント・oldPermission（または NewOnly 時は新 permission）に対応する
         * フロント RT ポップアップ（displayFrontEndPopupRenew）を出さない。
         */
        shouldSuppressRtPopupForAutoRT: function (rd) {
          if (!this.isAutoRTable || !this.autoRTInfo || !this.autoRTInfo.clientId) return false
          if (rd.client_id !== this.autoRTInfo.clientId) return false
          const pt = Number(rd.permission_type)
          const oldPt = this.autoRTInfo.oldPermissionType
          if (oldPt != null && oldPt !== 0) {
            return pt === Number(oldPt)
          }
          return pt === Number(this.autoRTInfo.permissionType)
        },

        displayFrontEndPopupRenew: function (formatId, formatData, basicData, otherFormatData, request_data, previewFormat, isMypage = false) {
          if (this.is_BehindRT && this.is_BehindRT()) {
            return false
          }

          if (formatId == 'rirekisho_esf_challenged') {
            return false
          }
          // ① 氏名チェック（どちらかがあればOK）
          const hasName = !!basicData.lastName || !!basicData.firstName

          // ② 電話番号チェック（全ての桁に値があり、数字のみ）
          const tel = [basicData.tel1, basicData.tel2, basicData.tel3].join('')
          const isTelValid = basicData.tel1 && basicData.tel2 && basicData.tel3 && /^[0-9０-９]+$/.test(tel)

          // ③ 生年月日チェック（birthYear が4桁）
          const isBirthYearValid = /^[0-9]{4}$/.test(basicData.birthYear)

          // 最終判定：すべてOKなら true、それ以外は false

          if (hasName && isTelValid && isBirthYearValid) {
            console.error('RT対象外')
          } else {
            return false
          }
          let isYagish1 = false
          let isMedley1 = false
          let isMedley2 = false
          let isMedley3 = false
          let isMedley4 = false
          let isMedley5 = false
          let isMedley6 = false
          let isMedley7 = false
          let isMedley8 = false
          let isMedley9 = false
          let isMedley10 = false
          let isJaic1 = false
          let isJaic2 = false
          let isJaic3 = false
          let medleyID = 1

          let isPharmate1 = false
          let isHuemaridge_1 = false
          let isNorms_1 = false

          let isMedley_Link_5 = false
          let isMedley_Link_6 = false
          let isMedley_Link_7 = false
          let isMedley_Link_8 = false
          let isMedley_Link_9 = false
          let isMedley_Link_10 = false
          let isMedley_Link_11 = false
          let isMedley_Link_12 = false
          let isMedley_Link_13 = false
          let isMedley_Link_14 = false
          let isMedley_Link_15 = false
          let isMedley_Link_16 = false
          let isMedley_Link_17 = false
          let isMedley_Link_18 = false
          let isMedley_Link_19 = false
          let isMedley_Link_20 = false
          let isMedley_Link_21 = false
          let isMedley_Link_22 = false

          let isJob919_1 = false
          let isJob919_2 = false
          let isJob919_3 = false
          let isJob919_4 = false
          let isJob919_5 = false
          let isJob919_7 = false
          let isJob919_8 = false
          let isJob919_9 = false

          let isPersolinnovation_1 = false
          let isPersolinnovation_2 = false
          let isPersolinnovation_3 = false
          let isPersolinnovation_4 = false

          let isPersolinnovation_5 = false

          let isRecrea_1 = false

          let isHrcareer_5 = false
          let isHrcareer_6 = false
          let isHrcareer_7 = false
          let isHrcareer_8 = false
          let isHrcareer_9 = false
          let isHrcareer_10 = false
          let isHrcareer_11 = false
          let isHrcareer_12 = false
          let isHrcareer_15 = false
          let isNeocareer_1 = false
          let isNeocareer_2 = false
          let isNeocareer_3 = false
          let isNeocareer_4 = false
          let isDrtc_1 = false

          let isOnecareer_1 = false
          let isVinc_1 = false

          let isNeocareerNew_1 = false

          let isCareerdraft_1 = false
          let isRecruitMc1 = false
          let isDely_1 = false
          let isRozas_1 = false
          let isRozas_2 = false
          let isRozas_3 = false
          let isRozas_4 = false
          let isRozas_5 = false
          let isWorkport_1 = false
          let isWorkport_2 = false
          let isWorkport_3 = false
          let isWorkport_4 = false

          let isCri_1 = false

          let isAgrinavi_1 = false

          let isRecree_2 = false
          let isRecree_3 = false
          let isRecree_4 = false
          let isRecree_5 = false

          let isPharmacareer_1 = false
          let isPharmacareer_2 = false
          let isPharmacareer_3 = false

          let isXmile_5 = false
          let isXmile_6 = false
          let isXmile_7 = false
          let isXmile_8 = false
          let isXmile_9 = false
          let isXmile_10 = false
          let isXmile_11 = false
          let isXmile_12 = false
          let isXmile_13 = false
          let isXmile_14 = false
          let isXmile_15 = false
          let isXmile_16 = false
          let isXmile_17 = false
          let isXmile_18 = false
          let isXmile_19 = false
          let isXmile_20 = false
          let isXmile_21 = false
          let isXmile_22 = false
          let isXmile_23 = false
          let isXmile_24 = false
          let isXmile_25 = false

          let isXmile_26 = false
          let isXmile_27 = false
          let isXmile_28 = false
          let isProselltraction_1 = false
          let isRerise_1 = false

          let isPlexjob_1 = false
          let isPlexjob_2 = false
          let isPlexjob_3 = false
          let isPlexjob_4 = false
          let isPlexjob_5 = false
          let isPlexjob_6 = false

          let isTimee_1 = false

          let isAwesome_1 = false

          let isBranu_1 = false
          let isBlankpad_1 = false
          let isCiw_1 = false
          let isBestand_1 = false
          let isHhjapan_1 = false

          let isRiajob_1 = false

          let isPleiades_1 = false
          let isPleiades_2 = false
          let isPleiades_3 = false
          let isPleiades_4 = false
          let isPleiades_5 = false
          let isPleiades_6 = false
          let isPleiades_7 = false
          let isPleiades_8 = false
          let isPleiades_9 = false
          let isPleiades_10 = false
          let isPleiades_11 = false
          let isPleiades_12 = false
          let isPleiades_13 = false
          let isPleiades_14 = false
          let isPleiades_15 = false
          let isPleiades_16 = false
          let isPleiades_17 = false
          let isPleiades_18 = false

          let isPeacekaigo1 = false
          let isPeacekaigo2 = false
          let isPeacekaigo3 = false
          let isPeacekaigo4 = false
          let isPeacekaigo5 = false
          let isHitotech_1 = false
          let isHitotech_2 = false
          let isHitotech_3 = false
          let isHitotech_4 = false

          let isHitotechNeocareer_1 = false

          let isTechouse_1 = false
          let isTechouse_2 = false
          let isTechouse_3 = false

          let isUsenworking_1 = false
          let isUsenworking_2 = false
          let isUsenworking_3 = false
          let isUsenworking_4 = false

          let isSms_1 = false
          let isSms_2 = false
          let isSms_3 = false

          let is400F_1 = false
          let isKikkakeagent_1 = false
          let isPrimalwork_1 = false
          let isTalentnavi_1 = false

          let isNsjapan_1 = false

          let isHuproinc_1 = false
          let isHuproinc_2 = false

          let isCareeradv_1 = false

          let isNineearth_1 = false
          let isNineearth_2 = false
          let isNineearth_3 = false
          let isNineearth_4 = false
          let isNineearth_5 = false

          let isAxes_1 = false

          let isValuablelife_1 = false
          let isParable_1 = false

          let isStarlabo_1 = false
          let isStarlabo_2 = false

          let isSupernurse_1 = false

          let isHeros_1 = false
          let isHeros_2 = false

          let isCloudlink_1 = false
          let isCloudlink_2 = false
          let isCloudlink_4 = false

          let isOutsourcing_1 = false

          let isAzurite_1 = false
          let isAzurite_2 = false

          let isProlg_1 = false
          let isProlg_2 = false

          let isSmartforce_1 = false
          let isSmartforce_2 = false

          let isKiminara_1 = false
          let isKiminara_2 = false
          let isKiminara_3 = false
          let isKiminara_4 = false

          let isStartme_1 = false
          let isStartme_2 = false
          let isAgent3_1 = false

          let isStrike_1 = false
          let isCloudlink_3 = false

          let isInternous_1 = false
          let isInternous_2 = false
          let isInternous_3 = false
          let isInternous_4 = false
          let isInternous_5 = false

          let isBearsnavi_1 = false
          let isBearsnavi_2 = false
          let isBearsnavi_3 = false

          let isNoajpn_1 = false
          let isNoajpn_2 = false
          let isJhr_1 = false
          let isJhr_2 = false
          let isSimple_1 = false

          let isBriedge_1 = false

          let isTryt_3 = false
          let isTryt_4 = false
          let isReaching_1 = false
          let isReaching_2 = false
          let isReaching_3 = false
          let isReaching_4 = false
          let isReaching_5 = false
          let isRepath_1 = false

          let isTerracia_2 = false
          let isTerracia_1 = false
          let isTerracia_3 = false
          let isTerracia_4 = false

          let isDagent_1 = false

          let isUnisoncareer_1 = false
          let isGeekly_1 = false
          let isFindy_1 = false

          let isGrandop_1 = false

          let isCookbiz_1 = false
          let isCookbiz_2 = false
          let isCookbiz_3 = false

          let isFoodison_1 = false
          let isFoodison_2 = false
          let isFoodison_3 = false

          let isOishiru_1 = false

          let isHayfield_1 = false

          let isItk_1 = false

          let isCareerdraft_2 = false
          let isCareerdraft_3 = false

          let isRoxx = false
          let isRoxx2 = false
          let isRoxx3 = false
          let isRoxx4 = false
          let isRoxx5 = false
          let isRoxx6 = false
          let isRoxx7 = false
          let isRoxx8 = false
          let isRoxx11 = false
          let isRoxx13 = false
          let isRoxx14 = false
          let isRoxx15 = false
          let isRoxx16 = false

          let isTaikennyusha_1 = false
          let isTaikennyusha_2 = false

          let isHitolabo_1 = false
          let isHitolabo_2 = false

          let isLeverages_1 = false

          let isLifeones_1 = false
          let isLifeones_2 = false
          let isLifeones_3 = false

          let isGojob_1 = false

          let isWillofwork_1 = false
          let isWillofwork_2 = false

          let isHrteam_1 = false

          let isDraft_1 = false

          let isSurely_1 = false
          let isLetsi_1 = false

          let isJmsc_1 = false
          let isJmsc_2 = false
          let isJmsc_3 = false

          let isKotrio_1 = false
          let isKotrio_2 = false

          let isCmindcareer_1 = false

          let isNeocareer_5 = false

          let isRecurrent_1 = false
          let isRecurrent_2 = false
          let isRecurrent_3 = false
          let isRecurrent_4 = false

          let isTsace_1 = false
          let isTsace_2 = false
          let isTsace_3 = false

          let isMitzmitz_1 = false
          let isMitzmitz_2 = false
          let isMitzmitz_3 = false
          let isMitzmitz_4 = false
          let isMitzmitz_5 = false
          let isMitzmitz_6 = false

          let isTruspo_1 = false

          let isFirstconnect_1 = false

          let isIrodas_1 = false
          let isRecrea_2 = false

          let isXmile_38 = false
          let isRecurrent_5 = false
          let isSecondgame_1 = false
          let isSecondgame_2 = false
          let isEil100_1 = false
          let isEil100_2 = false
          let isWitc1 = false
          let isBizreach_1 = false
          let isIrodas_2 = false

          if (true) {
            if (this.keywordCheck(formatId, formatData, '介護士') || this.keywordCheck(formatId, formatData, 'ヘルパー') || this.keywordCheck(formatId, formatData, '介護福祉士')) {
              isMedley1 = true
              medleyID = 1
            } else if (this.keywordCheck(formatId, formatData, '保育')) {
              isMedley2 = true
              medleyID = 2
            } else if (this.keywordCheck(formatId, formatData, '薬剤')) {
              isMedley3 = true
              medleyID = 3
            } else if (this.keywordCheck(formatId, formatData, '作業療法') || this.keywordCheck(formatId, formatData, '理学療法') ||
              this.keywordCheck(formatId, formatData, '言語聴覚') || this.keywordCheck(formatId, formatData, '視能訓練')) {
              isMedley4 = true
              medleyID = 4
            } else if (this.keywordCheck(formatId, formatData, '歯科衛生')) {
              isMedley5 = true
              medleyID = 5
            } else if (this.keywordCheck(formatId, formatData, '歯科助手')) {
              isMedley6 = true
              medleyID = 6
            } else if (this.keywordCheck(formatId, formatData, '看護師') || this.keywordCheck(formatId, formatData, '准看護師')) {
              isMedley7 = true
              medleyID = 7
            }
          }

          const yagish1KeywordArray = ['G2BAi4bWlzPRQ2vEF9ajZZx4ylX2']
          if (this.keywordCheckRirekisho(formatData, yagish1KeywordArray) ||
            this.keywordCheckShokumukeirekisho(formatData, yagish1KeywordArray)) {
            isYagish1 = true
          }

          const sms1AddressArray = ['東京都']
          const sms1KeywordArray = ['介護士', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員', 'ケアマネジャー']
          // let sms1KeywordArray = ['G2BAi4bWlzPRQ2vEF9ajZZx4ylX2']
          if (this.addressCheck(basicData, sms1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 59) {
              if (this.keywordCheckRirekisho(formatData, sms1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, sms1KeywordArray)) {
                isSms_1 = true
              }
            }
          }
          const sms2KeywordArray = ['栄養士']
          if (true) {
            if (basicData.age >= 23 && basicData.age <= 55) {
              if (this.keywordCheckRirekisho(formatData, sms2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, sms2KeywordArray)) {
                isSms_2 = true
              }
            }
          }
          const sms3KeywordArray = ['保育士']
          if (true) {
            if (basicData.age >= 20 && basicData.age <= 69) {
              if (this.keywordCheckRirekisho(formatData, sms3KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, sms3KeywordArray)) {
                isSms_3 = true
              }
            }
          }

          const jaic1addressArray = ['宮城県', '広島県', '福岡県']
          if (this.addressCheck(basicData, jaic1addressArray)) {
            if (basicData.age < 30 && basicData.age >= 20 && formatId == 'rerekisho_part_time') {
              isJaic1 = true
            }
          }
          const jaic2addressArray = ['宮城県', '広島県', '福岡県']
          if (this.addressCheck(basicData, jaic2addressArray)) {
            if (basicData.age <= 25 && this.keywordCheck(formatId, formatData, '中退') && (formatId == 'rirekisho_job_change' || formatId == 'rirekisho_ai_career' ||
              formatId == 'rirekisho_job_change2' ||
              formatId == 'rirekisho_job_change_old' ||
              formatId == 'rirekisho_single' ||
              formatId == 'rirekisho_nophoto_double' ||
              formatId == 'rirekisho_nophoto')) {
              isJaic2 = true
            }
          }
          const jaic3addressArray = ['宮城県']
          if (this.addressCheck(basicData, jaic3addressArray)) {
            if (basicData.age < 30 && basicData.age >= 20 && (formatId == 'rirekisho_job_change' || formatId == 'rirekisho_ai_career' ||
              formatId == 'rirekisho_job_change2' ||
              formatId == 'rirekisho_job_change_old' ||
              formatId == 'rirekisho_single' ||
              formatId == 'rirekisho_nophoto_double' ||
              formatId == 'rirekisho_nophoto')) {
              isJaic3 = true
            }
          }

          const isLifeones_1KeywordArray = ['ケアマネージャー', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員', 'ケアマネジャー ', '理学療法士', '作業療法士']
          const isLifeones_1NotKeywordArray = ['N1', 'N2', 'N3', 'N4', 'N5', '日本語能力試験', 'JLPT', '在宅', '営業', '事務']
          const isLifeones_1AddressArray = ['神奈川県', '埼玉県', '千葉県', '東京都', '愛知県', '大阪府', '兵庫県', '北海道', '京都府', '広島県', '愛媛県', '岡山県', '福岡県']
          if (this.addressCheck(basicData, isLifeones_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isLifeones_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isLifeones_1KeywordArray)) {
                isLifeones_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isLifeones_1NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isLifeones_1NotKeywordArray)) {
                isLifeones_1 = false
              }
            }
          }
          const isLifeones_2KeywordArray = ['タクシードライバー', '普通自動車第二種運転免許', '普通二種免許', '一般乗用旅客', '普通自動車二種免許', '普通自動車第二種免許', '旅客運送', 'タクシー']
          const isLifeones_2NotKeywordArray = ['N1', 'N2', 'N3', 'N4', 'N5', '日本語能力試験', 'JLPT']
          const isLifeones_2AddressArray = ['神奈川県', '埼玉県', '千葉県', '東京都']
          if (this.addressCheck(basicData, isLifeones_2AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 45) {
              if (this.keywordCheckRirekisho(formatData, isLifeones_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isLifeones_2KeywordArray)) {
                isLifeones_2 = true
              }
              if (this.keywordCheckRirekisho(formatData, isLifeones_2NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isLifeones_2NotKeywordArray)) {
                isLifeones_2 = false
              }
            }
          }

          const isLifeones_3KeywordArray = ['ケアマネージャー', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員', 'ヘルパー1級']
          const isLifeones_3NotKeywordArray = ['N1', 'N2', 'N3', 'N4', 'N5', '日本語能力試験', 'JLP']
          const isLifeones_3AddressArray = ['大阪府', '兵庫県', '京都府', '岡山県', '広島県', '愛媛県', '奈良県', '滋賀県', '北海道', '福岡県', '岐阜県', '三重県', '滋賀県']
          if (this.addressCheck(basicData, isLifeones_3AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isLifeones_3KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isLifeones_3KeywordArray)) {
                isLifeones_3 = true
              }
              if (this.keywordCheckRirekisho(formatData, isLifeones_3NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isLifeones_3NotKeywordArray)) {
                isLifeones_3 = false
              }
            }
          }
          //
          const isGojob_1KeywordArray = ['普通自動車第一種運転免許']
          const isGojob_1AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '愛知県', '大阪府', '茨城県', '兵庫県', '静岡県', '福岡県', '岐阜県', '新潟県', '北海道', '福島県']
          if (this.addressCheck(basicData, isGojob_1AddressArray)) {
            if (basicData.age >= 23 && basicData.age <= 59) {
              if (this.keywordCheckRirekisho(formatData, isGojob_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isGojob_1KeywordArray)) {
                isGojob_1 = true
              }
            }
          }

          const isWillofwork_1KeywordArray = ['準中型自動車第一種免許', '中型自動車第一種免許', '大型自動車第一種免許', '大型自動車第二種免許']
          const isWillofwork_1AddressArray = ['東京都', '埼玉県', '千葉県', '神奈川県', '大阪府', '京都府', '兵庫県', '奈良県']
          if (this.addressCheck(basicData, isWillofwork_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 55) {
              if (this.keywordCheckRirekisho(formatData, isWillofwork_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isWillofwork_1KeywordArray)) {
                isWillofwork_1 = true
              }
            }
          }

          const isWillofwork_2KeywordArray = ['空港', 'グランドスタッフ', 'グランドハンドリング', 'チェックインカウンター', 'フロント']
          const isWillofwork_2AddressArray = ['東京都', '埼玉県', '千葉県', '神奈川県', '大阪府', '京都府', '兵庫県', '奈良県']
          if (this.addressCheck(basicData, isWillofwork_2AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 55) {
              if (this.keywordCheckRirekisho(formatData, isWillofwork_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isWillofwork_2KeywordArray)) {
                isWillofwork_2 = true
              }
            }
          }

          if (this.keywordCheck(formatId, formatData, '施工管理')) {
            if (basicData.age <= 65 && basicData.age >= 1008) {
              isJob919_1 = true
            }
          }

          if (this.keywordCheck(formatId, formatData, '監理技術者')) {
            if (basicData.age <= 65 && basicData.age >= 1008) {
              isJob919_7 = true
            }
          }
          const job919addressArray = ['和歌山県', '北海道', '兵庫県', '福島県', '福岡県', '福井県', '富山県', '奈良県', '栃木県', '東京都', '長野県', '大分県', '大阪府', '千葉県', '石川県', '静岡県', '青森県', '神奈川県', '新潟県', '秋田県', '鹿児島県', '滋賀県', '山梨県', '山形県', '三重県', '埼玉県', '香川県', '広島県', '群馬県', '熊本県', '京都府', '宮城県', '岐阜県', '岩手県', '沖縄県', '岡山県', '茨城県', '愛媛県', '愛知県']
          if (this.keywordCheck(formatId, formatData, '自動車整備士')) {
            if (this.addressCheck(basicData, job919addressArray)) {
              if (basicData.age <= 54 && basicData.age >= 1008) {
                isJob919_2 = true
              }
            }
          }
          if (this.keywordCheck(formatId, formatData, '自動車検査員')) {
            if (this.addressCheck(basicData, job919addressArray)) {
              if (basicData.age <= 54 && basicData.age >= 1008) {
                isJob919_8 = true
              }
            }
          }
          if (this.keywordCheck(formatId, formatData, '板金塗装') ||
            this.keywordCheck(formatId, formatData, 'ジーゼル整備士') ||
            this.keywordCheck(formatId, formatData, 'ガソリン整備士') ||
            this.keywordCheck(formatId, formatData, '自動車整備工')) {
            if (this.addressCheck(basicData, job919addressArray)) {
              if (basicData.age <= 54 && basicData.age >= 1008) {
                isJob919_9 = true
              }
            }
          }
          if (this.keywordCheck(formatId, formatData, '建築士')) {
            if (basicData.age <= 65 && basicData.age >= 20) {
              isJob919_3 = true
            }
          }
          if (this.keywordCheck(formatId, formatData, '電気主任技術者')) {
            if (basicData.age <= 65 && basicData.age >= 1008) {
              isJob919_4 = true
            }
          }
          const job919_5_addressArray = ['香川県', '北海道', '青森県', '宮城県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '岐阜県', '静岡県', '愛知県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '岡山県', '広島県', '山口県', '愛媛県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県']
          const job919_5KeywordArray = ['看護師']
          const job919_5NotKeywordArray = ['動物看護']
          if (this.keywordCheck(formatId, formatData, '看護師') ||
            this.keywordCheckShokumukeirekisho(formatData, job919_5KeywordArray)) {
            if (this.addressCheck(basicData, job919_5_addressArray)) {
              if (basicData.age <= 39 && basicData.age >= 23) {
                isJob919_5 = true
              }
            }
            if (this.keywordCheckRirekisho(formatData, job919_5NotKeywordArray) ||
              this.keywordCheckShokumukeirekisho(formatData, job919_5NotKeywordArray)) {
              isJob919_5 = false
            }
          }

          const problemsolving1AddressArray = ['大阪府', '兵庫県', '京都府', '滋賀県', '奈良県', '和歌山県']
          const problemsolving1KeywordArray = ['看護師']

          const problemsolving2AddressArray = ['香川県', '愛媛県', '徳島県']
          const problemsolving2KeywordArray = ['介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']

          const isPersolinnovation_1AddressArray = ['東京', '神奈川', '埼玉', '千葉']
          const isPersolinnovation_1KeywordArray = ['介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          if (this.addressCheck(basicData, isPersolinnovation_1AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPersolinnovation_1KeywordArray)) {
              if (basicData.age >= 20 && basicData.age <= 34) {
                isPersolinnovation_1 = true
              } else if (basicData.age >= 35 && basicData.age <= 59) {
                isPersolinnovation_2 = true
              }
            }
          }

          const isRecrea_1KeywordArray = ['']
          const isRecrea_1AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府', '愛知県', '福岡県']
          if (this.addressCheck(basicData, isRecrea_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              isRecrea_1 = true
            }
          }

          const isSurely_1AddressArray = ['東京都']
          const isSurely_1NotKeywordArray = ['日本語能力試験', 'JLPT', '既往歴あり', '躁鬱', '発達障害', 'ADHD', '手帳']
          if (this.addressCheck(basicData, isSurely_1AddressArray)) {
            if (basicData.age >= 23 && basicData.age <= 25) {
              isSurely_1 = true
            }

            if (this.keywordCheckRirekisho(formatData, isSurely_1NotKeywordArray)) {
              isSurely_1 = false
            }
          }

          // let isPersolinnovation_3AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府', '愛知県', '福岡県']
          // let isPersolinnovation_3NotKeywordArray = ['看護師', '保育士', '栄養士', '施工管理', '自動車整備士', '電気主任技術者', '介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          const isPersolinnovation_3AddressArray = ['東愛知県', '大阪府', '福岡県', '神奈川県', '千葉県', '埼玉県']
          const isPersolinnovation_3NotKeywordArray = ['N1', 'N2', 'N3', 'N4', 'N5', '日本語能力試験', 'JLPT', 'フロントエンジニア', 'webデザイナー', 'ディレクター', '課長', '部長', 'ゼネラルマネジャー', 'ゼネラルマネージャー', '整備士', '整備工', '板金', '検査員']
          if (this.addressCheck(basicData, isPersolinnovation_3AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPersolinnovation_3NotKeywordArray)) {
              isPersolinnovation_3 = false
            } else {
              if (basicData.age >= 19 && basicData.age <= 29) {
                isPersolinnovation_3 = true
              }
            }
          }

          const isPersolinnovation_5NotKeywordArray = ['N1', 'N2', 'N3', 'N4', 'N5', '日本語能力試験', 'JLPT']
          const isPersolinnovation_5AddressArray = ['神奈川県', '千葉県', '埼玉県', '愛知県', '大阪府', '福岡県']
          if (this.addressCheck(basicData, isPersolinnovation_5AddressArray)) {
            if (basicData.age >= 25 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isPersolinnovation_5NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isPersolinnovation_5NotKeywordArray)) {
                isPersolinnovation_5 = false
              } else {
                isPersolinnovation_5 = true
              }
            }
          }

          const isPersolinnovation_4AddressArray = ['北海道', '群馬県', '茨城県', '愛知県', '福島県', '福岡県']
          const isPersolinnovation_4KeywordArray = ['介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          if (this.addressCheck(basicData, isPersolinnovation_4AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPersolinnovation_4KeywordArray)) {
              if (basicData.age >= 20 && basicData.age <= 59) {
                isPersolinnovation_4 = true
              }
            }
          }

          if (!(basicData.tel1) ||
            !(basicData.tel2) ||
            !(basicData.tel3)) {
          } else {
            const hrcareer1AddressArray = ['東京都', '千葉県', '神奈川県', '埼玉県', '大阪府', '京都府', '兵庫県']
            const hrcareer1KeywordArray = ['保育士']
            if (this.addressCheck(basicData, hrcareer1AddressArray) || true) {
              if (basicData.age <= 34) {
                if (this.keywordCheckRirekisho(formatData, hrcareer1KeywordArray)) {
                  isHrcareer_5 = true
                }
              } else if (basicData.age >= 35) {
                if (this.keywordCheckRirekisho(formatData, hrcareer1KeywordArray)) {
                  isHrcareer_6 = true
                }
              }
            }
            const hrcareer2AddressArray = ['東京都', '千葉県', '神奈川県', '埼玉県', '大阪府', '京都府', '兵庫県', '北海道']
            const hrcareer2KeywordArray = ['看護']

            const hrcareer2NotInKeywordArray = ['動物', '中退']
            if (this.addressCheck(basicData, hrcareer2AddressArray) || true) {
              if (basicData.age <= 34) {
                if (this.keywordCheckRirekisho(formatData, hrcareer2NotInKeywordArray)) {
                  isHrcareer_7 = false
                } else if (this.keywordCheckRirekisho(formatData, hrcareer2KeywordArray)) {
                  isHrcareer_7 = true
                }
              } else if (basicData.age >= 35) {
                if (this.keywordCheckRirekisho(formatData, hrcareer2NotInKeywordArray)) {
                  isHrcareer_8 = false
                } else if (this.keywordCheckRirekisho(formatData, hrcareer2KeywordArray)) {
                  isHrcareer_8 = true
                }
              }
            }

            // let hrcareer3AddressArray = ['東京都', '千葉県', '神奈川県', '埼玉県', '大阪府', '京都府', '兵庫県', '静岡県', '北海道']
            const hrcareer3AddressArray = ['東京都', '神奈川県']
            const hrcareer3KeywordArray = ['介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員', 'ヘルパー２級', 'ヘルパー１級', 'ヘルパー二級', 'ヘルパー一級']
            if (true) {
              if (basicData.age <= 34) {
                if (this.keywordCheckRirekisho(formatData, hrcareer3KeywordArray)) {
                  isHrcareer_9 = true
                }
              } else if (basicData.age >= 35) {
                if (this.keywordCheckRirekisho(formatData, hrcareer3KeywordArray)) {
                  isHrcareer_10 = true
                }
              }
            }

            const hrcareer4KeywordArray = ['栄養士']
            if (true) {
              if (basicData.age <= 34) {
                if (this.keywordCheckRirekisho(formatData, hrcareer4KeywordArray)) {
                  isHrcareer_11 = true
                }
              } else if (basicData.age >= 35) {
                if (this.keywordCheckRirekisho(formatData, hrcareer4KeywordArray)) {
                  isHrcareer_12 = true
                }
              }
            }

            const hrcareer15KeywordArray = ['建築士', '宅地建物取引士', '宅建']
            if (true) {
              if (this.keywordCheckRirekisho(formatData, hrcareer15KeywordArray)) {
                isHrcareer_15 = true
              }
            }
          }

          const isLeverages_1KeywordArray = ['保育士']
          const isLeverages_1AddressArray = ['東京都', '神奈川県', '大阪府', '兵庫県', '愛知県']
          if (this.addressCheck(basicData, isLeverages_1AddressArray)) {
            if (basicData.age >= 29 && basicData.age <= 39) {
              if (this.keywordCheckRirekisho(formatData, isLeverages_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isLeverages_1KeywordArray)) {
                isLeverages_1 = true
              }
            }
          }

          const isRoxx2NotKeywordArray = ['看護師', '保育士', '栄養士', '施工管理', '自動車整備士', '電気主任技術者', '介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          const isRoxx2AddressArray = ['東京都', '埼玉県', '千葉県', '神奈川県', '大阪府', '愛知県']
          if (this.addressCheck(basicData, isRoxx2AddressArray)) {
            if (basicData.age >= 31 && basicData.age <= 34) {
              isRoxx2 = true
              if (this.keywordCheckRirekisho(formatData, isRoxx2NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isRoxx2NotKeywordArray)) {
                isRoxx2 = false
              }
              if (!(basicData.tel1) ||
                !(basicData.tel2) ||
                !(basicData.tel3)) {
                isRoxx2 = false
              }
            }
          }

          const isRoxxNotKeywordArray = ['看護師', '保育士', '栄養士', '施工管理', '自動車整備士', '電気主任技術者', '介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          const isRoxxAddressArray = ['東京都', '埼玉県', '千葉県', '神奈川県', '大阪府', '愛知県']
          if (this.addressCheck(basicData, isRoxxAddressArray)) {
            if (basicData.age >= 19 && basicData.age <= 23) {
              isRoxx = true
              if (this.keywordCheckRirekisho(formatData, isRoxxNotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isRoxxNotKeywordArray)) {
                isRoxx = false
              }
              if (!(basicData.tel1) ||
                !(basicData.tel2) ||
                !(basicData.tel3)) {
                isRoxx = false
              }
            }
          }

          const isRoxx3NotKeywordArray = ['看護師', '保育士', '栄養士', '施工管理', '自動車整備士', '電気主任技術者', '介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          const isRoxx3AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府', '兵庫県', '京都府', '奈良県', '滋賀県', '三重県', '愛知県', '福岡県', '静岡県', '岐阜県', '札幌市', '仙台市', '新潟市', '広島市', '岡山市', '熊本市']
          if (this.addressCheck(basicData, isRoxx3AddressArray)) {
            if (basicData.age >= 19 && basicData.age <= 29 && (formatData.gradeYear == 24 || formatData.gradeYear == 25)) {
              isRoxx3 = true
              if (this.keywordCheckRirekisho(formatData, isRoxx3NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isRoxx3NotKeywordArray)) {
                isRoxx3 = false
              }
              if (!(basicData.tel1) ||
                !(basicData.tel2) ||
                !(basicData.tel3)) {
                isRoxx3 = false
              }
            }
          }

          const isRoxx4NotKeywordArray = ['看護師', '保育士', '栄養士', '施工管理', '自動車整備士', '電気主任技術者', '介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          const isRoxx4AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府', '兵庫県', '京都府', '奈良県', '滋賀県', '三重県', '愛知県', '福岡県', '静岡県', '岐阜県', '札幌市', '仙台市', '新潟市', '広島市', '岡山市', '熊本市']
          if (this.addressCheck(basicData, isRoxx4AddressArray)) {
            if (basicData.age >= 19 && basicData.age <= 29) {
              if (formatData.gradeYear == '' || !(formatData.gradeYear !== undefined)) {
                isRoxx4 = true
              }
              if (this.keywordCheckRirekisho(formatData, isRoxx4NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isRoxx4NotKeywordArray)) {
                isRoxx4 = false
              }
              if (!(basicData.tel1) ||
                !(basicData.tel2) ||
                !(basicData.tel3)) {
                isRoxx4 = false
              }
            }
          }

          const isRoxx5NotKeywordArray = ['看護師', '保育士', '栄養士', '施工管理', '自動車整備士', '電気主任技術者', '介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          const isRoxx5AddressArray = ['茨城県', '群馬県', '栃木県']
          if (this.addressCheck(basicData, isRoxx5AddressArray)) {
            if (basicData.age >= 19 && basicData.age <= 29) {
              isRoxx5 = true
              if (this.keywordCheckRirekisho(formatData, isRoxx5NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isRoxx5NotKeywordArray)) {
                isRoxx5 = false
              }
              if (!(basicData.tel1) ||
                !(basicData.tel2) ||
                !(basicData.tel3)) {
                isRoxx5 = false
              }
            }
          }

          if (!(formatData.gradeYear)) {
            if (!formatData.foreignStudent) {
              if (this.keywordCheck(formatId, formatData, '大学')) {
                if (basicData.age >= 20 && basicData.age <= 28) {
                  isCareerdraft_1 = true
                }
              }
            }
          }

          if (formatData.gradeYear == 26) {
            if (!formatData.foreignStudent) {
              if (this.keywordCheck(formatId, formatData, '大学')) {
                if (basicData.age >= 20 && basicData.age <= 28) {
                  isCareerdraft_2 = true
                }
              }
            }
          }
          const isCareerdraft_3AddressArray = ['北大阪北海道']
          if (formatData.gradeYear == 27) {
            if (!formatData.foreignStudent) {
              if (this.keywordCheck(formatId, formatData, '大学')) {
                if (basicData.age >= 1008 && basicData.age <= 28) {
                  if (this.addressCheck(basicData, isCareerdraft_3AddressArray)) {
                    isCareerdraft_3 = true
                  }
                }
              }
            }
          }

          if (formatData.gradeYear == 27) {
            if (this.keywordCheck(formatId, formatData, '大学')) {
              if (basicData.age >= 19 && basicData.age <= 25) {
                isRoxx11 = true
              }
            }
          }

          if (formatData.gradeYear == 26) {
            if (this.keywordCheck(formatId, formatData, '大学')) {
              if (basicData.age >= 19 && basicData.age <= 25) {
                isRoxx6 = true
              }
            }
          }
          if (basicData.age >= 19 && basicData.age <= 29) {
            isRoxx7 = true
          }

          const isRoxx8KeywordArray = ['']
          const isRoxx8NotAddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '京都府', '兵庫県', '奈良県', '滋賀県', '三重県', '愛知県', '福岡県', '静岡県', '岐阜県', '札幌市', '仙台市', '新潟市', '岡山市', '広島市', '熊本市']
          if (this.addressCheck(basicData, isRoxx8NotAddressArray)) {
            isRoxx8 = false
          } else {
            if (basicData.age >= 35 && basicData.age <= 60) {
              isRoxx8 = true
            }
          }

          if (formatData.gradeYear == 27) {
            if (basicData.age <= 25) {
              isHrteam_1 = true
            }
          }

          const isCmindcareer_1KeywordArray = ['大学']
          const isCmindcareer_1NotKeywordArray = ['短期大学', '短大', '大学院']
          if (formatData.gradeYear == 27) {
            if (basicData.age >= 21 && basicData.age <= 25) {
              if (this.keywordCheckRirekisho(formatData, isCmindcareer_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isCmindcareer_1KeywordArray)) {
                isCmindcareer_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isCmindcareer_1NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isCmindcareer_1NotKeywordArray)) {
                isCmindcareer_1 = false
              }
            }
          }

          const isDraft_1AddressArray = ['東京都']
          const isDraft_1NotKeywordArray = ['短期大学', '短大', '専門学校', '早稲田', '慶應', '理科', '一橋', '上智', '学習院', '明治', '青山学院', '立教', '中央', '法政', '工業', '基督']
          if (formatData.gradeYear == 27) {
            if (this.addressCheck(basicData, isDraft_1AddressArray)) {
              if (basicData.age <= 24) {
                isDraft_1 = true
              }

              if (this.keywordCheckRirekisho(formatData, isDraft_1NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isDraft_1NotKeywordArray)) {
                isDraft_1 = false
              }
            }
          }

          const isTaikennyusha_1KeywordArray = ['コミュニケーション']
          const isTaikennyusha_1AddressArray = ['宮城県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '新潟県', '長野県', '千葉県', '埼玉県', '東京都', '神奈川県', '静岡県', '愛知県', '富山県', '岐阜県', '三重県', '滋賀県', '大阪府', '奈良県', '京都府', '兵庫県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '福岡県', '沖縄県']
          if (this.addressCheck(basicData, isTaikennyusha_1AddressArray)) {
            if (basicData.age >= 21 && basicData.age <= 34) {
              if (this.keywordCheckRirekisho(formatData, isTaikennyusha_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isTaikennyusha_1KeywordArray)) {
                isTaikennyusha_1 = true
              }
              isTaikennyusha_1 = true
            }
          }
          const isTaikennyusha_2KeywordArray = ['コミュニケーション']
          const isTaikennyusha_2AddressArray = ['宮城県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '新潟県', '長野県', '千葉県', '埼玉県', '東京都', '神奈川県', '静岡県', '愛知県', '富山県', '岐阜県', '三重県', '滋賀県', '大阪府', '奈良県', '京都府', '兵庫県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '福岡県', '沖縄県']
          if (this.addressCheck(basicData, isTaikennyusha_2AddressArray)) {
            if (basicData.age >= 21 && basicData.age <= 34) {
              if (this.keywordCheckRirekisho(formatData, isTaikennyusha_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isTaikennyusha_2KeywordArray)) {
                isTaikennyusha_2 = true
              }
              isTaikennyusha_2 = true
            }
          }

          if (formatData.gradeYear == 26) {
            isHitotech_1 = true
          }
          const isHitotech_2addressArray = ['愛知県', '石川県', '新潟県', '福井県', '山口県', '岡山県', '広島県', '香川県', '愛媛県', '高知県', '富山県', '長野県', '鳥取県', '島根県', '徳島県']
          if (formatData.gradeYear == 25) {
            if (this.addressCheck(basicData, isHitotech_2addressArray)) {
              isHitotech_2 = true
            }
          }

          const isHitotech_3addressArray = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '山梨県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県']
          if (formatData.gradeYear == 25) {
            if (this.addressCheck(basicData, isHitotech_3addressArray)) {
              isHitotech_3 = true
            }
          }
          if (!formatData.gradeYear) {
            isHitotech_4 = true
          }

          const rozas1addressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '茨城県', '群馬県', '栃木県']
          const rozas1KeywordArray = ['看護師']
          const rozas1NotKeywordArray = ['動物看護', '助手']
          if (this.addressCheck(basicData, rozas1addressArray)) {
            if (basicData.age >= 22 && basicData.age <= 55) {
              console.error(formatData)
              if (this.keywordCheckRirekisho(formatData, rozas1KeywordArray)) {
                isRozas_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, rozas1NotKeywordArray)) {
                isRozas_1 = false
              }
            }
          }
          const isRozas_2KeywordArray = ['医療事務', '調剤事務', '外来クラーク', '病棟クラーク', 'レセプト業務', 'メディカルクラーク', '診療報酬請求事務能力認定試験', '医事オペレータ技能認定試験']
          const isRozas_2AddressArray = ['広島県', '熊本県', '東京都', '神奈川県', '千葉県', '埼玉県', '群馬県', '栃木県', '茨城県', '大阪府', '兵庫県', '静岡県', '岐阜県', '宮崎県', '福岡県']
          const rozas2NotKeywordArray = ['ホテル']
          if (this.addressCheck(basicData, isRozas_2AddressArray)) {
            if (basicData.age >= 22 && basicData.age <= 55) {
              if (this.keywordCheckRirekisho(formatData, isRozas_2KeywordArray)) {
                isRozas_2 = true
              }
              if (this.keywordCheckRirekisho(formatData, rozas2NotKeywordArray)) {
                isRozas_2 = false
              }
            }
          }
          const isRozas_3KeywordArray = ['診療放射線技師']
          const isRozas_3AddressArray = ['東京', '神奈川', '千葉', '埼玉', '、大阪', '兵庫', '愛知']
          if (this.addressCheck(basicData, isRozas_3AddressArray)) {
            if (basicData.age >= 22 && basicData.age <= 50) {
              if (this.keywordCheckRirekisho(formatData, isRozas_3KeywordArray)) {
                isRozas_3 = true
              }
            }
          }
          const isRozas_4KeywordArray = ['1級自動車整備士', '2級自動車整備士', '3級自動車整備士', '一級自動車整備士', '二級自動車整備士', '三級自動車整備士']
          const isRozas_4AddressArray = ['']
          if (true) {
            if (basicData.age >= 22 && basicData.age <= 50) {
              if (this.keywordCheckRirekisho(formatData, isRozas_4KeywordArray)) {
                isRozas_4 = true
              }
            }
          }
          const isRozas_5KeywordArray = ['看護助手', 'メディカルケアワーカー', '介護職員初任者研修']
          const isRozas_5AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '群馬県', '栃木県', '茨城県', '愛知県', '静岡県', '大阪府', '兵庫県']
          const rozas5NotKeywordArray = ['スクール']
          if (this.addressCheck(basicData, isRozas_5AddressArray)) {
            if (basicData.age >= 22 && basicData.age <= 55) {
              if (this.keywordCheckRirekisho(formatData, isRozas_5KeywordArray)) {
                isRozas_5 = true
              }
              if (this.keywordCheckRirekisho(formatData, rozas5NotKeywordArray)) {
                isRozas_5 = false
              }
            }
          }

          const dely1addressArray = ['東京都']
          const dely1KeywordArray = ['免許']
          const dely1NotInKeywordArray = ['週1', '週2', '週3', '週4']
          if (this.addressCheck(basicData, dely1addressArray)) {
            if (basicData.age >= 22 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, dely1NotInKeywordArray)) {
                isDely_1 = false
              } else if (this.keywordCheckRirekisho(formatData, dely1KeywordArray)) {
                isDely_1 = true
              }
            }
          }

          const workport1addressArray = ['佐賀県', '長崎県', '大分県', '熊本県', '宮崎県', '鹿児島県', '沖縄県', '広島県', '岡山県', '島根県', '鳥取県', '山口県', '香川県', '愛媛県', '高知県', '徳島県', '青森県', '秋田県', '岩手県', '山形県', '宮城県', '福県島', '石川県', '富山県', '福井県', '新潟県', '長野県']
          const workport1NotAddressArray = ['仙台市', '新潟市', '広島市', '岡山市', '熊本市']
          const workport1KeywordArray = ['エンジニア']
          if (this.addressCheck(basicData, workport1addressArray)) {
            if (this.addressCheck(basicData, workport1NotAddressArray)) {
              // なし
            } else {
              if (basicData.age >= 20 && basicData.age <= 45) {
                if (this.keywordCheckRirekisho(formatData, workport1KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, workport1KeywordArray)) {
                  isWorkport_1 = true
                }
              }
            }
          }
          const workport4addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府', '兵庫県', '京都府', '奈良県', '滋賀県', '和歌山県', '愛知県', '福岡県', '静岡県', '岐阜県', '北海道', '宮城県', '新潟県', '岡山県', '広島県', '熊本県']
          const workport4KeywordArray = ['エンジニア']
          if (true) {
            if (basicData.age >= 20 && basicData.age <= 45) {
              if (this.keywordCheckRirekisho(formatData, workport4KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, workport4KeywordArray)) {
                isWorkport_4 = true
              }
            }
          }
          const workport2addressArray = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県']
          const workport2KeywordArray = ['経理']
          if (this.addressCheck(basicData, workport2addressArray)) {
            if (basicData.age >= 23 && basicData.age <= 42) {
              if (this.keywordCheckRirekisho(formatData, workport2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, workport2KeywordArray)) {
                isWorkport_2 = true
              }
            }
          }
          const workport3KeywordArray = ['営業']
          if (this.addressCheck(basicData, workport2addressArray)) {
            if (basicData.age >= 23 && basicData.age <= 42) {
              if (this.keywordCheckRirekisho(formatData, workport3KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, workport3KeywordArray)) {
                isWorkport_3 = true
              }
            }
          }

          const isCri_1KeywordArray = ['ライセンス', 'A&R', 'premiere pro', 'After Effects', '制作進行', 'ポストプロダクション', 'ショート動画', 'SNS動画', 'VTube', '動画制作', 'SNS広告', 'SNSマーケ', 'Instagram', 'YouTube', 'TikTok', '動画編集', 'キャラクター', 'グッズデザイン', 'メディアミックス', '商品企画', '配信', 'アニメ', '映画', 'タレントマネジメント', 'Webデザイン', 'UIデザイン', 'UXデザイン', 'UIUXデザイン', 'BXデザイン', 'プロダクトデザイン', 'コミュニケーションデザイン', 'アートディレクション', 'Figma', 'photoshop', 'illustrator', 'Sketch', 'AdobeXD', 'UIUX']
          const isCri_1AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '茨城県']
          const isCri_NotKeywordArray = ['在庫管理', 'レジ業務', '販売員', '施工管理', 'CAD', 'パース', '内装', 'レジ打ち', '販売接客', '電話対応', 'クレーム対応', '備品発注', 'データ入力', 'POP', '臨床心理士', 'ウェイトレス', '営業', '営業事務', 'インストラクター', '軽作業スタッフ', '家電量販店', '清掃', '検品', 'ゲーム', '店舗マネージャー', 'コスメ', 'ドラッグストア', '財務', '管理栄養士', '個人事業主', '賃貸マンション', '保育士', '教師', '声優', '倉庫', '司法書士', 'Canva', 'レジ', 'レジ閉め', '品出し', 'イベントコンパニオン', 'ライター', '執筆', '空間デザイン', '現場管理', '図面製作', '家具製作', '日本語検定', '時短', '日本語能力', 'BGM', 'SE', 'ボイス', 'サウンドディレクション', '配送業務', '職業訓練校', 'プラント', '契約社員', '派遣社員', 'ネイリスト', 'ファッションデザイン', '接客']
          if (this.addressCheck(basicData, isCri_1AddressArray)) {
            if (basicData.age >= 25 && basicData.age <= 39) {
              if (this.keywordCheckShokumukeirekisho(formatData, isCri_1KeywordArray)) {
                isCri_1 = true
              }
              if (this.keywordCheckShokumukeirekisho(formatData, isCri_NotKeywordArray)) {
                isCri_1 = false
              }
            }
          }

          const isLetsi_1AddressArray = ['東京都', '神奈川県', '大阪府', '京都県', '兵庫県']
          const isLetsi_1KeywordArray = ['Webデザイナー', 'Webディレクター', 'コーダー', 'グラフィックデザイナー', 'グラフィックデザイン', 'DTP', 'パッケージデザイン', 'アートディレクション', 'Webデザイン', 'Web制作', 'コーディング', 'Webディレクション', 'LP制作', 'InDesign']
          const isLetsi_1NotKeywordArray = ['日本語検定', '日本語能力検定', '日本語能力試験']
          if (this.addressCheck(basicData, isLetsi_1AddressArray)) {
            if (basicData.age >= 22 && basicData.age <= 55) {
              if (this.LegacyKeywordCheckRirekisho(formatData, isLetsi_1KeywordArray) ||
                this.LegacyKeywordCheckShokumukeirekisho(formatData, isLetsi_1KeywordArray)) {
                isLetsi_1 = true
              }

              if (this.LegacyKeywordCheckRirekisho(formatData, isLetsi_1NotKeywordArray) ||
                this.LegacyKeywordCheckShokumukeirekisho(formatData, isLetsi_1NotKeywordArray)) {
                isLetsi_1 = false
              }
            }
          }

          const loginess1addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '静岡県']
          const loginess1KeywordArray = ['トラックドライバー', '長距離トラック', '長距離輸送', '大型免許', '準中型免許', '中型免許', 'フォークリフト']

          const agrinavi1addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府', '京都府', '兵庫県', '和歌山県', '奈良県', '京都県', '滋賀県', '愛知県', '福岡県', '岐阜県', '静岡県']
          const agrinavi1KeywordArray = ['農業']
          if (this.addressCheck(basicData, agrinavi1addressArray)) {
            if (basicData.age >= 20 && basicData.age <= 34) {
              if (this.keywordCheckRirekisho(formatData, agrinavi1KeywordArray)) {
                isAgrinavi_1 = true
              }
            }
          }

          const techouse1addressArray = ['愛知県', '栃木県']
          const techouse1KeywordArray = ['工場', '製造', '期間工', '溶接', 'フォークリフト']
          if (this.addressCheck(basicData, techouse1addressArray)) {
            if (basicData.age >= 20 && basicData.age <= 45) {
              if (this.keywordCheckRirekisho(formatData, techouse1KeywordArray)) {
                isTechouse_1 = true
              }
            }
          } else {
            if (basicData.age >= 20 && basicData.age <= 45) {
              if (this.keywordCheckRirekisho(formatData, techouse1KeywordArray)) {
                isTechouse_2 = true
              }
            }
          }

          const techouse3addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '愛知県', '大阪府']
          const techouse3KeywordArray = ['運輸', '運送', '物流', '配送', 'ドライバー', 'トラックドライバー', '長距離トラック', '長距離輸送', '大型免許', '準中型免許', '中型免許', '軽貨物']
          if (this.addressCheck(basicData, techouse3addressArray)) {
            if (basicData.age >= 20 && basicData.age <= 59) {
              if (this.keywordCheckRirekisho(formatData, techouse3KeywordArray)) {
                isTechouse_3 = true
              }
            }
          }

          const isOutsourcing_1addressArray = ['兵庫県', '滋賀県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '神奈川県', '福岡県', '大分県', '静岡県', '北海道', '愛知県', '三重県']
          const isOutsourcing_1Array = ['日総工産株式会社', '日研トータルソーシング株式会社', 'UTエイム株式会社', 'Man to Man株式会社', '日総工産', '日研トータルソーシング', 'UTエイム', 'Man to Man']
          const isOutsourcing_1NotKeyArray = ['製菓']
          // if (this.addressCheck(basicData, isOutsourcing_1addressArray)) {
          if (true) {
            if (basicData.age >= 30 && basicData.age <= 44) {
              if (this.keywordCheckRirekisho(formatData, isOutsourcing_1Array) ||
                this.keywordCheckShokumukeirekisho(formatData, isOutsourcing_1Array)) {
                isOutsourcing_1 = true
              }
              // if (this.keywordCheckRirekisho(formatData, isOutsourcing_1NotKeyArray)
              //   || this.keywordCheckShokumukeirekisho(formatData, isOutsourcing_1NotKeyArray)) {
              //   isOutsourcing_1 = false
              // }
            }
          }

          // let isHitolabo_1AddressArray = ['東京都', '神奈川県', '埼玉県', '大阪府', '京都府', '兵庫県']
          const isHitolabo_1AddressArray = ['東京都', '神奈川県']
          const isHitolabo_1KeywordArray = ['調理師']
          if (this.addressCheck(basicData, isHitolabo_1AddressArray)) {
            if (basicData.age >= 21 && basicData.age <= 53) {
              if (this.keywordCheckRirekisho(formatData, isHitolabo_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isHitolabo_1KeywordArray)) {
                isHitolabo_1 = true
              }
            }
          }
          // let isHitolabo_2AddressArray = ['東京都', '神奈川県', '埼玉県', '大阪府', '京都府', '兵庫県']
          const isHitolabo_2AddressArray = ['東京都', '神奈川県']
          const isHitolabo_2KeywordArray = ['栄養士']
          if (this.addressCheck(basicData, isHitolabo_2AddressArray)) {
            if (basicData.age >= 21 && basicData.age <= 53) {
              if (this.keywordCheckRirekisho(formatData, isHitolabo_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isHitolabo_2KeywordArray)) {
                isHitolabo_2 = true
              }
            }
          }

          const isCookbiz_1NotaddressArray = ['東京都', '愛知県', '大阪府']
          const isCookbiz_1KeywordArray = ['調理師', '料理人', '板前', 'シェフ', '食品衛生責任者', 'レストランサービス技能士', '料理長', '支配人', 'ソムリエ', 'バーテンダー']
          if (false) {
            // 除外
          } else {
            if (basicData.age >= 20 && basicData.age <= 45) {
              if (this.keywordCheckRirekisho(formatData, isCookbiz_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isCookbiz_1KeywordArray)) {
                isCookbiz_1 = true
              }
            }
          }
          const isCookbiz_2NotaddressArray = ['東京都', '愛知県', '大阪府']
          const isCookbiz_2KeywordArray = ['飲食', '接客']
          if (this.addressCheck(basicData, isCookbiz_2NotaddressArray)) {
            // 除外
          } else {
            if (basicData.age >= 20 && basicData.age <= 35) {
              if (this.keywordCheckRirekisho(formatData, isCookbiz_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isCookbiz_2KeywordArray)) {
                isCookbiz_2 = true
              }
            }
          }
          const isCookbiz_3NotaddressArray = ['東京都', '愛知県', '大阪府']
          const isCookbiz_3KeywordArray = ['飲食', '接客']
          if (false) {
            // 除外
          } else {
            isCookbiz_3 = true
          }

          const isFoodison_1AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '京都府', '大阪府', '兵庫県', '愛知県']
          const isFoodison_1KeywordArray = ['調理師', '大庄', 'トリドール', 'ワタミ', '木曽路', '物語コーポレーション', 'ペッパーフードサービス', 'ヨシックス', 'ゼンショー', 'ワイズテーブル', 'モンテローザ']
          const isFoodison_1NotKeywordArray = ['中華', '接客', '集団調理', 'カフェ']
          if (this.addressCheck(basicData, isFoodison_1AddressArray)) {
            if (basicData.age >= 23 && basicData.age <= 50) {
              if (this.keywordCheckRirekisho(formatData, isFoodison_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isFoodison_1KeywordArray)) {
                isFoodison_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isFoodison_1NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isFoodison_1NotKeywordArray)) {
                isFoodison_1 = false
              }
            }
          }

          const isFoodison_2AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '京都府', '大阪府', '兵庫県']
          const isFoodison_2KeywordArray = ['スーパー']
          const isFoodison_2NotKeywordArray = ['スーパーバイザー', '接客', '集団調理']
          if (this.addressCheck(basicData, isFoodison_2AddressArray)) {
            if (basicData.age >= 28 && basicData.age <= 50) {
              if (this.keywordCheckRirekisho(formatData, isFoodison_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isFoodison_2KeywordArray)) {
                isFoodison_2 = true
              }
              if (this.keywordCheckRirekisho(formatData, isFoodison_2NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isFoodison_2NotKeywordArray)) {
                isFoodison_2 = false
              }
            }
          }

          const isFoodison_3NotAddressArray = ['北海道']
          const isFoodison_3KeywordArray = ['鮮魚部門', '精肉部門', '鮮魚加工', '精肉加工', '魚売場', '魚屋']
          const isFoodison_3NotKeywordArray = ['接客', '集団調理']
          if (this.addressCheck(basicData, isFoodison_3NotAddressArray)) {
            // なし
          } else {
            if (basicData.age >= 28 && basicData.age <= 50) {
              if (this.keywordCheckRirekisho(formatData, isFoodison_3KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isFoodison_3KeywordArray)) {
                isFoodison_3 = true
              }
              // if (this.keywordCheckRirekisho(formatData, isFoodison_2NotKeywordArray)
              //   || this.keywordCheckShokumukeirekisho(formatData, isFoodison_2NotKeywordArray)) {
              //   isFoodison_2 = false
              // }
            }
          }

          const isOishiru_1KeywordArray = ['スーパーマーケット', '鮮魚部', '精肉部', '畜産部', '青果部', '農産部', '惣菜部', '総菜部', '鮮魚加工', '精肉加工', '魚売場', '魚売り場', '水産売場', '水産売り場', '魚屋', '精肉売場', '精肉売り場', '鮮魚店', '鮮魚専門店', '精肉店', '精肉専門店', '株式会社魚力', '株式会社魚喜', '角上魚類', '株式会社山助', '北辰水産', '北海道北辰', '東海北辰', '仙冷平庄', '鈴木水産', '株式会社NFT', 'タカマル鮮魚店', '旬フーズシステム', '魚太郎', '魚錠', '鮮魚丸忠', '髭定', '大起水産', '鮮魚たかぎ', '株式会社西浅', '最上鮮魚', 'ミートテラバヤシ', 'タカギフーズ', '株式会社天池', '伊藤ハムフードソリューション', '大三ミート産業', 'オーエムツーミート', 'オーエムツーネットワーク', '株式会社九州屋', '旬八青果', 'スーパーバリュー', '株式会社ロピア', 'イトーヨーカ堂', '業務スーパー', '食品スーパー', '食品館', 'イオンリテール', '水産部門', 'いかりスーパーマーケット', '株式会社オオゼキ', 'アブアブ赤札堂', 'ベンガベンガ', 'スーパー三和', 'おっ母さん']
          const isOishiru_1NotKeywordArray = ['イトーヨーカ堂へ', 'イトーヨーカ堂に', 'イトーヨーカ堂と', 'イトーヨーカ堂を', 'バックヤードの']
          const isOishiru_1AddressArray = ['北海道', '宮城県', '東京都', '神奈川県', '千葉県', '埼玉県', '愛知県', '大阪府', '兵庫県', '福岡県', '沖縄県']
          if (this.addressCheck(basicData, isOishiru_1AddressArray)) {
            if (basicData.age >= 23 && basicData.age <= 55) {
              if (this.keywordCheckRirekisho(formatData, isOishiru_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isOishiru_1KeywordArray)) {
                isOishiru_1 = true
              }
            }
            if (this.keywordCheckRirekisho(formatData, isOishiru_1NotKeywordArray) ||
              this.keywordCheckShokumukeirekisho(formatData, isOishiru_1NotKeywordArray)) {
              isOishiru_1 = false
            }
          }

          const isHayfield_1KeywordArray = ['建設', '建築', '土木', '電気工事', '管工事', '工務店']
          const isHayfield_1AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '北海道', '愛知県', '大阪府', '兵庫県', '福岡県', '静岡県']

          if (this.addressCheck(basicData, isHayfield_1AddressArray)) {
            if (basicData.age >= 22 && basicData.age <= 43) {
              if (this.keywordCheckRirekisho(formatData, isHayfield_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isHayfield_1KeywordArray)) {
                isHayfield_1 = true
              }
            }
          }

          const isItk_1KeywordArray = ['キッチン', '飲食', 'ホールスタッフ', 'スーシェフ', '副料理長', '調理師免許', '食品衛生責任者', 'ふぐ調理師', 'ソムリエ', '焼肉', '焼鳥', '居酒屋', 'ラーメン', '鮨', '寿司', '日本料理', 'ステーキ', 'レストラン', 'ダイニング', 'ベーカリー', 'パン製造', '製パン', '調理師専門学校', 'エコール辻']
          const isItk_1AddressArray = ['東京都', '神奈川県']
          if (this.addressCheck(basicData, isItk_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 35) {
              if (this.keywordCheckRirekisho(formatData, isItk_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isItk_1KeywordArray)) {
                isItk_1 = true
              }
            }
          }

          const isPrimalwork_1addressArray = ['東京都', '神奈川県', '埼玉県', '大阪府']
          const isPrimalwork_1NotArray = ['N1', 'N2', 'N3', 'N4', 'N5', '日本語能力試験', 'JLPT']
          if (this.addressCheck(basicData, isPrimalwork_1addressArray)) {
            if (basicData.age >= 23 && basicData.age <= 25) {
              isPrimalwork_1 = true
              if (this.keywordCheckRirekisho(formatData, isPrimalwork_1NotArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isPrimalwork_1NotArray)) {
                isPrimalwork_1 = false
              }
            }
          }

          const isNsjapan_1KeywordArray = ['営業']
          const isNsjapan_1AddressArray = ['東京都']
          if (this.addressCheck(basicData, isNsjapan_1AddressArray)) {
            if (basicData.age >= 18 && basicData.age <= 34) {
              if (this.keywordCheckRirekisho(formatData, isNsjapan_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isNsjapan_1KeywordArray)) {
                isNsjapan_1 = true
              }
            }
          }

          const isTalentnavi_1addressArray = ['東京都']
          // let isTalentnavi_1addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          const isTalentnavi_1Array = ['販売', 'コミュニケーション能力']
          if (this.addressCheck(basicData, isTalentnavi_1addressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isTalentnavi_1Array) ||
                this.keywordCheckShokumukeirekisho(formatData, isTalentnavi_1Array)) {
                isTalentnavi_1 = true
              }
            }
          }

          const azurite_mail_1addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          const azurite_mail_1KeywordArray = ['宅地建物取引士']
          if (this.addressCheck(basicData, azurite_mail_1addressArray)) {
            if (basicData.age >= 20 && basicData.age <= 55) {
              if (this.keywordCheckRirekisho(formatData, azurite_mail_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, azurite_mail_1KeywordArray)) {
                isAzurite_1 = true
              }
            }
          }
          const azurite_mail_2addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          const azurite_mail_2KeywordArray = ['東宝ハウス', '住友不動産ステップ', '東急リバブル', 'オープンハウス', '積水ハウス不動産ホールディングス', 'ケイアイスター不動産', 'アイダ設計', '三井不動産リアルティ', '三井のリハウス', '住友不動産販売', '東急リバブル', '野村不動産ソリューションズ', '大京穴吹不動産', '三菱地所ハウスネット', '小田急不動産', '京王不動産', '近鉄不動産', '三井ホーム不動産', 'センチュリー21・ジャパン', 'センチュリー21', 'ハウスドゥ', 'And Doホールディングス', 'イエステーション', 'ERA', 'LIXIL不動産ショップ', 'みずほ不動産販売', '三井住友トラスト不動産', '大成有楽不動産販売', '大和ハウスリアルエステート', '積水ハウス不動産東京', '積水化学工業', 'セキスイハイム不動産', 'オークラヤ住宅', '明和地所', 'リビングライフ', '城南建設', '住宅情報館', '日商エステム', '株式会社東宝ハウスグループ', '株式会社アドキャスト', '株式会社リアル', '株式会社プレシャスライフ', '株式会社アーバンホーム', '株式会社ベストセレクト', '株式会社藤和ハウス', '株式会社クラシア', '株式会社ハウジングスカイ', '株式会社ケーコーポレーション', '株式会社マイタウン', '株式会社マックホーム', '株式会社エステート白馬', '株式会社ホームプラザ', '株式会社サンシティホーム', '株式会社アイデアル', '株式会社S-FIT', '株式会社アシスト', '株式会社アンビション・エージェンシー', '株式会社クレアスレント', '株式会社シマダハウス', '株式会社ユーミーネット', '株式会社リブマックス', '株式会社誠興業', '株式会社エムズ', '株式会社アーバン21', '株式会社エステートトーワ', '株式会社タウン住宅販売', '株式会社ベストホーム', '株式会社ゼロメンテナンス', '株式会社エイムプレイス', '株式会社ハウスメイトショップ', '株式会社フォーラス＆カンパニー', '株式会社フォーラス&カンパニー', '株式会社アクシス・ジャパン', '株式会社リズム']
          if (this.addressCheck(basicData, azurite_mail_2addressArray)) {
            if (basicData.age >= 20 && basicData.age <= 28) {
              if (this.keywordCheckRirekisho(formatData, azurite_mail_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, azurite_mail_2KeywordArray)) {
                isAzurite_2 = true
              }
            }
          }

          const isProlg_1KeywordArray = ['ブライダル', '中古車']
          const isProlg_1AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          if (this.addressCheck(basicData, isProlg_1AddressArray)) {
            if (basicData.age >= 24 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isProlg_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isProlg_1KeywordArray)) {
                isProlg_1 = true
              }
            }
          }

          const isProlg_2KeywordArray = ['不動産', '塾']
          const isProlg_2AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          if (this.addressCheck(basicData, isProlg_2AddressArray)) {
            if (basicData.age >= 24 && basicData.age <= 27) {
              if (this.keywordCheckRirekisho(formatData, isProlg_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isProlg_2KeywordArray)) {
                isProlg_2 = true
              }
            }
          }

          const isSmartforce_1KeywordArray = ['接客', '販売', '向上', '営業', '正社員', 'バイトリーダー', 'テレアポ', 'セールス', '明るい', '元気', 'コミュニケーション能力', '成長', '挑戦', '未経験']
          const isSmartforce_1AddressArray = ['東京都']
          const isSmartforce_1NotKeywordArray = ['N1', 'N2', 'N3', 'N4', 'N5', '日本語能力試験', 'JLPT', '卒業見込み', '週1', '週2', '週3', '週4', '副業', '病気治療', '見込み', '在学中', 'ペット', '動物', '医療法人', '子ども', '子供', '子育て', '出勤日数', 'ファッション', 'ダブルワーク', '週１', '週２', '週３', '週４', '美容師', '病院', '卒業見込', 'ダンス', '持病', '勤務曜日', '月曜', '火曜', '水曜', '木曜', '金曜', '土曜', '日曜', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日', '日曜日', '勤務希望時間', '妊婦', 'Wワーク', '歯科助手']
          if (this.addressCheck(basicData, isSmartforce_1AddressArray)) {
            if (basicData.age >= 25 && basicData.age <= 29) {
              isSmartforce_1 = true
              if (this.keywordCheckRirekisho(formatData, isSmartforce_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isSmartforce_1KeywordArray)) {
                isSmartforce_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isSmartforce_1NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isSmartforce_1NotKeywordArray)) {
                isSmartforce_1 = false
              }
            }
          }

          const isStartme_1KeywordArray = ['']
          const isStartme_1AddressArray = ['東京都']
          if (this.addressCheck(basicData, isStartme_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              isStartme_1 = true
            }
          }
          const isStartme_2KeywordArray = ['']
          const isStartme_2AddressArray = ['東京都']
          if (this.addressCheck(basicData, isStartme_2AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              isStartme_2 = true
            }
          }

          // let isAgent3_1KeywordArray = ['営業', '販売', '接客']
          const isAgent3_1AddressArray = ['埼玉県']
          const isAgent3_1NotKeywordArray = ['在学中', '卒業見込み', '営業', '販売', '事務', '配送', 'ドライバー', '清掃', '警備', '日本語検定', 'N1', 'N2', 'N3', '未経験', '挑戦', '志望', '従事', 'エンジニア', 'IT', 'web', 'デザイナー']
          if (this.addressCheck(basicData, isAgent3_1AddressArray)) {
            if (basicData.age >= 23 && basicData.age <= 29) {
              // if (formatId == "shokumukeirekisho"
              //   || formatId == "rirekisho_job_change") {
              //   isAgent3_1 = true
              // }

              if (this.keywordCheckRirekisho(formatData, isAgent3_1NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isAgent3_1NotKeywordArray)) {
                isAgent3_1 = false
              }
            }
          }

          // let kiminara_mail_1addressArray = ['東京都', '埼玉県', '千葉県', '神奈川県', '大阪府']
          const kiminara_mail_1addressArray = ['東京都', '埼玉県', '千葉県', '神奈川県', '大阪府']
          const kiminara_mail_1NotKeywordArray = ['看護師', '保育士', '栄養士', '施工管理', '自動車整備士', '電気主任技術者', '介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          if (this.addressCheck(basicData, kiminara_mail_1addressArray)) {
            if (basicData.age >= 24 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, kiminara_mail_1NotKeywordArray)) {
                isKiminara_1 = false
                isKiminara_2 = false
              } else {
                isKiminara_1 = true
                isKiminara_2 = true
              }
            }
          }
          const kiminara_mail_3addressArray = ['東京都', '埼玉県', '千葉県', '神奈川県', '大阪府']
          const kiminara_mail_3NotKeywordArray = ['看護師', '保育士', '栄養士', '施工管理', '自動車整備士', '電気主任技術者', '介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          if (this.addressCheck(basicData, kiminara_mail_3addressArray)) {
            if (basicData.age >= 22 && basicData.age <= 25) {
              isKiminara_3 = true
              if (this.keywordCheckRirekisho(formatData, kiminara_mail_3NotKeywordArray)) {
                isKiminara_3 = false
              }
            }
          }
          const kiminara_mail_4addressArray = ['東京都', '埼玉県', '千葉県', '神奈川県', '大阪府']
          const kiminara_mail_4NotKeywordArray = ['看護師', '保育士', '栄養士', '施工管理', '自動車整備士', '電気主任技術者', '介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          if (this.addressCheck(basicData, kiminara_mail_4addressArray)) {
            if (basicData.age >= 22 && basicData.age <= 25) {
              isKiminara_4 = true
              if (this.keywordCheckRirekisho(formatData, kiminara_mail_4NotKeywordArray)) {
                isKiminara_4 = false
              }
            }
          }

          const isCloudlink_3keywordArray = ['営業']
          const isCloudlink_3NotkeywordArray = ['アルバイト']
          const isCloudlink_3AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '愛知県', '大阪府', '兵庫県', '京都府', '福岡県']

          if (this.addressCheck(basicData, isCloudlink_3AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isCloudlink_3keywordArray) ||
              this.keywordCheckShokumukeirekisho(formatData, isCloudlink_3keywordArray)) {
              if (basicData.age >= 24 && basicData.age <= 27) {
                isCloudlink_3 = true
              }
            }
            if (this.keywordCheckRirekisho(formatData, isCloudlink_3NotkeywordArray) ||
              this.keywordCheckShokumukeirekisho(formatData, isCloudlink_3NotkeywordArray)) {
              isCloudlink_3 = false
            }
          }

          const isBearsnavi_1KeywordArray = ['主体性', 'コミュニケーション能力', '協調性', '自発的', '積極的']
          const isBearsnavi_1NotKeywordArray = ['日本語能力検定', '在留資格', '技術・人文知識・国際業務', '人文知識', '国際業務', 'JLPT', '通訳', '在日', '日本語能力', '日本語スキル', '製造', '接客', '販売', '営業', '看護', '柔道整復師', 'ピアノ', '調律', '講師', 'マッサージ', 'サロン', '芸術', 'レッスン', '接骨院', '医科', '医学', '歯科', '歯学', '声優', '俳優', '芸能']
          const isBearsnavi_1AddressArray = ['東京都', '大阪府']
          if (this.addressCheck(basicData, isBearsnavi_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isBearsnavi_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isBearsnavi_1KeywordArray)) {
                isBearsnavi_1 = true
              }
            }
            if (this.keywordCheckRirekisho(formatData, isBearsnavi_1NotKeywordArray) ||
              this.keywordCheckShokumukeirekisho(formatData, isBearsnavi_1NotKeywordArray)) {
              isBearsnavi_1 = false
            }
          }

          const isBearsnavi_2KeywordArray = ['向上心']
          const isBearsnavi_2NotKeywordArray = ['日本語能力検定', '在留資格', '技術・人文知識・国際業務', '人文知識', '国際業務', 'JLPT', '通訳', '在日', '日本語能力', '日本語スキル', '製造', '接客', '販売', '営業', '看護', '柔道整復師', 'ピアノ', '調律', '講師', 'マッサージ', 'サロン', '芸術', 'レッスン', '接骨院', '医科', '医学', '歯科', '歯学', '声優', '俳優', '芸能']
          const isBearsnavi_2AddressArray = ['東京都']
          if (this.addressCheck(basicData, isBearsnavi_2AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 20) {
              if (this.keywordCheckRirekisho(formatData, isBearsnavi_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isBearsnavi_2KeywordArray)) {
                isBearsnavi_2 = true
              }
            }
            if (this.keywordCheckRirekisho(formatData, isBearsnavi_2NotKeywordArray) ||
              this.keywordCheckShokumukeirekisho(formatData, isBearsnavi_2NotKeywordArray)) {
              isBearsnavi_2 = false
            }
          }
          const isBearsnavi_3KeywordArray = ['体力', '向上', 'やる気']
          const isBearsnavi_3NotKeywordArray = ['日本語能力検定', '在留資格', '技術・人文知識・国際業務', '人文知識', '国際業務', 'JLPT', '通訳', '在日', '日本語能力', '日本語スキル', '製造', '接客', '販売', '営業', '看護', '柔道整復師', 'ピアノ', '調律', '講師', 'マッサージ', 'サロン', '芸術', 'レッスン', '接骨院', '医科', '医学', '歯科', '歯学', '声優', '俳優', '芸能']
          const isBearsnavi_3AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府']
          if (this.addressCheck(basicData, isBearsnavi_3AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isBearsnavi_3KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isBearsnavi_3KeywordArray)) {
                isBearsnavi_3 = true
              }
            }
            if (this.keywordCheckRirekisho(formatData, isBearsnavi_3NotKeywordArray) ||
              this.keywordCheckShokumukeirekisho(formatData, isBearsnavi_3NotKeywordArray)) {
              isBearsnavi_3 = false
            }
          }

          const isStrike_1addressArray = ['東京都', '埼玉県', '千葉県', '神奈川県', '愛知県', '大阪府', '兵庫県', '京都府']
          if (this.addressCheck(basicData, isStrike_1addressArray)) {
            if (basicData.age >= 23 && basicData.age <= 35) {
              isStrike_1 = true
            }
          }

          const isInternous_1KeywordArray = ['接客', '販売']
          const isInternous_1AddressArray = ['茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県']
          if (this.addressCheck(basicData, isInternous_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 30) {
              if (this.keywordCheckRirekisho(formatData, isInternous_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isInternous_1KeywordArray)) {
                isInternous_1 = true
              }
            }
          }

          const isInternous_2KeywordArray = ['事務']
          const isInternous_2AddressArray = ['茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県']
          if (this.addressCheck(basicData, isInternous_2AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 30) {
              if (this.keywordCheckRirekisho(formatData, isInternous_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isInternous_2KeywordArray)) {
                isInternous_2 = true
              }
            }
          }

          const isInternous_3KeywordArray = ['製造']
          const isInternous_3AddressArray = ['茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県']
          if (this.addressCheck(basicData, isInternous_3AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 30) {
              if (this.keywordCheckRirekisho(formatData, isInternous_3KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isInternous_3KeywordArray)) {
                isInternous_3 = true
              }
            }
          }

          const isInternous_4KeywordArray = ['IT', 'WEB', 'web', 'Web']
          const isInternous_4AddressArray = ['茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県']
          if (this.addressCheck(basicData, isInternous_4AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 30) {
              if (this.keywordCheckRirekisho(formatData, isInternous_4KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isInternous_4KeywordArray)) {
                isInternous_4 = true
              }
            }
          }

          const isInternous_5KeywordArray = ['']
          const isInternous_5AddressArray = ['茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県']
          if (this.addressCheck(basicData, isInternous_5AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 30) {
              if (true) {
                isInternous_5 = true
              }
            }
          }

          const isBriedge_1addressArray = ['東京都', '神奈川県', '埼玉県', '千葉県']
          const isBriedge_1KeywordArray = ['営業']
          if (this.addressCheck(basicData, isBriedge_1addressArray)) {
            if (basicData.age >= 20 && basicData.age <= 25) {
              if (this.keywordCheckRirekisho(formatData, isBriedge_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isBriedge_1KeywordArray)) {
                isBriedge_1 = true
              }
            }
          }

          const is400f1addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '愛知県', '大阪府', '福岡県']
          const is400f1KeywordArray = ['事務', '営業']
          if (this.addressCheck(basicData, is400f1addressArray)) {
            if (basicData.age >= 23 && basicData.age <= 34) {
              if (this.keywordCheckRirekisho(formatData, is400f1KeywordArray)) {
                is400F_1 = true
              }
            }
          }

          const usenworking1addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府']
          const usenworking1KeywordArray = ['飲食', '調理', '厨房', 'キッチン', 'ホール', '店舗', '料理長', '接客', 'SV', '店舗開発']
          // let usenworking1NotKeywordArray = ['週１', '週２', '週３', '週４', '週1', '週2', '週3', '週4', 'パート希望', 'アルバイト希望', '時短']
          const usenworking1NotKeywordArray = ['週１', '週２', '週３', '週４', '週1', '週2', '週3', '週4', 'パート希望', 'アルバイト希望', '時短', '事務', '業務委託']
          if (this.addressCheck(basicData, usenworking1addressArray)) {
            if (this.keywordCheckRirekisho(formatData, usenworking1NotKeywordArray)) {

            } else {
              if (this.keywordCheckRirekisho(formatData, usenworking1KeywordArray)) {
                if (basicData.age >= 27 && basicData.age <= 34) {
                  isUsenworking_1 = true
                } else if (basicData.age >= 35 && basicData.age <= 36) {
                  isUsenworking_2 = true
                }
              }
            }
          }
          const usenworking2addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府']
          const usenworking2KeywordArray = ['営業', 'セールス', 'カスタマーサクセス']
          if (this.addressCheck(basicData, usenworking2addressArray)) {
            if (this.keywordCheckRirekisho(formatData, usenworking2KeywordArray)) {
              if (basicData.age >= 27 && basicData.age <= 34) {
                isUsenworking_3 = true
              } else if (basicData.age >= 35 && basicData.age <= 36) {
                isUsenworking_4 = true
              }
            }
          }

          const recree2KeywordArray = ['施工監理', '施工管理']
          const recree2AddressArray = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県', '東京都', '千葉県', '神奈川県', '埼玉県']
          if (this.addressCheck(basicData, recree2AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 65) {
              if (this.keywordCheckRirekisho(formatData, recree2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, recree2KeywordArray)) {
                isRecree_2 = true
              }
            }
          }

          const recree345NotKeywordArray = ['IT', 'SE']
          const recree3AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '静岡県', '愛知県', '岐阜県', '大阪府', '京都府', '兵庫県', '奈良県', '和歌山県', '北海道', '広県島', '岡山県']
          // let recree3KeywordArray = ['現場監督', 'ゼネコン', '現場管理', '土木', '現場代理', 'ウィルオブ・コンストラクション', 'ワールドコーポレーション', 'アーキ・ジャパン', 'テクノプロ・コンストラクション', 'イーフラッグ', 'SUGUNI', 'コプロ・エンジニアード', '夢真', 'アクトエンジニアリング', 'スタッフ・アクティオ', 'UTコンストラクション', 'サイマリーディング', 'ハウスメーカー', 'RCCM', '意匠設計', '内装設計', '構造設計', '設備設計', '設計士', '工事', '改修工事', '修繕工事', '改築工事', '主任技術者', '管理技術者', '電験', '電気主任', '大規模修繕', '積算', 'サブコン', '電気工事士', '日建学院', 'RC造', 'SRC造', 'PC造', 'S造', '軽量鉄骨造', '木質フレーム構造', '地盤改良工事', 'プレキャストコンクリート工法', 'システム建築工法', 'トンネル工法', '地中構造物工法', '逆打ち工法', 'スリップフォーム工法', 'クライミングフォーム工法', 'トンネル工事', '河川工事', '上下水道工事', '海岸工事', '地滑り防止工事', '災害復旧工事', '地下構造物の建設', '工事監理', '専任技術者', 'コンストラクションマネジメント', '技術士', '概略設計', 'リフォーム工事', 'W造', '木造住宅', '戸建て住宅', 'マンション工事', 'ビル工事', '杭工事', '鋼構造物', '法面工事', '港湾工事', 'CADオペレーター', '建築CAD検定', '2次元CAD利用技術者', '3次元CAD利用技術者', 'CADデザインマスター', 'CADトレース技士', '共同エンジニアリング', 'JAGフィールド', 'イーフラッグ']
          // let recree3KeywordArray = ['共同エンジニアリング', 'JAGフィールド', '工事監理', '専任技術者', 'コンストラクションマネジメント', '管理技術者', '概略設計', 'リフォーム工事', 'W造', 'マンション工事', 'ビル工事', '杭工事', '鋼構造物', '法面工事', '港湾工事', '現場監督', '現場代理', 'ウィルオブ・コンストラクション', 'ワールドコーポレーション', 'テクノプロ・コンストラクション', 'イーフラッグ', 'SUGUNI', 'コプロ・エンジニアード', '夢真', 'アクトエンジニアリング', 'スタッフ・アクティオ', 'ＵＴコンストラクション', 'サイマリーディング', '意匠設計', '主任技術者', '監理技術者', 'RCCM', '内装設計', '構造設計', '設備設計', '設計士', '設計監理', '管工事', '改修工事', '修繕工事', '改築工事', '電験', '大規模修繕', '高松建設', 'ヤマギシリフォーム工業', 'カシワバラコーポレーション', 'メルディア', 'フクダアンドパートナーズ', '塩浜工業', 'ホークワン', '北野建設', '生和コーポレーション', '電気工事士', 'RC造', 'PC造', 'S造', '軽量鉄骨造', '木質フレーム構造', '地盤改良工事', 'プレキャストコンクリート工法', 'システム建築工法', 'ツーバイフォー工法', 'トンネル工法', '地中構造物工法', '逆打ち工法', 'スリップフォーム工法', 'クライミングフォーム工法', 'トンネル工事', '河川工事', '上下水道工事', '海岸工事', '地滑り防止工事', '災害復旧工事', '地下構造物の建設', '施工技士', '現場監理', '工事管理', '建築士', '現場所長', '現場主任', '工事主任', '建設コンサルタント', '建築コンサルタント', '建設マネジメント', 'トライトエンジニアリング', 'ウィルオブコンストラクション', 'コプロエンジニアード', 'テクノプロコンストラクション', 'UTコンストラクション', '設計管理', '土木設計', '建築設計', '工事監督', '建築設備士', '建築積算士', '発注者支援', '技士補']
          const recree3KeywordArray = ['施工技士', '建築士', '現場所長', '現場主任', '工事主任', '工事監理', '専任技術者', '現場監督', '現場代理', 'RCCM', '電験', '電気主任技術者', '建築設備士', '建築積算士']
          if (basicData.age >= 20 && basicData.age <= 30) {
            if (this.addressCheck(basicData, recree3AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, recree345NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, recree345NotKeywordArray)) {
                isRecree_3 = false
              } else if (this.keywordCheckRirekisho(formatData, recree3KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, recree3KeywordArray)) {
                isRecree_3 = true
              }
            }
          }

          const recree4AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '静岡県', '愛知県', '岐阜県', '大阪府', '京都府', '兵庫県', '奈良県', '和歌山県', '北海道', '広県島', '岡山県']
          const recree4KeywordArray = ['共同エンジニアリング', 'JAGフィールド', '工事監理', '専任技術者', 'コンストラクションマネジメント', '概略設計', '杭工事', '現場監督', '現場代理', 'イーフラッグ', 'SUGUNI', 'コプロ・エンジニアード', 'アクトエンジニアリング', '建築積算士', '発注者支援', '高松建設', 'ヤマギシリフォーム工業', 'カシワバラコーポレーション', 'フクダアンドパートナーズ', 'トライトエンジニアリング', 'スタッフ・アクティオ', 'サイマリーディング', '意匠設計', '主任技術者', '監理技術者', 'RCCM', '施工技士', '技士補', '内装設計', '構造設計', '設備設計', '設計士', '設計監理', '管工事', '改築工事', '電験', 'トンネル工事', '河川工事', '上下水道工事', '塩浜工業', 'ホークワン', '北野建設', '生和コーポレーション', '電気工事士', 'ツーバイフォー工法', '建設マネジメント', '現場監理', '工事管理', '建築士', '現場所長', '現場主任', '工事主任', '建設コンサルタント', '建築コンサルタント', 'テクノプロコンストラクション', 'UTコンストラクション', '設計管理', '土木設計', '建築設計', '工事監督', '建築設備士', '電気主任技術者', '大和ハウス工業', '大林組', '大成建設', '清水建設', '関電工', '竹中工務店', '鹿島建設', '積水ハウス', '日鉄テックスエンジ', '九電工', '戸田建設', '前田建設工業', '安藤・間', 'トーエネック', '五洋建設', 'ユアテック', '中電工', '一条工務店', 'エクシオグループ', '東急建設', 'ミライト・ワン', '西松建設', '三井住友建設', '熊谷組', '奥村組', 'ＪＦＥエンジニアリング', '新菱冷熱工業', '長谷工コーポレーション', '鴻池組', '前田道路', '東亜建設工業', '東芝プラントシステム', '鉄建建設', '四電工', 'かんでんエンジニアリング', '東鉄工業', '鹿島道路', '日本道路', '千代田化工建設', '大氣社', '三井ホーム', '西日本プラント工業', '淺沼組', '東洋建設']
          if (basicData.age >= 31 && basicData.age <= 55) {
            if (this.addressCheck(basicData, recree4AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, recree345NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, recree345NotKeywordArray)) {
                isRecree_4 = false
              } else if (this.keywordCheckRirekisho(formatData, recree3KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, recree3KeywordArray)) {
                isRecree_4 = true
              }
            }
          }

          const recree5AddressArray = ['青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '三重県', '滋賀県', '鳥取県', '島根県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県']
          const recree5KeywordArray = ['共同エンジニアリング', 'JAGフィールド', '工事監理', '専任技術者', 'コンストラクションマネジメント', '管理技術者', '概略設計', 'リフォーム工事', 'W造', '木造住宅', '戸建て住宅', 'マンション工事', 'ビル工事', '杭工事', '鋼構造物', '法面工事', '港湾工事', '現場監督', 'ゼネコン', '現場管理', '土木', '現場代理', 'ウィルオブ・コンストラクション', 'ワールドコーポレーション', 'アーキ・ジャパン', 'テクノプロ・コンストラクション', 'イーフラッグ', 'SUGUNI', 'コプロ・エンジニアード', '夢真', 'アクトエンジニアリング', 'スタッフ・アクティオ', 'ＵＴコンストラクション', 'サイマリーディング', '意匠設計', '主任技術者', '監理技術者', 'ハウスメーカー', 'RCCM', '内装設計', '構造設計', '設備設計', '設計士', '設計監理', '管工事', '改修工事', '修繕工事', '改築工事', '電験', '大規模修繕', '高松建設', 'ヤマギシリフォーム工業', 'カシワバラコーポレーション', 'メルディア', 'フクダアンドパートナーズ', 'ケイアイスター不動産', '一建設', '塩浜工業', 'ホークワン', '北野建設', '生和コーポレーション', 'サブコン', '電気工事士', '日建学院', 'RC造', 'PC造', 'S造', '軽量鉄骨造', '木質フレーム構造', '地盤改良工事', 'プレキャストコンクリート工法', 'システム建築工法', 'ツーバイフォー工法', 'トンネル工法', '地中構造物工法', '逆打ち工法', 'スリップフォーム工法', 'クライミングフォーム工法', 'トンネル工事', '河川工事', '上下水道工事', '海岸工事', '地滑り防止工事', '災害復旧工事', '地下構造物の建設', '施工技士', '現場監理', '工事管理', '建築士', '現場所長', '現場主任', '工事主任', '建設コンサルタント', '建築コンサルタント', '住宅リフォーム', '建設マネジメント']
          if (basicData.age >= 20 && basicData.age <= 35) {
            if (this.addressCheck(basicData, recree5AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, recree345NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, recree345NotKeywordArray)) {
                isRecree_5 = false
              } else if (this.keywordCheckRirekisho(formatData, recree3KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, recree3KeywordArray)) {
                isRecree_5 = true
              }
            }
          }

          const isXmile_28KeywordArray = ['1級建築施工管理技士', '１級建築施工管理技士', '一級建築施工管理技士', '1級土木施工管理技士', '１級土木施工管理技士', '一級土木施工管理技士', '1級管工事施工管理技士', '１級電気工事施工管理技士', '一級電気工事施工管理技士', '1級管工事施工管理技士', '１級管工事施工管理技士', '一級管工事施工管理技士']
          const isXmile_28AddressArray = ['']
          if (true) {
            if (basicData.age >= 20 && basicData.age <= 65) {
              if (this.keywordCheckRirekisho(formatData, isXmile_28KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isXmile_28KeywordArray)) {
                isXmile_28 = true
              }
            }
          }

          const isXmile_5AddressArray = ['']
          const isXmile_5KeywordArray = ['施工管理']
          if (basicData.age >= 20 && basicData.age <= 49) {
            if (this.addressCheck(basicData, isXmile_5AddressArray) || true) {
              if (this.keywordCheckRirekisho(formatData, isXmile_5KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isXmile_5KeywordArray)) {
                isXmile_5 = true
              }
            }
          }

          const isXmile_26KeywordArray = ['施工管理']
          const isXmile_26AddressArray = ['']
          if (true) {
            if (basicData.age >= 50 && basicData.age <= 65) {
              if (this.keywordCheckRirekisho(formatData, isXmile_26KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isXmile_26KeywordArray)) {
                isXmile_26 = true
              }
            }
          }

          const isXmile_27KeywordArray = ['製造', '工場', 'ライン作業', 'ものづくり', 'モノづくり', 'もの作り', 'もの造り', '物作り', '物造り', 'もの造り', 'モノ造り', '機オペレーター', '旋盤', 'マシニングセンタ', 'CNC', '切削', '研削', 'ワイヤーカット', '放電加工', 'レーザー加工', '面加工', 'プレス金型', '金型', 'プレス仕上げ', '射出成形', '押出成形', '鋳造', '圧延', '溶接', 'ハンダ付け', 'ハンダづけ', 'はんだづけ', 'はんだ付け', '車体組立', 'エンジン組立', '生産設備', '設備立ち上げ', '治具', 'CAD/CAM', 'クリーンルーム', '露光装置', 'エッチング', '外観検査', '目視検査', '非破壊検査', 'KYT', '原料投入', '充填作業', 'オフセット印刷', 'デジタル印刷', 'グラビア印刷', 'フレキソ印刷', '量産設計', '生産設計', 'AutoCAD', 'SOLIDWORKS', 'Inventor', 'CATIA', 'Creo Parametric']
          const isXmile_27AddressArray = ['三重県', '京都府', '兵庫県', '千葉県', '埼玉県', '大阪府', '奈良県', '宮城県', '岐阜県', '岡山県', '愛知県', '新潟県', '東京都', '栃木県', '神奈川県', '福島県', '群馬県', '茨城県', '長野県']
          if (this.addressCheck(basicData, isXmile_27AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 44) {
              if (this.keywordCheckRirekisho(formatData, isXmile_27KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isXmile_27KeywordArray)) {
                isXmile_27 = true
              }
            }
          }

          const isXmile_38KeywordArray = ['期間従業員', '期間工', '期間社員', '期間作業員', '自動車製造ライン', '自動車の製造', '自動車の組立', '自動車の組み立て', '完成車組立', '完成車両', '車体組立', 'エンジン組立', '元町工場', '堤工場', '田原工場', '高岡工場', '衣浦工場', '長草工場', '追浜工場', '栃木工場', '鈴鹿製作所', '寄居工場']
          const isXmile_38AddressArray = ['愛知県', '岐阜県', '三重県', '静岡県', '滋賀県']
          if (this.addressCheck(basicData, isXmile_38AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 39) {
              if (this.keywordCheckRirekisho(formatData, isXmile_38KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isXmile_38KeywordArray)) {
                isXmile_38 = true
              }
            }
          }

          const isXmile_6AddressArray = ['三重県', '京都府', '佐賀県', '兵庫県', '千葉県', '埼玉県', '大分県', '大阪府', '奈良県', '宮崎県', '岐阜県', '岡山県', '島根県', '広島県', '徳島県', '愛媛県', '愛知県', '東京都', '栃木県', '滋賀県', '熊本県', '神奈川県', '福岡県', '茨城県', '香川県', '高知県', '鳥取県', '鹿児島県']
          const isXmile_6KeywordArray = ['中型自動車第二種運転免許', '中型自動車運転免許', '準中型自動車運転免許', '大型自動車第二種運転免許', '大型特殊自動車免許', '牽引自動車第一種運転免許', '大型特殊免許', '大型二種免許', '第二種運転免許', 'けん引免許', '玉掛け免許', 'フォークリフト運転技能者', '大型自動車免許', '第二種自動車運転免許', '大型自動車二種免許', 'トラックドライバー', '配送ドライバー', '長距離ドライバー', 'バスドライバー', '長距離輸送', '特殊車両', '軽貨物', 'タンクローリー', '長距離運転', '倉庫管理主任者', 'ルート配送', '準中型自動車免許', '運行管理者', '大型自動車第一種運転免許', '中型自動車第一種運転免許']
          if (basicData.age >= 20 && basicData.age <= 54) {
            if (this.addressCheck(basicData, isXmile_6AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, isXmile_6KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isXmile_6KeywordArray)) {
                isXmile_6 = true
              }
            }
          }
          const isXmile_7AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '茨城県', '大阪府', '福岡県', '広島県', '京都府', '兵庫県']
          const isXmile_7KeywordArray = ['タクシードライバー', '普通自動車第二種運転免許', '普通二種免許', '一般乗用旅客', '普通自動車二種免許', '普通自動車第二種免許', '旅客運送']
          if (basicData.age >= 20 && basicData.age <= 54) {
            if (this.addressCheck(basicData, isXmile_7AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, isXmile_7KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isXmile_7KeywordArray)) {
                isXmile_7 = true
              }
            }
          }
          const isXmile_8AddressArray = ['']
          const isXmile_8KeywordArray = ['自動車検査員', '整備士']
          if (basicData.age >= 20 && basicData.age <= 49) {
            if (this.addressCheck(basicData, isXmile_8AddressArray) || true) {
              if (this.keywordCheckRirekisho(formatData, isXmile_8KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isXmile_8KeywordArray)) {
                isXmile_8 = true
              }
            }
          }
          const isXmile_9AddressArray = ['三重県', '京都府', '兵庫県', '千葉県', '埼玉県', '大阪府', '奈良県', '宮城県', '岐阜県', '岡山県', '愛知県', '新潟県', '東京都', '栃木県', '神奈川県', '福島県', '群馬県', '茨城県', '長野県']
          const isXmile_9KeywordArray = ['機械設計', '機械加工技能士', '機械加工', 'CADオペレーター', '製造オペレーター', '生産技術', '品質保証', '設計開発', 'サービスエンジニア', '機械操作', '製造ライン']
          if (basicData.age >= 20 && basicData.age <= 44) {
            if (this.addressCheck(basicData, isXmile_9AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, isXmile_9KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isXmile_9KeywordArray)) {
                isXmile_9 = true
              }
            }
          }
          const isXmile_10AddressArray = ['千葉県', '埼玉県', '愛知県', '東京都', '神奈川県', '群馬県', '茨城県']
          const isXmile_10KeywordArray = ['警備員指導教育責任者', '施設警備業務', '交通誘導警備業務', '貴重品運搬警備業務', '空港保安警備業務', '機械警備業務']
          if (basicData.age >= 20 && basicData.age <= 54) {
            if (this.addressCheck(basicData, isXmile_10AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, isXmile_10KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isXmile_10KeywordArray)) {
                isXmile_10 = true
              }
            }
          }

          const isXmile_11AddressArray = true
          const isXmile_11KeywordArray = ['建築士', '建築設計', '測量士補', 'RC造']
          if (basicData.age >= 20 && basicData.age <= 35) {
            if (isXmile_11AddressArray) {
              if (this.keywordCheckRirekisho(formatData, isXmile_11KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isXmile_11KeywordArray)) {
                isXmile_11 = true
              }
            }
          }
          const isXmile_12AddressArray = true
          const isXmile_12KeywordArray = ['プラントエンジニアリング']
          if (basicData.age >= 20 && basicData.age <= 35) {
            if (isXmile_12AddressArray) {
              if (this.keywordCheckRirekisho(formatData, isXmile_12KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isXmile_12KeywordArray)) {
                isXmile_12 = true
              }
            }
          }
          const isXmile_13AddressArray = true
          const isXmile_13KeywordArray = ['工業高等学校建築科', '工業高等学校土木科', '学部建築学科', '工業高等学校　建築科', '工業高等学校 建築科', '工業高等学校　土木科', '工業高等学校 土木科', '学部　建築学科', '学部 建築学科']
          if (basicData.age >= 20 && basicData.age <= 35) {
            if (isXmile_13AddressArray) {
              if (this.keywordCheckRirekisho(formatData, isXmile_13KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isXmile_13KeywordArray)) {
                isXmile_13 = true
              }
            }
          }
          const isXmile_14AddressArray = true
          const isXmile_14KeywordArray = ['工業高等学校電気科', '工業高等学校機械科', '工業高等学校　電気科', '工業高等学校　機械科', '工業高等学校 電気科', '工業高等学校 機械科']
          if (basicData.age >= 20 && basicData.age <= 35) {
            if (isXmile_14AddressArray) {
              if (this.keywordCheckRirekisho(formatData, isXmile_14KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isXmile_14KeywordArray)) {
                isXmile_14 = true
              }
            }
          }
          const isXmile_15AddressArray = true
          const isXmile_15KeywordArray = ['自動車大学校', '自動車整備士専門学校', 'ホンダテクニカルカレッジ', '株式会社IDOM', 'モータース', '株式会社ネクステージ', '日産', 'イエローハット', 'オートバックス', 'スズキ']
          if (basicData.age >= 20 && basicData.age <= 35) {
            if (isXmile_15AddressArray) {
              if (this.keywordCheckRirekisho(formatData, isXmile_15KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isXmile_15KeywordArray)) {
                isXmile_15 = true
              }
            }
          }
          const isXmile_16AddressArray = ['東京都', '神奈川県', '愛知県', '大阪府']
          const isXmile_16KeywordArray = ['法人営業', 'ルート営業', '訪問販売', '営業職', 'セールス', '新規開拓', 'カスタマーサクセス']
          if (basicData.age >= 20 && basicData.age <= 35) {
            if (this.addressCheck(basicData, isXmile_16AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, isXmile_16KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isXmile_16KeywordArray)) {
                isXmile_16 = true
              }
            }
          }
          const isXmile_17AddressArray = ['東京都', '神奈川県', '愛知県', '大阪府']
          const isXmile_17KeywordArray = ['不動産営業', '宅地建物取引士', '賃貸不動産経営管理士', '管理業務主任者', '賃貸', '売買', '仲介', '宅建']
          if (basicData.age >= 20 && basicData.age <= 35) {
            if (this.addressCheck(basicData, isXmile_17AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, isXmile_17KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isXmile_17KeywordArray)) {
                isXmile_17 = true
              }
            }
          }
          const isXmile_18AddressArray = ['東京都', '大阪府', '福岡県', '広島県', '愛知県']
          const isXmile_18KeywordArray = ['キャリアアドバイザー', 'キャリアコンサルタント', '人材コーディネーター', '人材紹介', '人材派遣']
          if (basicData.age >= 20 && basicData.age <= 35) {
            if (this.addressCheck(basicData, isXmile_18AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, isXmile_18KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isXmile_18KeywordArray)) {
                isXmile_18 = true
              }
            }
          }
          const isXmile_19AddressArray = ['東京都']
          const isXmile_19KeywordArray = ['販売職', '販売員']
          if (basicData.age >= 20 && basicData.age <= 35) {
            if (this.addressCheck(basicData, isXmile_19AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, isXmile_19KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isXmile_19KeywordArray)) {
                isXmile_19 = true
              }
            }
          }
          const isXmile_20AddressArray = ['']
          const isXmile_20KeywordArray = ['電気主任', '電気工事']
          if (basicData.age >= 20 && basicData.age <= 49) {
            if (this.addressCheck(basicData, isXmile_20AddressArray) || true) {
              if (this.keywordCheckRirekisho(formatData, isXmile_20KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isXmile_20KeywordArray)) {
                isXmile_20 = true
              }
            }
          }
          const isXmile_21AddressArray = ['東京都', '愛知県', '宮城県', '北海道', '福岡県']
          const isXmile_21KeywordArray = ['大学卒業', '大学 卒業', '大学 卒業']
          if (basicData.age >= 20 && basicData.age <= 35) {
            if (this.addressCheck(basicData, isXmile_21AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, isXmile_21KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isXmile_21KeywordArray)) {
                isXmile_21 = true
              }
            }
          }

          const isXmile_22KeywordArray = ['建築物環境衛生管理技術者', '建物管理', '清掃管理', '環境衛生管理', '工事立ち合い', '工事業者選定', '工事業者手配', '工事業者選定・手配', 'テナントとの折衝', 'オーナーとの折衝', 'テナント・オーナーとの折衝']
          const isXmile_22AddressArray = ['東京都', '神奈川県', '埼玉県', '大阪府', '京都府', '愛知県', '福岡県']
          if (this.addressCheck(basicData, isXmile_22AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 55) {
              if (this.keywordCheckRirekisho(formatData, isXmile_22KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isXmile_22KeywordArray)) {
                isXmile_22 = true
              }
            }
          }

          const isXmile_23KeywordArray = ['自動車免許', '普通自動車第一種運転免許', '普通自動車第１種運転免許', '普通自動車第1種運転免許', '普通自動車第一種免許', '普通自動車第１種免許', '普通自動車第1種免許', '普通自動車免許', '普通車免許', '普通免許', '中型自動車第一種運転免許', '中型自動第１種運転免許', '中型自動車第1種運転免許', '中型自動車第一種免許', '中型自動車第１種免許', '中型自動車第1種免許', '中型自動車免許', '中型車免許', '中型免許']
          const isXmile_23AddressArray = ['東京都', '神奈川県', '埼玉県']
          if (this.addressCheck(basicData, isXmile_23AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isXmile_23KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isXmile_23KeywordArray)) {
                isXmile_23 = true
              }
            }
          }
          const isXmile_24KeywordArray = ['自動車免許', '普通自動車第一種運転免許', '普通自動車第１種運転免許', '普通自動車第1種運転免許', '普通自動車第一種免許', '普通自動車第１種免許', '普通自動車第1種免許', '普通自動車免許', '普通車免許', '普通免許', '中型自動車第一種運転免許', '中型自動第１種運転免許', '中型自動車第1種運転免許', '中型自動車第一種免許', '中型自動車第１種免許', '中型自動車第1種免許', '中型自動車免許', '中型車免許', '中型免許']
          const isXmile_24AddressArray = ['東京都', '神奈川県', '埼玉県']
          if (this.addressCheck(basicData, isXmile_24AddressArray)) {
            if (basicData.age >= 30 && basicData.age <= 35) {
              if (this.keywordCheckRirekisho(formatData, isXmile_24KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isXmile_24KeywordArray)) {
                isXmile_24 = true
              }
            }
          }
          const isXmile_25KeywordArray = ['']
          const isXmile_25AddressArray = ['東京都', '神奈川県', '埼玉県']
          if (this.addressCheck(basicData, isXmile_25AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              isXmile_25 = true
            }
          }

          const isPlexjob_1KeywordArray = ['電気主任技術者']
          const isPlexjob_1AddressArray = ['北海道', '宮城県', '埼玉県', '東京都', '神奈川県', '千葉県', '静岡県', '愛知県', '三重県', '京都府', '大阪府', '兵庫県', '岡山県', '香川県', '愛媛県', '広島県', '福岡県', '佐賀県', '長崎県', '大分県', '福岡県', '栃木県']
          if (this.addressCheck(basicData, isPlexjob_1AddressArray)) {
            if (basicData.age >= 23 && basicData.age <= 59) {
              if (this.keywordCheckRirekisho(formatData, isPlexjob_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isPlexjob_1KeywordArray)) {
                isPlexjob_1 = true
              }
            }
          }

          const isPlexjob_2KeywordArray = ['自動車検査員', '自動車整備士']
          const isPlexjob_2AddressArray = ['東京都', '神奈川県横浜市', '神奈川県川崎市', '埼玉県川口市', '埼玉県八潮市', '千葉市美浜区', '千葉市花見川区', '千葉市稲毛区']
          if (this.addressCheck(basicData, isPlexjob_2AddressArray)) {
            if (basicData.age >= 23 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isPlexjob_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isPlexjob_2KeywordArray)) {
                isPlexjob_2 = true
              }
            }
          }

          const isPlexjob_3KeywordArray = ['介護福祉士', 'ケアマネージャー', '介護支援専門員', '初任者研修', '実務者研修']
          const isPlexjob_3AddressArray = ['新潟県', '長野県', '石川県', '富山県']
          if (this.addressCheck(basicData, isPlexjob_3AddressArray)) {
            if (basicData.age >= 18 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isPlexjob_3KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isPlexjob_3KeywordArray)) {
                isPlexjob_3 = true
              }
            }
          }

          const isPlexjob_4KeywordArray = ['理学療法士', '作業療法士', '言語聴覚療法士']
          const isPlexjob_4AddressArray = ['東京都', '神奈川県横浜市', '神奈川県川崎市', '埼玉県川口市', '埼玉県八潮市', '千葉市美浜区', '千葉市花見川区', '千葉市稲毛区']
          if (this.addressCheck(basicData, isPlexjob_4AddressArray)) {
            if (basicData.age >= 18 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isPlexjob_4KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isPlexjob_4KeywordArray)) {
                isPlexjob_4 = true
              }
            }
          }

          const isPlexjob_5KeywordArray = ['中型自動車第二種運転免許', '中型自動車運転免許', '準中型自動車運転免許', '大型自動車第二種運転免許', '大型特殊自動車免許', '牽引自動車第一種運転免許', '大型特殊免許', '大型二種免許', '第二種運転免許', 'けん引免許', '玉掛け免許', 'フォークリフト運転技能者', '大型自動車免許', '第二種自動車運転免許', '大型自動車二種免許', 'トラックドライバー', '配送ドライバー', '長距離ドライバー', '長距離輸送', '特殊車両', '軽貨物', 'タンクローリー', '長距離運転', '倉庫管理主任者', 'ルート配送', '準中型自動車免許', '運行管理者', '大型自動車第一種運転免許', '中型自動車第一種運転免許', '準中型免許', '中型免許', '大型免許', '牽引免許', 'けん引免許']
          const isPlexjob_5AddressArray = ['東京都', '神奈川県横浜市', '神奈川県川崎市', '埼玉県川口市', '埼玉県八潮市', '千葉市美浜区', '千葉市花見川区', '千葉市稲毛区']
          if (this.addressCheck(basicData, isPlexjob_5AddressArray)) {
            if (basicData.age >= 18 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isPlexjob_5KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isPlexjob_5KeywordArray)) {
                isPlexjob_5 = true
              }
            }
          }

          const isPlexjob_6KeywordArray = ['普通自動車第二種運転免許', '普通二種免許', '一般乗用旅客', '普通自動車二種免許', '普通自動車第二種免許', '旅客運送']
          const isPlexjob_6AddressArray = ['東京都', '神奈川県横浜市', '神奈川県川崎市', '埼玉県川口市', '埼玉県八潮市', '千葉市美浜区', '千葉市花見川区', '千葉市稲毛区']
          if (this.addressCheck(basicData, isPlexjob_6AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 59) {
              if (this.keywordCheckRirekisho(formatData, isPlexjob_6KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isPlexjob_6KeywordArray)) {
                isPlexjob_6 = true
              }
            }
          }

          const isProselltraction_1KeywordArray = ['営業', 'セールス', '新規開拓', 'テレアポ', '目標達成', '売上目標', '販売']
          const isProselltraction_1NotKeywordArray = ['事務']
          const isProselltraction_1AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '福岡県', '愛知県']
          if (this.addressCheck(basicData, isProselltraction_1AddressArray)) {
            if (basicData.age >= 19 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isProselltraction_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isProselltraction_1KeywordArray)) {
                isProselltraction_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isProselltraction_1NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isProselltraction_1NotKeywordArray)) {
                isProselltraction_1 = false
              }
            }
          }

          const isRerise_1KeywordArray = ['事務', '接客', '販売', '営業', 'セールス', '新規開拓', 'テレアポ', '目標達成', '売上目標', '工場']
          const isRerise_1AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府', '愛知県']
          if (this.addressCheck(basicData, isRerise_1AddressArray)) {
            if (basicData.age >= 19 && basicData.age <= 28) {
              if (this.keywordCheckRirekisho(formatData, isRerise_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isRerise_1KeywordArray)) {
                isRerise_1 = true
              }
            }
          }

          const isTimee_1KeywordArray = ['物流', '製造']
          const isTimee_1NotKeywordArray = ['PMO', 'PMP', 'コンサルティング', 'バックエンド開発', 'COBOL', 'Spring Boot', 'システムインテグレータ', '薬機法', '景表法', '広告審査', '社会保険労務士', '税理士', '公認会計士', '簿記2級', ' 精神保健福祉士', '柔道整復師', '一級建築士', '建築設計士', 'CAD', 'SolidWorks', 'インテリアプランナー', '一般事務', '営業事務', '医療事務', '秘書', '受付', 'データ入力', 'ヘルプデスク', 'ITサポート', 'クリニック', '医療', '在学中', '履修', '卒業見込み', '経営者', '社長', '代表取締役', '自営業', 'フリーランス', '個人事業主', 'コンサルタント', '顧問', '取締役', 'オーナー', '役員', 'スタートアップ', 'ベンチャー経営', '事業開発', '経営企画', '投資家', 'ファンド', 'エンジェル投資', '派遣', '業務委託', '請負', '登録スタッフ', '登録制', '登録販売者', 'SES', 'BPO', '在宅ワーク', 'リモートワーク', 'クラウドワークス', 'ランサーズ', '副業', '兼業', 'Wワーク', '単発', '日雇い', '弁護士', '会計士', '税理士', '医師', '看護師', '薬剤師', '司法書士', '行政書士', '弁理士', '建築士', 'エンジニア', 'プログラマー', 'デザイナー', 'プロデューサー', 'マネージャー', 'ディレクター', '部長', '課長', 'リーダー', ' チーフ', ' 教授', '研究員', '研究職', '外資', 'MBA', '博士', 'PhD', '研究開発', 'コンサル', '戦略コンサル', 'マーケティングマネージャー', 'PRマネージャー', '主婦', '主夫', '専業主婦', '子育て中', '介護中', '療養中', '無職', '求職中', '就職活動中', 'ブランク', '家事手伝い', '休職中', 'ニート', 'ひきこもり', '支援施設', '生活保護', '障害者', '障がい者', '障害者手帳', '療育手帳', '精神障害', '発達障害', '知的障害', '身体障害', 'ADHD', 'ASD', '自閉症', 'うつ病', '双極性障害', '統合失調症', '適応障害', '精神疾患', '精神手帳', 'メンタルヘルス', '心療内科', '通院', '通院中', '既往歴', '難病', '持病', 'てんかん', 'PTSD', '病気', '外国人', '留学生', 'ビザ', '就労ビザ', '特定技能', '技能実習', '永住権', 'working holiday', 'ワーキングホリデー', 'non-Japanese', 'international student', 'foreigner', 'ESL', 'exchange student', 'study abroad', 'overseas student', '日本語', 'N1', 'N2', 'JLPT', '英語ネイティブ', '営業', 'スカウト', 'リクルーター', '人材紹介', 'ヘッドハンター', '転職エージェント', '代理店', 'アフィリエイト', '勧誘', '紹介業', '斡旋', '求人広告', '採用代行', 'Afghanistan', 'Argentina', 'Australia', 'Austria', 'Bangladesh', 'Belgium', 'Brazil', 'Cambodia', 'Canada', 'China', 'Colombia', 'Egypt', 'Finland', 'France', 'Germany', 'Greece', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Japan', 'Kenya', 'Korea', 'Laos', 'Malaysia', 'Mexico', 'Mongolia', 'Nepal', 'Netherlands', 'New Zealand', 'Pakistan', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Russia', 'Singapore', 'South Africa', 'Spain', 'Sri Lanka', 'Sweden', 'Switzerland', 'Taiwan', 'Thailand', 'Turkey', 'Ukraine', 'United Kingdom', 'United States', 'Vietnam', 'アメリカ', 'イギリス', '中国', '韓国', '台湾', 'インド', 'フィリピン', 'ベトナム', 'ネパール', 'ミャンマー', 'カンボジア', 'インドネシア', 'バングラデシュ', 'モンゴル', 'ブラジル', 'ペルー', 'ナイジェリア', 'ケニア', 'University', 'College', 'School', 'Academy', 'Institute', 'International', 'Global', 'High School', 'Technical School', 'Vocational', 'Graduate School', 'Bilingual School', 'Language School', 'International School', 'Summer School', 'Exchange', 'Study Abroad', 'インターナショナルスクール', '語学学校', '英語学校', 'グローバルキャンパス', 'キャンパス', '事務', '入力', 'サポート', '寄り添う', '400万', '500万', '600万', '700万', '800万', '900万', '1000万']
          const isTimee_1AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '静岡県', '大阪府', '福岡県']
          if (this.addressCheck(basicData, isTimee_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 35) {
              if (this.keywordCheckRirekisho(formatData, isTimee_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isTimee_1KeywordArray)) {
                isTimee_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isTimee_1NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isTimee_1NotKeywordArray)) {
                isTimee_1 = false
              }
            }
          }

          const isBestand_1KeywordArray = ['コールセンター', '店長', 'SV', 'スーパーバイザー', '販売', '営業']
          const isBestand_1AddressArray = ['東京都']
          if (this.addressCheck(basicData, isBestand_1AddressArray)) {
            if (basicData.age >= 25 && basicData.age <= 32) {
              if (this.keywordCheckRirekisho(formatData, isBestand_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isBestand_1KeywordArray)) {
                isBestand_1 = true
              }
            }
          }

          const isHhjapan_1KeywordArray = ['コミュニケーション', '営業']
          const isHhjapan_1AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          if (this.addressCheck(basicData, isHhjapan_1AddressArray)) {
            if (basicData.age >= 24 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isHhjapan_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isHhjapan_1KeywordArray)) {
                isHhjapan_1 = true
              }
            }
          }

          const isRiajob_1KeywordArray = ['大学']
          const isRiajob_1AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          if (this.addressCheck(basicData, isRiajob_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isRiajob_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isRiajob_1KeywordArray)) {
                isRiajob_1 = true
              }
            }
          }

          const isBranu_1KeywordArray = ['大工', '造作工', '型枠工', '建具工', '左官工', '配管工', '空調工', '設備工', '配線工', '電気通信工', '基礎工事']
          const isBranu_1NotKeywordArray = ['セールス', '事務', '営業', '製造']
          const isBranu_1AddressArray = ['宮城県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '静岡県', '愛知県', '大阪府', '兵庫県', '福岡県']
          if (this.addressCheck(basicData, isBranu_1AddressArray)) {
            if (basicData.age >= 18 && basicData.age <= 50) {
              if (this.keywordCheckRirekisho(formatData, isBranu_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isBranu_1KeywordArray)) {
                isBranu_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isBranu_1NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isBranu_1NotKeywordArray)) {
                isBranu_1 = false
              }
            }
          }

          const isCiw_1KeywordArray = ['フォークリフト', '玉掛け', 'クレーン', '溶接', '電気保全技能士', 'エネルギー管理士', '有機溶剤作業主任者', '金型設計', '射出成型']
          const isCiw_1AddressArray = ['愛知県あま市', '愛知県みよし市', '愛知県愛西市', '愛知県愛知郡東郷町', '愛知県安城市', '愛知県岡崎市', '愛知県海部郡蟹江町', '愛知県海部郡大治町', '愛知県海部郡飛島村', '愛知県額田郡幸田町', '愛知県蒲郡市', '愛知県刈谷市', '愛知県岩倉市', '愛知県犬山市', '愛知県江南市', '愛知県高浜市', '愛知県春日井市', '愛知県小牧市', '愛知県常滑市', '愛知県新城市', '愛知県瀬戸市', '愛知県清須市', '愛知県西春日井郡豊山町', '愛知県西尾市', '愛知県大府市', '愛知県丹羽郡大口町', '愛知県知多郡阿久比町', '愛知県知多郡東浦町', '愛知県知多郡美浜町', '愛知県知多郡武豊町', '愛知県知多市', '愛知県知立市', '愛知県長久手市', '愛知県田原市', '愛知県東海市', '愛知県日進市', '愛知県半田市', '愛知県尾張旭市', '愛知県碧南市', '愛知県豊橋市', '愛知県豊山町', '愛知県豊川市', '愛知県豊田市', '愛知県豊明市', '愛知県北設楽郡設楽町', '愛知県北名古屋市', '愛知県名古屋市港区', '愛知県名古屋市北区', '愛知県名古屋市緑区', '愛知県弥富市', '茨城県稲敷郡河内町', '茨城県稲敷市', '茨城県笠間市', '茨城県桜川市', '茨城県鹿嶋市', '茨城県常陸大宮市', '茨城県神栖市', '茨城県水戸市', '茨城県筑西市', '茨城県潮来市', '茨城県東茨城郡城里町', '茨城県那珂市', '茨城県北茨城市', '茨城県北相馬郡利根町', '茨城県龍ケ崎市', '岡山県井原市', '岡山県岡山市東区', '岡山県岡山市南区', '岡山県岡山市北区', '岡山県加賀郡吉備中央町', '岡山県玉野市', '岡山県高梁市', '岡山県小田郡矢掛町', '岡山県新見市', '岡山県真庭市', '岡山県瀬戸内市', '岡山県赤磐市', '岡山県浅口市', '岡山県倉敷市', '岡山県総社市', '岡山県都窪郡早島町', '岡山県備前市', '岡山県美作市', '岡山県和気郡和気町', '岐阜県安八郡安八町', '岐阜県安八郡神戸町', '岐阜県安八郡輪之内町', '岐阜県羽島市', '岐阜県加茂郡七宗町', '岐阜県加茂郡川辺町', '岐阜県加茂郡八百津町', '岐阜県海津市', '岐阜県岐阜市', '岐阜県恵那市', '岐阜県瑞穂市', '岐阜県瑞浪市', '岐阜県大垣市', '岐阜県土岐市', '岐阜県美濃加茂市', '岐阜県不破郡関ケ原町', '岐阜県不破郡垂井町', '岐阜県揖斐郡池田町', '岐阜県養老郡養老町', '京都府京田辺市', '京都府八幡市', '群馬県伊勢崎市', '群馬県館林市', '群馬県桐生市', '群馬県高崎市', '群馬県佐波郡玉村町', '群馬県渋川市', '群馬県沼田市', '群馬県前橋市', '群馬県北群馬郡吉岡町', '群馬県北群馬郡榛東村', '群馬県邑楽郡千代田町', '群馬県邑楽郡板倉町', '群馬県邑楽郡明和町', '広島県安芸郡坂町', '広島県安芸郡府中町', '広島県安芸高田市', '広島県海田町', '広島県熊野町', '広島県呉市', '広島県広島市中区', '広島県山県郡安芸太田町', '広島県山県郡北広島町', '広島県庄原市', '広島県神石郡神石高原町', '広島県東広島市', '広島県廿日市市', '香川県坂出市', '埼玉県さいたま市岩槻区', '埼玉県さいたま市南区', '埼玉県羽生市', '埼玉県越谷市', '埼玉県吉川市', '埼玉県久喜市', '埼玉県熊谷市', '埼玉県戸田市', '埼玉県行田市', '埼玉県坂戸市', '埼玉県三郷市', '埼玉県春日部市', '埼玉県川口市', '埼玉県草加市', '埼玉県東松山市', '埼玉県南埼玉郡宮代町', '埼玉県白岡市', '埼玉県八潮市', '埼玉県比企郡滑川町', '埼玉県比企郡吉見町', '埼玉県比企郡川島町', '埼玉県比企郡鳩山町', '埼玉県比企郡嵐山町', '埼玉県蓮田市', '埼玉県蕨市', '三重県いなべ市', '三重県員弁郡東員町', '三重県桑名郡木曽岬町', '三重県桑名市', '三重県三重郡菰野町', '三重県四日市市', '山形県最上郡真室川町', '山形県酒田市', '山形県飽海郡遊佐町', '山口県下関市', '山梨県上野原市', '山梨県身延町', '山梨県早川町', '山梨県大月市', '山梨県都留市', '山梨県南アルプス市', '山梨県南巨摩郡南部町', '山梨県南都留郡道志村', '山梨県北都留郡小菅村', '滋賀県犬上郡多賀町', '滋賀県東近江市', '滋賀県米原市', '秋田県にかほ市', '秋田県横手市', '秋田県秋田市', '秋田県大仙市', '秋田県湯沢市', '秋田県由利本荘市', '秋田県雄勝郡羽後町', '新潟県糸魚川市', '神奈川県愛甲郡愛川町', '神奈川県愛甲郡清川村', '神奈川県綾瀬市', '神奈川県伊勢原市', '神奈川県横須賀市', '神奈川県横浜市', '神奈川県横浜市旭区', '神奈川県横浜市磯子区', '神奈川県横浜市栄区', '神奈川県横浜市金沢区', '神奈川県横浜市戸塚区', '神奈川県横浜市港南区', '神奈川県横浜市港北区', '神奈川県横浜市神奈川区', '神奈川県横浜市瀬谷区', '神奈川県横浜市西区', '神奈川県横浜市青葉区', '神奈川県横浜市泉区', '神奈川県横浜市中区', '神奈川県横浜市鶴見区', '神奈川県横浜市都筑区', '神奈川県横浜市南区', '神奈川県横浜市保土ケ谷区', '神奈川県横浜市緑区', '神奈川県海老名市', '神奈川県鎌倉市', '神奈川県厚木市', '神奈川県高座郡寒川町', '神奈川県座間市', '神奈川県秦野市', '神奈川県逗子市', '神奈川県川崎市', '神奈川県川崎市宮前区', '神奈川県川崎市幸区', '神奈川県川崎市高津区', '神奈川県川崎市川崎区', '神奈川県川崎市多摩区', '神奈川県川崎市中原区', '神奈川県川崎市麻生区', '神奈川県相模原市中央区', '神奈川県相模原市南区', '神奈川県相模原市緑区', '神奈川県足柄下郡箱根町', '神奈川県大和市', '神奈川県藤沢市', '神奈川県平塚市', '静岡県掛川市', '静岡県菊川市', '静岡県湖西市', '静岡県御前崎市', '静岡県御殿場市', '静岡県三島市', '静岡県周智郡森町', '静岡県駿東郡小山町', '静岡県駿東郡長泉町', '静岡県焼津市', '静岡県裾野市', '静岡県静岡市清水区', '静岡県川根本町', '静岡県袋井市', '静岡県島田市', '静岡県藤枝市', '静岡県磐田市', '静岡県浜松市浜名区', '静岡県富士宮市', '静岡県富士市', '石川県加賀市', '千葉県旭市', '千葉県印旛郡栄町', '千葉県浦安市', '千葉県鎌ケ谷市', '千葉県香取郡神崎町', '千葉県香取郡多古町', '千葉県香取郡東庄町', '千葉県香取市', '千葉県佐倉市', '千葉県四街道市', '千葉県市原市', '千葉県市川市', '千葉県習志野市', '千葉県松戸市', '千葉県成田市', '千葉県千葉市稲毛区', '千葉県千葉市花見川区', '千葉県千葉市若葉区', '千葉県千葉市中央区', '千葉県千葉市美浜区', '千葉県千葉市緑区', '千葉県船橋市', '千葉県匝瑳市', '千葉県大網白里市', '千葉県銚子市', '千葉県東金市', '千葉県八街市', '千葉県八千代市', '千葉県茂原市', '大阪府羽曳野市', '大阪府河内長野市', '大阪府岸和田市', '大阪府交野市', '大阪府高石市', '大阪府高槻市', '大阪府阪南市', '大阪府堺市堺区', '大阪府堺市西区', '大阪府堺市中区', '大阪府堺市東区', '大阪府堺市南区', '大阪府堺市美原区', '大阪府堺市北区', '大阪府三島郡島本町', '大阪府松原市', '大阪府寝屋川市', '大阪府泉大津市', '大阪府泉南郡岬町', '大阪府泉北郡忠岡町', '大阪府大阪狭山市', '大阪府大阪市', '大阪府大阪市阿倍野区', '大阪府大阪市旭区', '大阪府大阪市港区', '大阪府大阪市此花区', '大阪府大阪市住吉区', '大阪府大阪市住之江区', '大阪府大阪市城東区', '大阪府大阪市生野区', '大阪府大阪市西区', '大阪府大阪市西成区', '大阪府大阪市西淀川区', '大阪府大阪市大正区', '大阪府大阪市中央区', '大阪府大阪市鶴見区', '大阪府大阪市天王寺区', '大阪府大阪市都島区', '大阪府大阪市東住吉区', '大阪府大阪市東成区', '大阪府大阪市東淀川区', '大阪府大阪市福島区', '大阪府大阪市平野区', '大阪府大阪市北区', '大阪府大阪市淀川区', '大阪府大阪市浪速区', '大阪府富田林市', '大阪府豊中市', '大阪府枚方市', '大阪府和泉市', '長野県伊那市', '長野県下伊那郡根羽村', '長野県大鹿村', '長野県飯田市', '長野県北安曇郡白馬村', '東京都稲城市', '東京都江戸川区', '東京都江東区', '東京都狛江市', '東京都世田谷区', '東京都西多摩郡奥多摩町', '東京都西多摩郡檜原村', '東京都足立区', '東京都多摩市', '東京都大田区', '東京都町田市', '東京都調布市', '東京都品川区', '東京都目黒区', '栃木県宇都宮市', '栃木県下野市', '栃木県河内郡上三川町', '栃木県小山市', '栃木県真岡市', '栃木県芳賀郡益子町', '栃木県芳賀郡市貝町', '栃木県芳賀郡芳賀町', '栃木県芳賀郡茂木町', '奈良県生駒市', '富山県下新川郡朝日町', '富山県下新川郡入善町', '富山県黒部市', '福井県あわら市', '福井県吉田郡永平寺町', '福井県坂井市', '福井県勝山市', '福井県福井市', '福岡県芦屋町', '福岡県鞍手郡鞍手町', '福岡県京都郡みやこ町', '福岡県京都郡苅田町', '福岡県行橋市', '福岡県香春町', '福岡県水巻町', '福岡県中間市', '福岡県直方市', '福岡県福智町', '福岡県北九州市若松区', '福岡県北九州市小倉南区', '福島県いわき市', '福島県石川郡古殿町', '福島県石川郡平田村', '福島県双葉郡広野町', '福島県双葉郡川内村', '福島県双葉郡楢葉町', '福島県田村郡小野町', '福島県田村市', '福島県東白川郡鮫川村', '兵庫県伊丹市', '兵庫県加西市', '兵庫県加東市', '兵庫県佐用郡佐用町', '兵庫県三田市', '兵庫県三木市', '兵庫県小野市', '兵庫県西宮市', '兵庫県西脇市', '兵庫県赤穂郡上郡町', '兵庫県赤穂市', '兵庫県丹波篠山市', '兵庫県尼崎市', '和歌山県伊都郡かつらぎ町', '和歌山県海南市', '和歌山県岩出市', '和歌山県紀の川市', '和歌山県和歌山市']
          const isCiw_1NotKeywardArray = ['障害', '障がい', '障碍']
          if (this.addressCheck(basicData, isCiw_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 39) {
              if (this.keywordCheckRirekisho(formatData, isCiw_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isCiw_1KeywordArray)) {
                isCiw_1 = true
              }

              if (this.keywordCheckRirekisho(formatData, isCiw_1NotKeywardArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isCiw_1NotKeywardArray)) {
                isCiw_1 = false
              }
            }
          }
          const isBlankpad_1KeywordArray = ['営業', 'セールス', '新規開拓', 'テレアポ', '目標達成', '売上目標']
          const isBlankpad_1NotKeywordArray = ['事務']
          const isBlankpad_1AddressArray = ['東京都']
          if (this.addressCheck(basicData, isBlankpad_1AddressArray)) {
            if (basicData.age >= 24 && basicData.age <= 27) {
              if (this.keywordCheckRirekisho(formatData, isBlankpad_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isBlankpad_1KeywordArray)) {
                isBlankpad_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isBlankpad_1NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isBlankpad_1NotKeywordArray)) {
                isBlankpad_1 = false
              }
            }
          }

          const isSmartforce_2KeywordArray = ['正社員', 'バイトリーダー', 'テレアポ', 'セールス', '明るい', '元気', 'コミュニケーション能力', '成長', '挑戦', '未経験', '努力', '積極的', '接客', '販売', '向上', '営業']
          const isSmartforce_2NotKeywordArray = ['N1', 'N2', 'N3', 'N4', 'N5', '日本語能力試験', 'JLPT', '卒業見込み', '週1', '週2', '週3', '週4', '副業', '病気治療', '見込み', '在学中', 'ペット', '動物', '医療法人', '子ども', '子供', '子育て', '出勤日数', 'ファッション', 'ダブルワーク', '週１', '週２', '週３', '週４', '美容師', '病院', '卒業見込', 'ダンス', '持病', '勤務曜日', '月曜', '火曜', '水曜', '木曜', '金曜', '土曜', '日曜', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日', '日曜日', '勤務希望時間', '妊婦', 'Wワーク', '歯科助手']
          const isSmartforce_2AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県']
          if (this.addressCheck(basicData, isSmartforce_2AddressArray)) {
            if (basicData.age >= 22 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isSmartforce_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isSmartforce_2KeywordArray)) {
                isSmartforce_2 = true
              }
              if (this.keywordCheckRirekisho(formatData, isSmartforce_2NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isSmartforce_2NotKeywordArray)) {
                isSmartforce_2 = false
              }
            }
          }

          const isAwesome_1addressArray = ['東京都', '大阪府']
          const isAwesome_1KeywordArray = ['営業', 'セールス', '新規開拓', '法人営業']
          const isAwesome_1NotKeywordArray = ['N1', 'N2', 'N3', 'N4', 'N5', '日本語能力試験', 'JLPT', 'リモート', '時短', 'フリーランス', '看護師', '保育士', '栄養士', '施工管理', '自動車整備士', '電気主任技術者', '介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員', '理学療法士', '作業療法士', '言語聴覚士']
          if (this.addressCheck(basicData, isAwesome_1addressArray)) {
            if (basicData.age >= 24 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isAwesome_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isAwesome_1KeywordArray)) {
                isAwesome_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isAwesome_1NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isAwesome_1NotKeywordArray)) {
                isAwesome_1 = false
              }
            }
          }

          const isDrtc_1AddressArray = true
          const isDrtc_1KeywordArray = ['ドライバー', '運輸', '運送', 'トランスポート', 'タクシー', 'ハイヤー', 'バス', '送迎', '交通', 'トラック', '大型免許', '大型二種', '配送', '輸送', '軽貨物', '地場', '運転手']
          if (basicData.age >= 35) {
            if (isDrtc_1AddressArray) {
              if (this.keywordCheckRirekisho(formatData, isDrtc_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isDrtc_1KeywordArray)) {
                isDrtc_1 = true
              }
            }
          }

          const isNeocareerNew_1AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府', '京都府', '兵庫県']
          const isNeocareerNew_1NotKeywordArray = ['休職', '鬱', '障害', '日本語能力検定', 'N1', 'N2', 'N3']
          if (this.addressCheck(basicData, isNeocareerNew_1AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isNeocareerNew_1NotKeywordArray)) {
              isNeocareerNew_1 = false
            } else {
              if (basicData.age >= 20 && basicData.age <= 29) {
                isNeocareerNew_1 = true
              }
            }
          }

          const isPharmate1KeywordArray = ['7fgsy9']
          const isPharmate1AddressArray = ['']
          if (true) {
            if (basicData.age >= 23 && basicData.age <= 59) {
              if (this.keywordCheckRirekisho(formatData, isPharmate1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isPharmate1KeywordArray)) {
                isPharmate1 = true
              }
            }
          }

          const isNorms_1KeywordArray = ['事業開発', 'SaaS', '月次決算', 'カスタマーサクセス', 'M&A', 'インフラエンジニア', 'WEBマーケ', 'プロジェクトマネージャ', '内部監査', '事業企画', '機械学習', '資金調達', 'ダイレクトリクルーティング', '日商簿記2級', 'HRBP', 'PdM', 'Kubernetes', 'テックリード', 'SRE', 'データエンジニア']
          const isNorms_1NotKeywordArray = ['日本語能力検定', '在留資格', '休職', '鬱', 'メンタル', 'パート', 'アルバイト', '時短', 'N1', 'N2', '派遣', '希望退職', '早期退職']
          const isNorms_1AddressArray = ['']
          if (true) {
            if (basicData.age >= 23 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isNorms_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isNorms_1KeywordArray)) {
                isNorms_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isNorms_1NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isNorms_1NotKeywordArray)) {
                isNorms_1 = false
              }
            }
          }

          const isHuemaridge_1AddressArray = ['東京都', '埼玉県', '千葉県', '神奈川県', '新潟県', '青森県', '宮城県', '福島県', '岩手県', '栃木県', '群馬県', '茨城県', '静岡県', '大阪県', '京都県', '愛知県', '石川県', '山形県', '富山県', '大分県', '岐阜県', '鳥取県', '広島県', '福岡県', '佐賀県', '沖縄県']
          const isHuemaridge_1KeywordArray = ['エステティシャン']
          if (basicData.age >= 18 && basicData.age <= 35) {
            if (this.addressCheck(basicData, isHuemaridge_1AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, isHuemaridge_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isHuemaridge_1KeywordArray)) {
                isHuemaridge_1 = true
              }
            }
          }

          if (formatData.gradeYear == 26) {
            if (basicData.email &&
              basicData.tel1 &&
              basicData.tel2 &&
              basicData.tel3 &&
              basicData.lastName &&
              basicData.firstName) {
              const isNeocareerAddressArray2 = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '山梨県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県']
              if (false) {
                if (basicData.age <= 25 && !formatData.foreignStudent) {
                  isNeocareer_1 = true
                  isHitotechNeocareer_1 = false
                }
              }
            }
          }
          if (basicData.email &&
            basicData.tel1 &&
            basicData.tel2 &&
            basicData.tel3 &&
            basicData.lastName &&
            basicData.firstName) {
            const isNeocareerAddressArray2 = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '山梨県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県']
            if (this.addressCheck(basicData, isNeocareerAddressArray2)) {
              if (basicData.age <= 25) {
                if (this.keywordCheck(formatId, formatData, '2026年　卒業見込') || this.keywordCheck(formatId, formatData, '2026年 卒業見込')) {
                  isNeocareer_2 = true
                }
              }
            }
          }
          if (formatData.gradeYear == 27) {
            if (basicData.email &&
              basicData.tel1 &&
              basicData.tel2 &&
              basicData.tel3 &&
              basicData.lastName &&
              basicData.firstName) {
              const isNeocareerAddressArray2 = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '山梨県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県']
              if (true) {
                if (basicData.age <= 25 && !formatData.foreignStudent) {
                  isNeocareer_3 = true
                }
              }
            }
          }

          if (formatData.gradeYear == 26) {
            const isOnecareer_1KeywordArray = ['大学']
            const isOnecareer_1AddressArray = ['東京都', '千葉県', '埼玉県', '神奈川県', '茨城県', '栃木県', '群馬県', '大阪府', '京都府', '兵庫県', '奈良県', '和歌山県', '滋賀県', '三重県']
            if (this.addressCheck(basicData, isOnecareer_1AddressArray)) {
              if (basicData.age >= 9998 && basicData.age <= 9999) {
                if (this.keywordCheckRirekisho(formatData, isOnecareer_1KeywordArray) ||
                  this.keywordCheckShokumukeirekisho(formatData, isOnecareer_1KeywordArray)) {
                  isOnecareer_1 = true
                }
              }
            }
          }

          if (formatData.gradeYear == 27) {
            const isVinc_1NotKeywordArray = ['東京大学', '京都大学', '大阪大学', '東北大学', '一橋大学', '東京外国語大学', '名古屋大学', '神戸大学', '早稲田大学', '慶應義塾大学', '東京理科大学', '東京科学大学']
            isVinc_1 = true
            if (this.keywordCheckRirekisho(formatData, isVinc_1NotKeywordArray)) {
              isVinc_1 = false
            }
          }

          const isRecrea_2KeywordArray = ['普通自動車第一種運転免許']
          const isRecrea_2AddressArray = ['宮城県', '福島県', '茨城県', '栃木県', '群馬県', '山梨県', '長野県', '石川県', '福井県', '岐阜県', '静岡県', '三重県', '兵庫県', '京都府', '滋賀県', '奈良県', '岡山県', '広島県', '山口県', '佐賀県', '長崎県', '大分県', '宮崎県', '鹿児島県']
          if (this.addressCheck(basicData, isRecrea_2AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isRecrea_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isRecrea_2KeywordArray)) {
                isRecrea_2 = true
              }
            }
          }

          const isNeocareer4AddressArray = ['北海道', '青森県', '岩手県', '宮城県', '福島県', '秋田県', '山形県', '茨城県', '栃木県', '群馬県', '長野県', '山梨県', '静岡県', '愛知県', '岐阜県', '新潟県', '富山県', '石川県', '福井県', '滋賀県', '京都府', '大阪府', '奈良県', '三重県', '和歌山県', '兵庫県', '岡山県', '広島県', '山口県', '島根県', '鳥取県', '香川県', '愛媛県', '高知県', '徳島県', '福岡県', '大分県', '宮崎県', '鹿児島県', '熊本県', '佐賀県', '長崎県', '沖縄県']
          if (this.addressCheck(basicData, isNeocareer4AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 50) {
              if (this.keywordCheck(formatId, formatData, '保育士')) {
                isNeocareer_4 = true
              }
            }
          }

          const isMedley_Link_5KeywordArray = ['看護師']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_5KeywordArray)) {
            isMedley_Link_5 = true
          }
          const isMedley_Link_6KeywordArray = ['介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_6KeywordArray)) {
            isMedley_Link_6 = true
          }
          const isMedley_Link_7KeywordArray = ['保育士']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_7KeywordArray)) {
            isMedley_Link_7 = true
          }
          const isMedley_Link_8KeywordArray = ['栄養士']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_8KeywordArray)) {
            isMedley_Link_8 = true
          }
          const isMedley_Link_9KeywordArray = ['作業療法士']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_9KeywordArray)) {
            isMedley_Link_9 = true
          }
          const isMedley_Link_10KeywordArray = ['理学療法士']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_10KeywordArray)) {
            isMedley_Link_10 = true
          }
          const isMedley_Link_11KeywordArray = ['臨床工学技士']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_11KeywordArray)) {
            isMedley_Link_11 = true
          }
          const isMedley_Link_12KeywordArray = ['臨床検査技師']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_12KeywordArray)) {
            isMedley_Link_12 = true
          }
          const isMedley_Link_13KeywordArray = ['診療放射線技師']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_13KeywordArray)) {
            isMedley_Link_13 = true
          }
          const isMedley_Link_14KeywordArray = ['言語聴覚士']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_14KeywordArray)) {
            isMedley_Link_14 = true
          }
          const isMedley_Link_15KeywordArray = ['視能訓練士']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_15KeywordArray)) {
            isMedley_Link_15 = true
          }
          const isMedley_Link_16KeywordArray = ['歯科衛生士']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_16KeywordArray)) {
            isMedley_Link_16 = true
          }
          const isMedley_Link_17KeywordArray = ['歯科助手']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_17KeywordArray)) {
            isMedley_Link_17 = true
          }
          const isMedley_Link_18KeywordArray = ['看護助手']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_18KeywordArray)) {
            isMedley_Link_18 = true
          }
          const isMedley_Link_19KeywordArray = ['美容師']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_19KeywordArray)) {
            isMedley_Link_19 = true
          }
          const isMedley_Link_20KeywordArray = ['柔道整復師']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_20KeywordArray)) {
            isMedley_Link_20 = true
          }
          const isMedley_Link_21KeywordArray = ['児童指導員']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_21KeywordArray)) {
            isMedley_Link_21 = true
          }
          const isMedley_Link_22KeywordArray = ['医療事務']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_22KeywordArray)) {
            isMedley_Link_22 = true
          }

          const isPleiades_9KeywordArray = ['保育士']
          if (this.keywordCheckRirekisho(formatData, isPleiades_9KeywordArray)) {
            if (basicData.age >= 51 && basicData.age <= 60) {
              isPleiades_9 = true
            }
          }

          const isPleiades_1KeywordArray = ['児童発達支援管理責任者', '児童支援員', '学童指導員', '放課後等デイサービス']
          if (this.keywordCheckRirekisho(formatData, isPleiades_1KeywordArray)) {
            if (basicData.age >= 30 && basicData.age <= 59) {
              isPleiades_1 = true
            }
          }
          const isPleiades_2KeywordArray = ['栄養士']
          const isPleiades_2NotKeywordArray = ['事務', '助手', '営業']
          const isPleiades_2AddressArray = ['北大阪北海道']
          // if (this.addressCheck(basicData, isPleiades_2AddressArray) || true) {
          if (true) {
            if (this.keywordCheckRirekisho(formatData, isPleiades_2KeywordArray) ||
              this.keywordCheckShokumukeirekisho(formatData, isPleiades_2KeywordArray)) {
              if (basicData.age >= 1008 && basicData.age <= 54) {
                isPleiades_2 = true
              }
            }
            if (this.keywordCheckRirekisho(formatData, isPleiades_2NotKeywordArray) ||
              this.keywordCheckShokumukeirekisho(formatData, isPleiades_2NotKeywordArray)) {
              isPleiades_2 = false
            }
          }
          const isPleiades_3KeywordArray = ['パティシエ', 'パン職人', 'ブーランジェ', '鮮魚加工', '精肉加工']
          const isPleiades_3AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '兵庫県', '京都府']
          if (this.addressCheck(basicData, isPleiades_3AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPleiades_3KeywordArray)) {
              if (basicData.age >= 23 && basicData.age <= 45) {
                isPleiades_3 = true
              }
            }
          }
          const isPleiades_4KeywordArray = ['建設機械整備技能士']
          if (true) {
            if (this.keywordCheckRirekisho(formatData, isPleiades_4KeywordArray)) {
              if (basicData.age >= 23 && basicData.age <= 45) {
                isPleiades_4 = true
              }
            }
          }
          const isPleiades_5KeywordArray = ['設備管理', '電気保安', 'ビルメンテナンス']
          const isPleiades_5AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '兵庫県', '京都府', '奈良県', '福岡県', '愛知県']
          if (this.addressCheck(basicData, isPleiades_5AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPleiades_5KeywordArray)) {
              if (basicData.age >= 23 && basicData.age <= 45) {
                isPleiades_5 = true
              }
            }
          }
          const isPleiades_6KeywordArray = ['ゼネコン', 'サブコン', '現場代理人', '現場監督']
          const isPleiades_6AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '兵庫県', '京都府', '奈良県', '福岡県', '愛知県']
          if (this.addressCheck(basicData, isPleiades_6AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPleiades_6KeywordArray)) {
              if (basicData.age >= 23 && basicData.age <= 45) {
                isPleiades_6 = true
              }
            }
          }
          const isPleiades_7KeywordArray = ['設備保全', 'ビル管理', '建築物環境衛生管理技術者']
          const isPleiades_7AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '兵庫県', '京都府', '奈良県', '福岡県', '愛知県']
          if (this.addressCheck(basicData, isPleiades_7AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPleiades_7KeywordArray)) {
              if (basicData.age >= 23 && basicData.age <= 45) {
                isPleiades_7 = true
              }
            }
          }
          const isPleiades_8KeywordArray = ['大型自動車', '中型自動車']
          const isPleiades_8AddressArray = ['大阪府']
          if (this.addressCheck(basicData, isPleiades_8AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPleiades_8KeywordArray)) {
              if (basicData.age >= 20 && basicData.age <= 49) {
                isPleiades_8 = true
              }
            }
          }

          const isJhr_1KeywordArray = ['営業', '製造', 'エンジニア', '接客', '販売']
          if (basicData.age >= 18 && basicData.age <= 34) {
            if (this.keywordCheckRirekisho(formatData, isJhr_1KeywordArray) ||
              this.keywordCheckShokumukeirekisho(formatData, isJhr_1KeywordArray)) {
              isJhr_1 = true
            }
          }
          const isJhr_2KeywordArray = ['製造', 'エンジニア']
          const isJhr_2AddressArray = ['東京都', '埼玉県', '神奈川県', '千葉県', '大阪府', '愛知県', '福岡県']
          if (this.addressCheck(basicData, isJhr_2AddressArray)) {
            if (basicData.age >= 18 && basicData.age <= 34) {
              if (this.keywordCheckRirekisho(formatData, isJhr_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isJhr_2KeywordArray)) {
                isJhr_2 = true
              }
            }
          }

          const isPeacekaigo1KeywordArray = ['ヘルパー2級', 'ヘルパー２級', 'ヘルパー二級', 'ヘルパー1級', 'ヘルパー１級', 'ヘルパー一級', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '精神保険福祉士', '介護支援専門員']
          const isPeacekaigo1AddressArray = ['北海道', '大阪府', '奈良県', '兵庫県']
          if (this.addressCheck(basicData, isPeacekaigo1AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPeacekaigo1KeywordArray) ||
              this.keywordCheckShokumukeirekisho(formatData, isPeacekaigo1KeywordArray)) {
              isPeacekaigo1 = true
            }
          }

          const isPeacekaigo2KeywordArray = ['介護福祉士', '実務者研修', '初任者研修']
          const isPeacekaigo2AddressArray = ['北海道', '青森県', '岩手県', '宮城県', '新潟県', '大阪府', '京都府', '兵庫県', '奈良県']
          if (this.addressCheck(basicData, isPeacekaigo2AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPeacekaigo2KeywordArray)) {
              isPeacekaigo2 = true
            }
          }

          const isPeacekaigo3KeywordArray = ['ヘルパー2級', 'ヘルパー1級', '初任者研修', '実務者研修', '介護福祉士', '介護支援専門員', '主任介護支援専門員']
          const isPeacekaigo3AddressArray = ['大阪府']
          if (this.addressCheck(basicData, isPeacekaigo3AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPeacekaigo3KeywordArray) ||
              this.keywordCheckShokumukeirekisho(formatData, isPeacekaigo3KeywordArray)) {
              isPeacekaigo3 = true
            }
          }

          const isPeacekaigo4KeywordArray = ['准看護師', '正看護師']
          if (true) {
            if (this.keywordCheckRirekisho(formatData, isPeacekaigo4KeywordArray)) {
              isPeacekaigo4 = true
            }
          }

          const isPeacekaigo5KeywordArray = ['正看護師']
          const isPeacekaigo5AddressArray = ['埼玉県', '千葉県', '東京都', '神奈川県', '大阪府', '兵庫県', '奈良県']
          if (this.addressCheck(basicData, isPeacekaigo5AddressArray)) {
            if (basicData.age >= 23 && basicData.age <= 65) {
              if (this.keywordCheckRirekisho(formatData, isPeacekaigo5KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isPeacekaigo5KeywordArray)) {
                isPeacekaigo5 = true
              }
            }
          }

          const isPleiades_10KeywordArray = ['保育士']
          const isPleiades_10_NotKeywordArray = ['事務', '接客', '在宅']
          const isPleiades_10AddressArray = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '新潟県', '富山県', '石川県', '福井県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県']
          if (this.addressCheck(basicData, isPleiades_10AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isPleiades_10KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isPleiades_10KeywordArray)) {
                isPleiades_10 = true
              }
              if (this.keywordCheckRirekisho(formatData, isPleiades_10_NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isPleiades_10_NotKeywordArray)) {
                isPleiades_10 = false
              }
            }
          }
          const isPleiades_18KeywordArray = ['保育士']
          const isPleiades_18_NotKeywordArray = ['事務', '接客', '在宅']
          const isPleiades_18AddressArray = ['茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県']
          if (this.addressCheck(basicData, isPleiades_18AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isPleiades_18KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isPleiades_18KeywordArray)) {
                isPleiades_18 = true
              }
              if (this.keywordCheckRirekisho(formatData, isPleiades_18_NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isPleiades_18_NotKeywordArray)) {
                isPleiades_18 = false
              }
            }
          }
          const isPleiades_11KeywordArray = ['施工管理']
          if (basicData.age >= 20 && basicData.age <= 65) {
            if (this.keywordCheckShokumukeirekisho(formatData, isPleiades_11KeywordArray)) {
              isPleiades_11 = true
            }
          }
          const isPleiades_12KeywordArray = ['自動車整備士']
          const isPleiades_12NotKeywordArray = ['事務職', 'IT', 'アルバイト']
          const isPleiades_12AddressArray = ['北大阪北海道']
          if (this.addressCheck(basicData, isPleiades_12AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 65) {
              if (this.keywordCheckShokumukeirekisho(formatData, isPleiades_12KeywordArray)) {
                isPleiades_12 = true
              }
              if (this.keywordCheckShokumukeirekisho(formatData, isPleiades_12NotKeywordArray)) {
                isPleiades_12 = false
              }
            }
          }
          const isPleiades_13KeywordArray = ['自動車整備工']
          if (basicData.age >= 20 && basicData.age <= 65) {
            if (this.keywordCheckShokumukeirekisho(formatData, isPleiades_13KeywordArray)) {
              isPleiades_13 = true
            }
          }
          const isPleiades_14KeywordArray = ['電気主任技術者']
          if (basicData.age >= 20 && basicData.age <= 65) {
            if (this.keywordCheckShokumukeirekisho(formatData, isPleiades_14KeywordArray)) {
              isPleiades_14 = true
            }
          }
          const isPleiades_15KeywordArray = ['管理技術者']
          if (basicData.age >= 20 && basicData.age <= 65) {
            if (this.keywordCheckShokumukeirekisho(formatData, isPleiades_15KeywordArray)) {
              isPleiades_15 = true
            }
          }
          const isPleiades_16KeywordArray = ['電気工事']
          if (basicData.age >= 20 && basicData.age <= 65) {
            if (this.keywordCheckShokumukeirekisho(formatData, isPleiades_16KeywordArray)) {
              isPleiades_16 = true
            }
          }
          const isPleiades_17KeywordArray = ['現場監督']
          if (basicData.age >= 20 && basicData.age <= 65) {
            if (this.keywordCheckShokumukeirekisho(formatData, isPleiades_17KeywordArray)) {
              isPleiades_17 = true
            }
          }

          if (true) {
            if (basicData.age >= 23 && basicData.age <= 59) {
              if (this.keywordCheckOnlyLicense(formatId, formatData, '薬剤師') ||
                this.keywordCheckShokumukeirekishoOnlyLicense(formatData, '薬剤師')) {
                isPharmacareer_1 = true
              }
            }
          }
          const isPharmacareer_2KeywordArray = ['薬剤師']
          if (true) {
            if (basicData.age >= 23 && basicData.age <= 59) {
              if (this.keywordCheckOnlyLicense(formatId, formatData, '薬剤師') ||
                this.keywordCheckShokumukeirekishoOnlyLicense(formatData, '薬剤師')) {
                isPharmacareer_2 = true
              }
            }
          }

          const isPharmacareer_3KeywordArray = ['']
          const isPharmacareer_3AddressArray = ['']
          if (true) {
            if (basicData.age >= 23 && basicData.age <= 59) {
              if (this.keywordCheckOnlyLicense(formatId, formatData, '薬剤師') ||
                this.keywordCheckShokumukeirekishoOnlyLicense(formatData, '薬剤師')) {
                isPharmacareer_3 = true
              }
            }
          }

          // let isKikkakeagent_1KeywordArray = ['Java', 'PHP', 'C#', 'プロジェクトマネージャー', 'PM', 'プロジェクトリーダー', 'システムアーキテクト', 'システムエンジニア', 'バックエンドエンジニア', 'インフラエンジニア', 'フロントエンドエンジニア', 'AWS', 'Azure', 'GCP', 'Linux']
          const isKikkakeagent_1KeywordArray = ['Java', 'PHP', 'C#', 'システムアーキテクト', 'システムエンジニア', 'バックエンドエンジニア', 'インフラエンジニア', 'フロントエンドエンジニア', 'GCP', 'Linux', 'TypeScript', 'Python', 'Go言語', 'COBOL', 'Angular', 'Laravel', 'React', 'Vue.js', 'Apache', 'Nginx', 'MariaDB', 'MongoDB', 'MySQL', 'Postgre', 'SES']
          const isKikkakeagent_1NotKeywordArray = ['営業']
          const isKikkakeagent_1AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府', '愛知県', '福岡県']
          if (this.addressCheck(basicData, isKikkakeagent_1AddressArray)) {
            if (basicData.age >= 24 && basicData.age <= 40) {
              if (this.keywordCheckRirekisho(formatData, isKikkakeagent_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isKikkakeagent_1KeywordArray)) {
                isKikkakeagent_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isKikkakeagent_1NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isKikkakeagent_1NotKeywordArray)) {
                isKikkakeagent_1 = false
              }
            }
          }
          if (formatId == 'engineer_shokumukeirekisho') {
            isKikkakeagent_1 = true
          }

          const isCloudlink_1KeywordArray = ['機械設計', '研究開発', '制御設計', '設計開発', '電気設計', '回路設計']
          const isCloudlink_1NotKeywordArray = ['事務', '営業', '経理']
          const isCloudlink_1AddressArray = ['']
          if (true) {
            if (basicData.age >= 20 && basicData.age <= 60) {
              if (this.keywordCheckRirekisho(formatData, isCloudlink_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isCloudlink_1KeywordArray)) {
                isCloudlink_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isCloudlink_1NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isCloudlink_1NotKeywordArray)) {
                isCloudlink_1 = false
              }
            }
          }
          const isCloudlink_2KeywordArray = ['Java', 'PHP', 'C#', 'システムアーキテクト', 'システムエンジニア', 'バックエンドエンジニア', 'インフラエンジニア', 'フロントエンドエンジニア', 'GCP', 'Linux', 'TypeScript', 'Python', 'Go言語', 'COBOL', 'Angular', 'Laravel', 'React', 'Vue.js', 'Apache', 'Nginx', 'MariaDB', 'MongoDB', 'MySQL', 'Postgre', 'SES']
          const isCloudlink_2AddressArray = ['']
          if (true) {
            if (basicData.age >= 25 && basicData.age <= 35) {
              if (this.keywordCheckRirekisho(formatData, isCloudlink_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isCloudlink_2KeywordArray)) {
                isCloudlink_2 = true
              }
            }
            if (basicData.age >= 40 && basicData.age <= 55) {
              if (this.keywordCheckRirekisho(formatData, isCloudlink_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isCloudlink_2KeywordArray)) {
                isCloudlink_2 = true
              }
            }
          }

          const isCloudlink_4AddressArray = ['']
          if ((basicData.age >= 25 && basicData.age <= 35) || (basicData.age >= 40 && basicData.age <= 55)) {
            isCloudlink_4 = true
          }

          const isHeros_1KeywordArray = ['販売']
          const isHeros_1AddressArray = ['大阪府']
          if (this.addressCheck(basicData, isHeros_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isHeros_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isHeros_1KeywordArray)) {
                isHeros_1 = true
              }
            }
          }
          const isHeros_2KeywordArray = ['販売', '接客']
          const isHeros_2AddressArray = ['新潟県', '石川県', '栃木県', '静岡県', '岐阜県', '福井県', '茨城県', '群馬県', '岡山県', '徳島県', '愛媛県', '宮崎県']
          const isHeros_2NotKeywordArray = ['事務']
          if (this.addressCheck(basicData, isHeros_2AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isHeros_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isHeros_2KeywordArray)) {
                isHeros_2 = true
              }
              if (this.keywordCheckRirekisho(formatData, isHeros_2NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isHeros_2NotKeywordArray)) {
                isHeros_2 = false
              }
            }
          }

          const isHuproinc_1KeywordArray = ['経理', '税理士', '税務', '財務', 'CFO']
          const isHuproinc_1NotKeywordArray = ['経理事務', '経理総務']
          const isHuproinc_1AddressArray = ['東京都', '大阪府']
          if (this.addressCheck(basicData, isHuproinc_1AddressArray)) {
            if (basicData.age >= 25 && basicData.age <= 45) {
              if (this.keywordCheckRirekisho(formatData, isHuproinc_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isHuproinc_1KeywordArray)) {
                isHuproinc_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isHuproinc_1NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isHuproinc_1NotKeywordArray)) {
                isHuproinc_1 = false
              }
            }
          }

          const isHuproinc_2KeywordArray = ['税理士法人', '社労士法人', '会計事務所', '社労士事務所', '税理士事務所', '簿記論', '財務諸表論', '相続税法', '消費税法', '酒税法', '国税徴収法', '所得税', '法人税', '住民税', '固定資産税', '事業税', '公認会計士', '月次決算', '年次決算', '四半期決算', '単体決算', '連結決算', '開示', '有価証券報告書の作成', 'Ⅰの部作成', '連結パッケージ', '法人税申告書作成', 'ショートレビュー', '税務申告', '巡回監査']
          const isHuproinc_2AddressArray = ['東京都', '大阪府']
          if (this.addressCheck(basicData, isHuproinc_2AddressArray)) {
            if (basicData.age >= 25 && basicData.age <= 45) {
              if (this.keywordCheckRirekisho(formatData, isHuproinc_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isHuproinc_2KeywordArray)) {
                isHuproinc_2 = true
              }
            }
          }

          const isJmsc_1KeywordArray = ['決算業務', '経理事務', '買掛・売掛管理', '伝票処理・記帳', '月次決算補助', '月次決算', '年次決算', '補助年次決算', '四半期決算補助', '四半期決算', '被連結決算', '連結決算', '上場企業経理', '有価証券報告書', '決算短信', '税務申告書作成', 'USGAAP', 'IFRS', '財務', '資金繰り', '資産運用', '資金調達', '与信管理', '税務調査対応', '自計化', '経理システム導入', '原価計算', '内部監査対応', '内部監査', 'IR', 'M&A', '医療会計・福祉会計']
          const isJmsc_1AddressArray = ['東京都', '大阪府', '愛知県']
          if (this.addressCheck(basicData, isJmsc_1AddressArray)) {
            if (basicData.age >= 30 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isJmsc_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isJmsc_1KeywordArray)) {
                isJmsc_1 = true
              }
            }
          }

          const isJmsc_2KeywordArray = ['新卒採用', '中途採用', '採用計画', '面接対応', '採用補助', 'SE採用', 'ダイレクトリクルーティング', '就業規則導入・運用・改定', '賃金制度', '人事考課制度', '福利厚生制度']
          const isJmsc_2AddressArray = ['東京都', '大阪府', '愛知県']
          if (this.addressCheck(basicData, isJmsc_2AddressArray)) {
            if (basicData.age >= 30 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isJmsc_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isJmsc_2KeywordArray)) {
                isJmsc_2 = true
              }
            }
          }

          const isJmsc_3KeywordArray = ['契約書管理', '契約書作成', '英文契約', '知的財産', '出願', '明細書作成', '各種中間処理', '特許', '意匠登録', '商標登録', '弁護士事務所対応', 'リスクマネジメント', '労働法務', '訴訟対応', 'コンプライアンス', '不動産法務']
          const isJmsc_3AddressArray = ['東京都', '大阪府', '愛知県']
          if (this.addressCheck(basicData, isJmsc_3AddressArray)) {
            if (basicData.age >= 30 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isJmsc_3KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isJmsc_3KeywordArray)) {
                isJmsc_3 = true
              }
            }
          }

          const isCareeradv_1KeywordArray = ['税理士法人', '税理士事務所', '会計事務所', '監査法人', '会計コンサルティングファーム', '税理士試験', '公認会計士試験', 'USCPA', 'CFO']
          const isCareeradv_1NotKeywordArray = ['派遣']
          const isCareeradv_1AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '愛知県', '静岡県', '大阪府', '京都府', '兵庫県', '広島県', '岡山県', '福岡県', '北海道', '宮城県']
          if (this.addressCheck(basicData, isCareeradv_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 45) {
              if (this.keywordCheckRirekisho(formatData, isCareeradv_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isCareeradv_1KeywordArray)) {
                isCareeradv_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isCareeradv_1NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isCareeradv_1NotKeywordArray)) {
                isCareeradv_1 = false
              }
            }
          }

          const isTryt_3KeywordArray = ['初任者研修', '実務者研修', '介護福祉士', 'ケアマネジャー']
          const isTryt_3NotAddressArray = ['山梨県', '大分県', '鳥取県', '山口県', '青森県', '神奈川県', '富山県', '秋田県', '千葉県', '兵庫県', '島根県', '北海道', '愛知県', '栃木県', '岐阜県', '宮城県', '宮崎県']

          if (this.addressCheck(basicData, isTryt_3NotAddressArray)) {
            // NOT
          } else {
            if (basicData.age >= 23 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isTryt_3KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isTryt_3KeywordArray)) {
                isTryt_3 = true
              }
            }
          }

          const isTryt_4KeywordArray = ['看護師', '助産師', '保健師']
          const isTryt_4NotAddressArray = ['東京都']
          const isTryt_4NotKeywordArray = ['動物看護士', '介護士', '営業', '事務']
          if (this.addressCheck(basicData, isTryt_4NotAddressArray)) {
            // NOT
          } else {
            if (basicData.age >= 23 && basicData.age <= 54) {
              if (this.keywordCheckRirekisho(formatData, isTryt_4KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isTryt_4KeywordArray)) {
                isTryt_4 = true
              }
              if (this.keywordCheckRirekisho(formatData, isTryt_4NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isTryt_4NotKeywordArray)) {
                isTryt_4 = false
              }
            }
          }

          const isTerracia_2KeywordArray = ['栄養士', '管理栄養士']
          const isTerracia_2NotKeywordArray = ['キャリアアドバイザー', 'エージェント', '人材業界', '転職斡旋', '転職サポート']
          const isTerracia_2AddressArray = ['東京都']
          if (this.addressCheck(basicData, isTerracia_2AddressArray)) {
            if (basicData.age >= 24 && basicData.age <= 35) {
              if (this.keywordCheckRirekisho(formatData, isTerracia_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isTerracia_2KeywordArray)) {
                isTerracia_2 = true
              }
              if (this.keywordCheckRirekisho(formatData, isTerracia_2NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isTerracia_2NotKeywordArray)) {
                isTerracia_2 = false
              }
            }
          }
          const isTerracia_1KeywordArray = ['保育士']
          const isTerracia_1NotKeywordArray = ['キャリアアドバイザー', 'エージェント', '人材業界', '転職斡旋', '転職サポート']
          const isTerracia_1AddressArray = ['東京都']
          if (this.addressCheck(basicData, isTerracia_1AddressArray)) {
            if (basicData.age >= 1000 && basicData.age <= 1001) {
              if (this.keywordCheckRirekisho(formatData, isTerracia_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isTerracia_1KeywordArray)) {
                isTerracia_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isTerracia_1NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isTerracia_1NotKeywordArray)) {
                isTerracia_1 = false
              }
            }
          }

          const isTerracia_3KeywordArray = ['保育士']
          const isTerracia_3NotKeywordArray = ['キャリアアドバイザー', 'エージェント', '人材業界', '転職斡旋', '転職サポート']
          const isTerracia_3AddressArray = ['沖縄県']
          if (this.addressCheck(basicData, isTerracia_3AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 55) {
              if (this.keywordCheckRirekisho(formatData, isTerracia_3KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isTerracia_3KeywordArray)) {
                isTerracia_3 = true
              }
              if (this.keywordCheckRirekisho(formatData, isTerracia_3NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isTerracia_3NotKeywordArray)) {
                isTerracia_3 = false
              }
            }
          }

          const isTerracia_4KeywordArray = ['保育士']
          const isTerracia_4NotKeywordArray = ['キャリアアドバイザー', 'エージェント', '人材業界', '転職斡旋', '転職サポート']
          const isTerracia_4AddressArray = ['長崎県', '熊本県']
          if (this.addressCheck(basicData, isTerracia_4AddressArray)) {
            if (basicData.age >= 1000 && basicData.age <= 1001) {
              if (this.keywordCheckRirekisho(formatData, isTerracia_4KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isTerracia_4KeywordArray)) {
                isTerracia_4 = true
              }
            }
          }

          const isUnisoncareer_1KeywordArray = ['ITエンジニア', '開発エンジニア', 'ソフトウェアエンジニア', 'バックエンドエンジニア', 'フロントエンドエンジニア', 'フルスタックエンジニア', 'iOSエンジニア', 'Androidエンジニア', 'モバイルアプリエンジニア', 'サーバーサイドエンジニア', '組み込みエンジニア', 'ファームウェアエンジニア', 'ゲームプログラマー', 'Unityエンジニア', 'Unreal Engineエンジニア', 'プログラマー', 'Javaエンジニア', 'Pythonエンジニア', 'Rubyエンジニア', 'インフラエンジニア', 'ネットワークエンジニア', 'サーバーエンジニア', 'DevOpsエンジニア', 'クラウドエンジニア', 'セキュリティエンジニア', 'データベースエンジニア', 'システムエンジニア', 'データサイエンティスト', '機械学習エンジニア', 'AIエンジニア', 'データエンジニア', 'BIエンジニア', 'リサーチエンジニア', '自然言語処理エンジニア', 'コンピュータビジョンエンジニア', 'ビッグデータエンジニア', 'プロジェクトマネージャー', 'スクラムマスター', 'テクニカルリード', 'テックリード', 'VPoE', 'CTO', 'QAエンジニア', 'テストエンジニア', '品質管理エンジニア', 'Java', 'Python', 'JavaScript', 'TypeScript', 'Go言語', 'Rust', 'C言語', 'C++', 'C#', 'Ruby', 'PHP', 'Swift', 'Kotlin', 'SQL', 'COBOL', 'VB.NET', 'Spring Boot', 'Django', 'Flask', 'Ruby on Rails', 'React', 'Angular', 'Vue.js', 'Next.js', 'React Native', 'Flutter', 'TensorFlow', 'PyTorch', 'pandas', 'Docker', 'Kubernetes', 'Laravel', '基本情報技術者', '応用情報技術者', 'プロジェクトマネージャ', 'ネットワークスペシャリスト', 'データベーススペシャリスト', '情報処理安全確保支援士', 'システムアーキテクト', 'ITストラテジスト', 'ITサービスマネージャ', 'システム監査技術者', 'エンベデッドシステムスペシャリスト', 'AWS', 'Microsoft Certified', 'Azure', 'Google Cloud Certified', 'Oracle Certified', 'Linux Professional Institute Certification', 'Linux技術者認定試験', 'Cisco Certified Network Associate', 'Cisco Certified Network Professional', 'VMware Certified Professional', 'Certified Information Systems Security Professional', 'Certified Information Systems Auditor', 'CompTIA', 'Project Management Professional', 'Certified ScrumMaster', 'Certified Scrum Product Owner', 'Projects in Controlled Environments 2', 'ITIL Foundation', 'Ruby技術者認定試験', 'UMLモデリング技能認定試験', 'SAA', 'DVA', 'SOA', 'SAP', 'DOP', 'DAS', 'MLS', 'SCS', 'DBS', 'GCP', 'AZ-900', 'AZ-104', 'AZ-204', 'AZ-305', 'AZ-400', 'AZ-500', 'LPIC', 'LinuC', 'CCNA', 'CCNP', 'Linux', 'macOS', 'Windows Server', 'MySQL', 'PostgreSQL', 'Oracle Database', 'MongoDB', 'Apache', 'Nginx', '要件定義', '基本設計', '詳細設計', 'エスカレーション', '切り分け', 'アジャイル', 'スクラム', 'ウォーターフォール', '単体テスト', '結合テスト', '総合テスト', '受入テスト', 'システムテスト', '自社開発', '受託開発', 'SIer', 'SES', 'OSSコントリビュート', 'コードレビュー', 'リファクタリング', 'マイクロサービス', 'サーバーレス', 'DDD', 'TDD', 'ドメイン駆動設計', 'テスト駆動開発', 'config', 'コンフィグ']
          const isUnisoncareer_1AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県']
          if (this.addressCheck(basicData, isUnisoncareer_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isUnisoncareer_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isUnisoncareer_1KeywordArray)) {
                isUnisoncareer_1 = true
              }
            }
          }

          const isGeekly_1KeywordArray = ['C#', 'システムアーキテクト', 'バックエンドエンジニア', 'インフラエンジニア', 'フロントエンドエンジニア', 'GCP', 'Linux', 'TypeScript', 'Python', 'Go言語', 'COBOL', 'Angular', 'Laravel', 'React', 'Vue.js', 'Apache', 'Nginx', 'MariaDB', 'MongoDB', 'MySQL', 'Postgre', 'データサイエンティスト', '社内SE', 'PdM', 'Docker', 'Unity', 'Ruby', 'Kotlin', 'Swift', '自然言語', '機械学習']
          const isGeekly_1AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府', '兵庫県', '京都府']
          if (this.addressCheck(basicData, isGeekly_1AddressArray)) {
            if (basicData.age >= 24 && basicData.age <= 55) {
              if (this.keywordCheckRirekisho(formatData, isGeekly_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isGeekly_1KeywordArray)) {
                isGeekly_1 = true
              }
            }
          }

          let isFindy_1KeywordArray = ['システムエンジニア', 'SE', 'プロジェクトマネジメント', 'C#', 'Java', 'PHP', '上流工程', '基幹システム', '業務システム', '基盤システム', 'システムインテグレーター', '運用保守', '保守開発', '設計フェーズ', '詳細設計', 'ウォーターフォール', 'ベンダーコントロール', '品質管理']

          // if (process.env.VUE_APP_MODE === 'staging') {
          //   console.error(process.env.VUE_APP_MODE)
          //   console.error(process.env.VUE_APP_MODE)
          //   console.error(process.env.VUE_APP_MODE)
          //   console.error(process.env.VUE_APP_MODE)
          //   console.error(process.env.VUE_APP_MODE)
          //   console.error(process.env.VUE_APP_MODE)
          //   console.error(process.env.VUE_APP_MODE)
          //   console.error(process.env.VUE_APP_MODE)
          //   console.error(process.env.VUE_APP_MODE)
          //   console.error(process.env.VUE_APP_MODE)
          //   console.error(process.env.VUE_APP_MODE)
          //   isFindy_1KeywordArray = ['スキル名', 'Azure OpenAI Service', 'Claude', 'Amazon Q Developer', 'Amazon Bedrock', 'Vertex AI', 'Perplexity', 'bolt', 'Felo', 'Cursor', 'Notion AI', 'Langfuse', 'LangSmith', 'LangGraph', 'Dify', 'v0', 'CodeRabbit', 'Devin', 'Cline', 'GitHub Copilot', 'LangChain', 'ChatGPT', 'Kiro', 'AI Agent', 'MCP', 'Claude Code', 'Codex', 'RAG', 'Coding Agent', 'Figma MCP', 'Mastra', 'LLMOps', 'OpenAI API', 'Context Engineering', 'Vercel AI', 'A2A', 'n8n', 'Greptile', 'Data Science', '強化学習', 'Agent Development Kit', 'pandas', 'presto', 'Pytorch', 'numpy', 'Apache Beam', 'Pyspark', 'Looker', 'Matplotlib', 'SciPy', 'LightGBM', 'QuickSight', 'Airflow', 'Dataform', 'xgboost', 'Spark', 'Hive', 'mecab', 'LookerStudio', 'Redash', 'dbt', 'OpenCV', 'Apache Spark', 'Databricks', 'OpenAI', 'MachineLearning', 'TensorFlow', 'Keras', 'splunk', 'Hadoop', 'Metabase', 'Chainer', 'MATLAB', 'Visual Basic', 'Elixir', 'Visual Basic .NET', 'Pascal', 'Bash', 'Dart', 'Rust', 'VBA', 'PowerShell', 'JCL', 'ABAP', 'C#.Net', 'SQL', 'Kotlin', 'ActionScript', 'ES6', 'Elm', 'AppleScript', 'Google App Script', 'Crystal', 'TypeScript', 'CoffeeScript', 'Common Lisp', 'ShellScript', 'OpenCL', 'PL/I', 'PLSQL', 'AccessVBA', 'BASIC', 'PHP', 'Nim', 'Julia', 'XML', 'GLSL', 'Shell', 'Cuda', 'Verilog', 'Scala', 'C#', 'Java', 'Smalltalk', 'VHDL', 'Zsh', 'HLSL', 'Python', 'Objective-C', 'C++', 'SystemVerilog', 'Apex', 'JavaScript', 'Solidity', 'VBScript', 'Swift', 'Perl', 'Ruby', 'F#', 'FORTRAN', 'OCaml', 'Assembly', 'Clojure', 'Delphi', 'Scheme', 'Lisp', 'Awk', 'Groovy', 'Haskell', 'COBOL', 'Lua', 'Erlang', 'Redux', 'Node.js', 'RxJava', 'Ruby on Rails', 'Laravel', 'Apache Cordova', 'RxSwift', 'Fastify', 'Akka', 'AngularJS', 'Django', 'Echo', 'SAStruts', 'Socket.IO', 'Electron', 'three.js', 'Hibernate', 'UniRx', 'OpenGL', 'mobx', 'React', 'Phalcon', 'Struts', 'FuelPHP', 'Vue', 'Symfony', 'jQuery', 'Tornado', 'Spring Framework', 'React Native', 'Angular', 'Vuex', 'WebGL', 'Riot.js', 'ASP.NET Core', 'Zend Framework', 'Struts2', 'Flask', 'Nuxt.js', 'Xamarin', 'Vuetify', 'Expo', 'DjangoRestFramework', 'Blazor', 'Drupal', 'VisualForce', 'NestJS', 'EJS', 'UIKit', 'Ajax', 'Thymeleaf', 'Sidekiq', 'Gatsby', 'TypeORM', 'ROS2', 'Next.js', 'UnrealEngine4', 'Hasura', 'FastAPI', 'svelte', 'Prisma', 'Seasar2', 'Apollo', 'Tailwind CSS', 'GORM', 'JSF', 'VIPER', 'MFC', 'D3.js', 'SwiftUI', 'Deno', 'Scrapy', 'Ktor', 'ProtocolBuffers', 'Apache Struts', 'Gatsbyjs', 'MovableType', 'Recoil', 'Material-UI', 'CodeIgniter', 'Twig', 'CakePHP', 'WPF', 'TanStack Query', 'Processing', 'RxJS', 'Strapi', 'Bootstrap', 'Haml', 'openFrameworks', 'SvelteKit', 'Smarty', 'Jetpack Compose', 'Sinatra', 'Liquid', 'GraphQL', 'Astro', 'MyBatis', 'Slim', 'Backbone.js', 'Spring Boot', 'Sass', 'Flutter', 'Play framework', 'MySQL', 'Apache Solr', 'Postgres', 'PostGIS', 'Oracle database', 'MSSQL', 'Neo4J', 'Realm', 'Aerospike', 'Elasticsearch', 'MongoDB', 'Firestore', 'SQLite', 'InfluxDB', 'Groonga', 'oracleDB', 'HBase', 'Redis', 'DynamoDB', 'Cassandra', 'Memcached', 'OpenSearch', 'MariaDB', 'SQL Server', 'PostgreSQL', 'Vim', 'GitHub Enterprise', 'Appium', 'Bitbucket', 'webpack', 'Selenium', 'GitHub', 'CircleCI', 'Storybook', 'Sketch', 'RSpec', 'Emacs', 'Babel', 'Gradle', 'Redmine', 'Eclipse', 'jupyter notebook', 'GitLab', 'Microcms', 'OutSystems', 'puppeteer', 'Code Climate', 'Invision', 'VisualStudio', 'Subversion', 'simulink', 'Jetbrains', 'Zube', 'BrowserStack', 'SchemaSpy', 'ZenHub', 'QGIS', 'TestCafe', 'YouTrack', 'Stoplight', 'Cypress', 'Jmeter', 'GitBucket', 'GitHub Projects', 'GitHub Actions', 'Backlog', 'Sentry', 'Intune', 'SonarQube', 'Bugsnag', 'PHPUnit', 'Android Studio', 'Postman', 'Maya', 'Stripe', 'Azure Pipelines', 'Cacoo', 'retool', 'maven', 'Jupyter', 'SVN', 'Adobe Dreamweaver', 'VSCode', 'fastlane', 'mabl', 'Toggl', 'Azure DevOps', 'Xcode', 'jest', 'Playwright', 'Gather', 'gulp', 'pytest', 'TravisCI', 'LaTeX', 'Power Virtual Agents', 'Bitrise', 'JUnit', 'SpeedCurve', 'ESLint', 'Autify', 'IntelliJ', 'grunt', 'oVice', 'Renovate', 'ffmpeg', 'MagicPod', 'GitLab CI/CD', 'Vite', 'Linear', 'Excel', 'Chromatic', 'Vitest', 'Git', 'Jira', 'Monaca', 'Zeplin', 'Pagerduty', 'PyCharm', 'Notion', 'yarn', 'Swagger', 'Confluence', 'Rollbar', 'Arduino', 'WebAssembly', 'UML', 'OAuth', 'Blockchain', 'Lambda', 'HULFT', 'Alexa', 'IaC', 'オンプレミス', 'PLC', 'FPGA', 'GIS', 'OpenAPI', 'Ethereum', 'RaspberryPi', 'BigQuery', 'AWS', 'OpenStack', 'AWS Lambda', 'Amazon Redshift', 'Amazon Aurora', 'Amazon RDS', 'Google App Engine', 'Amazon EC2', 'Amazon EKS', 'ElasticBeanstalk', 'Amazon ECS', 'Google Kubernetes Engine', 'CodeCommit', 'AWS CDK', 'AppSync', 'Salesforce', 'AzureAD', 'CloudFunctions', 'ElastiCache', 'Cloudwatch', 'Amazon SES', 'AWS CloudFormation', 'Cloudflare', 'AWS Fargate', 'Fastly', 'CodeBuild', 'Amazon Athena', 'Amazon CloudFront', 'Netlify', 'Cloud Run', 'OpenShift', 'Amazon SageMaker', 'AWS Elastic Beanstalk', 'Akamai', 'CloudSpanner', 'AWS Glue', 'Dataflow', 'algolia', 'Vercel', 'AWS Amplify', 'Amazon API Gateway', 'AWS CodePipeline', 'Cognito', 'Spanner', 'Auth0', 'Firebase', 'Supabase', 'Okta', 'Amazon EMR', 'Snowflake', 'TreasureData', 'Docker', 'Grafana', 'Itamae', 'Postfix', 'Juniper', 'Embulk', 'Consul', 'BGP', 'Squid', 'Capistrano', 'Serverless Framework', 'websocket', 'Yocto', 'Packer', 'Helm', 'Digdag', 'Envoy', 'Istio', 'weblogic', 'OSPF', 'Podman', 'Pulumi', 'Dovecot', 'Fabric', 'k8s', 'Docker Compose', 'Apache Tomcat', 'ArgoCD', 'ActiveDirectory', 'New Relic', 'MQTT', 'Chef', 'Vagrant', 'LDAP', 'Fluentd', 'Kafka', 'Terraform', 'Nagios', 'RabbitMQ', 'OpenTelemetry', 'Paloalto', 'Ansible', 'Prometheus', 'Jenkins', 'Kubernetes', 'haproxy', 'Zabbix', 'Nginx', 'BIND', 'Apache', 'Datadog', 'Ubuntu', 'AIX', 'VMware', 'RHEL', 'Windows Server', 'RTOS', 'HP-UX', 'KVM', 'ESXi', 'UWP', 'solaris', 'Hyper-V', 'VirtualBox', 'FreeBSD', 'Debian', 'UNIX', 'Linux', 'vSphere']
          // }
          isFindy_1KeywordArray = ['Azure OpenAI Service', 'Claude', 'Amazon Q Developer', 'Amazon Bedrock', 'Vertex AI', 'Perplexity', 'bolt', 'Felo', 'Cursor', 'Notion AI', 'Langfuse', 'LangSmith', 'LangGraph', 'Dify', 'v0', 'CodeRabbit', 'Devin', 'Cline', 'GitHub Copilot', 'LangChain', 'ChatGPT', 'Kiro', 'AI Agent', 'MCP', 'Claude Code', 'Codex', 'RAG', 'Coding Agent', 'Figma MCP', 'Mastra', 'LLMOps', 'OpenAI API', 'Context Engineering', 'Vercel AI', 'A2A', 'n8n', 'Greptile', 'Data Science', '強化学習', 'Agent Development Kit', 'pandas', 'presto', 'Pytorch', 'numpy', 'Apache Beam', 'Pyspark', 'Looker', 'Matplotlib', 'SciPy', 'LightGBM', 'QuickSight', 'Airflow', 'Dataform', 'xgboost', 'Spark', 'Hive', 'mecab', 'LookerStudio', 'Redash', 'dbt', 'OpenCV', 'Apache Spark', 'Databricks', 'OpenAI', 'MachineLearning', 'TensorFlow', 'Keras', 'splunk', 'Hadoop', 'Metabase', 'Chainer', 'MATLAB', 'Visual Basic', 'Elixir', 'Visual Basic .NET', 'Pascal', 'Bash', 'Dart', 'Rust', 'VBA', 'PowerShell', 'JCL', 'ABAP', 'C#.Net', 'SQL', 'Kotlin', 'ActionScript', 'ES6', 'Elm', 'AppleScript', 'Google App Script', 'Crystal', 'TypeScript', 'CoffeeScript', 'Common Lisp', 'ShellScript', 'OpenCL', 'PL/I', 'PLSQL', 'AccessVBA', 'BASIC', 'PHP', 'Nim', 'Julia', 'XML', 'GLSL', 'Shell', 'Cuda', 'Verilog', 'Scala', 'C#', 'Java', 'Smalltalk', 'VHDL', 'Zsh', 'HLSL', 'Python', 'Objective-C', 'C++', 'SystemVerilog', 'Apex', 'JavaScript', 'Solidity', 'VBScript', 'Swift', 'Perl', 'Ruby', 'F#', 'FORTRAN', 'OCaml', 'Assembly', 'Clojure', 'Delphi', 'Scheme', 'Lisp', 'Awk', 'Groovy', 'Haskell', 'COBOL', 'Lua', 'Erlang', 'Redux', 'Node.js', 'RxJava', 'Ruby on Rails', 'Laravel', 'Apache Cordova', 'RxSwift', 'Fastify', 'Akka', 'AngularJS', 'Django', 'Echo', 'SAStruts', 'Socket.IO', 'Electron', 'three.js', 'Hibernate', 'UniRx', 'OpenGL', 'mobx', 'React', 'Phalcon', 'Struts', 'FuelPHP', 'Vue', 'Symfony', 'jQuery', 'Tornado', 'Spring Framework', 'React Native', 'Angular', 'Vuex', 'WebGL', 'Riot.js', 'ASP.NET Core', 'Zend Framework', 'Struts2', 'Flask', 'Nuxt.js', 'Xamarin', 'Vuetify', 'Expo', 'DjangoRestFramework', 'Blazor', 'Drupal', 'VisualForce', 'NestJS', 'EJS', 'UIKit', 'Ajax', 'Thymeleaf', 'Sidekiq', 'Gatsby', 'TypeORM', 'ROS2', 'Next.js', 'UnrealEngine4', 'Hasura', 'FastAPI', 'svelte', 'Prisma', 'Seasar2', 'Apollo', 'Tailwind CSS', 'GORM', 'JSF', 'VIPER', 'MFC', 'D3.js', 'SwiftUI', 'Deno', 'Scrapy', 'Ktor', 'ProtocolBuffers', 'Apache Struts', 'Gatsbyjs', 'MovableType', 'Recoil', 'Material-UI', 'CodeIgniter', 'Twig', 'CakePHP', 'WPF', 'TanStack Query', 'Processing', 'RxJS', 'Strapi', 'Bootstrap', 'Haml', 'openFrameworks', 'SvelteKit', 'Smarty', 'Jetpack Compose', 'Sinatra', 'Liquid', 'GraphQL', 'Astro', 'MyBatis', 'Slim', 'Backbone.js', 'Spring Boot', 'Sass', 'Flutter', 'Play framework', 'MySQL', 'Apache Solr', 'Postgres', 'PostGIS', 'Oracle database', 'MSSQL', 'Neo4J', 'Realm', 'Aerospike', 'Elasticsearch', 'MongoDB', 'Firestore', 'SQLite', 'InfluxDB', 'Groonga', 'oracleDB', 'HBase', 'Redis', 'DynamoDB', 'Cassandra', 'Memcached', 'OpenSearch', 'MariaDB', 'SQL Server', 'PostgreSQL', 'Vim', 'GitHub Enterprise', 'Appium', 'Bitbucket', 'webpack', 'Selenium', 'GitHub', 'CircleCI', 'Storybook', 'Sketch', 'RSpec', 'Emacs', 'Babel', 'Gradle', 'Redmine', 'Eclipse', 'jupyter notebook', 'GitLab', 'Microcms', 'OutSystems', 'puppeteer', 'Code Climate', 'Invision', 'VisualStudio', 'Subversion', 'simulink', 'Jetbrains', 'Zube', 'BrowserStack', 'SchemaSpy', 'ZenHub', 'QGIS', 'TestCafe', 'YouTrack', 'Stoplight', 'Cypress', 'Jmeter', 'GitBucket', 'GitHub Projects', 'GitHub Actions', 'Backlog', 'Sentry', 'Intune', 'SonarQube', 'Bugsnag', 'PHPUnit', 'Android Studio', 'Postman', 'Maya', 'Stripe', 'Azure Pipelines', 'Cacoo', 'retool', 'maven', 'Jupyter', 'SVN', 'Adobe Dreamweaver', 'VSCode', 'fastlane', 'mabl', 'Toggl', 'Azure DevOps', 'Xcode', 'jest', 'Playwright', 'Gather', 'gulp', 'pytest', 'TravisCI', 'LaTeX', 'Power Virtual Agents', 'Bitrise', 'JUnit', 'SpeedCurve', 'ESLint', 'Autify', 'IntelliJ', 'grunt', 'oVice', 'Renovate', 'ffmpeg', 'MagicPod', 'GitLab CI/CD', 'Vite', 'Linear', 'Chromatic', 'Vitest', 'Git', 'Jira', 'Monaca', 'Zeplin', 'Pagerduty', 'PyCharm', 'Notion', 'yarn', 'Swagger', 'Confluence', 'Rollbar', 'Arduino', 'WebAssembly', 'UML', 'OAuth', 'Blockchain', 'Lambda', 'HULFT', 'Alexa', 'IaC', 'オンプレミス', 'PLC', 'FPGA', 'GIS', 'OpenAPI', 'Ethereum', 'RaspberryPi', 'BigQuery', 'AWS', 'OpenStack', 'AWS Lambda', 'Amazon Redshift', 'Amazon Aurora', 'Amazon RDS', 'Google App Engine', 'Amazon EC2', 'Amazon EKS', 'ElasticBeanstalk', 'Amazon ECS', 'Google Kubernetes Engine', 'CodeCommit', 'AWS CDK', 'AppSync', 'Salesforce', 'AzureAD', 'CloudFunctions', 'ElastiCache', 'Cloudwatch', 'Amazon SES', 'AWS CloudFormation', 'Cloudflare', 'AWS Fargate', 'Fastly', 'CodeBuild', 'Amazon Athena', 'Amazon CloudFront', 'Netlify', 'Cloud Run', 'OpenShift', 'Amazon SageMaker', 'AWS Elastic Beanstalk', 'Akamai', 'CloudSpanner', 'AWS Glue', 'Dataflow', 'algolia', 'Vercel', 'AWS Amplify', 'Amazon API Gateway', 'AWS CodePipeline', 'Cognito', 'Spanner', 'Auth0', 'Firebase', 'Supabase', 'Okta', 'Amazon EMR', 'Snowflake', 'TreasureData', 'Docker', 'Grafana', 'Itamae', 'Postfix', 'Juniper', 'Embulk', 'Consul', 'BGP', 'Squid', 'Capistrano', 'Serverless Framework', 'websocket', 'Yocto', 'Packer', 'Helm', 'Digdag', 'Envoy', 'Istio', 'weblogic', 'OSPF', 'Podman', 'Pulumi', 'Dovecot', 'Fabric', 'k8s', 'Docker Compose', 'Apache Tomcat', 'ArgoCD', 'ActiveDirectory', 'New Relic', 'MQTT', 'Chef', 'Vagrant', 'LDAP', 'Fluentd', 'Kafka', 'Terraform', 'Nagios', 'RabbitMQ', 'OpenTelemetry', 'Paloalto', 'Ansible', 'Prometheus', 'Jenkins', 'Kubernetes', 'haproxy', 'Zabbix', 'Nginx', 'BIND', 'Apache', 'Datadog', 'Ubuntu', 'AIX', 'VMware', 'RHEL', 'Windows Server', 'RTOS', 'HP-UX', 'KVM', 'ESXi', 'UWP', 'solaris', 'Hyper-V', 'VirtualBox', 'FreeBSD', 'Debian', 'UNIX', 'Linux', 'vSphere']
          const isFindy_1AddressArray = ['']
          if (true) {
            if (basicData.age >= 24 && basicData.age <= 50) {
              if (this.keywordCheckRirekisho(formatData, isFindy_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isFindy_1KeywordArray)) {
                isFindy_1 = true
              }
            }
          }

          const isGrandop_1KeywordArray = ['情報処理科', '情報システム科', '電子情報技術科', '情報学部', '工学部', '情報科学科', '情報工学科', 'コンピュータ科学科', '情報システム学科', '情報通信工学科', 'データサイエンス学部', 'データサイエンス学科', '人工知能学科']
          const isGrandop_1AddressArray = ['']
          if (true) {
            if (basicData.age >= 18 && basicData.age <= 35) {
              if (this.keywordCheckRirekisho(formatData, isGrandop_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isGrandop_1KeywordArray)) {
                isGrandop_1 = true
              }
            }
          }

          const isReaching_1KeywordArray = ['ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          const isReaching_1AddressArray = ['東京都', '神奈川県', '埼玉県', '愛知県', '静岡県', '京都府', '大阪府', '兵庫県', '福岡県']
          if (this.addressCheck(basicData, isReaching_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 39) {
              if (this.keywordCheckRirekisho(formatData, isReaching_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isReaching_1KeywordArray)) {
                isReaching_1 = true
              }
            }
          }

          const isReaching_2KeywordArray = ['看護師']
          const isReaching_2AddressArray = ['神奈川県', '千葉県', '東京都', '埼玉県', '静岡県', '愛知県', '京都府', '大阪府', '兵庫県', '奈良県', '福岡県', '熊本県', '鹿児島県', '沖縄県']
          if (this.addressCheck(basicData, isReaching_2AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 59) {
              if (this.keywordCheckRirekisho(formatData, isReaching_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isReaching_2KeywordArray)) {
                isReaching_2 = true
              }
            }
          }
          const isReaching_3KeywordArray = ['保育士', '幼稚園教諭']
          const isReaching_3AddressArray = ['東京都', '埼玉県', '神奈川県', '愛知県', '大阪府', '兵庫県']
          if (this.addressCheck(basicData, isReaching_3AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isReaching_3KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isReaching_3KeywordArray)) {
                isReaching_3 = true
              }
            }
          }
          const isReaching_4KeywordArray = ['接客', '販売']
          const isReaching_4AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '愛知県', '大阪府']
          if (this.addressCheck(basicData, isReaching_4AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isReaching_4KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isReaching_4KeywordArray)) {
                isReaching_4 = true
              }
            }
          }
          const isReaching_5KeywordArray = ['機械', '生産技術', '生産管理', '品質管理', '品質保証', '研究開発', '制御設計', '設計開発', '電気設計', '回路設計']
          const isReaching_5AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '愛知県', '大阪府']
          if (this.addressCheck(basicData, isReaching_5AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isReaching_5KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isReaching_5KeywordArray)) {
                isReaching_5 = true
              }
            }
          }

          const isRepath_1KeywordArray = ['看護師']
          const isRepath_1NotKeywordArray = ['動物看護師', '医療事務']
          const isRepath_1AddressArray = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県']
          if (this.addressCheck(basicData, isRepath_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 30) {
              if (this.keywordCheckRirekisho(formatData, isRepath_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isRepath_1KeywordArray)) {
                isRepath_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isRepath_1NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isRepath_1NotKeywordArray)) {
                isRepath_1 = false
              }
            }
          }

          const isDagent_1KeywordArray = ['看護師', '正看護師 ', '准看護師']
          const isDagent_1AddressArray = ['大阪府', '兵庫県', '京都府', '奈良県', '北海道']
          if (this.addressCheck(basicData, isDagent_1AddressArray)) {
            if (basicData.age >= 30 && basicData.age <= 50) {
              if (this.keywordCheckRirekisho(formatData, isDagent_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isDagent_1KeywordArray)) {
                isDagent_1 = true
              }
            }
          }

          const isSimple_1KeywordArray = ['保育士', '幼稚園教諭']
          const isSimple_1AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県']
          const isSimple_1NotAddressArray = ['Simple株式会社']
          if (this.addressCheck(basicData, isSimple_1AddressArray)) {
            if (basicData.age >= 23 && basicData.age <= 50) {
              if (this.keywordCheckRirekisho(formatData, isSimple_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isSimple_1KeywordArray)) {
                isSimple_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isSimple_1NotAddressArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isSimple_1NotAddressArray)) {
                isSimple_1 = false
              }
            }
          }

          const isNoajpn_1KeywordArray = ['看護師', '准看護師']
          const isNoajpn_1AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府']
          if (this.addressCheck(basicData, isNoajpn_1AddressArray)) {
            if (basicData.age >= 40 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isNoajpn_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isNoajpn_1KeywordArray)) {
                isNoajpn_1 = true
              }
            }
          }
          const isNoajpn_2KeywordArray = ['介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          const isNoajpn_2AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府']
          if (this.addressCheck(basicData, isNoajpn_2AddressArray)) {
            if (basicData.age >= 25 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isNoajpn_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isNoajpn_2KeywordArray)) {
                isNoajpn_2 = true
              }
            }
          }

          const isNineearth_1KeywordArray = ['介護福祉士', '初任者研修', '実務者研修', '介護士業務', '介護業務']
          const isNineearth_1AddressArray = ['愛知県', '岐阜県']
          const isNineearth_1NotKeywordArray = ['事務職', '営業職', '物流', '工場']
          if (this.addressCheck(basicData, isNineearth_1AddressArray)) {
            if (basicData.age >= 23 && basicData.age <= 60) {
              if (this.keywordCheckRirekisho(formatData, isNineearth_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isNineearth_1KeywordArray)) {
                isNineearth_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isNineearth_1NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isNineearth_1NotKeywordArray)) {
                isNineearth_1 = false
              }
            }
          }
          const isNineearth_2KeywordArray = ['介護福祉士', '初任者研修', '実務者研修']
          const isNineearth_2AddressArray = ['東京都']
          const isNineearth_2NotKeywordArray = ['事務職', '営業職', '物流', '工場', 'ネイル', '予約管理', 'ゲーム']
          if (this.addressCheck(basicData, isNineearth_2AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 60) {
              if (this.keywordCheckRirekisho(formatData, isNineearth_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isNineearth_2KeywordArray)) {
                isNineearth_2 = true
              }
              if (this.keywordCheckRirekisho(formatData, isNineearth_2NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isNineearth_2NotKeywordArray)) {
                isNineearth_2 = false
              }
            }
          }

          const isNineearth_3KeywordArray = ['介護福祉士', '初任者研修', '実務者研修', '介護士業務', '介護業務']
          const isNineearth_3NotKeywordArray = ['事務職', '営業職', '物流', '工場']
          const isNineearth_3AddressArray = ['三重県']
          if (this.addressCheck(basicData, isNineearth_3AddressArray)) {
            if (basicData.age >= 23 && basicData.age <= 60) {
              if (this.keywordCheckRirekisho(formatData, isNineearth_3KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isNineearth_3KeywordArray)) {
                isNineearth_3 = true
              }
              if (this.keywordCheckRirekisho(formatData, isNineearth_3NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isNineearth_3NotKeywordArray)) {
                isNineearth_3 = false
              }
            }
          }

          const isNineearth_4KeywordArray = ['介護福祉士', '初任者研修', '実務者研修', '介護士業務', '介護業務']
          const isNineearth_4NotKeywordArray = ['事務職', '営業職', '物流', '工場']
          const isNineearth_4AddressArray = ['静岡県']
          if (this.addressCheck(basicData, isNineearth_4AddressArray)) {
            if (basicData.age >= 23 && basicData.age <= 60) {
              if (this.keywordCheckRirekisho(formatData, isNineearth_4KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isNineearth_4KeywordArray)) {
                isNineearth_4 = true
              }
              if (this.keywordCheckRirekisho(formatData, isNineearth_4NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isNineearth_4NotKeywordArray)) {
                isNineearth_4 = false
              }
            }
          }

          const isNineearth_5KeywordArray = ['看護師', '助産師']
          const isNineearth_5NotKeywordArray = ['動物', 'リモート', 'オンライン']
          const isNineearth_5AddressArray = ['愛知県', '岐阜県']
          if (this.addressCheck(basicData, isNineearth_5AddressArray)) {
            if (basicData.age >= 23 && basicData.age <= 60) {
              if (this.keywordCheckRirekisho(formatData, isNineearth_5KeywordArray)) {
                isNineearth_5 = true
              }
              if (this.keywordCheckRirekisho(formatData, isNineearth_5NotKeywordArray)) {
                isNineearth_5 = false
              }
            }
          }

          const isKotrio_1KeywordArray = ['看護師']
          const isKotrio_1AddressArray = ['東京都', '神奈川県', '大阪府']
          const isKotrio_1NotKeywordArray = ['動物看護師']
          if (this.addressCheck(basicData, isKotrio_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isKotrio_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isKotrio_1KeywordArray)) {
                isKotrio_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isKotrio_1NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isKotrio_1NotKeywordArray)) {
                isKotrio_1 = false
              }
            }
          }

          const isAxes_1KeywordArray = ['介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          const isAxes_1AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '埼玉県']
          if (this.addressCheck(basicData, isAxes_1AddressArray)) {
            if (basicData.age >= 18 && basicData.age <= 60) {
              if (this.keywordCheckRirekisho(formatData, isAxes_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isAxes_1KeywordArray)) {
                isAxes_1 = true
              }
            }
          }

          const isKotrio_2KeywordArray = ['介護士', '初任者研修', '実務者研修', '介護福祉士']
          const isKotrio_2AddressArray = ['東京都', '神奈川県', '大阪府']
          if (this.addressCheck(basicData, isKotrio_2AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isKotrio_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isKotrio_2KeywordArray)) {
                isKotrio_2 = true
              }
            }
          }

          const isValuablelife_1KeywordArray = ['ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '介護支援専門員']
          const isValuablelife_1AddressArray = ['大阪府', '福岡県']
          if (this.addressCheck(basicData, isValuablelife_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 54) {
              if (this.keywordCheckRirekisho(formatData, isValuablelife_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isValuablelife_1KeywordArray)) {
                isValuablelife_1 = true
              }
            }
          }

          const isParable_1KeywordArray = ['看護師']
          const isParable_1NotKeywordArray = ['動物看護士']
          const isParable_1AddressArray = ['東京都']
          if (this.addressCheck(basicData, isParable_1AddressArray)) {
            if (basicData.age >= 23 && basicData.age <= 35) {
              if (this.keywordCheckRirekisho(formatData, isParable_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isParable_1KeywordArray)) {
                isParable_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isParable_1NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isParable_1NotKeywordArray)) {
                isParable_1 = false
              }
            }
          }

          const isStarlabo_1KeywordArray = ['看護師']
          const isStarlabo_1AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '茨城県', '栃木県', '群馬県']
          if (this.addressCheck(basicData, isStarlabo_1AddressArray)) {
            if (basicData.age >= 25 && basicData.age <= 55) {
              if (this.keywordCheckRirekisho(formatData, isStarlabo_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isStarlabo_1KeywordArray)) {
                isStarlabo_1 = true
              }
            }
          }

          const isSupernurse_1KeywordArray = ['看護師']
          const isSupernurse_1NotKeywordArray = ['准看護師']
          const isSupernurse_1AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          if (this.addressCheck(basicData, isSupernurse_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 59) {
              if (this.keywordCheckRirekisho(formatData, isSupernurse_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isSupernurse_1KeywordArray)) {
                isSupernurse_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isSupernurse_1NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isSupernurse_1NotKeywordArray)) {
                isSupernurse_1 = false
              }
            }
          }

          const isStarlabo_2KeywordArray = ['施工管理']
          const isStarlabo_2AddressArray = ['東京都', '埼玉県', '千葉県', '神奈川県', '愛知県', '大阪府', '福岡県']
          if (this.addressCheck(basicData, isStarlabo_2AddressArray)) {
            if (basicData.age >= 30 && basicData.age <= 45) {
              if (this.keywordCheckRirekisho(formatData, isStarlabo_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isStarlabo_2KeywordArray)) {
                isStarlabo_2 = true
              }
            }
          }

          if (this.keywordCheck(formatId, formatData, '薬剤師')) {
            if (basicData.age >= 23 && basicData.age <= 50) {
              isRecruitMc1 = true
            }
          }

          const isNeocareer_5AddressArray = ['ヤギ島']
          if (this.addressCheck(basicData, isNeocareer_5AddressArray)) {
            if (formatData.gradeYear === 27) {
              if (basicData.age <= 25 && false) {
                isNeocareer_5 = true
              }
            }
          }

          const isRecurrent_1KeywordArray = ['看護師資格', '看護師免許', '正看護師']
          const isRecurrent_1NotKeywordArray = ['動物', '中退']
          if (basicData.age >= 30 && basicData.age <= 39) {
            if (this.keywordCheckRirekisho(formatData, isRecurrent_1KeywordArray) ||
              this.keywordCheckShokumukeirekisho(formatData, isRecurrent_1KeywordArray)) {
              isRecurrent_1 = true
            }
            if (this.keywordCheckRirekisho(formatData, isRecurrent_1NotKeywordArray) ||
              this.keywordCheckShokumukeirekisho(formatData, isRecurrent_1NotKeywordArray)) {
              isRecurrent_1 = false
            }
          }

          const isRecurrent_2KeywordArray = ['ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          if (basicData.age >= 30 && basicData.age <= 39) {
            if (this.keywordCheckRirekisho(formatData, isRecurrent_2KeywordArray) ||
              this.keywordCheckShokumukeirekisho(formatData, isRecurrent_2KeywordArray)) {
              isRecurrent_2 = true
            }
          }

          const isRecurrent_3KeywordArray = ['理学療法士', '言語聴覚士', '作業療法士']
          if (basicData.age >= 20 && basicData.age <= 39) {
            if (this.keywordCheckRirekisho(formatData, isRecurrent_3KeywordArray) ||
              this.keywordCheckShokumukeirekisho(formatData, isRecurrent_3KeywordArray)) {
              isRecurrent_3 = true
            }
          }

          const isRecurrent_4KeywordArray = ['保育士資格', '保育士免許']
          if (basicData.age >= 20 && basicData.age <= 39) {
            if (this.keywordCheckRirekisho(formatData, isRecurrent_4KeywordArray) ||
              this.keywordCheckShokumukeirekisho(formatData, isRecurrent_4KeywordArray)) {
              isRecurrent_4 = true
            }
          }

          const isTsace_1KeywordArray = ['ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          if (basicData.age >= 20 && basicData.age <= 59) {
            if (this.keywordCheckRirekisho(formatData, isTsace_1KeywordArray) ||
              this.keywordCheckShokumukeirekisho(formatData, isTsace_1KeywordArray)) {
              isTsace_1 = true
            }
          }

          const isTsace_2KeywordArray = ['理学療法士', '作業療法士', '言語聴覚士']
          const isTsace_2AddressArray = ['東京都', '千葉県', '神奈川県', '埼玉県', '北海道', '宮城県', '大阪府', '兵庫県', '愛知県']
          if (this.addressCheck(basicData, isTsace_2AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 59) {
              if (this.keywordCheckRirekisho(formatData, isTsace_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isTsace_2KeywordArray)) {
                isTsace_2 = true
              }
            }
          }

          const isTsace_3KeywordArray = ['保育士', '幼稚園教諭', '児童発達支援管理責任者']
          const isTsace_3AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '兵庫県', '京都府', '愛知県', '宮城県', '茨城県', '群馬県', '山形県', '北海道']
          if (this.addressCheck(basicData, isTsace_3AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 59) {
              if (this.keywordCheckRirekisho(formatData, isTsace_3KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isTsace_3KeywordArray)) {
                isTsace_3 = true
              }
            }
          }

          const isMitzmitz_5KeywordArray = ['施工管理技士']
          const isMitzmitz_5AddressArray = ['東京都', '埼玉県', '千葉県', '神奈川県', '大阪府', '京都府', '兵庫県']
          if (this.addressCheck(basicData, isMitzmitz_5AddressArray)) {
            if (basicData.age >= 18 && basicData.age <= 65) {
              if (this.keywordCheckRirekisho(formatData, isMitzmitz_5KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isMitzmitz_5KeywordArray)) {
                isMitzmitz_5 = true
              }
            }
          }

          const isMitzmitz_6KeywordArray = ['機械設計', 'CAD']
          const isMitzmitz_6AddressArray = ['大阪府', '京都府', '兵庫県']
          if (this.addressCheck(basicData, isMitzmitz_6AddressArray)) {
            if (basicData.age >= 18 && basicData.age <= 65) {
              if (this.keywordCheckRirekisho(formatData, isMitzmitz_6KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isMitzmitz_6KeywordArray)) {
                isMitzmitz_6 = true
              }
            }
          }

          const isMitzmitz_3KeywordArray = ['化学']
          const isMitzmitz_3AddressArray = ['大阪府', '京都府', '兵庫県']
          if (this.addressCheck(basicData, isMitzmitz_3AddressArray)) {
            if (basicData.age >= 18 && basicData.age <= 65) {
              if (this.keywordCheckRirekisho(formatData, isMitzmitz_3KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isMitzmitz_3KeywordArray)) {
                isMitzmitz_3 = true
              }
            }
          }

          const isMitzmitz_2KeywordArray = ['保育士']
          const isMitzmitz_2AddressArray = ['大阪府']
          if (this.addressCheck(basicData, isMitzmitz_2AddressArray)) {
            if (basicData.age >= 18 && basicData.age <= 65) {
              if (this.keywordCheckRirekisho(formatData, isMitzmitz_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isMitzmitz_2KeywordArray)) {
                isMitzmitz_2 = true
              }
            }
          }

          const isMitzmitz_1KeywordArray = ['法人営業', 'カスタマーサポート', 'コールセンター']
          const isMitzmitz_1AddressArray = ['東京都', '埼玉県', '千葉県', '神奈川県', '大阪府', '兵庫県', '北海道', '広島県', '福岡県']
          if (this.addressCheck(basicData, isMitzmitz_1AddressArray)) {
            if (basicData.age >= 18 && basicData.age <= 65) {
              if (this.keywordCheckRirekisho(formatData, isMitzmitz_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isMitzmitz_1KeywordArray)) {
                isMitzmitz_1 = true
              }
            }
          }

          const isMitzmitz_4KeywordArray = ['建築士']
          const isMitzmitz_4AddressArray = ['東京都', '埼玉県', '千葉県', '神奈川県', '大阪府', '京都府', '兵庫県']
          if (this.addressCheck(basicData, isMitzmitz_4AddressArray)) {
            if (basicData.age >= 18 && basicData.age <= 65) {
              if (this.keywordCheckRirekisho(formatData, isMitzmitz_4KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isMitzmitz_4KeywordArray)) {
                isMitzmitz_4 = true
              }
            }
          }

          const isTruspo_1KeywordArray = ['法人営業', '個人営業', '新規営業', 'ルート営業', 'インサイドセールス', 'フィールドセールス', '提案営業', 'コンサル営業', '営業', '接客', '販売', 'セールス', 'リーダー']
          const isTruspo_1NotKeywordArray = ['事務', '経理', '人事', '総務', 'エンジニア', 'プログラマー', 'デザイナー', '看護師', '介護', '保育士']
          const isTruspo_1AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          if (this.addressCheck(basicData, isTruspo_1AddressArray)) {
            if (basicData.age >= 23 && basicData.age <= 34) {
              if (this.keywordCheckRirekisho(formatData, isTruspo_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isTruspo_1KeywordArray)) {
                isTruspo_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isTruspo_1NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isTruspo_1NotKeywordArray)) {
                isTruspo_1 = false
              }
            }
          }

          const isFirstconnect_1KeywordArray = ['歯科医師', '歯科衛生士']
          const isFirstconnect_1NotKeywordArray = ['歯科助手', '保育', '栄養', '養護', 'ピラティス', 'ヨガ', '秘書', '簿記', 'ファイナンシャルプランナー', '派遣', '営業', '経理', 'カスタマーサポート', 'マーケティング', '株', '会社', '再就職', '職業訓練']
          // let isFirstconnect_1AddressArray = ['']
          if (basicData.age >= 20 && basicData.age <= 59) {
            if (this.keywordCheckRirekisho(formatData, isFirstconnect_1KeywordArray) ||
              this.keywordCheckShokumukeirekisho(formatData, isFirstconnect_1KeywordArray)) {
              isFirstconnect_1 = true
            }

            isFirstconnect_1KeywordArray.forEach(keyword => {
              if (this.keywordCheckOnlyLicense(formatId, formatData, keyword)) {
                isFirstconnect_1 = true
              }
            })

            if (this.keywordCheckRirekisho(formatData, isFirstconnect_1NotKeywordArray) ||
              this.keywordCheckShokumukeirekisho(formatData, isFirstconnect_1NotKeywordArray)) {
              isFirstconnect_1 = false
            }
          }

          if (formatData.gradeYear == 27) {
            if (!formatData.foreignStudent) {
              if (this.keywordCheck(formatId, formatData, '大学')) {
                isIrodas_1 = true
              }
            }
          }

          const isRoxx13AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          const isRoxx13NotKeywordArray = ['看護師', '保育士', '栄養士', '施工管理', '自動車整備士', '電気主任技術者', '介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          if (this.addressCheck(basicData, isRoxx13AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 35) {
              isRoxx13 = true
              if (this.keywordCheckRirekisho(formatData, isRoxx13NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isRoxx13NotKeywordArray)) {
                isRoxx13 = false
              }
            }
          }

          const isRoxx14AddressArray = ['茨城県', '栃木県', '群馬県']
          const isRoxx14NotKeywordArray = ['看護師', '保育士', '栄養士', '施工管理', '自動車整備士', '電気主任技術者', '介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          if (this.addressCheck(basicData, isRoxx14AddressArray)) {
            if (basicData.age >= 1004 && basicData.age <= 35) {
              isRoxx14 = true
              if (this.keywordCheckRirekisho(formatData, isRoxx14NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isRoxx14NotKeywordArray)) {
                isRoxx14 = false
              }
            }
          }

          const isRoxx15AddressArray = ['大阪府']
          const isRoxx15NotKeywordArray = ['看護師', '保育士', '栄養士', '施工管理', '自動車整備士', '電気主任技術者', '介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          if (this.addressCheck(basicData, isRoxx15AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 35) {
              isRoxx15 = true
              if (this.keywordCheckRirekisho(formatData, isRoxx15NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isRoxx15NotKeywordArray)) {
                isRoxx15 = false
              }
            }
          }

          const isRoxx16AddressArray = ['兵庫県', '京都府']
          const isRoxx16NotKeywordArray = ['看護師', '保育士', '栄養士', '施工管理', '自動車整備士', '電気主任技術者', '介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          if (this.addressCheck(basicData, isRoxx16AddressArray)) {
            if (basicData.age >= 1004 && basicData.age <= 35) {
              isRoxx16 = true
              if (this.keywordCheckRirekisho(formatData, isRoxx16NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isRoxx16NotKeywordArray)) {
                isRoxx16 = false
              }
            }
          }

          const isRecurrent_5KeywordArray = ['ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          const isRecurrent_5NotKeywordArray = ['派遣', 'パート', 'アルバイト']
          const isRecurrent_5AddressArray = ['神奈川県横浜市', '神奈川県川崎市']
          if (this.addressCheck(basicData, isRecurrent_5AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isRecurrent_5KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isRecurrent_5KeywordArray)) {
                isRecurrent_5 = true
              }
              if (this.keywordCheckRirekisho(formatData, isRecurrent_5NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isRecurrent_5NotKeywordArray)) {
                isRecurrent_5 = false
              }
            }
          }

          const isSecondgame_1KeywordArray = ['保育士', '保母', '幼稚園教諭', '幼稚園免許', '保育教諭', '幼稚園教員免許', '幼保特例']
          const isSecondgame_1NotKeywordArray = ['無資格', '資格なし', '取得予定', '受験予定', '子育て支援員', '保育補助']
          const isSecondgame_1AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          if (this.addressCheck(basicData, isSecondgame_1AddressArray)) {
            if (basicData.age >= 22 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isSecondgame_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isSecondgame_1KeywordArray)) {
                isSecondgame_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isSecondgame_1NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isSecondgame_1NotKeywordArray)) {
                isSecondgame_1 = false
              }
            }
          }

          const isSecondgame_2KeywordArray = ['保育士', '保母', '幼稚園教諭', '幼稚園免許', '保育教諭', '幼稚園教員免許', '幼保特例']
          const isSecondgame_2NotKeywordArray = ['無資格', '資格なし', '取得予定', '受験予定', '子育て支援員', '保育補助']
          const isSecondgame_2AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          if (this.addressCheck(basicData, isSecondgame_2AddressArray)) {
            if (basicData.age >= 22 && basicData.age <= 54) {
              if (this.keywordCheckRirekisho(formatData, isSecondgame_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isSecondgame_2KeywordArray)) {
                isSecondgame_2 = true
              }
              if (this.keywordCheckRirekisho(formatData, isSecondgame_2NotKeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isSecondgame_2NotKeywordArray)) {
                isSecondgame_2 = false
              }
            }
          }

          const isEil100_1KeywordArray = ['准看護師', '正看護師', '保健師']
          const isEil100_1AddressArray = ['北海道', '大阪府']
          if (this.addressCheck(basicData, isEil100_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 59) {
              if (this.keywordCheckRirekisho(formatData, isEil100_1KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isEil100_1KeywordArray)) {
                isEil100_1 = true
              }
            }
          }

          const isEil100_2KeywordArray = ['介護福祉士', '社会福祉法人']
          const isEil100_2AddressArray = ['北海道', '埼玉県', '愛知県']
          if (this.addressCheck(basicData, isEil100_2AddressArray)) {
            if (basicData.age >= 25 && basicData.age <= 56) {
              if (this.keywordCheckRirekisho(formatData, isEil100_2KeywordArray) ||
                this.keywordCheckShokumukeirekisho(formatData, isEil100_2KeywordArray)) {
                isEil100_2 = true
              }
            }
          }

          const isWitc1KeywordArray = ['製造']
          const isWitc1NotKeywordArray = ['日本語', 'N1', 'N2', 'N3', 'N4', 'N5', '日本語能力試験', 'JLPT', '障害者手帳']
          if (basicData.age >= 18 && basicData.age <= 49) {
            if (this.keywordCheckRirekisho(formatData, isWitc1KeywordArray) ||
              this.keywordCheckShokumukeirekisho(formatData, isWitc1KeywordArray)) {
              isWitc1 = true
            }
            if (this.keywordCheckRirekisho(formatData, isWitc1NotKeywordArray) ||
              this.keywordCheckShokumukeirekisho(formatData, isWitc1NotKeywordArray)) {
              isWitc1 = false
            }
          }

          // ビズリーチ送信条件
          if (basicData.age >= 25 && basicData.age <= 45) {
            if (this.keywordCheckBizreach1(formatData, basicData)) {
              isBizreach_1 = true
            }
          }

          if (formatData.gradeYear == 28) {
            if (!formatData.foreignStudent) {
              if (this.keywordCheck(formatId, formatData, '大学')) {
                isIrodas_2 = true
              }
            }
          }

          for (const val in request_data) {
            if (request_data[val].client_id == 'roxx_api' &&
              request_data[val].permission_type == 2 &&
              (!request_data[val].request_able || this.shouldSuppressRtPopupForAutoRT(request_data[val]))) {
              isRoxx2 = false
            }
            if (request_data[val].client_id == 'roxx_api' &&
              request_data[val].permission_type == 1 &&
              (!request_data[val].request_able || this.shouldSuppressRtPopupForAutoRT(request_data[val]))) {
              isRoxx = false
            }
            if (request_data[val].client_id == 'roxx_api' &&
              request_data[val].permission_type == 13 &&
              (!request_data[val].request_able || this.shouldSuppressRtPopupForAutoRT(request_data[val]))) {
              isRoxx13 = false
            }
            if (request_data[val].client_id == 'roxx_api' &&
              request_data[val].permission_type == 14 &&
              (!request_data[val].request_able || this.shouldSuppressRtPopupForAutoRT(request_data[val]))) {
              isRoxx14 = false
            }
            if (request_data[val].client_id == 'roxx_api' &&
              request_data[val].permission_type == 15 &&
              (!request_data[val].request_able || this.shouldSuppressRtPopupForAutoRT(request_data[val]))) {
              isRoxx15 = false
            }
            if (request_data[val].client_id == 'roxx_api' &&
              request_data[val].permission_type == 16 &&
              (!request_data[val].request_able || this.shouldSuppressRtPopupForAutoRT(request_data[val]))) {
              isRoxx16 = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isJob919_1 = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 7 &&
              !request_data[val].request_able) {
              isJob919_7 = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isJob919_2 = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 8 &&
              !request_data[val].request_able) {
              isJob919_8 = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 9 &&
              !request_data[val].request_able) {
              isJob919_9 = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isJob919_3 = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isJob919_4 = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isJob919_5 = false
            }
            if (request_data[val].client_id == 'persolinnovation_admin' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isPersolinnovation_1 = false
            }
            if (request_data[val].client_id == 'persolinnovation_admin' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isPersolinnovation_2 = false
            }

            if (request_data[val].client_id == 'persolinnovation_admin' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isPersolinnovation_3 = false
            }

            if (request_data[val].client_id == 'persolinnovation_admin' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isPersolinnovation_5 = false
            }

            if (request_data[val].client_id == 'recrea_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isRecrea_1 = false
            }

            if (request_data[val].client_id == 'surely_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isSurely_1 = false
            }

            if (request_data[val].client_id == 'persolinnovation_admin' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isPersolinnovation_4 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isHrcareer_5 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 6 &&
              !request_data[val].request_able) {
              isHrcareer_6 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 7 &&
              !request_data[val].request_able) {
              isHrcareer_7 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 8 &&
              !request_data[val].request_able) {
              isHrcareer_8 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 9 &&
              !request_data[val].request_able) {
              isHrcareer_9 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 10 &&
              !request_data[val].request_able) {
              isHrcareer_10 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 11 &&
              !request_data[val].request_able) {
              isHrcareer_11 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 12 &&
              !request_data[val].request_able) {
              isHrcareer_12 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 15 &&
              !request_data[val].request_able) {
              isHrcareer_15 = false
            }

            if (request_data[val].client_id == 'leverages_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isLeverages_1 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isMedley1 = false
              isMedley2 = false
              isMedley3 = false
              isMedley4 = false
              isMedley5 = false
              isMedley6 = false
              isMedley7 = false
              isMedley8 = false
              isMedley9 = false
              isMedley10 = false
            }
            // 特定のメールドメインがidのユーザー送客の停止「@privaterelay.appleid.com」
            if (this.$firebase.user.email.includes('privaterelay.appleid')) {
              isMedley_Link_5 = false
              isMedley_Link_6 = false
              isMedley_Link_7 = false
              isMedley_Link_8 = false
            }

            if (request_data[val].client_id == 'roxx_api' &&
              request_data[val].permission_type == 3 &&
              (!request_data[val].request_able || this.shouldSuppressRtPopupForAutoRT(request_data[val]))) {
              isRoxx3 = false
            }
            if (request_data[val].client_id == 'roxx_api' &&
              request_data[val].permission_type == 4 &&
              (!request_data[val].request_able || this.shouldSuppressRtPopupForAutoRT(request_data[val]))) {
              isRoxx4 = false
            }
            // Hrteam_mail 1はauto-RT表示時に suppressRtPopupForAutoRT で非表示とする
            if (request_data[val].client_id == 'hrteam_mail' &&
              request_data[val].permission_type == 1 &&
              (!request_data[val].request_able || this.shouldSuppressRtPopupForAutoRT(request_data[val]))) {
              isHrteam_1 = false
            }
            if (request_data[val].client_id == 'cmindcareer_mail' &&
              request_data[val].permission_type == 1 &&
              (!request_data[val].request_able || this.shouldSuppressRtPopupForAutoRT(request_data[val]))) {
              isCmindcareer_1 = false
            }
            if (request_data[val].client_id == 'draft_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isDraft_1 = false
            }
            if (request_data[val].client_id == 'roxx_api' &&
              request_data[val].permission_type == 5 &&
              (!request_data[val].request_able || this.shouldSuppressRtPopupForAutoRT(request_data[val]))) {
              isRoxx5 = false
            }
            if (request_data[val].client_id == 'hitotech_admin' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isHitotech_1 = false
            }
            if (request_data[val].client_id == 'hitotech_admin' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isHitotech_2 = false
            }
            if (request_data[val].client_id == 'hitotech_admin' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isHitotech_3 = false
            }
            if (request_data[val].client_id == 'hitotech_admin' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isHitotech_4 = false
            }
            if (request_data[val].client_id == 'careerdraft_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isCareerdraft_1 = false
            }
            if (request_data[val].client_id == 'careerdraft_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isCareerdraft_2 = false
            }
            if (request_data[val].client_id == 'careerdraft_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isCareerdraft_3 = false
            }

            if (request_data[val].client_id == 'roxx_api' &&
              request_data[val].permission_type == 11 &&
              (!request_data[val].request_able || this.shouldSuppressRtPopupForAutoRT(request_data[val]))) {
              isRoxx11 = false
            }
            if (request_data[val].client_id == 'roxx_api' &&
              request_data[val].permission_type == 6 &&
              (!request_data[val].request_able || this.shouldSuppressRtPopupForAutoRT(request_data[val]))) {
              isRoxx6 = false
            }
            if (request_data[val].client_id == 'roxx_api' &&
              request_data[val].permission_type == 7 &&
              (!request_data[val].request_able || this.shouldSuppressRtPopupForAutoRT(request_data[val]))) {
              isRoxx7 = false
            }

            if (request_data[val].client_id == 'roxx_api' &&
              request_data[val].permission_type == 8 &&
              (!request_data[val].request_able || this.shouldSuppressRtPopupForAutoRT(request_data[val]))) {
              isRoxx8 = false
            }

            if (request_data[val].client_id == 'taikennyusha_link' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isTaikennyusha_1 = false
            }
            if (request_data[val].client_id == 'taikennyusha_link' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isTaikennyusha_2 = false
            }
            if (request_data[val].client_id == 'neocareer_new_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isNeocareerNew_1 = false
            }
            if (request_data[val].client_id == 'drtc_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isDrtc_1 = false
            }
            if (request_data[val].client_id == 'neocareer_admin' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isNeocareer_1 = false
            }
            if (request_data[val].client_id == 'neocareer_admin' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isHitotechNeocareer_1 = false
            }
            if (request_data[val].client_id == 'neocareer_admin' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isHitotechNeocareer_1 = false
            }
            if (request_data[val].client_id == 'hitotech_admin' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isHitotechNeocareer_1 = false
            }

            if (request_data[val].client_id == 'neocareer_admin' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isNeocareer_2 = false
            }
            if (request_data[val].client_id == 'neocareer_admin' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isNeocareer_3 = false
            }

            if (request_data[val].client_id == 'onecareer_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isOnecareer_1 = false
            }

            if (request_data[val].client_id == 'vinc_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isVinc_1 = false
            }

            if (request_data[val].client_id == 'hitoshia_admin' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isNeocareer_4 = false
            }

            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isPleiades_1 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isPleiades_2 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isPleiades_3 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isPleiades_4 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isPleiades_5 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 6 &&
              !request_data[val].request_able) {
              isPleiades_6 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 7 &&
              !request_data[val].request_able) {
              isPleiades_7 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 8 &&
              !request_data[val].request_able) {
              isPleiades_8 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 9 &&
              !request_data[val].request_able) {
              isPleiades_9 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 10 &&
              !request_data[val].request_able) {
              isPleiades_10 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 18 &&
              !request_data[val].request_able) {
              isPleiades_18 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 11 &&
              !request_data[val].request_able) {
              isPleiades_11 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 12 &&
              !request_data[val].request_able) {
              isPleiades_12 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 13 &&
              !request_data[val].request_able) {
              isPleiades_13 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 14 &&
              !request_data[val].request_able) {
              isPleiades_14 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 15 &&
              !request_data[val].request_able) {
              isPleiades_15 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 16 &&
              !request_data[val].request_able) {
              isPleiades_16 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 17 &&
              !request_data[val].request_able) {
              isPleiades_17 = false
            }

            if (request_data[val].client_id == 'peacekaigo_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isPeacekaigo1 = false
            }
            if (request_data[val].client_id == 'peacekaigo_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isPeacekaigo2 = false
            }
            if (request_data[val].client_id == 'peacekaigo_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isPeacekaigo3 = false
            }

            if (request_data[val].client_id == 'jhr_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isJhr_1 = false
            }
            if (request_data[val].client_id == 'jhr_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isJhr_2 = false
            }
            if (request_data[val].client_id == 'peacekaigo_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isPeacekaigo4 = false
            }
            if (request_data[val].client_id == 'peacekaigo_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isPeacekaigo5 = false
            }

            if (request_data[val].client_id == 'kikkakeagent_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isKikkakeagent_1 = false
            }

            if (request_data[val].client_id == 'cloudlink_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isCloudlink_1 = false
            }
            if (request_data[val].client_id == 'cloudlink_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isCloudlink_2 = false
            }
            if (request_data[val].client_id == 'cloudlink_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isCloudlink_4 = false
            }

            if (request_data[val].client_id == 'heros_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isHeros_1 = false
            }
            if (request_data[val].client_id == 'heros_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isHeros_2 = false
            }

            if (request_data[val].client_id == 'huproinc_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isHuproinc_1 = false
            }
            if (request_data[val].client_id == 'huproinc_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isHuproinc_2 = false
            }

            if (request_data[val].client_id == 'jmsc_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isJmsc_1 = false
            }

            if (request_data[val].client_id == 'jmsc_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isJmsc_2 = false
            }

            if (request_data[val].client_id == 'jmsc_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isJmsc_3 = false
            }

            if (request_data[val].client_id == 'careeradv_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isCareeradv_1 = false
            }

            if (request_data[val].client_id == 'nineearth_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isNineearth_1 = false
            }

            if (request_data[val].client_id == 'nineearth_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isNineearth_2 = false
            }

            if (request_data[val].client_id == 'nineearth_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isNineearth_3 = false
            }
            if (request_data[val].client_id == 'nineearth_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isNineearth_4 = false
            }

            if (request_data[val].client_id == 'nineearth_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isNineearth_5 = false
            }

            if (request_data[val].client_id == 'kotrio_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isKotrio_1 = false
            }

            if (request_data[val].client_id == 'axes_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isAxes_1 = false
            }

            if (request_data[val].client_id == 'kotrio_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isKotrio_2 = false
            }

            if (request_data[val].client_id == 'lifeones_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isLifeones_1 = false
            }

            if (request_data[val].client_id == 'lifeones_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isLifeones_3 = false
            }
            if (request_data[val].client_id == 'valuablelife_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isValuablelife_1 = false
            }

            if (request_data[val].client_id == 'parable_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isParable_1 = false
            }
            if (request_data[val].client_id == 'starlabo_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isStarlabo_1 = false
            }

            if (request_data[val].client_id == 'supernurse_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isSupernurse_1 = false
            }

            if (request_data[val].client_id == 'starlabo_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isStarlabo_2 = false
            }

            if (request_data[val].client_id == 'tryt_api' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isTryt_3 = false
            }
            if (request_data[val].client_id == 'tryt_api' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isTryt_4 = false
            }

            if (request_data[val].client_id == 'terracia_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isTerracia_2 = false
            }
            if (request_data[val].client_id == 'terracia_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isTerracia_1 = false
            }
            if (request_data[val].client_id == 'terracia_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isTerracia_3 = false
            }

            if (request_data[val].client_id == 'terracia_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isTerracia_4 = false
            }
            if (request_data[val].client_id == 'reaching_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isReaching_1 = false
            }
            if (request_data[val].client_id == 'reaching_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isReaching_2 = false
            }
            if (request_data[val].client_id == 'reaching_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isReaching_3 = false
            }
            if (request_data[val].client_id == 'reaching_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isReaching_4 = false
            }
            if (request_data[val].client_id == 'reaching_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isReaching_5 = false
            }

            if (request_data[val].client_id == 'repath_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isRepath_1 = false
            }
            if (request_data[val].client_id == 'dagent_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isDagent_1 = false
            }

            if (request_data[val].client_id == 'unisoncareer_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isUnisoncareer_1 = false
            }

            if (request_data[val].client_id == 'geekly_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isGeekly_1 = false
            }

            if (request_data[val].client_id == 'findy_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isFindy_1 = false
            }
            if (request_data[val].client_id == 'simple_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isSimple_1 = false
            }

            if (request_data[val].client_id == 'noajpn_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isNoajpn_1 = false
            }

            if (request_data[val].client_id == 'noajpn_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isNoajpn_2 = false
            }

            if (request_data[val].client_id == 'recruit_mc_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isRecruitMc1 = false
            }
            if (request_data[val].client_id == 'pharmacareer_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isPharmacareer_1 = false
            }
            if (request_data[val].client_id == 'pharmacareer_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isPharmacareer_2 = false
            }

            if (request_data[val].client_id == 'pharmacareer_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isPharmacareer_3 = false
            }
            if (request_data[val].client_id == 'rozas_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isRozas_1 = false
            }
            if (request_data[val].client_id == 'rozas_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isRozas_2 = false
            }
            if (request_data[val].client_id == 'rozas_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isRozas_3 = false
            }
            if (request_data[val].client_id == 'rozas_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isRozas_4 = false
            }
            if (request_data[val].client_id == 'rozas_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isRozas_5 = false
            }
            if (request_data[val].client_id == 'dely_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isDely_1 = false
            }

            if (request_data[val].client_id == 'workport_admin' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isWorkport_1 = false
            }

            if (request_data[val].client_id == 'workport_admin' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isWorkport_4 = false
            }
            if (request_data[val].client_id == 'briedge_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isBriedge_1 = false
            }

            if (request_data[val].client_id == 'prolg_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isProlg_1 = false
            }

            if (request_data[val].client_id == 'prolg_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isProlg_2 = false
            }

            if (request_data[val].client_id == 'smartforce_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isSmartforce_1 = false
            }

            if (request_data[val].client_id == 'smartforce_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isSmartforce_2 = false
            }

            if (request_data[val].client_id == 'startme_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isStartme_1 = false
            }
            if (request_data[val].client_id == 'startme_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isStartme_2 = false
            }

            if (request_data[val].client_id == 'agent3_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isAgent3_1 = false
            }
            if (request_data[val].client_id == 'kiminara_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isKiminara_1 = false
            }
            if (request_data[val].client_id == 'kiminara_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isKiminara_2 = false
            }
            if (request_data[val].client_id == 'kiminara_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isKiminara_3 = false
            }
            if (request_data[val].client_id == 'kiminara_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isKiminara_4 = false
            }
            if (request_data[val].client_id == 'cloudlink_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isCloudlink_3 = false
            }

            if (request_data[val].client_id == 'bearsnavi_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isBearsnavi_1 = false
            }
            if (request_data[val].client_id == 'bearsnavi_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isBearsnavi_2 = false
            }
            if (request_data[val].client_id == 'bearsnavi_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isBearsnavi_3 = false
            }

            if (request_data[val].client_id == 'strike_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isStrike_1 = false
            }

            if (request_data[val].client_id == 'internous_link' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isInternous_1 = false
            }

            if (request_data[val].client_id == 'internous_link' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isInternous_2 = false
            }

            if (request_data[val].client_id == 'internous_link' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isInternous_3 = false
            }

            if (request_data[val].client_id == 'internous_link' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isInternous_4 = false
            }

            if (request_data[val].client_id == 'internous_link' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isInternous_5 = false
            }

            if (request_data[val].client_id == 'workport_admin' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isWorkport_2 = false
            }

            if (request_data[val].client_id == 'workport_admin' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isWorkport_3 = false
            }

            if (request_data[val].client_id == 'cri_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isCri_1 = false
            }

            if (request_data[val].client_id == 'letsi_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isLetsi_1 = false
            }

            if (request_data[val].client_id == 'agrinavi_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isAgrinavi_1 = false
            }
            if (request_data[val].client_id == 'techouse_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isTechouse_1 = false
            }
            if (request_data[val].client_id == 'techouse_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isTechouse_2 = false
            }
            if (request_data[val].client_id == 'techouse_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isTechouse_3 = false
            }

            if (request_data[val].client_id == 'outsourcing_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isOutsourcing_1 = false
            }

            if (request_data[val].client_id == 'cookbiz_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isCookbiz_1 = false
            }
            if (request_data[val].client_id == 'cookbiz_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isCookbiz_2 = false
            }
            if (request_data[val].client_id == 'cookbiz_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isCookbiz_3 = false
            }
            if (request_data[val].client_id == 'hitolabo_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isHitolabo_1 = false
            }

            if (request_data[val].client_id == 'hitolabo_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isHitolabo_2 = false
            }

            if (request_data[val].client_id == 'foodison_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isFoodison_1 = false
            }
            if (request_data[val].client_id == 'foodison_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isFoodison_2 = false
            }
            if (request_data[val].client_id == 'foodison_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isFoodison_3 = false
            }

            if (request_data[val].client_id == 'oishiru_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isOishiru_1 = false
            }

            if (request_data[val].client_id == 'hayfield_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isHayfield_1 = false
            }

            if (request_data[val].client_id == 'itk_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isItk_1 = false
            }

            if (request_data[val].client_id == 'primalwork_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isPrimalwork_1 = false
            }

            if (request_data[val].client_id == 'nsjapan_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isNsjapan_1 = false
            }

            if (request_data[val].client_id == 'talentnavi_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isTalentnavi_1 = false
            }
            if (request_data[val].client_id == 'azurite_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isAzurite_1 = false
            }
            if (request_data[val].client_id == 'azurite_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isAzurite_2 = false
            }
            if (request_data[val].client_id == '400f_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              is400F_1 = false
            }
            if (request_data[val].client_id == 'usenworking_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isUsenworking_1 = false
            }
            if (request_data[val].client_id == 'usenworking_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isUsenworking_2 = false
            }
            if (request_data[val].client_id == 'usenworking_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isUsenworking_3 = false
            }
            if (request_data[val].client_id == 'usenworking_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isUsenworking_4 = false
            }

            if (request_data[val].client_id == 'recree_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isRecree_2 = false
            }

            if (request_data[val].client_id == 'recree_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isRecree_3 = false
            }

            if (request_data[val].client_id == 'recree_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isRecree_4 = false
            }

            if (request_data[val].client_id == 'recree_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isRecree_5 = false
            }

            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 28 &&
              !request_data[val].request_able) {
              isXmile_28 = false
            }

            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isXmile_5 = false
            }

            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 26 &&
              !request_data[val].request_able) {
              isXmile_26 = false
            }

            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 27 &&
              !request_data[val].request_able) {
              isXmile_27 = false
            }

            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 38 &&
              !request_data[val].request_able) {
              isXmile_38 = false
            }

            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 6 &&
              !request_data[val].request_able) {
              isXmile_6 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 7 &&
              !request_data[val].request_able) {
              isXmile_7 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 8 &&
              !request_data[val].request_able) {
              isXmile_8 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 9 &&
              !request_data[val].request_able) {
              isXmile_9 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 10 &&
              !request_data[val].request_able) {
              isXmile_10 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 11 &&
              !request_data[val].request_able) {
              isXmile_11 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 12 &&
              !request_data[val].request_able) {
              isXmile_12 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 13 &&
              !request_data[val].request_able) {
              isXmile_13 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 14 &&
              !request_data[val].request_able) {
              isXmile_14 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 15 &&
              !request_data[val].request_able) {
              isXmile_15 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 16 &&
              !request_data[val].request_able) {
              isXmile_16 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 17 &&
              !request_data[val].request_able) {
              isXmile_17 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 18 &&
              !request_data[val].request_able) {
              isXmile_18 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 19 &&
              !request_data[val].request_able) {
              isXmile_19 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 20 &&
              !request_data[val].request_able) {
              isXmile_20 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 21 &&
              !request_data[val].request_able) {
              isXmile_21 = false
            }

            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 23 &&
              !request_data[val].request_able) {
              isXmile_23 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 24 &&
              !request_data[val].request_able) {
              isXmile_24 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 25 &&
              !request_data[val].request_able) {
              isXmile_25 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 22 &&
              !request_data[val].request_able) {
              isXmile_22 = false
            }

            if (request_data[val].client_id == 'plexjob_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isPlexjob_1 = false
            }

            if (request_data[val].client_id == 'plexjob_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isPlexjob_2 = false
            }

            if (request_data[val].client_id == 'plexjob_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isPlexjob_3 = false
            }

            if (request_data[val].client_id == 'plexjob_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isPlexjob_4 = false
            }

            if (request_data[val].client_id == 'plexjob_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isPlexjob_5 = false
            }

            if (request_data[val].client_id == 'plexjob_mail' &&
              request_data[val].permission_type == 6 &&
              !request_data[val].request_able) {
              isPlexjob_6 = false
            }
            if (request_data[val].client_id == 'lifeones_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isLifeones_2 = false
            }

            if (request_data[val].client_id == 'gojob_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isGojob_1 = false
            }
            if (request_data[val].client_id == 'willofwork_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isWillofwork_1 = false
            }

            if (request_data[val].client_id == 'willofwork_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isWillofwork_2 = false
            }

            if (request_data[val].client_id == 'proselltraction_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isProselltraction_1 = false
            }

            if (request_data[val].client_id == 'rerise_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isRerise_1 = false
            }

            if (request_data[val].client_id == 'timee_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isTimee_1 = false
            }

            if (request_data[val].client_id == 'branu_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isBranu_1 = false
            }

            if (request_data[val].client_id == 'grandop_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isGrandop_1 = false
            }
            if (request_data[val].client_id == 'bestand_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isBestand_1 = false
            }

            if (request_data[val].client_id == 'hhjapan_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isHhjapan_1 = false
            }

            if (request_data[val].client_id == 'riajob_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isRiajob_1 = false
            }
            if (request_data[val].client_id == 'ciw_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isCiw_1 = false
            }
            if (request_data[val].client_id == 'blankpad_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isBlankpad_1 = false
            }
            if (request_data[val].client_id == 'awesome_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isAwesome_1 = false
            }

            if (request_data[val].client_id == 'yagish_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isYagish1 = false
            }
            if (request_data[val].client_id == 'sms_admin' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isSms_1 = false
            }
            if (request_data[val].client_id == 'sms_admin_eiyoshi' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isSms_2 = false
            }
            if (request_data[val].client_id == 'sms_admin_hoiku' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isSms_3 = false
            }

            if (request_data[val].client_id == 'pharmate_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isPharmate1 = false
            }

            if (request_data[val].client_id == 'norms_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isNorms_1 = false
            }

            if (request_data[val].client_id == 'huemaridge_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isHuemaridge_1 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isMedley_Link_5 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 6 &&
              !request_data[val].request_able) {
              isMedley_Link_6 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 7 &&
              !request_data[val].request_able) {
              isMedley_Link_7 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 8 &&
              !request_data[val].request_able) {
              isMedley_Link_8 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 9 &&
              !request_data[val].request_able) {
              isMedley_Link_9 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 10 &&
              !request_data[val].request_able) {
              isMedley_Link_10 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 11 &&
              !request_data[val].request_able) {
              isMedley_Link_11 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 12 &&
              !request_data[val].request_able) {
              isMedley_Link_12 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 13 &&
              !request_data[val].request_able) {
              isMedley_Link_13 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 14 &&
              !request_data[val].request_able) {
              isMedley_Link_14 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 15 &&
              !request_data[val].request_able) {
              isMedley_Link_15 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 16 &&
              !request_data[val].request_able) {
              isMedley_Link_16 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 17 &&
              !request_data[val].request_able) {
              isMedley_Link_17 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 18 &&
              !request_data[val].request_able) {
              isMedley_Link_18 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 19 &&
              !request_data[val].request_able) {
              isMedley_Link_19 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 20 &&
              !request_data[val].request_able) {
              isMedley_Link_20 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 21 &&
              !request_data[val].request_able) {
              isMedley_Link_21 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 22 &&
              !request_data[val].request_able) {
              isMedley_Link_22 = false
            }
            if (request_data[val].client_id == 'neocareer_admin' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isNeocareer_5 = false
            }
            if (request_data[val].client_id == 'recurrent_api' &&
              !request_data[val].request_able) {
              isRecurrent_1 = false
            }
            if (request_data[val].client_id == 'recurrent_api' &&
              !request_data[val].request_able) {
              isRecurrent_2 = false
            }
            if (request_data[val].client_id == 'recurrent_api' &&
              !request_data[val].request_able) {
              isRecurrent_3 = false
            }
            if (request_data[val].client_id == 'recurrent_api' &&
              !request_data[val].request_able) {
              isRecurrent_4 = false
            }

            if (request_data[val].client_id == 'tsace_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isTsace_1 = false
            }
            if (request_data[val].client_id == 'tsace_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isTsace_2 = false
            }
            if (request_data[val].client_id == 'tsace_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isTsace_3 = false
            }
            if (request_data[val].client_id == 'mitzmitz_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isMitzmitz_5 = false
            }
            if (request_data[val].client_id == 'mitzmitz_mail' &&
              request_data[val].permission_type == 6 &&
              !request_data[val].request_able) {
              isMitzmitz_6 = false
            }
            if (request_data[val].client_id == 'mitzmitz_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isMitzmitz_3 = false
            }
            if (request_data[val].client_id == 'mitzmitz_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isMitzmitz_2 = false
            }
            if (request_data[val].client_id == 'mitzmitz_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isMitzmitz_1 = false
            }
            if (request_data[val].client_id == 'mitzmitz_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isMitzmitz_4 = false
            }
            if (request_data[val].client_id == 'truspo_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isTruspo_1 = false
            }
            if (request_data[val].client_id == 'firstconnect_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isFirstconnect_1 = false
            }
            if (request_data[val].client_id == 'irodas_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isIrodas_1 = false
            }
            if (request_data[val].client_id == 'recrea_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isRecrea_2 = false
            }
            if (request_data[val].client_id == 'recurrent_api' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isRecurrent_5 = false
            }
            if (request_data[val].client_id == 'secondgame_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isSecondgame_1 = false
            }
            if (request_data[val].client_id == 'secondgame_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isSecondgame_2 = false
            }
            if (request_data[val].client_id == 'eil100_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isEil100_1 = false
            }
            if (request_data[val].client_id == 'eil100_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isEil100_2 = false
            }
            if (request_data[val].client_id == 'witc_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isWitc1 = false
            }
            if (request_data[val].client_id == 'bizreach_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isBizreach_1 = false
            }
            if (request_data[val].client_id == 'irodas_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isIrodas_2 = false
            }
          }

          const nowdate3 = new Date()
          console.error(nowdate3)
          if (isSms_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/sms_1_yagish_logo_20250115.jpg',
              clientId: 'sms_admin',
              dialogName: 'sms-dialog',
              clientName: 'カイゴジョブエージェント',
              termurl: 'https://www.kaigoagent.com/contents/tos.html',
              privacyurl: 'https://www.kaigoagent.com/contents/pmark.html',
              clientServiceName: 'キャリア支援サービス',
              subArea1: '介護の求人・転職ならカイゴジョブエージェント<br>電話にて非公開求人をご紹介します！',
              requiredAgree: true
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isJob919_5 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/job919_roo_20230915_yagish_logo.png',
              clientId: 'jobs919_mail',
              dialogName: 'jobs919_dialog',
              clientName: '(株)クイック',
              termurl: 'https://www.kango-roo.com/career/rule',
              privacyurl: 'https://www.kango-roo.com/career/entry/ruleprivacy',
              clientServiceName: 'カンゴルー',
              sendApiEndpointKey: 'sendJobs919'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 5, dialogInfo, basicData, isMypage)
          } else if (isXmile_28 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_28_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 28, dialogInfo, basicData, isMypage)
          } else if (isMitzmitz_5 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/mitzmitz_1_yagish_logo.png',
              clientId: 'mitzmitz_mail',
              dialogName: 'mitzmitz-dialog',
              clientName: '株式会社ミッツミッツ',
              termurl: 'https://mitzmitz.com/meeting',
              privacyurl: 'https://mitzmitz.com/meeting',
              clientServiceName: 'ミッツミッツ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 5, dialogInfo, basicData, isMypage)
          } else if (isXmile_5 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_5_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 5, dialogInfo, basicData, isMypage)
          } else if (isXmile_26 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_26_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 26, dialogInfo, basicData, isMypage)
          } else if (isJob919_1 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/919kensetsu_yagish_logo_20230810.png',
              clientId: 'jobs919_mail',
              dialogName: 'jobs919_dialog',
              clientName: '(株)クイック',
              termurl: 'https://plant.ten-navi.com/ruleprivacy/',
              privacyurl: 'https://plant.ten-navi.com/ruleprivacy/',
              clientServiceName: '建設・設備求人データベース',
              sendApiEndpointKey: 'sendJobs919'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isJob919_7 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/919kensetsu_yagish_logo_20230810.png',
              clientId: 'jobs919_mail',
              dialogName: 'jobs919_dialog',
              clientName: '(株)クイック',
              termurl: 'https://plant.ten-navi.com/ruleprivacy/',
              privacyurl: 'https://plant.ten-navi.com/ruleprivacy/',
              clientServiceName: '建設・設備求人データベース',
              sendApiEndpointKey: 'sendJobs919'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 7, dialogInfo, basicData, isMypage)
          } else if (isJob919_2 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/919jobs_yagish_logo_20230810.png',
              clientId: 'jobs919_mail',
              dialogName: 'jobs919_dialog',
              clientName: '(株)クイック',
              termurl: 'https://plant.ten-navi.com/ruleprivacy/',
              privacyurl: 'https://plant.ten-navi.com/ruleprivacy/',
              clientServiceName: '整備士JOBS',
              sendApiEndpointKey: 'sendJobs919'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isJob919_8 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/919jobs_yagish_logo_20230810.png',
              clientId: 'jobs919_mail',
              dialogName: 'jobs919_dialog',
              clientName: '(株)クイック',
              termurl: 'https://plant.ten-navi.com/ruleprivacy/',
              privacyurl: 'https://plant.ten-navi.com/ruleprivacy/',
              clientServiceName: '整備士JOBS',
              sendApiEndpointKey: 'sendJobs919'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 8, dialogInfo, basicData, isMypage)
          } else if (isJob919_9 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/919jobs_yagish_logo_20230810.png',
              clientId: 'jobs919_mail',
              dialogName: 'jobs919_dialog',
              clientName: '(株)クイック',
              termurl: 'https://plant.ten-navi.com/ruleprivacy/',
              privacyurl: 'https://plant.ten-navi.com/ruleprivacy/',
              clientServiceName: '整備士JOBS',
              sendApiEndpointKey: 'sendJobs919'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 9, dialogInfo, basicData, isMypage)
          } else if (isJob919_3 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/919kensetsu_yagish_logo_20230810.png',
              clientId: 'jobs919_mail',
              dialogName: 'jobs919_dialog',
              clientName: '(株)クイック',
              termurl: 'https://plant.ten-navi.com/ruleprivacy/',
              privacyurl: 'https://plant.ten-navi.com/ruleprivacy/',
              clientServiceName: '建設・設備求人データベース',
              sendApiEndpointKey: 'sendJobs919'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
          } else if (isJob919_4 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/919kensetsu_yagish_logo_20230810.png',
              clientId: 'jobs919_mail',
              dialogName: 'jobs919_dialog',
              clientName: '(株)クイック',
              termurl: 'https://plant.ten-navi.com/ruleprivacy/',
              privacyurl: 'https://plant.ten-navi.com/ruleprivacy/',
              clientServiceName: '建設・設備求人データベース',
              sendApiEndpointKey: 'sendJobs919'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 4, dialogInfo, basicData, isMypage)
          } else if (isHrcareer_9 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/kaigoeiyo_hrcareer_yagish_logo_20240512.jpeg',
              clientId: 'hrcareer_mail',
              dialogName: 'hrcareer_dialog',
              clientName: '（株）HR CAREER',
              termurl: 'https://kaigoyell.com/lp/terms.html',
              privacyurl: 'https://hryell.com/eiyoushi/privacy.html',
              clientServiceName: '介護ギフト',
              sendApiEndpointKey: 'sendHrcareer'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 9, dialogInfo, basicData, isMypage)
          } else if (isHrcareer_10 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/kaigoeiyo_hrcareer_yagish_logo_20240512.jpeg',
              clientId: 'hrcareer_mail',
              dialogName: 'hrcareer_dialog',
              clientName: '（株）HR CAREER',
              termurl: 'https://kaigoyell.com/lp/terms.html',
              privacyurl: 'https://hryell.com/eiyoushi/privacy.html',
              clientServiceName: '介護ギフト',
              sendApiEndpointKey: 'sendHrcareer'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 10, dialogInfo, basicData, isMypage)
          } else if (isSms_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/sms_2_yagish_logo_20250205.png',
              clientId: 'sms_admin_eiyoshi',
              dialogName: 'sms-dialog',
              clientName: '株式会社エス･エム･エス',
              termurl: 'https://policy.bm-sms.co.jp/consumer/terms/jinzaibank-com',
              privacyurl: 'https://policy.bm-sms.co.jp/consumer/privacy/policy',
              clientServiceName: 'キャリア支援サービス'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isCloudlink_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/cloudlink_1_yagish_logo.png',
              clientId: 'cloudlink_mail',
              dialogName: 'cloudlink-dialog',
              clientName: '株式会社Cloud Link',
              termurl: 'https://cloud-link.co.jp/terms-of-service/',
              privacyurl: 'https://cloud-link.co.jp/privacy-policy/',
              clientServiceName: 'Cloud Link',
              setTimeLink: 'https://cloud-link.eeasy.jp/shokai_mendan_kikai'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isMitzmitz_6 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/mitzmitz_1_yagish_logo.png',
              clientId: 'mitzmitz_mail',
              dialogName: 'mitzmitz-dialog',
              clientName: '株式会社ミッツミッツ',
              termurl: 'https://mitzmitz.com/meeting',
              privacyurl: 'https://mitzmitz.com/meeting',
              clientServiceName: 'ミッツミッツ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 6, dialogInfo, basicData, isMypage)
          } else if (isCloudlink_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/cloudlink_2_yagish_logo.png',
              clientId: 'cloudlink_mail',
              dialogName: 'cloudlink-dialog',
              clientName: '株式会社Cloud Link',
              termurl: 'https://cloud-link.co.jp/terms-of-service/',
              privacyurl: 'https://cloud-link.co.jp/privacy-policy/',
              clientServiceName: 'Cloud Link',
              setTimeLink: 'https://cloud-link.eeasy.jp/shokai_mendan_IT'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isCloudlink_4 && (formatId == 'engineer_shokumukeirekisho')) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/cloudlink_4_yagish_logo.png',
              clientId: 'cloudlink_mail',
              dialogName: 'cloudlink-dialog',
              clientName: '株式会社Cloud Link',
              termurl: 'https://cloud-link.co.jp/terms-of-service/',
              privacyurl: 'https://cloud-link.co.jp/privacy-policy/',
              clientServiceName: 'Cloud Link',
              setTimeLink: 'https://cloud-link.eeasy.jp/shokai_mendan_IT'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 4, dialogInfo, basicData, isMypage)
          } else if (isUnisoncareer_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/unisoncareer_1_yagish_logo.png',
              clientId: 'unisoncareer_mail',
              dialogName: 'unisoncareer-dialog',
              clientName: '株式会社ユニゾン・テクノロジー',
              termurl: 'https://unison-career.jp/terms/',
              privacyurl: 'https://unison-career.jp/governance/',
              clientServiceName: '株式会社ユニゾン・テクノロジー'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isGeekly_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/geekly_1_yagish_logo.png',
              clientId: 'geekly_mail',
              dialogName: 'geekly-dialog',
              clientName: '株式会社ギークリー',
              termurl: 'https://www.geekly.co.jp/terms/',
              privacyurl: 'https://www.geekly.co.jp/privacypolicy/',
              clientServiceName: 'Geekly'
            }
            const isGeekly_1_ButtonSizeUp = true
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage, isGeekly_1_ButtonSizeUp)
          } else if (isFindy_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/findy_1_yagish_logo.png',
              clientId: 'findy_mail',
              dialogName: 'findy-dialog',
              clientName: 'ファインディ株式会社',
              termurl: 'https://findy-code.io/terms',
              privacyurl: 'https://findy.co.jp/privacy/',
              clientServiceName: 'ファインディ株式会社'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isKikkakeagent_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/kikkakeagent_yagish_logo_20250326.png',
              clientId: 'kikkakeagent_mail',
              dialogName: 'kikkakeagent-dialog',
              clientName: '株式会社キッカケクリエイション',
              termurl: 'https://kikkakeagent.com/terms/',
              privacyurl: 'https://kikkakecreation.com/privacy/',
              clientServiceName: 'キッカケエージェント'
            }
            const isKikkakeagent_1_ButtonSizeUp = true
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage, isKikkakeagent_1_ButtonSizeUp)
          } else if (isMitzmitz_3 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/mitzmitz_1_yagish_logo.png',
              clientId: 'mitzmitz_mail',
              dialogName: 'mitzmitz-dialog',
              clientName: '株式会社ミッツミッツ',
              termurl: 'https://mitzmitz.com/meeting',
              privacyurl: 'https://mitzmitz.com/meeting',
              clientServiceName: 'ミッツミッツ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
          } else if (isGrandop_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/grandop_1_yagish_logo.png',
              clientId: 'grandop_mail',
              dialogName: 'grandop-dialog',
              clientName: '株式会社GRANDOP',
              termurl: 'https://drive.google.com/file/d/1iMBrcbmhvd_tKTyCE8VnETWN5q87_HrE/view?usp=sharing',
              privacyurl: 'https://grandop.net/wp/recruitment-business-privacy-policy/',
              clientServiceName: 'GRANDOP'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isRecurrent_1 && this.isJobChangeFormat(formatId)) {
            this.RecurrentWords = this.getMatchedCanonicalSkillList(formatData, this.getCategoryKeyByRecurrentPermission(1))
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/recurrent_1_yagish_logo.jpg',
              clientId: 'recurrent_api',
              dialogName: 'recurrent-dialog',
              clientName: 'リカレント・キャピタル株式会社',
              termurl: 'https://hoiku.med-ridge.com/terms',
              privacyurl: 'https://hoiku.med-ridge.com/privacy',
              clientServiceName: 'メドリッジ'
            }
            const isRecurrent_1_ButtonSizeUp = true
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage, isRecurrent_1_ButtonSizeUp)
          } else if (isRecurrent_5 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/recurrent_5_yagish_logo.jpg',
              clientId: 'recurrent_api',
              dialogName: 'recurrent-dialog',
              clientName: 'リカレント・キャピタル株式会社',
              termurl: 'https://kaigo.med-ridge.com/terms',
              privacyurl: 'https://kaigo.med-ridge.com/privacy',
              clientServiceName: '介護求人クイック'
            }
            const isRecurrent_5_ButtonSizeUp = true
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 5, dialogInfo, basicData, isMypage, isRecurrent_5_ButtonSizeUp)
          } else if (isRecurrent_2 && this.isJobChangeFormat(formatId)) {
            this.RecurrentWords = this.getMatchedCanonicalSkillList(formatData, this.getCategoryKeyByRecurrentPermission(2))
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/recurrent_2_yagish_logo.jpg',
              clientId: 'recurrent_api',
              dialogName: 'recurrent-dialog',
              clientName: 'リカレント・キャピタル株式会社',
              termurl: 'https://kaigo.med-ridge.com/terms',
              privacyurl: 'https://kaigo.med-ridge.com/privacy',
              clientServiceName: 'メドリッジ'
            }
            const isRecurrent_2_ButtonSizeUp = true
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage, isRecurrent_2_ButtonSizeUp)
          } else if (isRecurrent_3 && this.isJobChangeFormat(formatId)) {
            this.RecurrentWords = this.getMatchedCanonicalSkillList(formatData, this.getCategoryKeyByRecurrentPermission(3))
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/recurrent_3_yagish_logo.jpg',
              clientId: 'recurrent_api',
              dialogName: 'recurrent-dialog',
              clientName: 'リカレント・キャピタル株式会社',
              termurl: 'https://nurse.med-ridge.com/terms',
              privacyurl: 'https://nurse.med-ridge.com/privacy',
              clientServiceName: 'メドリッジ'
            }
            const isRecurrent_3_ButtonSizeUp = true
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage, isRecurrent_3_ButtonSizeUp)
          } else if (isRecurrent_4 && this.isJobChangeFormat(formatId)) {
            this.RecurrentWords = this.getMatchedCanonicalSkillList(formatData, this.getCategoryKeyByRecurrentPermission(4))
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/recurrent_4_yagish_logo.jpg',
              clientId: 'recurrent_api',
              dialogName: 'recurrent-dialog',
              clientName: 'リカレント・キャピタル株式会社',
              termurl: 'https://ptotst.med-ridge.com/terms',
              privacyurl: 'https://ptotst.med-ridge.com/privacy',
              clientServiceName: 'メドリッジ'
            }
            const isRecurrent_4_ButtonSizeUp = true
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 4, dialogInfo, basicData, isMypage, isRecurrent_4_ButtonSizeUp)
          } else if (isReaching_4 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/reaching_4_yagish_logo.png',
              clientId: 'reaching_mail',
              dialogName: 'reaching-dialog',
              clientName: '株式会社リーチング',
              termurl: 'https://drive.google.com/file/d/1KaXtYZ5lC8ZZebo2Z2Uyo-M96B5yXW7f/view?usp=sharing',
              privacyurl: 'https://drive.google.com/file/d/1-clvJ--G6NKE26Y194fz6uf0wNfCI22u/view?usp=drive_link',
              clientServiceName: 'JOBリーチ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 4, dialogInfo, basicData, isMypage)
          } else if (isReaching_5 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/reaching_5_yagish_logo.png',
              clientId: 'reaching_mail',
              dialogName: 'reaching-dialog',
              clientName: '株式会社リーチング',
              termurl: 'https://drive.google.com/file/d/1KaXtYZ5lC8ZZebo2Z2Uyo-M96B5yXW7f/view?usp=sharing',
              privacyurl: 'https://drive.google.com/file/d/1-clvJ--G6NKE26Y194fz6uf0wNfCI22u/view?usp=drive_link',
              clientServiceName: 'JOBリーチ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 5, dialogInfo, basicData, isMypage)
          } else if (isHeros_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/heros_1_yagish_logo.png',
              clientId: 'heros_mail',
              dialogName: 'heros-dialog',
              clientName: '株式会社HeRos',
              termurl: 'https://hr-heros.co.jp/term',
              privacyurl: 'https://hr-heros.co.jp/privacy',
              clientServiceName: 'セカチャレ！'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isHeros_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/heros_2_yagish_logo.png',
              clientId: 'heros_mail',
              dialogName: 'heros-dialog',
              clientName: '株式会社HeRos',
              termurl: 'https://hr-heros.co.jp/term',
              privacyurl: 'https://hr-heros.co.jp/privacy',
              clientServiceName: 'セカチャレ！'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isHuproinc_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/huproinc_yagish_logo_20250406.png',
              clientId: 'huproinc_mail',
              dialogName: 'huproinc-dialog',
              clientName: '株式会社ヒュープロ',
              termurl: 'https://hupro-job.com/terms',
              privacyurl: 'https://hupro-job.com/privacy_policy',
              clientServiceName: 'ヒュープロ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isHuproinc_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/huproinc_yagish_logo_20250406.png',
              clientId: 'huproinc_mail',
              dialogName: 'huproinc-dialog',
              clientName: '株式会社ヒュープロ',
              termurl: 'https://hupro-job.com/terms',
              privacyurl: 'https://hupro-job.com/privacy_policy',
              clientServiceName: 'ヒュープロ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isJmsc_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/jmsc_1_yagish_logo.png',
              clientId: 'jmsc_mail',
              dialogName: 'jmsc-dialog',
              clientName: '株式会社MS-Japan',
              termurl: 'https://www.jmsc.co.jp/career/mypageregist/terms/rules/',
              privacyurl: 'https://www.jmsc.co.jp/privacypolicy/',
              clientServiceName: '株式会社MS-Japan',
              agree_text: '規約に同意してエージェント利用を希望する'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isJmsc_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/jmsc_2_yagish_logo.png',
              clientId: 'jmsc_mail',
              dialogName: 'jmsc-dialog',
              clientName: '株式会社MS-Japan',
              termurl: 'https://www.jmsc.co.jp/career/mypageregist/terms/rules/',
              privacyurl: 'https://www.jmsc.co.jp/privacypolicy/',
              clientServiceName: '株式会社MS-Japan',
              agree_text: '規約に同意してエージェント利用を希望する'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isJmsc_3 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/jmsc_3_yagish_logo.png',
              clientId: 'jmsc_mail',
              dialogName: 'jmsc-dialog',
              clientName: '株式会社MS-Japan',
              termurl: 'https://www.jmsc.co.jp/career/mypageregist/terms/rules/',
              privacyurl: 'https://www.jmsc.co.jp/privacypolicy/',
              clientServiceName: '株式会社MS-Japan',
              agree_text: '規約に同意してエージェント利用を希望する'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
          } else if (isCareeradv_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/careeradv_1_yagish_logo.png',
              clientId: 'careeradv_mail',
              dialogName: 'careeradv-dialog',
              clientName: '株式会社レックスアドバイザーズ',
              termurl: 'https://www.career-adv.jp/riyokiyaku/',
              privacyurl: 'https://www.rex-adv.co.jp/privacy?_ebx=kzhpm5fv6x.1748928507.825rvqv',
              clientServiceName: 'レックスアドバイザーズ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isFirstconnect_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/firstconnect_1_yagish_logo.png',
              clientId: 'firstconnect_mail',
              dialogName: 'firstconnect-dialog',
              clientName: '株式会社ファーストコネクト',
              termurl: 'https://sikaeiseisi.firstnavi.jp/terms.html',
              privacyurl: 'https://sikaeiseisi.firstnavi.jp/pp.html',
              clientServiceName: 'ファーストナビ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isFirstconnect_1 && (formatId == 'rerekisho_part_time' || formatId == 'rirekisho_part_time2')) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/firstconnect_1_yagish_logo.png',
              clientId: 'firstconnect_mail',
              dialogName: 'firstconnect-dialog',
              clientName: '株式会社ファーストコネクト',
              termurl: 'https://sikaeiseisi.firstnavi.jp/terms.html',
              privacyurl: 'https://sikaeiseisi.firstnavi.jp/pp.html',
              clientServiceName: 'ファーストナビ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isNeocareer_4 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/neoe_yagish_logo_20230704.png',
              clientId: 'neocareer_admin',
              dialogName: 'neocareer_dialog',
              clientName: '株式会社ネオキャリア',
              termurl: 'https://www.s-agent.jp/agreement',
              privacyurl: 'https://www.neo-career.co.jp/policy/',
              clientServiceName: '就職Agent neo',
              sendApiEndpointKey: 'sendNeocareer'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 4, dialogInfo, basicData, isMypage)
          } else if (isMedley_Link_11 && this.isJobChangeFormat(formatId)) {
            emitGlobalVarPopupDialog('open-medley-dialog', formatId, previewFormat, 0, 11, isMypage)
          } else if (isMedley_Link_12 && this.isJobChangeFormat(formatId)) {
            emitGlobalVarPopupDialog('open-medley-dialog', formatId, previewFormat, 0, 12, isMypage)
          } else if (isMedley_Link_13 && this.isJobChangeFormat(formatId)) {
            emitGlobalVarPopupDialog('open-medley-dialog', formatId, previewFormat, 0, 13, isMypage)
          } else if (isMedley_Link_14 && this.isJobChangeFormat(formatId)) {
            emitGlobalVarPopupDialog('open-medley-dialog', formatId, previewFormat, 0, 14, isMypage)
          } else if (isMedley_Link_15 && this.isJobChangeFormat(formatId)) {
            emitGlobalVarPopupDialog('open-medley-dialog', formatId, previewFormat, 0, 15, isMypage)
          } else if (isMedley_Link_16 && this.isJobChangeFormat(formatId)) {
            emitGlobalVarPopupDialog('open-medley-dialog', formatId, previewFormat, 0, 16, isMypage)
          } else if (isMedley_Link_17 && this.isJobChangeFormat(formatId)) {
            emitGlobalVarPopupDialog('open-medley-dialog', formatId, previewFormat, 0, 17, isMypage)
          } else if (isMedley_Link_18 && this.isJobChangeFormat(formatId)) {
            emitGlobalVarPopupDialog('open-medley-dialog', formatId, previewFormat, 0, 18, isMypage)
          } else if (isMedley_Link_19 && this.isJobChangeFormat(formatId)) {
            emitGlobalVarPopupDialog('open-medley-dialog', formatId, previewFormat, 0, 19, isMypage)
          } else if (isMedley_Link_20 && this.isJobChangeFormat(formatId)) {
            emitGlobalVarPopupDialog('open-medley-dialog', formatId, previewFormat, 0, 20, isMypage)
          } else if (isMedley_Link_21 && this.isJobChangeFormat(formatId)) {
            emitGlobalVarPopupDialog('open-medley-dialog', formatId, previewFormat, 0, 21, isMypage)
          } else if (isMedley_Link_22 && this.isJobChangeFormat(formatId)) {
            emitGlobalVarPopupDialog('open-medley-dialog', formatId, previewFormat, 0, 22, isMypage)
          } else if (isPleiades_1 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/pleiades_yagish_logo_1.png',
              clientId: 'pleiades_mail',
              dialogName: 'pleiades_dialog',
              clientName: '株式会社プレアデス',
              termurl: 'https://www.pleiades-net.co.jp/privacy/',
              privacyurl: 'https://www.pleiades-net.co.jp/privacy/',
              clientServiceName: '株式会社プレアデス',
              sendApiEndpointKey: 'sendPleiades'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isPleiades_9 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/pleiades_yagish_logo_9.png',
              clientId: 'pleiades_mail',
              dialogName: 'pleiades_dialog',
              clientName: '株式会社プレアデス',
              termurl: 'https://www.pleiades-net.co.jp/privacy/',
              privacyurl: 'https://www.pleiades-net.co.jp/privacy/',
              clientServiceName: '株式会社プレアデス',
              sendApiEndpointKey: 'sendPleiades'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 9, dialogInfo, basicData, isMypage)
          } else if (isPleiades_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/pleiades_yagish_logo_2.png',
              clientId: 'pleiades_mail',
              dialogName: 'pleiades_dialog',
              clientName: '株式会社プレアデス',
              termurl: 'https://www.pleiades-net.co.jp/privacy/',
              privacyurl: 'https://www.pleiades-net.co.jp/privacy/',
              clientServiceName: '株式会社プレアデス',
              sendApiEndpointKey: 'sendPleiades'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isPleiades_3 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/pleiades_yagish_logo_3.png',
              clientId: 'pleiades_mail',
              dialogName: 'pleiades_dialog',
              clientName: '株式会社プレアデス',
              termurl: 'https://www.pleiades-net.co.jp/privacy/',
              privacyurl: 'https://www.pleiades-net.co.jp/privacy/',
              clientServiceName: '株式会社プレアデス',
              sendApiEndpointKey: 'sendPleiades'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
          } else if (isPleiades_4 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/pleiades_yagish_logo_4.png',
              clientId: 'pleiades_mail',
              dialogName: 'pleiades_dialog',
              clientName: '株式会社プレアデス',
              termurl: 'https://www.pleiades-net.co.jp/privacy/',
              privacyurl: 'https://www.pleiades-net.co.jp/privacy/',
              clientServiceName: '株式会社プレアデス',
              sendApiEndpointKey: 'sendPleiades'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 4, dialogInfo, basicData, isMypage)
          } else if (isPleiades_5 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/pleiades_yagish_logo_567.png',
              clientId: 'pleiades_mail',
              dialogName: 'pleiades_dialog',
              clientName: '株式会社プレアデス',
              termurl: 'https://www.pleiades-net.co.jp/privacy/',
              privacyurl: 'https://www.pleiades-net.co.jp/privacy/',
              clientServiceName: '株式会社プレアデス',
              sendApiEndpointKey: 'sendPleiades'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 5, dialogInfo, basicData, isMypage)
          } else if (isPleiades_6 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/pleiades_yagish_logo_567.png',
              clientId: 'pleiades_mail',
              dialogName: 'pleiades_dialog',
              clientName: '株式会社プレアデス',
              termurl: 'https://www.pleiades-net.co.jp/privacy/',
              privacyurl: 'https://www.pleiades-net.co.jp/privacy/',
              clientServiceName: '株式会社プレアデス',
              sendApiEndpointKey: 'sendPleiades'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 6, dialogInfo, basicData, isMypage)
          } else if (isPleiades_7 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/pleiades_yagish_logo_567.png',
              clientId: 'pleiades_mail',
              dialogName: 'pleiades_dialog',
              clientName: '株式会社プレアデス',
              termurl: 'https://www.pleiades-net.co.jp/privacy/',
              privacyurl: 'https://www.pleiades-net.co.jp/privacy/',
              clientServiceName: '株式会社プレアデス',
              sendApiEndpointKey: 'sendPleiades'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 7, dialogInfo, basicData, isMypage)
          } else if (isPleiades_8 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/pleiades_yagish_logo_8.png',
              clientId: 'pleiades_mail',
              dialogName: 'pleiades_dialog',
              clientName: '株式会社プレアデス',
              termurl: 'https://www.pleiades-net.co.jp/privacy/',
              privacyurl: 'https://www.pleiades-net.co.jp/privacy/',
              clientServiceName: '株式会社プレアデス',
              sendApiEndpointKey: 'sendPleiades'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 8, dialogInfo, basicData, isMypage)
          } else if (isPleiades_10 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/pleiades_yagish_logo_9.png',
              clientId: 'pleiades_mail',
              dialogName: 'pleiades_dialog',
              clientName: '株式会社プレアデス',
              termurl: 'https://www.pleiades-net.co.jp/privacy/',
              privacyurl: 'https://www.pleiades-net.co.jp/privacy/',
              clientServiceName: '株式会社プレアデス',
              sendApiEndpointKey: 'sendPleiades'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 10, dialogInfo, basicData, isMypage)
          } else if (isPleiades_18 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/pleiades_yagish_logo_9.png',
              clientId: 'pleiades_mail',
              dialogName: 'pleiades_dialog',
              clientName: '株式会社プレアデス',
              termurl: 'https://www.pleiades-net.co.jp/privacy/',
              privacyurl: 'https://www.pleiades-net.co.jp/privacy/',
              clientServiceName: '株式会社プレアデス',
              sendApiEndpointKey: 'sendPleiades'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 18, dialogInfo, basicData, isMypage)
          } else if (isPleiades_11 && (formatId.includes('shokumukeirekisho'))) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/pleiades_yagish_logo_567.png',
              clientId: 'pleiades_mail',
              dialogName: 'pleiades_dialog',
              clientName: '株式会社プレアデス',
              termurl: 'https://www.pleiades-net.co.jp/privacy/',
              privacyurl: 'https://www.pleiades-net.co.jp/privacy/',
              clientServiceName: '株式会社プレアデス',
              sendApiEndpointKey: 'sendPleiades'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 11, dialogInfo, basicData, isMypage)
          } else if (isPleiades_12 && (this.isJobChangeShokumukeirekiFormat(formatId))) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/pleiades_yagish_logo_4.png',
              clientId: 'pleiades_mail',
              dialogName: 'pleiades_dialog',
              clientName: '株式会社プレアデス',
              termurl: 'https://www.pleiades-net.co.jp/privacy/',
              privacyurl: 'https://www.pleiades-net.co.jp/privacy/',
              clientServiceName: '株式会社プレアデス',
              sendApiEndpointKey: 'sendPleiades'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 12, dialogInfo, basicData, isMypage)
          } else if (isPleiades_13 && (this.isJobChangeShokumukeirekiFormat(formatId))) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/pleiades_yagish_logo_4.png',
              clientId: 'pleiades_mail',
              dialogName: 'pleiades_dialog',
              clientName: '株式会社プレアデス',
              termurl: 'https://www.pleiades-net.co.jp/privacy/',
              privacyurl: 'https://www.pleiades-net.co.jp/privacy/',
              clientServiceName: '株式会社プレアデス',
              sendApiEndpointKey: 'sendPleiades'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 13, dialogInfo, basicData, isMypage)
          } else if (isPleiades_14 && (formatId.includes('shokumukeirekisho'))) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/pleiades_yagish_logo_567.png',
              clientId: 'pleiades_mail',
              dialogName: 'pleiades_dialog',
              clientName: '株式会社プレアデス',
              termurl: 'https://www.pleiades-net.co.jp/privacy/',
              privacyurl: 'https://www.pleiades-net.co.jp/privacy/',
              clientServiceName: '株式会社プレアデス',
              sendApiEndpointKey: 'sendPleiades'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 14, dialogInfo, basicData, isMypage)
          } else if (isPleiades_15 && (formatId.includes('shokumukeirekisho'))) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/pleiades_yagish_logo_567.png',
              clientId: 'pleiades_mail',
              dialogName: 'pleiades_dialog',
              clientName: '株式会社プレアデス',
              termurl: 'https://www.pleiades-net.co.jp/privacy/',
              privacyurl: 'https://www.pleiades-net.co.jp/privacy/',
              clientServiceName: '株式会社プレアデス',
              sendApiEndpointKey: 'sendPleiades'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 15, dialogInfo, basicData, isMypage)
          } else if (isPleiades_16 && (formatId.includes('shokumukeirekisho'))) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/pleiades_yagish_logo_567.png',
              clientId: 'pleiades_mail',
              dialogName: 'pleiades_dialog',
              clientName: '株式会社プレアデス',
              termurl: 'https://www.pleiades-net.co.jp/privacy/',
              privacyurl: 'https://www.pleiades-net.co.jp/privacy/',
              clientServiceName: '株式会社プレアデス',
              sendApiEndpointKey: 'sendPleiades'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 16, dialogInfo, basicData, isMypage)
          } else if (isPleiades_17 && (formatId.includes('shokumukeirekisho'))) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/pleiades_yagish_logo_567.png',
              clientId: 'pleiades_mail',
              dialogName: 'pleiades_dialog',
              clientName: '株式会社プレアデス',
              termurl: 'https://www.pleiades-net.co.jp/privacy/',
              privacyurl: 'https://www.pleiades-net.co.jp/privacy/',
              clientServiceName: '株式会社プレアデス',
              sendApiEndpointKey: 'sendPleiades'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 17, dialogInfo, basicData, isMypage)
          } else if (isPeacekaigo1 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/peacekaigo_yagish_logo_1.png',
              clientId: 'peacekaigo_mail',
              dialogName: 'peacekaigo_dialog',
              clientName: 'ネクストイノベーション',
              termurl: 'https://peace-kaigo.com/terms/',
              privacyurl: 'https://peace-kaigo.com/terms/',
              clientServiceName: 'ネクストイノベーション',
              sendApiEndpointKey: 'sendPeacekaigo'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isPeacekaigo2 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/peacekaigo_yagish_logo_1.png',
              clientId: 'peacekaigo_mail',
              dialogName: 'peacekaigo_dialog',
              clientName: 'ネクストイノベーション',
              termurl: 'https://peace-kaigo.com/terms/',
              privacyurl: 'https://peace-kaigo.com/terms/',
              clientServiceName: 'ネクストイノベーション',
              sendApiEndpointKey: 'sendPeacekaigo'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isPeacekaigo3 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/peacekaigo_yagish_logo_1.png',
              clientId: 'peacekaigo_mail',
              dialogName: 'peacekaigo_dialog',
              clientName: 'ネクストイノベーション',
              termurl: 'https://peace-kaigo.com/terms/',
              privacyurl: 'https://peace-kaigo.com/terms/',
              clientServiceName: 'ネクストイノベーション',
              sendApiEndpointKey: 'sendPeacekaigo'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
          } else if (isPersolinnovation_1 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/persolinnovation_yagish_logo_1.png',
              clientId: 'persolinnovation_admin',
              dialogName: 'persolinnovation_dialog',
              clientName: '株式会社パーソルイノベーション',
              termurl: 'https://agent.meetscare.jp/agreement.html',
              privacyurl: 'https://agent.meetscare.jp/privacy-policy.html',
              clientServiceName: 'みーつけあエージェント',
              sendApiEndpointKey: 'sendPersolinnovation'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isPersolinnovation_2 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/persolinnovation_yagish_logo_1.png',
              clientId: 'persolinnovation_admin',
              dialogName: 'persolinnovation_dialog',
              clientName: '株式会社パーソルイノベーション',
              termurl: 'https://agent.meetscare.jp/agreement.html',
              privacyurl: 'https://agent.meetscare.jp/privacy-policy.html',
              clientServiceName: 'みーつけあエージェント',
              sendApiEndpointKey: 'sendPersolinnovation'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isPersolinnovation_4 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/persolinnovation_yagish_logo_1.png',
              clientId: 'persolinnovation_admin',
              dialogName: 'persolinnovation_dialog',
              clientName: '株式会社パーソルイノベーション',
              termurl: 'https://agent.meetscare.jp/agreement.html',
              privacyurl: 'https://agent.meetscare.jp/privacy-policy.html',
              clientServiceName: 'みーつけあエージェント',
              sendApiEndpointKey: 'sendPersolinnovation'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 4, dialogInfo, basicData, isMypage)
          } else if (isLeverages_1 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/leverages_1_yagish_logo.png',
              clientId: 'leverages_mail',
              dialogName: 'leverages-dialog',
              clientName: 'レバウェル株式会社',
              termurl: 'https://levwell.jp/terms/',
              privacyurl: 'https://leverages.jp/privacypolicy/ ',
              clientServiceName: 'レバウェル保育士'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isHrcareer_5 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/hoikueiyo_hrcareer_yagish_logo_20240512.jpeg',
              clientId: 'hrcareer_mail',
              dialogName: 'hrcareer_dialog',
              clientName: '（株）HR CAREER',
              termurl: 'https://hoikuhaken.net/terms.html',
              privacyurl: 'https://hryell.com/eiyoushi/privacy.html',
              clientServiceName: '保育ギフト',
              sendApiEndpointKey: 'sendHrcareer'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 5, dialogInfo, basicData, isMypage)
          } else if (isHrcareer_6 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/hoikueiyo_hrcareer_yagish_logo_20240512.jpeg',
              clientId: 'hrcareer_mail',
              dialogName: 'hrcareer_dialog',
              clientName: '（株）HR CAREER',
              termurl: 'https://hoikuhaken.net/terms.html',
              privacyurl: 'https://hryell.com/eiyoushi/privacy.html',
              clientServiceName: '保育ギフト',
              sendApiEndpointKey: 'sendHrcareer'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 6, dialogInfo, basicData, isMypage)
          } else if (isHrcareer_7 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/kangoeiyo_hrcareer_yagish_logo_20240512.jpeg',
              clientId: 'hrcareer_mail',
              dialogName: 'hrcareer_dialog',
              clientName: '（株）HR CAREER',
              termurl: 'https://knagoyell.com/lp/terms.html',
              privacyurl: 'https://hryell.com/eiyoushi/privacy.html',
              clientServiceName: '看護エール',
              sendApiEndpointKey: 'sendHrcareer'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 7, dialogInfo, basicData, isMypage)
          } else if (isHrcareer_8 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/kangoeiyo_hrcareer_yagish_logo_20240512.jpeg',
              clientId: 'hrcareer_mail',
              dialogName: 'hrcareer_dialog',
              clientName: '（株）HR CAREER',
              termurl: 'https://knagoyell.com/lp/terms.html',
              privacyurl: 'https://hryell.com/eiyoushi/privacy.html',
              clientServiceName: '看護エール',
              sendApiEndpointKey: 'sendHrcareer'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 8, dialogInfo, basicData, isMypage)
          } else if (isHrcareer_11 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/eiyo_hrcareer_yagish_logo_20240512.jpeg',
              clientId: 'hrcareer_mail',
              dialogName: 'hrcareer_dialog',
              clientName: '（株）HR CAREER',
              termurl: 'https://hryell.com/eiyoushi/terms.html',
              privacyurl: 'https://hryell.com/eiyoushi/privacy.html',
              clientServiceName: '栄養士エール',
              sendApiEndpointKey: 'sendHrcareer'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 11, dialogInfo, basicData, isMypage)
          } else if (isHrcareer_12 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/eiyo_hrcareer_yagish_logo_20240512.jpeg',
              clientId: 'hrcareer_mail',
              dialogName: 'hrcareer_dialog',
              clientName: '（株）HR CAREER',
              termurl: 'https://hryell.com/eiyoushi/terms.html',
              privacyurl: 'https://hryell.com/eiyoushi/privacy.html',
              clientServiceName: '栄養士エール',
              sendApiEndpointKey: 'sendHrcareer'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 12, dialogInfo, basicData, isMypage)
          } else if (isHrcareer_15 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/kensetsu_hrcareer_yagish_logo_20240805.png',
              clientId: 'hrcareer_mail',
              dialogName: 'hrcareer_dialog',
              clientName: '（株）HR CAREER',
              termurl: 'https://kensetsu-yell.com/terms.html',
              privacyurl: 'https://hryell.com/eiyoushi/privacy.html',
              clientServiceName: '建設エール',
              sendApiEndpointKey: 'sendHrcareer'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 15, dialogInfo, basicData, isMypage)
          } else if (isSecondgame_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/secondgame_1_yagish_logo.png',
              clientId: 'secondgame_mail',
              dialogName: 'secondgame-dialog',
              clientName: '株式会社SecondGame',
              termurl: 'https://career-x.net/kiyaku01/',
              privacyurl: 'https://www.secondgame.net/privacypolicy',
              clientServiceName: '保育士キャリアX'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isSecondgame_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/secondgame_2_yagish_logo.png',
              clientId: 'secondgame_mail',
              dialogName: 'secondgame-dialog',
              clientName: '株式会社SecondGame',
              termurl: 'https://hoikushione.com/lp/%e5%88%a9%e7%94%a8%e8%a6%8f%e7%b4%84/',
              privacyurl: 'https://www.secondgame.net/privacypolicy',
              clientServiceName: '保育士ONE'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isReaching_1 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/reaching_1_yagish_logo.jpg',
              clientId: 'reaching_mail',
              dialogName: 'reaching-dialog',
              clientName: '株式会社リーチング',
              termurl: 'https://drive.google.com/file/d/1KaXtYZ5lC8ZZebo2Z2Uyo-M96B5yXW7f/view?usp=sharing',
              privacyurl: 'https://drive.google.com/file/d/1-clvJ--G6NKE26Y194fz6uf0wNfCI22u/view?usp=drive_link',
              clientServiceName: '介護リーチ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isTerracia_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/terracia_2_yagish_logo.png',
              clientId: 'terracia_mail',
              dialogName: 'terracia-dialog',
              clientName: '株式会社テラシア',
              termurl: 'https://terracia-web.com/terms-of-service/',
              privacyurl: 'https://terracia-web.com/privacypolicy/',
              clientServiceName: '保育士テラス'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isTryt_4 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/tryt_4_yagish_logo.png',
              clientId: 'tryt_api',
              dialogName: 'tryt-dialog',
              clientName: '株式会社トライトキャリア',
              termurl: 'https://iryouworker.com/company/sitepolicy/',
              privacyurl: 'https://iryouworker.com/company/privacypolicy/',
              handlingurl: 'https://iryouworker.com/company/handling/',
              clientServiceName: '看護師ワーカー'
            }
            const isTryt_4_ButtonSizeUp = true
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 4, dialogInfo, basicData, isMypage, isTryt_4_ButtonSizeUp)
          } else if (isTryt_3 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/tryt_3_yagish_logo.png',
              clientId: 'tryt_api',
              dialogName: 'tryt-dialog',
              clientName: '株式会社トライトキャリア',
              termurl: 'https://kaigoworker.jp/company/sitepolicy/',
              privacyurl: 'https://kaigoworker.jp/company/privacypolicy/',
              handlingurl: 'https://kaigoworker.jp/company/handling/',
              clientServiceName: '介護ワーカー'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
          } else if (isRepath_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/repath_1_yagish_logo.jpg',
              clientId: 'repath_mail',
              dialogName: 'repath-dialog',
              clientName: 'RePath株式会社',
              termurl: 'https://repath.co.jp/terms',
              privacyurl: 'https://repath.co.jp/privacy',
              clientServiceName: 'リーパスナース'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isReaching_2 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/reaching_2_yagish_logo.jpg',
              clientId: 'reaching_mail',
              dialogName: 'reaching-dialog',
              clientName: '株式会社リーチング',
              termurl: 'https://drive.google.com/file/d/1KaXtYZ5lC8ZZebo2Z2Uyo-M96B5yXW7f/view?usp=sharing',
              privacyurl: 'https://drive.google.com/file/d/1-clvJ--G6NKE26Y194fz6uf0wNfCI22u/view?usp=drive_link',
              clientServiceName: '看護リーチ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isDagent_1 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/dagent_1_yagish_logo.png',
              clientId: 'dagent_mail',
              dialogName: 'dagent-dialog',
              clientName: '株式会社デイリー・インフォメーション関西',
              termurl: 'https://d-agent.net/terms/',
              privacyurl: 'https://dac-kansai.co.jp/privacypolicy/',
              clientServiceName: 'D-agent'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isReaching_3 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/reaching_3_yagish_logo.jpg',
              clientId: 'reaching_mail',
              dialogName: 'reaching-dialog',
              clientName: '株式会社リーチング',
              termurl: 'https://drive.google.com/file/d/1KaXtYZ5lC8ZZebo2Z2Uyo-M96B5yXW7f/view?usp=sharing',
              privacyurl: 'https://drive.google.com/file/d/1-clvJ--G6NKE26Y194fz6uf0wNfCI22u/view?usp=drive_link',
              clientServiceName: '保育リーチ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
          } else if (isRozas_1 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/rozas_1_yagish_logo.png',
              clientId: 'rozas_mail',
              dialogName: 'rozas_dialog',
              clientName: '株式会社ローザス',
              termurl: 'https://co-medical-pro.jp/terms',
              privacyurl: 'https://co-medical-pro.jp/privacy',
              clientServiceName: '看護プロ',
              sendApiEndpointKey: 'sendRozas'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isRozas_2 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/rozas_2_yagish_logo.png',
              clientId: 'rozas_mail',
              dialogName: 'rozas_dialog',
              clientName: '株式会社ローザス',
              termurl: 'https://co-medical-pro.jp/terms',
              privacyurl: 'https://co-medical-pro.jp/privacy',
              clientServiceName: 'コメディカルプロ',
              sendApiEndpointKey: 'sendRozas'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isRozas_3 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/rozas_3_yagish_logo.png',
              clientId: 'rozas_mail',
              dialogName: 'rozas_dialog',
              clientName: '株式会社ローザス',
              termurl: 'https://co-medical-pro.jp/terms',
              privacyurl: 'https://co-medical-pro.jp/privacy',
              clientServiceName: 'コメディカルプロ',
              sendApiEndpointKey: 'sendRozas'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
          } else if (isRozas_4 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/rozas_4_yagish_logo.png',
              clientId: 'rozas_mail',
              dialogName: 'rozas_dialog',
              clientName: '株式会社ローザス',
              termurl: 'https://co-medical-pro.jp/terms',
              privacyurl: 'https://co-medical-pro.jp/privacy',
              clientServiceName: 'ローザス',
              sendApiEndpointKey: 'sendRozas'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 4, dialogInfo, basicData, isMypage)
          } else if (isRozas_5 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/rozas_5_yagish_logo.png',
              clientId: 'rozas_mail',
              dialogName: 'rozas_dialog',
              clientName: '株式会社ローザス',
              termurl: 'https://co-medical-pro.jp/terms',
              privacyurl: 'https://co-medical-pro.jp/privacy',
              clientServiceName: 'コメディカルプロ',
              sendApiEndpointKey: 'sendRozas'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 5, dialogInfo, basicData, isMypage)
          } else if (isEil100_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/eil100_2_yagish_logo.png',
              clientId: 'eil100_mail',
              dialogName: 'eil100-dialog',
              clientName: '株式会社EIL',
              termurl: 'https://kaigoroute.com/terms/',
              privacyurl: 'https://kaigoroute.com/privacy/',
              clientServiceName: '介護ルート'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isTsace_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/tsace_1_yagish_logo.png',
              clientId: 'tsace_mail',
              dialogName: 'tsace-dialog',
              clientName: '株式会社TSACE',
              termurl: 'https://kaigoace.jp/policy/',
              privacyurl: 'https://ts-ace.co.jp/privacy/',
              clientServiceName: '介護エース'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isTsace_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/tsace_2_yagish_logo.png',
              clientId: 'tsace_mail',
              dialogName: 'tsace-dialog',
              clientName: '株式会社TSACE',
              termurl: 'https://ptotstace.jp/sitepolicy/',
              privacyurl: 'https://ts-ace.co.jp/privacy/',
              clientServiceName: 'PTOTSTエース'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isTsace_3 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/tsace_3_yagish_logo.png',
              clientId: 'tsace_mail',
              dialogName: 'tsace-dialog',
              clientName: '株式会社TSACE',
              termurl: 'https://hoikushiace.jp/policy/',
              privacyurl: 'https://ts-ace.co.jp/privacy/',
              clientServiceName: '保育エース'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
          } else if (isTerracia_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/terracia_1_yagish_logo.png',
              clientId: 'terracia_mail',
              dialogName: 'terracia-dialog',
              clientName: '株式会社テラシア',
              termurl: 'https://terracia-web.com/terms-of-service/',
              privacyurl: 'https://terracia-web.com/privacypolicy/',
              clientServiceName: '保育士テラス'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isTerracia_3 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/terracia_1_yagish_logo.png',
              clientId: 'terracia_mail',
              dialogName: 'terracia-dialog',
              clientName: '株式会社テラシア',
              termurl: 'https://terracia-web.com/terms-of-service/',
              privacyurl: 'https://terracia-web.com/privacypolicy/',
              clientServiceName: '保育士テラス'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
          } else if (isTerracia_4 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/terracia_2_yagish_logo.png',
              clientId: 'terracia_mail',
              dialogName: 'terracia-dialog',
              clientName: '株式会社テラシア',
              termurl: 'https://terracia-web.com/terms-of-service/',
              privacyurl: 'https://terracia-web.com/privacypolicy/',
              clientServiceName: '保育士テラス'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 4, dialogInfo, basicData, isMypage)
          } else if (isSimple_1 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/simple_1_yagish_logo.png',
              clientId: 'simple_mail',
              dialogName: 'simple-dialog',
              clientName: 'Simple株式会社',
              termurl: 'https://simple-hoiku.com/use-policy',
              privacyurl: 'https://simple-hoiku.com/privacypolicy',
              clientServiceName: 'しんぷる保育'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isMitzmitz_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/mitzmitz_1_yagish_logo.png',
              clientId: 'mitzmitz_mail',
              dialogName: 'mitzmitz-dialog',
              clientName: '株式会社ミッツミッツ',
              termurl: 'https://mitzmitz.com/meeting',
              privacyurl: 'https://mitzmitz.com/meeting',
              clientServiceName: 'ミッツミッツ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isNoajpn_1 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/noajpn_1_yagish_logo.jpg',
              clientId: 'noajpn_mail',
              dialogName: 'noajpn-dialog',
              clientName: 'NOA・JAPAN株式会社',
              termurl: 'https://noa-jpn.com/terms/?_gl=1*1auq0g3*_ga*MjQ5NDMyMzA0LjE3MTY0NTA1NTk.*_ga_890K6PB6H2*MTc0NTI4ODk0Ny43NC4xLjE3NDUyODg5ODAuMC4wLjA.',
              privacyurl: 'https://noa-jpn.com/terms/?_gl=1*1auq0g3*_ga*MjQ5NDMyMzA0LjE3MTY0NTA1NTk.*_ga_890K6PB6H2*MTc0NTI4ODk0Ny43NC4xLjE3NDUyODg5ODAuMC4wLjA.',
              clientServiceName: 'NOA・JAPAN'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isNoajpn_2 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/noajpn_2_yagish_logo.jpg',
              clientId: 'noajpn_mail',
              dialogName: 'noajpn-dialog',
              clientName: 'NOA・JAPAN株式会社',
              termurl: 'https://noa-jpn.com/terms/?_gl=1*1auq0g3*_ga*MjQ5NDMyMzA0LjE3MTY0NTA1NTk.*_ga_890K6PB6H2*MTc0NTI4ODk0Ny43NC4xLjE3NDUyODg5ODAuMC4wLjA.',
              privacyurl: 'https://noa-jpn.com/terms/?_gl=1*1auq0g3*_ga*MjQ5NDMyMzA0LjE3MTY0NTA1NTk.*_ga_890K6PB6H2*MTc0NTI4ODk0Ny43NC4xLjE3NDUyODg5ODAuMC4wLjA.',
              clientServiceName: 'NOA・JAPAN'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isNineearth_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/nineearth_1_yagish_logo.png',
              clientId: 'nineearth_mail',
              dialogName: 'nineearth-dialog',
              clientName: '株式会社N.E',
              termurl: 'https://nine-earth.co.jp/kaigo_s2/terms.html',
              privacyurl: 'https://nine-earth.co.jp/kaigo_s2/privacy.html',
              clientServiceName: '介護ナイン'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isNineearth_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/nineearth_2_yagish_logo.png',
              clientId: 'nineearth_mail',
              dialogName: 'nineearth-dialog',
              clientName: '株式会社N.E',
              termurl: 'https://nine-earth.co.jp/kaigo_s2/terms.html',
              privacyurl: 'https://nine-earth.co.jp/kaigo_s2/privacy.html',
              clientServiceName: '介護ナイン'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isNineearth_3 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/nineearth_3_yagish_logo.png',
              clientId: 'nineearth_mail',
              dialogName: 'nineearth-dialog',
              clientName: '株式会社N.E',
              termurl: 'https://nine-earth.co.jp/kaigo_s2/terms.html',
              privacyurl: 'https://nine-earth.co.jp/kaigo_s2/privacy.html',
              clientServiceName: '介護ナイン'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
          } else if (isNineearth_4 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/nineearth_4_yagish_logo.png',
              clientId: 'nineearth_mail',
              dialogName: 'nineearth-dialog',
              clientName: '株式会社N.E',
              termurl: 'https://nine-earth.co.jp/kaigo_s2/terms.html',
              privacyurl: 'https://nine-earth.co.jp/kaigo_s2/privacy.html',
              clientServiceName: '介護ナイン'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 4, dialogInfo, basicData, isMypage)
          } else if (isNineearth_5 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/nineearth_5_yagish_logo.png',
              clientId: 'nineearth_mail',
              dialogName: 'nineearth-dialog',
              clientName: '株式会社N.E',
              termurl: 'https://nine-earth.co.jp/kaigo_s2/terms.html',
              privacyurl: 'https://nine-earth.co.jp/kaigo_s2/privacy.html',
              clientServiceName: '看護ナイン'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 5, dialogInfo, basicData, isMypage)
          } else if (isKotrio_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/kotrio_1_yagish_logo.png',
              clientId: 'kotrio_mail',
              dialogName: 'kotrio-dialog',
              clientName: '	株式会社コトリオ',
              termurl: 'https://kotrio.co.jp/terms/',
              privacyurl: 'https://kotrio.co.jp/privacy_policy/',
              clientServiceName: 'コトリオ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isAxes_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/axes_1_yagish_logo.jpg',
              clientId: 'axes_mail',
              dialogName: 'axes-dialog',
              clientName: '株式会社axes',
              termurl: 'https://axes.jobs/terms-of-use/',
              privacyurl: 'https://axes.jobs/privacy-policy/',
              clientServiceName: 'アクキャリ介護'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isKotrio_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/kotrio_2_yagish_logo.png',
              clientId: 'kotrio_mail',
              dialogName: 'kotrio-dialog',
              clientName: '	株式会社コトリオ',
              termurl: 'https://kotrio.co.jp/terms/',
              privacyurl: 'https://kotrio.co.jp/privacy_policy/',
              clientServiceName: 'コトリオ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isPlexjob_3 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/plexjob_3_yagish_logo.png',
              clientId: 'plexjob_mail',
              dialogName: 'plexjob-dialog',
              clientName: '株式会社プレックス',
              termurl: 'https://www.plex-job.com/terms/',
              privacyurl: 'https://www.plex-job.com/privacy-policy/',
              clientServiceName: 'PLEX JOB'
            }
            const isPlexjob_3_ButtonSizeUp = true
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage, isPlexjob_3_ButtonSizeUp)
          } else if (isLifeones_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/lifeones_1_yagish_logo.png',
              clientId: 'lifeones_mail',
              dialogName: 'lifeones-dialog',
              clientName: 'ライフワンズ株式会社',
              termurl: 'https://kaigo.clickjob.jp/policy',
              privacyurl: 'https://kaigo.clickjob.jp/privacy',
              clientServiceName: 'クリックジョブ介護'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isLifeones_3 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/lifeones_3_yagish_logo.png',
              clientId: 'lifeones_mail',
              dialogName: 'lifeones-dialog',
              clientName: 'ライフワンズ株式会社',
              termurl: 'https://kaigo.clickjob.jp/policy',
              privacyurl: 'https://kaigo.clickjob.jp/privacy',
              clientServiceName: 'クリックジョブ介護'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
          } else if (isValuablelife_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/valuablelife_1_yagish_logo.jpg',
              clientId: 'valuablelife_mail',
              dialogName: 'valuablelife-dialog',
              clientName: '株式会社VALUABLE LIFE',
              termurl: 'https://valuable-life.co.jp/kaigo/meta/terms.html',
              privacyurl: 'https://valuable-life.co.jp/kaigo/meta/privacy.html',
              clientServiceName: 'ナカムラ介護'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isParable_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/parable_1_yagish_logo.png',
              clientId: 'parable_mail',
              dialogName: 'parable-dialog',
              clientName: '株式会社パラブル',
              termurl: 'https://tensyoku-garden.com/articles/static%2Dgroup/static%2Dcategory/terms',
              privacyurl: 'https://tensyoku-garden.com/articles/static%2Dgroup/static%2Dcategory/privacy',
              clientServiceName: '転職ガーデン'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isStarlabo_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/starlabo_1_yagish_logo_20250406.png',
              clientId: 'starlabo_mail',
              dialogName: 'starlabo-dialog',
              clientName: '株式会社スターラボ',
              termurl: 'https://search.eir-agent.jp/terms',
              privacyurl: 'https://search.eir-agent.jp/privacy',
              clientServiceName: '看護師転職支援サービスEIR(エイル)'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isSupernurse_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/supernurse_1_yagish_logo.png',
              clientId: 'supernurse_mail',
              dialogName: 'supernurse-dialog',
              clientName: '株式会社スーパーナース',
              termurl: 'https://www.supernurse.co.jp/cms/wp-content/uploads/2025/07/スーパーナース利用規約.pdf',
              privacyurl: 'https://www.supernurse.co.jp/privacy/',
              clientServiceName: 'スーパーナース'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isStarlabo_2 && formatId.includes('shokumukeirekisho')) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/starlabo_2_yagish_logo_20250406.png',
              clientId: 'starlabo_mail',
              dialogName: 'starlabo-dialog',
              clientName: '株式会社スターラボ',
              termurl: 'https://scout.star-labo.co.jp/terms',
              privacyurl: 'https://scout.star-labo.co.jp/policy/',
              clientServiceName: 'スターラボ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isRecree_2 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/recree_yagish_logo_20240421.png',
              clientId: 'recree_mail',
              dialogName: 'recree_dialog',
              clientName: '株式会社レクリー',
              termurl: 'https://recree.jobree.co.jp/terms',
              privacyurl: 'https://recree.jobree.co.jp/privacy_policy',
              clientServiceName: 'ジョブリー建設',
              sendApiEndpointKey: 'sendRecree',
              btn_text: '同意する'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isRecree_3 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/recree_yagish_logo_20240421.png',
              clientId: 'recree_mail',
              dialogName: 'recree_dialog',
              clientName: '株式会社レクリー',
              termurl: 'https://recree.jobree.co.jp/terms',
              privacyurl: 'https://recree.jobree.co.jp/privacy_policy',
              clientServiceName: 'ジョブリー建設',
              sendApiEndpointKey: 'sendRecree',
              btn_text: '同意する'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
          } else if (isRecree_4 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/recree_yagish_logo_20240421.png',
              clientId: 'recree_mail',
              dialogName: 'recree_dialog',
              clientName: '株式会社レクリー',
              termurl: 'https://recree.jobree.co.jp/terms',
              privacyurl: 'https://recree.jobree.co.jp/privacy_policy',
              clientServiceName: 'ジョブリー建設',
              sendApiEndpointKey: 'sendRecree',
              btn_text: '同意する'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 4, dialogInfo, basicData, isMypage)
          } else if (isSms_3 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/sms_3_yagish_logo_20250205.png',
              clientId: 'sms_admin_hoiku',
              dialogName: 'sms-dialog',
              clientName: '株式会社エス･エム･エス',
              termurl: 'https://hoiku.jinzaibank.com/contents/tos.html',
              privacyurl: 'https://policy.bm-sms.co.jp/consumer/privacy/policy',
              clientServiceName: 'キャリア支援サービス'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
          } else if (isPeacekaigo4 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/peacekaigo_yagish_logo_4.png',
              clientId: 'peacekaigo_mail',
              dialogName: 'peacekaigo_dialog',
              clientName: 'ネクストイノベーション',
              termurl: 'https://peace-kaigo.com/terms/',
              privacyurl: 'https://peace-kaigo.com/terms/',
              clientServiceName: 'ネクストイノベーション',
              sendApiEndpointKey: 'sendPeacekaigo'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 4, dialogInfo, basicData, isMypage)
          } else if (isPeacekaigo5 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/peacekaigo_yagish_logo_4.png',
              clientId: 'peacekaigo_mail',
              dialogName: 'peacekaigo_dialog',
              clientName: 'ネクストイノベーション',
              termurl: 'https://peace-kaigo.com/terms/',
              privacyurl: 'https://peace-kaigo.com/terms/',
              clientServiceName: 'ネクストイノベーション',
              sendApiEndpointKey: 'sendPeacekaigo'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 5, dialogInfo, basicData, isMypage)
          } else if (isEil100_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/eil100_1_yagish_logo.png',
              clientId: 'eil100_mail',
              dialogName: 'eil100-dialog',
              clientName: '株式会社EIL',
              termurl: 'https://kaigoroute.com/terms/',
              privacyurl: 'https://kaigoroute.com/privacy/',
              clientServiceName: '株式会社EIL'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)
          } else if (isJhr_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/jhr_1_yagish_logo.jpg',
              clientId: 'jhr_mail',
              dialogName: 'jhr-dialog',
              clientName: 'JHR株式会社',
              termurl: 'https://drive.google.com/file/d/1BehbiQGs7Nf5sns3hQRt5btf4DRHQTB7/view?usp=drive_link',
              privacyurl: 'https://j-h-r.com/privacy/',
              clientServiceName: 'JHR株式会社'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isJhr_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/jhr_1_yagish_logo.jpg',
              clientId: 'jhr_mail',
              dialogName: 'jhr-dialog',
              clientName: 'JHR株式会社',
              termurl: 'https://drive.google.com/file/d/1BehbiQGs7Nf5sns3hQRt5btf4DRHQTB7/view?usp=drive_link',
              privacyurl: 'https://j-h-r.com/privacy/',
              clientServiceName: 'JHR株式会社'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isPharmate1 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/pharmate_1_yagish_logo.png',
              clientId: 'pharmate_mail',
              dialogName: 'pharmate-dialog',
              clientName: '株式会社ファル・メイト',
              termurl: 'https://www.pharmate.jp/policy/',
              privacyurl: 'https://www.pharmate.jp/policy/',
              clientServiceName: 'Phar+Mate'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isPharmacareer_2 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/pharmacareer_yagish_logo_1.png',
              clientId: 'pharmacareer_mail',
              dialogName: 'pharmacareer_dialog',
              clientName: 'エニーキャリア株式会社',
              termurl: 'https://pharmacareer.jp/tos',
              privacyurl: 'https://pharmacareer.jp/privacy',
              clientServiceName: 'ファーマキャリア',
              sendApiEndpointKey: 'sendPharmacareer'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isPharmacareer_3 && this.isShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/pharmacareer_yagish_logo_1.png',
              clientId: 'pharmacareer_mail',
              dialogName: 'pharmacareer_dialog',
              clientName: 'エニーキャリア株式会社',
              termurl: 'https://pharmacareer.jp/tos',
              privacyurl: 'https://pharmacareer.jp/privacy',
              clientServiceName: 'ファーマキャリア',
              sendApiEndpointKey: 'sendPharmacareer'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
          } else if (isPharmacareer_1 && (formatId == 'rerekisho_part_time' || formatId == 'rirekisho_part_time2')) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/pharmacareer_yagish_logo_1.png',
              clientId: 'pharmacareer_mail',
              dialogName: 'pharmacareer_dialog',
              clientName: 'エニーキャリア株式会社',
              termurl: 'https://pharmacareer.jp/tos',
              privacyurl: 'https://pharmacareer.jp/privacy',
              clientServiceName: 'ファーマキャリア',
              sendApiEndpointKey: 'sendPharmacareer'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isRecruitMc1 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/recruit_mc_1_yagish_log_20251210.jpg',
              clientId: 'recruit_mc_mail',
              dialogName: 'recruit_mc_dialog',
              clientName: '(株)リクルートメディカルキャリア',
              termurl: 'https://cdn.p.recruit.co.jp/terms/ryz-t-1001/index.html',
              privacyurl: 'https://cdn.p.recruit.co.jp/terms/cmn-t-1002/index.html',
              clientServiceName: 'リクナビ薬剤師',
              sendApiEndpointKey: 'sendRecruitMc'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isNorms_1 && this.isShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/norms_1_yagish_logo.png',
              clientId: 'norms_mail',
              dialogName: 'norms-dialog',
              clientName: 'norms株式会社',
              termurl: 'https://norms.jp/terms/',
              privacyurl: 'https://norms.jp/privacy-policy/',
              clientServiceName: 'norms株式会社'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isHuemaridge_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/huemaridge_1_yagish_logo.png',
              clientId: 'huemaridge_mail',
              dialogName: 'huemaridge-dialog',
              clientName: '株式会社ヒューマリッジ',
              termurl: 'https://drive.google.com/file/d/14WkOz9-7YyvDWuYE2rYyhbyVdiUCPt3x/view?usp=drive_link',
              privacyurl: 'https://www.huemaridge.co.jp/privacy/',
              clientServiceName: '株式会社ヒューマリッジ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isMedley_Link_5 && this.isJobChangeFormat(formatId)) {
            emitGlobalVarPopupDialog('open-medley-dialog', formatId, previewFormat, 0, 5, isMypage)
          } else if (isMedley_Link_6 && this.isJobChangeFormat(formatId)) {
            emitGlobalVarPopupDialog('open-medley-dialog', formatId, previewFormat, 0, 6, isMypage)
          } else if (isMedley_Link_7 && this.isJobChangeFormat(formatId)) {
            emitGlobalVarPopupDialog('open-medley-dialog', formatId, previewFormat, 0, 7, isMypage)
          } else if (isMedley_Link_9 && this.isJobChangeFormat(formatId)) {
            emitGlobalVarPopupDialog('open-medley-dialog', formatId, previewFormat, 0, 9, isMypage)
          } else if (isMedley_Link_10 && this.isJobChangeFormat(formatId)) {
            emitGlobalVarPopupDialog('open-medley-dialog', formatId, previewFormat, 0, 10, isMypage)
          } else if (isMedley_Link_8 && this.isJobChangeFormat(formatId)) {
            emitGlobalVarPopupDialog('open-medley-dialog', formatId, previewFormat, 0, 8, isMypage)
          } else if (isDely_1 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/dely_yagish_logo_20240321.png',
              clientId: 'dely_mail',
              dialogName: 'dely_dialog',
              clientName: 'dely株式会社',
              termurl: 'https://jobs.kurashiru.com/service-policy',
              privacyurl: 'https://jobs.kurashiru.com/privacy-policy',
              clientServiceName: 'クラシルジョブ',
              sendApiEndpointKey: 'sendDely',
              btn_text: '同意する'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isAgrinavi_1 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/agrinavi_yagish_logo_20240418.png',
              clientId: 'agrinavi_mail',
              dialogName: 'agrinavi_dialog',
              clientName: 'あぐりナビ',
              termurl: 'https://www.agri-navi.com/membership_agreement',
              privacyurl: 'https://agrimedia.jp/privacy/',
              clientServiceName: 'アグリナビ',
              sendApiEndpointKey: 'sendAgrinavi',
              btn_text: '同意する'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isRecree_5 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/recree_yagish_logo_20240421.png',
              clientId: 'recree_mail',
              dialogName: 'recree_dialog',
              clientName: '株式会社レクリー',
              termurl: 'https://recree.jobree.co.jp/terms',
              privacyurl: 'https://recree.jobree.co.jp/privacy_policy',
              clientServiceName: 'ジョブリー建設',
              sendApiEndpointKey: 'sendRecree',
              btn_text: '同意する'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 5, dialogInfo, basicData, isMypage)
          } else if (isXmile_6 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_6_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 6, dialogInfo, basicData, isMypage)
          } else if (isXmile_7 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_7_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 7, dialogInfo, basicData, isMypage)
          } else if (isXmile_8 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_8_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 8, dialogInfo, basicData, isMypage)
          } else if (isXmile_9 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_9_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 9, dialogInfo, basicData, isMypage)
          } else if (isXmile_27 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_27_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 27, dialogInfo, basicData, isMypage)
          } else if (isXmile_38 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_38_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 38, dialogInfo, basicData, isMypage)
          } else if (isXmile_10 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_10_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 10, dialogInfo, basicData, isMypage)
          } else if (isXmile_11 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_11_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 11, dialogInfo, basicData, isMypage)
          } else if (isXmile_12 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_12_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 12, dialogInfo, basicData, isMypage)
          } else if (isXmile_13 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_13_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 13, dialogInfo, basicData, isMypage)
          } else if (isXmile_14 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_14_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 14, dialogInfo, basicData, isMypage)
          } else if (isXmile_15 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_15_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 15, dialogInfo, basicData, isMypage)
          } else if (isXmile_16 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_16_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 16, dialogInfo, basicData, isMypage)
          } else if (isXmile_17 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_17_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 17, dialogInfo, basicData, isMypage)
          } else if (isXmile_18 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_18_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 18, dialogInfo, basicData, isMypage)
          } else if (isXmile_19 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_19_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 19, dialogInfo, basicData, isMypage)
          } else if (isXmile_20 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_20_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 20, dialogInfo, basicData, isMypage)
          } else if (isXmile_21 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_21_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 21, dialogInfo, basicData, isMypage)
          } else if (isXmile_22 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_22_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 22, dialogInfo, basicData, isMypage)
          } else if (isWitc1 && this.isShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/witc_1_yagish_logo.png',
              clientId: 'witc_mail',
              dialogName: 'witc-dialog',
              clientName: '株式会社ワールドインテック',
              termurl: 'https://www.witc.co.jp/terms/',
              privacyurl: 'https://www.witc.co.jp/privacy/',
              clientServiceName: 'ワールドインテック'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isPlexjob_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/plexjob_1_yagish_logo.png',
              clientId: 'plexjob_mail',
              dialogName: 'plexjob-dialog',
              clientName: '株式会社プレックス',
              termurl: 'https://www.plex-job.com/terms/',
              privacyurl: 'https://www.plex-job.com/privacy-policy/',
              clientServiceName: 'PLEX JOB'
            }
            const isPlexjob_1_ButtonSizeUp = true
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage, isPlexjob_1_ButtonSizeUp)
          } else if (isPlexjob_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/plexjob_2_yagish_logo.png',
              clientId: 'plexjob_mail',
              dialogName: 'plexjob-dialog',
              clientName: '株式会社プレックス',
              termurl: 'https://www.plex-job.com/terms/',
              privacyurl: 'https://www.plex-job.com/privacy-policy/',
              clientServiceName: 'PLEX JOB'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isPlexjob_4 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/plexjob_4_yagish_logo.png',
              clientId: 'plexjob_mail',
              dialogName: 'plexjob-dialog',
              clientName: '株式会社プレックス',
              termurl: 'https://www.plex-job.com/terms/',
              privacyurl: 'https://www.plex-job.com/privacy-policy/',
              clientServiceName: 'PLEX JOB'
            }
            const isPlexjob_4_ButtonSizeUp = true
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 4, dialogInfo, basicData, isMypage, isPlexjob_4_ButtonSizeUp)
          } else if (isPlexjob_5 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/plexjob_5_yagish_logo.png',
              clientId: 'plexjob_mail',
              dialogName: 'plexjob-dialog',
              clientName: '株式会社プレックス',
              termurl: 'https://www.plex-job.com/terms/',
              privacyurl: 'https://www.plex-job.com/privacy-policy/',
              clientServiceName: 'PLEX JOB'
            }
            const isPlexjob_5_ButtonSizeUp = true
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 5, dialogInfo, basicData, isMypage, isPlexjob_5_ButtonSizeUp)
          } else if (isPlexjob_6 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/plexjob_6_yagish_logo.png',
              clientId: 'plexjob_mail',
              dialogName: 'plexjob-dialog',
              clientName: '株式会社プレックス',
              termurl: 'https://www.plex-job.com/terms/',
              privacyurl: 'https://www.plex-job.com/privacy-policy/',
              clientServiceName: 'PLEX JOB'
            }
            const isPlexjob_6_ButtonSizeUp = true
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 6, dialogInfo, basicData, isMypage, isPlexjob_6_ButtonSizeUp)
          } else if (isLifeones_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/lifeones_2_yagish_logo.png',
              clientId: 'lifeones_mail',
              dialogName: 'lifeones-dialog',
              clientName: 'ライフワンズ株式会社',
              termurl: 'https://kaigo.clickjob.jp/policy',
              privacyurl: 'https://kaigo.clickjob.jp/privacy',
              clientServiceName: 'クリックジョブ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isGojob_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/gojob_1_yagish_logo.png',
              clientId: 'gojob_mail',
              dialogName: 'gojob-dialog',
              clientName: 'GOジョブ株式会社',
              termurl: 'https://gojob.go.goinc.jp/terms-of-service',
              privacyurl: 'https://gojob.go.goinc.jp/privacy-policy',
              clientServiceName: 'GOジョブ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isWillofwork_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/willofwork_1_yagish_logo.png',
              clientId: 'willofwork_mail',
              dialogName: 'willofwork-dialog',
              clientName: '株式会社ウィルオブ・ワーク',
              termurl: 'https://willof-work.co.jp/corp/aboutus/rule/',
              privacyurl: 'https://willof-work.co.jp/corp/aboutus/compliance/',
              clientServiceName: 'GMエージェント'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isProselltraction_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/proselltraction_1_yagish_logo.png',
              clientId: 'proselltraction_mail',
              dialogName: 'proselltraction-dialog',
              clientName: '株式会社プロセルトラクション',
              termurl: 'https://www.prosell-traction.com/privacy/',
              privacyurl: 'https://www.prosell-traction.com/privacy/',
              clientServiceName: 'プロセルトラクション'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isRerise_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/rerise_1_yagish_logo.jpg',
              clientId: 'rerise_mail',
              dialogName: 'rerise-dialog',
              clientName: '株式会社Re.rise',
              termurl: 'https://drive.google.com/file/d/1fPCkg63CNG25GceKF60muFRFVO6sYxQn/view?usp=sharing',
              privacyurl: 'https://drive.google.com/file/d/1HSePOn4_q54DgT4duyKe-cjiTqIqxzP4/view?usp=sharing',
              clientServiceName: 'Re.rise　'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isTimee_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/timee_1_yagish_logo.png',
              clientId: 'timee_mail',
              dialogName: 'timee-dialog',
              clientName: '株式会社タイミー',
              termurl: 'https://timee.notion.site/1bac5579d2b880318d0fca57e79b0ed2',
              privacyurl: 'https://timee.co.jp/policy/',
              occupationurl: 'https://timee.co.jp/occupation/',
              clientServiceName: 'タイミーキャリアプラス'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isMitzmitz_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/mitzmitz_1_yagish_logo.png',
              clientId: 'mitzmitz_mail',
              dialogName: 'mitzmitz-dialog',
              clientName: '株式会社ミッツミッツ',
              termurl: 'https://mitzmitz.com/meeting',
              privacyurl: 'https://mitzmitz.com/meeting',
              clientServiceName: 'ミッツミッツ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isWillofwork_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/willofwork_2_yagish_logo.png',
              clientId: 'willofwork_mail',
              dialogName: 'willofwork-dialog',
              clientName: '株式会社ウィルオブ・ワーク',
              termurl: 'https://willof-work.co.jp/corp/aboutus/rule/',
              privacyurl: 'https://willof-work.co.jp/corp/aboutus/compliance/',
              clientServiceName: 'GMエージェント'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isCiw_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/ciw_1_yagish_logo.png',
              clientId: 'ciw_mail',
              dialogName: 'ciw-dialog',
              clientName: '株式会社コンフィデンス・インターワークス',
              termurl: 'https://04510.jp/app/m/memp/a/Agreement/pid/faw',
              privacyurl: 'https://ciw.jp/privacypolicy/',
              clientServiceName: '工場ワークス'
            }
            const isCiw_1_ButtonSizeUp = true
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage, isCiw_1_ButtonSizeUp)
          } else if (isTruspo_1 && this.isShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/truspo_1_yagish_logo.png',
              clientId: 'truspo_mail',
              dialogName: 'truspo-dialog',
              clientName: '株式会社トラスポ',
              termurl: 'https://truspo.co.jp/policy/',
              privacyurl: 'https://truspo.co.jp/privacy/',
              clientServiceName: 'Truspo',
              setTimeLink: 'https://sb.truspo.co.jp/ab/timerex_yagish'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isBestand_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/bestand_1_yagish_logo.png',
              clientId: 'bestand_mail',
              dialogName: 'bestand-dialog',
              clientName: '株式会社BESTAND',
              termurl: 'https://bestand.jp/kiyaku',
              privacyurl: 'https://bestand.jp/policy',
              clientServiceName: 'HIKITATE Career'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isHhjapan_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/hhjapan_1_yagish_logo.png',
              clientId: 'hhjapan_mail',
              dialogName: 'hhjapan-dialog',
              clientName: 'Head Hunting Japan',
              termurl: 'https://hh-j.co.jp/Head-Hunting-Japan-rules',
              privacyurl: 'https://hh-j.co.jp/Head-Hunting-Japan-privacy',
              clientServiceName: 'Head Hunting Japan'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isRiajob_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/riajob_1_yagish_logo.jpg',
              clientId: 'riajob_mail',
              dialogName: 'riajob-dialog',
              clientName: '株式会社リアジョブ',
              termurl: 'https://drive.google.com/drive/folders/1DcynTgiHWygRI9FAgZxKtldd7UffekUU',
              privacyurl: 'https://careertsukuru.com/privacypolicy',
              clientServiceName: 'キャリつく！'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isBranu_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/branu_1_yagish_logo.png',
              clientId: 'branu_mail',
              dialogName: 'branu-dialog',
              clientName: 'BRANU株式会社',
              termurl: 'https://job.careecon.jp/terms',
              privacyurl: 'https://branu.jp/privacy',
              clientServiceName: 'キャリコンジョブ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isBlankpad_1 && this.isShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/blankpad_1_yagish_logo.png',
              clientId: 'blankpad_mail',
              dialogName: 'blankpad-dialog',
              clientName: '株式会社blankpad',
              termurl: 'https://blankpad.co.jp/terms-of-recruitment',
              privacyurl: 'https://blankpad.co.jp/privacy#top',
              clientServiceName: ''
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isSmartforce_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/smartforce_1_yagish_logo.jpg',
              clientId: 'smartforce_mail',
              dialogName: 'smartforce-dialog',
              clientName: '株式会社SmartForce',
              termurl: 'https://smartforce.jp/terms-of-service',
              privacyurl: 'https://smartforce.jp/privacy-policy',
              clientServiceName: 'SmartForce'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isAwesome_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/awesome_1_yagish_logo.jpg',
              clientId: 'awesome_mail',
              dialogName: 'awesome-dialog',
              clientName: 'AWESOME株式会社',
              termurl: 'https://drive.google.com/file/d/1FCX_wO1XMBeMOVoN4LLi-YI22ourIYr-/view?usp=drive_link',
              privacyurl: 'https://awesome0707.com/policy/',
              clientServiceName: 'AWESOME株式会社'
              // text_1: 'プロが条件に合う転職エージェンをご紹介します！'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isOutsourcing_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/outsourcing_yagish_logo_20250414.jpg',
              clientId: 'outsourcing_mail',
              dialogName: 'outsourcing-dialog',
              clientName: '株式会社アウトソーシング',
              termurl: 'https://www.894651.com/guide/terms-of-use-for-user/',
              privacyurl: 'https://www.outsourcing.co.jp/privacy/01',
              clientServiceName: 'はたらくヨロコビ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isHitolabo_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/hitolabo_1_yagish_logo.png',
              clientId: 'hitolabo_mail',
              dialogName: 'hitolabo-dialog',
              clientName: 'ヒトラボエージェント株式会社',
              termurl: 'https://hitolabo-agent.com/%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84/',
              privacyurl: 'https://hitolabo-agent.com/privacy-policy/',
              clientServiceName: '調理師・栄養士のおしごとらぼ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isHitolabo_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/hitolabo_2_yagish_logo.png',
              clientId: 'hitolabo_mail',
              dialogName: 'hitolabo-dialog',
              clientName: 'ヒトラボエージェント株式会社',
              termurl: 'https://hitolabo-agent.com/%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84/',
              privacyurl: 'https://hitolabo-agent.com/privacy-policy/',
              clientServiceName: '調理師・栄養士のおしごとらぼ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isCookbiz_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/cookbiz_1_yagish_logo.jpg',
              clientId: 'cookbiz_mail',
              dialogName: 'cookbiz-dialog',
              clientName: 'クックビズ株式会社',
              termurl: 'https://cookbiz.co.jp/terms',
              privacyurl: 'https://corp.cookbiz.co.jp/privacy-policy/',
              clientServiceName: 'cookbiz'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isCookbiz_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/cookbiz_2_yagish_logo.jpg',
              clientId: 'cookbiz_mail',
              dialogName: 'cookbiz-dialog',
              clientName: 'クックビズ株式会社',
              termurl: 'https://cookbiz.co.jp/terms',
              privacyurl: 'https://corp.cookbiz.co.jp/privacy-policy/',
              clientServiceName: 'cookbiz',
              link: 'https://liff.line.me/2006706940-XWrw0jwQ/landing?follow=%40639witoy&lp=nFe2b1&liff_id=2006706940-XWrw0jwQ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isCookbiz_3 && (formatId == 'rerekisho_part_time' ||
            formatId == 'rirekisho_part_time2')) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/cookbiz_3_yagish_logo.jpg',
              clientId: 'cookbiz_mail',
              dialogName: 'cookbiz-dialog',
              clientName: 'クックビズ株式会社',
              termurl: 'https://cookbiz.co.jp/terms',
              privacyurl: 'https://corp.cookbiz.co.jp/privacy-policy/',
              clientServiceName: 'cookbiz',
              link: 'https://liff.line.me/2006706940-XWrw0jwQ/landing?follow=%40639witoy&lp=rkmnx1&liff_id=2006706940-XWrw0jwQ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
          } else if (isFoodison_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/foodison_1_yagish_logo.png',
              clientId: 'foodison_mail',
              dialogName: 'foodison-dialog',
              clientName: '株式会社フーディソン',
              termurl: 'https://foodjinzaibank.jp/terms',
              privacyurl: 'https://docs.google.com/document/d/e/2PACX-1vRVeKM7rPsERCKlZNLz_UBKI1-nSsv0LhP36-LtSVxx8BmTKNN1IS3Tn4pwc1hnE7Ql7x__GEvFH1JX/pub',
              clientServiceName: 'フード人材バンク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isFoodison_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/foodison_2_yagish_logo.png',
              clientId: 'foodison_mail',
              dialogName: 'foodison-dialog',
              clientName: '株式会社フーディソン',
              termurl: 'https://foodjinzaibank.jp/terms',
              privacyurl: 'https://docs.google.com/document/d/e/2PACX-1vRVeKM7rPsERCKlZNLz_UBKI1-nSsv0LhP36-LtSVxx8BmTKNN1IS3Tn4pwc1hnE7Ql7x__GEvFH1JX/pub',
              clientServiceName: 'フード人材バンク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isFoodison_3 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/foodison_3_yagish_logo.png',
              clientId: 'foodison_mail',
              dialogName: 'foodison-dialog',
              clientName: '株式会社フーディソン',
              termurl: 'https://foodjinzaibank.jp/terms',
              privacyurl: 'https://docs.google.com/document/d/e/2PACX-1vRVeKM7rPsERCKlZNLz_UBKI1-nSsv0LhP36-LtSVxx8BmTKNN1IS3Tn4pwc1hnE7Ql7x__GEvFH1JX/pub',
              clientServiceName: 'フード人材バンク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
          } else if (isOishiru_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/oishiru_1_yagish_logo.png',
              clientId: 'oishiru_mail',
              dialogName: 'oishiru-dialog',
              clientName: '株式会社オイシル',
              termurl: 'https://oishiru-career.jp/lp/service_policy.html',
              privacyurl: 'https://oishiru-career.jp/lp/privacy_policy.html',
              clientServiceName: 'オイシルキャリア'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isMitzmitz_4 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/mitzmitz_1_yagish_logo.png',
              clientId: 'mitzmitz_mail',
              dialogName: 'mitzmitz-dialog',
              clientName: '株式会社ミッツミッツ',
              termurl: 'https://mitzmitz.com/meeting',
              privacyurl: 'https://mitzmitz.com/meeting',
              clientServiceName: 'ミッツミッツ'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 4, dialogInfo, basicData, isMypage)
          } else if (isHayfield_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/hayfield_1_yagish_logo.png',
              clientId: 'hayfield_mail',
              dialogName: 'hayfield-dialog',
              clientName: '株式会社ヘイフィールド',
              termurl: 'https://hayfield.jp/terms/',
              privacyurl: 'https://hayfield.jp/privacy/',
              clientServiceName: '宅建Jobエージェント'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isItk_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/itk_1_yagish_logo.jpg',
              clientId: 'itk_mail',
              dialogName: 'itk-dialog',
              clientName: '株式会社itk',
              termurl: 'https://i-t-k.co.jp/rules',
              privacyurl: 'https://i-t-k.co.jp/privacy',
              clientServiceName: '飲食専門エージェント'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isPrimalwork_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/primalwork_yagish_logo_20250326.jpg',
              clientId: 'primalwork_mail',
              dialogName: 'primalwork-dialog',
              clientName: '株式会社プライマルワーク',
              termurl: 'https://primalwork.net/terms-of-service/',
              privacyurl: 'https://primalwork.net/privacy-policy/',
              clientServiceName: 'プライマルワーク'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isNsjapan_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/nsjapan_1_yagish_logo.jpg',
              clientId: 'nsjapan_mail',
              dialogName: 'nsjapan-dialog',
              clientName: 'エヌエス・ジャパン株式会社',
              termurl: 'https://www.ns-japan.co.jp/make-drama/lp/wp-content/themes/nsjapan/images/service_terms.pdf',
              privacyurl: 'https://www.ns-japan.co.jp/web/wp-content/uploads/2023/08/d10fedb7508ee1d858b0ed324db86f5f.pdf',
              clientServiceName: 'Make Drame CAREER'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isTalentnavi_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/talentnavi_1_yagish_logo.png',
              clientId: 'talentnavi_mail',
              dialogName: 'talentnavi-dialog',
              clientName: '株式会社タレントナビゲーター',
              termurl: 'https://talent-navi.jp/terms',
              privacyurl: 'https://talent-navi.jp/privacy',
              clientServiceName: 'タレントナビゲーター'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isAzurite_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/azurite_1_yagish_logo.png',
              clientId: 'azurite_mail',
              dialogName: 'azurite-dialog',
              clientName: '株式会社アズライト',
              termurl: 'https://azu-rite.co.jp/terms',
              privacyurl: 'https://azu-rite.co.jp/privacy_policy',
              clientServiceName: 'アズライト'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isAzurite_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/azurite_2_yagish_logo.png',
              clientId: 'azurite_mail',
              dialogName: 'azurite-dialog',
              clientName: '株式会社アズライト',
              termurl: 'https://azu-rite.co.jp/privacy_policy',
              privacyurl: 'https://azu-rite.co.jp/privacy_policy',
              clientServiceName: 'アズライト'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (is400F_1 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/400f_yagish_logo_20241212.png',
              clientId: '400f_mail',
              dialogName: '400f-dialog',
              clientName: '株式会社400F',
              termurl: 'https://lpd.okane-kenko.jp/tenshoku/docs/terms.pdf',
              privacyurl: 'https://okane-kenko.jp/policies/privacy',
              clientServiceName: 'オカネコ転職'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isTechouse_1 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/techouse_yagish_logo_make_1.png',
              clientId: 'techouse_mail',
              dialogName: 'techouse_dialog',
              clientName: 'Techouse社',
              termurl: 'https://jobhouse.jp/terms',
              privacyurl: 'https://jobhouse.jp/terms',
              clientServiceName: 'ジョブハウス',
              sendApiEndpointKey: 'sendTechouse'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isTechouse_2 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/techouse_yagish_logo_make_1.png',
              clientId: 'techouse_mail',
              dialogName: 'techouse_dialog',
              clientName: 'Techouse社',
              termurl: 'https://jobhouse.jp/terms',
              privacyurl: 'https://jobhouse.jp/terms',
              clientServiceName: 'ジョブハウス',
              sendApiEndpointKey: 'sendTechouse'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isTechouse_3 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/techouse_yagish_logo_driver_1.png',
              clientId: 'techouse_mail',
              dialogName: 'techouse_dialog',
              clientName: 'Techouse社',
              termurl: 'https://jobhouse.jp/terms',
              privacyurl: 'https://jobhouse.jp/terms',
              clientServiceName: 'ジョブハウス',
              sendApiEndpointKey: 'sendTechouse'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
          } else if (isRoxx2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/zcareer-roxx-yagish-logo.png',
              clientId: 'roxx_api',
              dialogName: 'roxx_dialog',
              clientName: 'Zキャリア エージェント',
              termurl: 'https://agent.zcareer.com/terms/',
              privacyurl: 'https://roxx.co.jp/policy/privacy',
              clientServiceName: 'Zキャリア エージェント',
              sendApiEndpointKey: 'sendDataRoxx',
              gradeYear: '',
              inputEmail: basicData.email,
              useDataSource: true
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isRoxx && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/zcareer-roxx-yagish-logo.png',
              clientId: 'roxx_api',
              dialogName: 'roxx_dialog',
              clientName: 'Zキャリア エージェント',
              termurl: 'https://agent.zcareer.com/terms/',
              privacyurl: 'https://roxx.co.jp/policy/privacy',
              clientServiceName: 'Zキャリア エージェント',
              sendApiEndpointKey: 'sendDataRoxx',
              gradeYear: '',
              inputEmail: basicData.email,
              useDataSource: true
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isRoxx13 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/roxx_13-16_yagish_logo.png',
              clientId: 'roxx_api',
              dialogName: 'roxx_dialog',
              clientName: 'Zキャリア エージェント',
              termurl: 'https://agent.zcareer.com/terms/',
              privacyurl: 'https://roxx.co.jp/policy/privacy',
              clientServiceName: 'Zキャリア エージェント',
              sendApiEndpointKey: 'sendDataRoxx',
              gradeYear: '',
              inputEmail: basicData.email,
              useDataSource: true
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 13, dialogInfo, basicData, isMypage)
          } else if (isRoxx14 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/roxx_13-16_yagish_logo.png',
              clientId: 'roxx_api',
              dialogName: 'roxx_dialog',
              clientName: 'Zキャリア エージェント',
              termurl: 'https://agent.zcareer.com/terms/',
              privacyurl: 'https://roxx.co.jp/policy/privacy',
              clientServiceName: 'Zキャリア エージェント',
              sendApiEndpointKey: 'sendDataRoxx',
              gradeYear: '',
              inputEmail: basicData.email,
              useDataSource: true
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 14, dialogInfo, basicData, isMypage)
          } else if (isRoxx15 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/roxx_13-16_yagish_logo.png',
              clientId: 'roxx_api',
              dialogName: 'roxx_dialog',
              clientName: 'Zキャリア エージェント',
              termurl: 'https://agent.zcareer.com/terms/',
              privacyurl: 'https://roxx.co.jp/policy/privacy',
              clientServiceName: 'Zキャリア エージェント',
              sendApiEndpointKey: 'sendDataRoxx',
              gradeYear: '',
              inputEmail: basicData.email,
              useDataSource: true
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 15, dialogInfo, basicData, isMypage)
          } else if (isRoxx16 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/roxx_13-16_yagish_logo.png',
              clientId: 'roxx_api',
              dialogName: 'roxx_dialog',
              clientName: 'Zキャリア エージェント',
              termurl: 'https://agent.zcareer.com/terms/',
              privacyurl: 'https://roxx.co.jp/policy/privacy',
              clientServiceName: 'Zキャリア エージェント',
              sendApiEndpointKey: 'sendDataRoxx',
              gradeYear: '',
              inputEmail: basicData.email,
              useDataSource: true
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 16, dialogInfo, basicData, isMypage)
          } else if (isUsenworking_1 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/usenworking_yagish_logo_1.png',
              clientId: 'usenworking_mail',
              dialogName: 'usenworking_dialog',
              clientName: '株式会社ＵＳＥＮ ＷＯＲＫＩＮＧ',
              termurl: 'https://usen-working.co.jp/file/ucareer_termsofservice_jobseeker.pdf',
              privacyurl: 'https://usen-working.co.jp/privacy/policy2.pdf',
              clientServiceName: 'USEN WORKING',
              sendApiEndpointKey: 'sendUsenworking'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
          } else if (isUsenworking_2 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/usenworking_yagish_logo_1.png',
              clientId: 'usenworking_mail',
              dialogName: 'usenworking_dialog',
              clientName: '株式会社ＵＳＥＮ ＷＯＲＫＩＮＧ',
              termurl: 'https://usen-working.co.jp/file/ucareer_termsofservice_jobseeker.pdf',
              privacyurl: 'https://usen-working.co.jp/privacy/policy2.pdf',
              clientServiceName: 'USEN WORKING',
              sendApiEndpointKey: 'sendUsenworking'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
          } else if (isUsenworking_3 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/usenworking_yagish_logo_2.png',
              clientId: 'usenworking_mail',
              dialogName: 'usenworking_dialog',
              clientName: '株式会社ＵＳＥＮ ＷＯＲＫＩＮＧ',
              termurl: 'https://usen-working.co.jp/file/ucareer_termsofservice_jobseeker.pdf',
              privacyurl: 'https://usen-working.co.jp/privacy/policy2.pdf',
              clientServiceName: 'USEN WORKING',
              sendApiEndpointKey: 'sendUsenworking'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
          } else if (isUsenworking_4 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew2_img/usenworking_yagish_logo_2.png',
              clientId: 'usenworking_mail',
              dialogName: 'usenworking_dialog',
              clientName: '株式会社ＵＳＥＮ ＷＯＲＫＩＮＧ',
              termurl: 'https://usen-working.co.jp/file/ucareer_termsofservice_jobseeker.pdf',
              privacyurl: 'https://usen-working.co.jp/privacy/policy2.pdf',
              clientServiceName: 'USEN WORKING',
              sendApiEndpointKey: 'sendUsenworking'
            }
            emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 4, dialogInfo, basicData, isMypage)
          } else {
            if ((isMedley1 || isMedley2 || isMedley3 || isMedley4 || isMedley5 || isMedley6 || isMedley7 || isMedley8 || isMedley9 || isMedley10) &&
              !(formatId == 'rirekisho_job_new' || formatId == 'rirekisho_job_new_single' || formatId == 'internship' || formatId == 'entrysheet')) {
              emitGlobalVarPopupDialog('open-medley-dialog', formatId, previewFormat, medleyID, 0, isMypage)
            } else if (isRoxx3 && (formatId == 'rirekisho_job_new' ||
              formatId == 'rirekisho_job_new_single' ||
              formatId == 'entrysheet')) {
              const dialogInfo = {
                logoImage: '/static/renew2_img/zcareer-roxx-yagish-logo.png',
                clientId: 'roxx_api',
                dialogName: 'roxx_dialog',
                clientName: 'Zキャリア エージェント',
                termurl: 'https://agent.zcareer.com/terms/',
                privacyurl: 'https://roxx.co.jp/policy/privacy',
                clientServiceName: 'Zキャリア エージェント',
                sendApiEndpointKey: 'sendDataRoxx',
                gradeYear: formatData.gradeYear,
                inputEmail: basicData.email,
                useDataSource: true
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
            } else if (isBriedge_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/briedge_1_yagish_logo.png',
                clientId: 'briedge_mail',
                dialogName: 'briedge-dialog',
                clientName: 'ブライエッジ株式会社',
                termurl: 'https://drive.google.com/file/d/1pn2C2hz7tBqz5Ql3tw0svnTWgvEYxE1d/view?usp=sharing',
                privacyurl: 'https://briedge.co.jp/privacypolicy/',
                clientServiceName: 'ブライエッジ株式会社'
                // text_1: 'プロが条件に合う転職エージェンをご紹介します！'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if (isCloudlink_3 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/cloudlink_3_yagish_logo.png',
                clientId: 'cloudlink_mail',
                dialogName: 'cloudlink-dialog',
                clientName: '株式会社Cloud Link',
                termurl: 'https://cloud-link.co.jp/terms-of-service/',
                privacyurl: 'https://cloud-link.co.jp/privacy-policy/',
                clientServiceName: 'Cloud Link',
                setTimeLink: 'https://cloud-link.eeasy.jp/shokai_mendan_pro'

              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
            } else if (isBearsnavi_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/bearsnavi_1_yagish_logo.png',
                clientId: 'bearsnavi_mail',
                dialogName: 'bearsnavi-dialog',
                clientName: 'ベアーズナビ株式会社',
                termurl: 'https://drive.google.com/file/d/1Frifaolfz0fnNECHBrtdDepYwHgyt9FC/view',
                privacyurl: 'https://bearsnavi.com/privacypolicy',
                clientServiceName: 'ベアーズナビ株式会社'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if (isBearsnavi_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/bearsnavi_2_yagish_logo.png',
                clientId: 'bearsnavi_mail',
                dialogName: 'bearsnavi-dialog',
                clientName: 'ベアーズナビ株式会社',
                termurl: 'https://drive.google.com/file/d/1Frifaolfz0fnNECHBrtdDepYwHgyt9FC/view',
                privacyurl: 'https://bearsnavi.com/privacypolicy',
                clientServiceName: 'ベアーズナビ株式会社'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
            } else if (isBearsnavi_3 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/bearsnavi_3_yagish_logo.png',
                clientId: 'bearsnavi_mail',
                dialogName: 'bearsnavi-dialog',
                clientName: 'ベアーズナビ株式会社',
                termurl: 'https://drive.google.com/file/d/1Frifaolfz0fnNECHBrtdDepYwHgyt9FC/view',
                privacyurl: 'https://bearsnavi.com/privacypolicy',
                clientServiceName: 'ベアーズナビ株式会社'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
            } else if (isProlg_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/prolg_1_yagish_logo.png',
                clientId: 'prolg_mail',
                dialogName: 'prolg-dialog',
                clientName: '株式会社プロローグ',
                termurl: 'https://drive.google.com/file/d/1I-fDPZb3wstO4_t9wLTfxi8fxVsnZNVA/view?usp=drive_link',
                privacyurl: 'https://prolg-shoukai.com/privacy',
                clientServiceName: '株式会社プロローグ'
                // text_1: 'キャリア・年収UP'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if (isProlg_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/prolg_2_yagish_logo.png',
                clientId: 'prolg_mail',
                dialogName: 'prolg-dialog',
                clientName: '株式会社プロローグ',
                termurl: 'https://drive.google.com/file/d/1I-fDPZb3wstO4_t9wLTfxi8fxVsnZNVA/view?usp=drive_link',
                privacyurl: 'https://prolg-shoukai.com/privacy',
                clientServiceName: '株式会社プロローグ'
                // text_1: 'キャリア・年収UP'

              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
            } else if (isSmartforce_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/smartforce_1_yagish_logo.jpg',
                clientId: 'smartforce_mail',
                dialogName: 'smartforce-dialog',
                clientName: '株式会社SmartForce',
                termurl: 'https://smartforce.jp/terms-of-service',
                privacyurl: 'https://smartforce.jp/privacy-policy',
                clientServiceName: 'SmartForce'
              }
              const isSmartforce_1_ButtonSizeUp = true
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage, isSmartforce_1_ButtonSizeUp)
            } else if (isXmile_23 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/xmile_23_yagish_logo.png',
                clientId: 'xmile_mail',
                dialogName: 'xmile-dialog',
                clientName: 'X Mile株式会社',
                termurl: 'https://www.xmile.co.jp/policy/08',
                privacyurl: 'https://www.xmile.co.jp/policy/06',
                clientServiceName: 'クロスワーク'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 23, dialogInfo, basicData, isMypage)
            } else if (isXmile_24 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/xmile_24_yagish_logo.png',
                clientId: 'xmile_mail',
                dialogName: 'xmile-dialog',
                clientName: 'X Mile株式会社',
                termurl: 'https://www.xmile.co.jp/policy/08',
                privacyurl: 'https://www.xmile.co.jp/policy/06',
                clientServiceName: 'クロスワーク'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 24, dialogInfo, basicData, isMypage)
            } else if (isXmile_25 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/xmile_25_yagish_logo.png',
                clientId: 'xmile_mail',
                dialogName: 'xmile-dialog',
                clientName: 'X Mile株式会社',
                termurl: 'https://www.xmile.co.jp/policy/08',
                privacyurl: 'https://www.xmile.co.jp/policy/06',
                clientServiceName: 'クロスワーク'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 25, dialogInfo, basicData, isMypage)
            } else if (isRecrea_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/recrea_2_yagish_logo.png',
                clientId: 'recrea_mail',
                dialogName: 'recrea-dialog',
                clientName: '株式会社Recrea',
                termurl: 'https://drive.google.com/file/d/1LuWgB1n3j4dPYeD18nyAbyr56AD0zSxp/view?usp=sharing',
                privacyurl: 'https://recrea-inc.com/privacy',
                clientServiceName: '株式会社Recrea'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
            } else if (isStartme_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/startme_1_yagish_logo.png',
                clientId: 'startme_mail',
                dialogName: 'startme-dialog',
                clientName: 'Start me株式会社',
                termurl: 'https://www.start-me.net/terms/',
                privacyurl: 'https://www.start-me.net/privacy-policy/',
                clientServiceName: 'スタートジョブ'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if (isAgent3_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/agent3_1_yagish_logo.png',
                clientId: 'agent3_mail',
                dialogName: 'agent3-dialog',
                clientName: '株式会社エージェントキューブ',
                termurl: 'https://www.agent3.co.jp/privacy',
                privacyurl: 'https://www.agent3.co.jp/privacy',
                clientServiceName: 'Agent cube'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if (isPersolinnovation_3 && this.isJobChangeFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/persolinnovation_3_yagish_logo.png',
                clientId: 'persolinnovation_admin',
                dialogName: 'persolinnovation_dialog',
                clientName: '株式会社パーソルイノベーション',
                termurl: 'https://lp.pitaten.jp/agreement.html',
                privacyurl: 'https://lp.pitaten.jp/privacy-policy.html',
                clientServiceName: '転職エージェントサービス',
                sendApiEndpointKey: 'sendPersolinnovation'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
            } else if (isKiminara_1 && this.isJobChangeFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/kiminara_1_yagish_logo.png',
                clientId: 'kiminara_mail',
                dialogName: 'kiminara-dialog',
                clientName: '株式会社キミナラ',
                termurl: 'https://kiminara.net/policy.php',
                privacyurl: 'https://kiminara.net/policy.php',
                clientServiceName: 'キャリアアドバイザー紹介サービス',
                text_1: 'プロが条件に合う転職エージェントをご紹介します！'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if (isKiminara_2 && this.isJobChangeFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/kiminara_2_yagish_logo.png',
                clientId: 'kiminara_mail',
                dialogName: 'kiminara-dialog',
                clientName: '株式会社キミナラ',
                termurl: 'https://kiminara.net/policy.php',
                privacyurl: 'https://kiminara.net/policy.php',
                clientServiceName: 'キャリアアドバイザー紹介サービス',
                text_1: 'プロが条件に合う転職エージェントをご紹介します！'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
            } else if (isKiminara_3 && this.isJobChangeFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/kiminara_1_yagish_logo.png',
                clientId: 'kiminara_mail',
                dialogName: 'kiminara-dialog',
                clientName: '株式会社キミナラ',
                termurl: 'https://kiminara.net/policy.php',
                privacyurl: 'https://kiminara.net/policy.php',
                clientServiceName: 'キャリアアドバイザー紹介サービス',
                text_1: 'プロが条件に合う転職エージェントをご紹介します！'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
            } else if (isKiminara_4 && this.isJobChangeFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/kiminara_2_yagish_logo.png',
                clientId: 'kiminara_mail',
                dialogName: 'kiminara-dialog',
                clientName: '株式会社キミナラ',
                termurl: 'https://kiminara.net/policy.php',
                privacyurl: 'https://kiminara.net/policy.php',
                clientServiceName: 'キャリアアドバイザー紹介サービス',
                text_1: 'プロが条件に合う転職エージェントをご紹介します！'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 4, dialogInfo, basicData, isMypage)
            } else if (isWorkport_4 && (formatId.includes('shokumukeirekisho'))) {
              const dialogInfo = {
                logoImage: '/static/renew2_img/workport_yagish_logo_20240702.png',
                clientId: 'workport_admin',
                dialogName: 'workport_dialog',
                clientName: '(株)ワークポート',
                termurl: 'https://www.workport.co.jp/terms/',
                privacyurl: 'https://www.workport.co.jp/privacy/',
                clientServiceName: 'ワークポート',
                sendApiEndpointKey: 'sendWorkport'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 4, dialogInfo, basicData, isMypage)
            } else if (isWorkport_1 && (formatId.includes('shokumukeirekisho'))) {
              const dialogInfo = {
                logoImage: '/static/renew2_img/workport_yagish_logo_20240702.png',
                clientId: 'workport_admin',
                dialogName: 'workport_dialog',
                clientName: '(株)ワークポート',
                termurl: 'https://www.workport.co.jp/terms/',
                privacyurl: 'https://www.workport.co.jp/privacy/',
                clientServiceName: 'ワークポート',
                sendApiEndpointKey: 'sendWorkport'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if (isWorkport_2 && (formatId.includes('shokumukeirekisho'))) {
              const dialogInfo = {
                logoImage: '/static/renew2_img/workport_yagish_logo_20240702.png',
                clientId: 'workport_admin',
                dialogName: 'workport_dialog',
                clientName: '(株)ワークポート',
                termurl: 'https://www.workport.co.jp/terms/',
                privacyurl: 'https://www.workport.co.jp/privacy/',
                clientServiceName: 'ワークポート',
                sendApiEndpointKey: 'sendWorkport'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
            } else if (isWorkport_3 && (formatId.includes('shokumukeirekisho'))) {
              const dialogInfo = {
                logoImage: '/static/renew2_img/workport_yagish_logo_20240702.png',
                clientId: 'workport_admin',
                dialogName: 'workport_dialog',
                clientName: '(株)ワークポート',
                termurl: 'https://www.workport.co.jp/terms/',
                privacyurl: 'https://www.workport.co.jp/privacy/',
                clientServiceName: 'ワークポート',
                sendApiEndpointKey: 'sendWorkport'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
            } else if (isCri_1 && formatId.includes('shokumukeirekisho')) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/cri_1_yagish_logo.png',
                clientId: 'cri_mail',
                dialogName: 'cri-dialog',
                clientName: 'クリーク･アンド･リバー社',
                termurl: 'https://cri-professional.com/mypage/guest/membership_terms.xhtml',
                privacyurl: 'https://www.cri.co.jp/privacy/',
                clientServiceName: 'HIGH-FIVE'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if (isLetsi_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/letsi_1_yagish_logo.png',
                clientId: 'letsi_mail',
                dialogName: 'letsi-dialog',
                clientName: '株式会社レッツアイ',
                termurl: 'https://letsi.co.jp/privacy/',
                privacyurl: 'https://letsi.co.jp/privacy/',
                clientServiceName: '株式会社レッツアイ'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if (isRoxx5 && this.isJobChangeFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew2_img/zcareer-roxx-yagish-logo.png',
                clientId: 'roxx_api',
                dialogName: 'roxx_dialog',
                clientName: 'Zキャリア エージェント',
                termurl: 'https://agent.zcareer.com/terms/',
                privacyurl: 'https://roxx.co.jp/policy/privacy',
                clientServiceName: 'Zキャリア エージェント',
                sendApiEndpointKey: 'sendDataRoxx',
                gradeYear: formatData.gradeYear,
                inputEmail: basicData.email,
                useDataSource: true
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 5, dialogInfo, basicData, isMypage)
            } else if (isRoxx4 && (formatId == 'rirekisho_job_new' ||
              formatId == 'rirekisho_job_new_single' ||
              formatId == 'entrysheet')) {
              const dialogInfo = {
                logoImage: '/static/renew2_img/zcareer-roxx-yagish-logo.png',
                clientId: 'roxx_api',
                dialogName: 'roxx_dialog',
                clientName: 'Zキャリア エージェント',
                termurl: 'https://agent.zcareer.com/terms/',
                privacyurl: 'https://roxx.co.jp/policy/privacy',
                clientServiceName: 'Zキャリア エージェント',
                sendApiEndpointKey: 'sendDataRoxx',
                gradeYear: formatData.gradeYear,
                inputEmail: basicData.email,
                useDataSource: true
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 4, dialogInfo, basicData, isMypage)
            } else if (isNeocareer_5 && this.isNewFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew2_img/neoe_yagish_logo_20230704.png',
                clientId: 'neocareer_admin',
                dialogName: 'neocareer_dialog',
                clientName: '株式会社ネオキャリア',
                termurl: 'https://www.s-agent.jp/agreement',
                privacyurl: 'https://www.neo-career.co.jp/policy/',
                clientServiceName: '就職Agent neo',
                sendApiEndpointKey: 'sendNeocareer'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 5, dialogInfo, basicData, isMypage)
            } else if (isRoxx11 && (formatId == 'rirekisho_job_new' ||
              formatId == 'rirekisho_job_new_single' ||
              formatId == 'entrysheet')) {
              const dialogInfo = {
                logoImage: '/static/renew2_img/zcareer-roxx-yagish-logo.png',
                clientId: 'roxx_api',
                dialogName: 'roxx_dialog',
                clientName: 'Zキャリア エージェント',
                termurl: 'https://agent.zcareer.com/terms/',
                privacyurl: 'https://roxx.co.jp/policy/privacy',
                clientServiceName: 'Zキャリア エージェント',
                sendApiEndpointKey: 'sendDataRoxx',
                gradeYear: formatData.gradeYear,
                inputEmail: basicData.email,
                useDataSource: true
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 11, dialogInfo, basicData)
            } else if (isHrteam_1 && (formatId == 'rirekisho_job_new' ||
              formatId == 'rirekisho_job_new_single' ||
              formatId == 'entrysheet')) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/hrteam_1_yagish_logo.png',
                clientId: 'hrteam_mail',
                dialogName: 'hrteam-dialog',
                clientName: '株式会社HRteam',
                termurl: 'https://hr-team.co.jp/commit-terms/',
                privacyurl: 'https://hr-team.co.jp/privacy/',
                clientServiceName: 'ジョブコミット新卒'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if (isCmindcareer_1 && (formatId == 'rirekisho_job_new' ||
              formatId == 'rirekisho_job_new_single' ||
              formatId == 'entrysheet' ||
              formatId == 'internship')) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/cmindcareer_1_yagish_logo.png',
                clientId: 'cmindcareer_mail',
                dialogName: 'cmindcareer-dialog',
                clientName: '株式会社シーマインドキャリア',
                termurl: 'https://my.cmindcareer.co.jp/terms/',
                privacyurl: 'https://cmindcareer.co.jp/privacy/',
                clientServiceName: 'シーマインドキャリア'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if (isDraft_1 && (formatId == 'rirekisho_job_new' ||
              formatId == 'rirekisho_job_new_single' ||
              formatId == 'entrysheet' ||
              formatId == 'internship')) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/draft_1_yagish_logo.jpg',
                clientId: 'draft_mail',
                dialogName: 'draft-dialog',
                clientName: '株式会社DRAFT',
                termurl: 'https://drive.google.com/file/d/10GEDlAJVmPRE2Xb8L9FDtzNvkWUfYrx9/view?usp=sharing',
                privacyurl: 'https://drive.google.com/file/d/1JgqrYmicJ_mJFYnQWR5odASDthiRGg37/view?usp=sharing',
                clientServiceName: 'DRAFTエージェント'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if (isRecrea_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/recrea_1_yagish_logo.png',
                clientId: 'recrea_mail',
                dialogName: 'recrea-dialog',
                clientName: '株式会社Recrea',
                termurl: '',
                privacyurl: '',
                clientServiceName: '株式会社Recrea'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if (isSurely_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/surely_1_yagish_logo.png',
                clientId: 'surely_mail',
                dialogName: 'surely-dialog',
                clientName: 'Surely株式会社',
                termurl: 'https://drive.google.com/file/d/1RO-SfVU3im35tLwHg33MSER-7YGEvcwH/view?usp=sharing',
                privacyurl: 'https://surely.co.jp/privacy/',
                clientServiceName: 'Surely株式会社'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if (isBizreach_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/bizreach_1_yagish_logo.png',
                clientId: 'bizreach_mail',
                dialogName: 'bizreach-dialog',
                clientName: '株式会社ビズリーチ',
                termurl: 'https://www.bizreach.jp/pages/service/rules/',
                privacyurl: 'https://www.bizreach.jp/pages/service/rules/',
                clientServiceName: 'ビズリーチ'
              }
              emitGlobalVarPopupDialog('open-bizreach-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if (isPersolinnovation_5 && (formatId == 'rerekisho_part_time' ||
              formatId == 'rirekisho_part_time2')) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/persolinnovation_yagish_logo_1.png',
                clientId: 'persolinnovation_admin',
                dialogName: 'persolinnovation_dialog',
                clientName: '株式会社パーソルイノベーション',
                termurl: 'https://agent.meetscare.jp/agreement.html',
                privacyurl: 'https://agent.meetscare.jp/privacy-policy.html',
                clientServiceName: 'みーつけあエージェント',
                sendApiEndpointKey: 'sendPersolinnovation'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 5, dialogInfo, basicData, isMypage)
            } else if (isStartme_2 && (formatId == 'rerekisho_part_time' ||
              formatId == 'rirekisho_part_time2')) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/startme_2_yagish_logo.png',
                clientId: 'startme_mail',
                dialogName: 'startme-dialog',
                clientName: 'Start me株式会社',
                termurl: 'https://www.start-me.net/terms/',
                privacyurl: 'https://www.start-me.net/privacy-policy/',
                clientServiceName: 'ヒバライト'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
            } else if (isDrtc_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/drtc_1_yagish_logo.png',
                clientId: 'drtc_mail',
                dialogName: 'drtc-dialog',
                clientName: '株式会社ドライバーテクノロジーズ',
                termurl: 'https://www.drtc.co.jp/terms',
                privacyurl: 'https://driver-direct.jp/personal/index.html',
                clientServiceName: 'ドライバーテクノロジーズ'
                // text_1: 'プロが条件に合う転職エージェンをご紹介します！'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if (isNeocareerNew_1 && this.isJobChangeFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/neocareer_1_yagish_logo.png',
                clientId: 'neocareer_new_mail',
                dialogName: 'neocareer-dialog',
                clientName: '第二新卒Agent neo',
                termurl: 'https://www.daini-agent.jp/terms',
                privacyurl: 'https://www.daini-agent.jp/terms',
                clientServiceName: '第二新卒Agent neo'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if ((formatId == 'rirekisho_job_new' ||
              formatId == 'rirekisho_job_new_single' ||
              formatId == 'entrysheet' ||
              formatId == 'internship') && isNeocareer_1) {
              const dialogInfo = {
                logoImage: '/static/renew2_img/neoe_yagish_logo_20230704.png',
                clientId: 'neocareer_admin',
                dialogName: 'neocareer_dialog',
                clientName: '株式会社ネオキャリア',
                termurl: 'https://www.s-agent.jp/agreement',
                privacyurl: 'https://www.neo-career.co.jp/policy/',
                clientServiceName: '第二新卒Agent neo',
                sendApiEndpointKey: 'sendNeocareer'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if (isOnecareer_1 && (formatId == 'rirekisho_job_new' ||
              formatId == 'rirekisho_job_new_single' ||
              formatId == 'entrysheet' ||
              formatId == 'internship')) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/onecareer_1_yagish_logo.png',
                clientId: 'onecareer_mail',
                dialogName: 'onecareer-dialog',
                clientName: '株式会社ワンキャリア',
                termurl: 'https://www.onecareer.jp/infos/terms',
                privacyurl: 'https://www.onecareer.jp/infos/signup_privacy_policy',
                clientServiceName: 'ワンキャリア',
                text_1: 'プロが好条件の新卒向け企業をご紹介します！'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if (isVinc_1 && (formatId == 'rirekisho_job_new' ||
              formatId == 'rirekisho_job_new_single' ||
              formatId == 'entrysheet' ||
              formatId == 'internship')) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/vinc_1_yagish_logo.png',
                clientId: 'vinc_mail',
                dialogName: 'vinc-dialog',
                clientName: 'ビューイング株式会社',
                termurl: 'https://vinc.co.jp/mag/egent-policy/',
                privacyurl: 'https://vinc.co.jp/mag/privacy/',
                clientServiceName: '就活の名人エージェント'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if ((formatId == 'rirekisho_job_new' ||
              formatId == 'rirekisho_job_new_single' ||
              formatId == 'entrysheet' ||
              formatId == 'internship') && isNeocareer_3) {
              const dialogInfo = {
                logoImage: '/static/renew2_img/neoe_yagish_logo_20230704.png',
                clientId: 'neocareer_admin',
                dialogName: 'neocareer_dialog',
                clientName: '株式会社ネオキャリア',
                termurl: 'https://www.s-agent.jp/agreement',
                privacyurl: 'https://www.neo-career.co.jp/policy/',
                clientServiceName: 'ヒトシア',
                sendApiEndpointKey: 'sendNeocareer'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
            } else if ((formatId == 'rerekisho_part_time') && isNeocareer_2) {
              const dialogInfo = {
                logoImage: '/static/dialog_img/popup_neo24.png',
                clientId: 'neocareer_admin',
                dialogName: 'neocareer_dialog',
                clientName: '株式会社ネオキャリア',
                termurl: 'https://www.s-agent.jp/agreement',
                privacyurl: 'https://www.neo-career.co.jp/policy/',
                clientServiceName: 'ヒトシア',
                sendApiEndpointKey: 'sendNeocareer',
                requiredAgree: true
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
            } else if ((formatId == 'rirekisho_job_new' ||
              formatId == 'rirekisho_job_new_single' ||
              formatId == 'entrysheet' ||
              formatId == 'internship') && isHitotechNeocareer_1) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/neo_hito_yagish_logo_20241213.jpg',
                clientId: 'hitotechneocareer_admin',
                dialogName: 'hitotechneocareer_dialog',
                clientName: '(株)ネオキャリア',
                termurl: 'https://www.s-agent.jp/agreement',
                privacyurl: 'https://www.neo-career.co.jp/policy/',
                clientServiceName: '就職Agent neo',
                sendApiEndpointKey: 'sendHitotechneocareer'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if ((formatId == 'rirekisho_job_new' ||
              formatId == 'rirekisho_job_new_single' ||
              formatId == 'entrysheet' ||
              formatId == 'internship') && isHitotech_1) {
              const dialogInfo = {
                logoImage: '/static/renew2_img/hitotech_yagish_logo_1.png',
                clientId: 'hitotech_admin',
                dialogName: 'hitotech_dialog',
                clientName: '株式会社Hitotechnology',
                termurl: 'https://forms.gle/dgzv2hj9ikxYu1yE6',
                privacyurl: 'https://hitotechnology.co.jp/company/',
                clientServiceName: '株式会社Hitotechnology',
                sendApiEndpointKey: 'sendHitotech'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if ((formatId == 'rirekisho_job_new' ||
              formatId == 'rirekisho_job_new_single' ||
              formatId == 'entrysheet' ||
              formatId == 'internship') && isHitotech_2) {
              const dialogInfo = {
                logoImage: '/static/renew2_img/hitotech_yagish_logo_1.png',
                clientId: 'hitotech_admin',
                dialogName: 'hitotech_dialog',
                clientName: '株式会社Hitotechnology',
                termurl: 'https://forms.gle/dgzv2hj9ikxYu1yE6',
                privacyurl: 'https://hitotechnology.co.jp/company/',
                clientServiceName: '株式会社Hitotechnology',
                sendApiEndpointKey: 'sendHitotech'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
            } else if ((formatId == 'rirekisho_job_new' ||
              formatId == 'rirekisho_job_new_single' ||
              formatId == 'entrysheet' ||
              formatId == 'internship') && isHitotech_3) {
              const dialogInfo = {
                logoImage: '/static/renew2_img/hitotech_yagish_logo_1.png',
                clientId: 'hitotech_admin',
                dialogName: 'hitotech_dialog',
                clientName: '株式会社Hitotechnology',
                termurl: 'https://forms.gle/dgzv2hj9ikxYu1yE6',
                privacyurl: 'https://hitotechnology.co.jp/company/',
                clientServiceName: '株式会社Hitotechnology',
                sendApiEndpointKey: 'sendHitotech'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
            } else if ((formatId == 'rirekisho_job_new' ||
              formatId == 'rirekisho_job_new_single' ||
              formatId == 'entrysheet' ||
              formatId == 'internship') && isHitotech_4) {
              const dialogInfo = {
                logoImage: '/static/renew2_img/hitotech_yagish_logo_1.png',
                clientId: 'hitotech_admin',
                dialogName: 'hitotech_dialog',
                clientName: '株式会社Hitotechnology',
                termurl: 'https://forms.gle/dgzv2hj9ikxYu1yE6',
                privacyurl: 'https://hitotechnology.co.jp/company/',
                clientServiceName: '株式会社Hitotechnology',
                sendApiEndpointKey: 'sendHitotech'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 4, dialogInfo, basicData, isMypage)
            } else if ((formatId == 'rirekisho_job_new' ||
              formatId == 'rirekisho_job_new_single' ||
              formatId == 'entrysheet' ||
              formatId == 'internship') && isCareerdraft_1) {
              const dialogInfo = {
                logoImage: '/static/renew2_img/careerdraft_yagish_20240705_logo.png',
                clientId: 'careerdraft_mail',
                dialogName: 'careerdraft-dialog',
                clientName: '絆ホールディングス(株)',
                handlingurl: 'https://d27rnpuamwvieu.cloudfront.net/pdf/02d671yUKHXqyeZiX3cXxOQXX.pdf',
                clientServiceName: 'キャリアドラフト',
                sendApiEndpointKey: 'sendCareerdraft',
                text_1: 'プロが好条件の勤め先をご紹介します！',
                text_2: 'ご同意いただいた方には追ってご連絡させていただきますので、ご確認お願いいたします。'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if ((formatId == 'rirekisho_job_new' ||
              formatId == 'rirekisho_job_new_single' ||
              formatId == 'entrysheet' ||
              formatId == 'internship') && isCareerdraft_2) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/careerdraft_2_yagish_logo.png',
                clientId: 'careerdraft_mail',
                dialogName: 'careerdraft-dialog',
                clientName: '絆ホールディングス(株)',
                termurl: 'https://d27rnpuamwvieu.cloudfront.net/pdf/0nvXg8Nheikk1vyMiwjjlMQXX.pdf',
                privacyurl: 'https://d27rnpuamwvieu.cloudfront.net/pdf/0J67ChgX0gawBQYVnQiXVSwXX.pdf',
                clientServiceName: 'キャリアドラフト'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
            } else if (isRoxx8 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew2_img/zcareer-roxx-yagish-logo.png',
                clientId: 'roxx_api',
                dialogName: 'roxx_dialog',
                clientName: 'Zキャリア エージェント',
                termurl: 'https://agent.zcareer.com/terms/',
                privacyurl: 'https://roxx.co.jp/policy/privacy',
                clientServiceName: 'Zキャリア エージェント',
                sendApiEndpointKey: 'sendDataRoxx',
                gradeYear: formatData.gradeYear,
                inputEmail: basicData.email,
                useDataSource: true
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 8, dialogInfo, basicData, isMypage)
            } else if (isRoxx7 && (formatId == 'rerekisho_part_time' ||
              formatId == 'rirekisho_part_time2')) {
              const dialogInfo = {
                logoImage: '/static/renew2_img/zcareer-roxx-yagish-logo.png',
                clientId: 'roxx_api',
                dialogName: 'roxx_dialog',
                clientName: 'Zキャリア エージェント',
                termurl: 'https://agent.zcareer.com/terms/',
                privacyurl: 'https://roxx.co.jp/policy/privacy',
                clientServiceName: 'Zキャリア エージェント',
                sendApiEndpointKey: 'sendDataRoxx',
                gradeYear: formatData.gradeYear,
                inputEmail: basicData.email,
                useDataSource: true
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 7, dialogInfo, basicData, isMypage)
            } else if (isRoxx6 && (formatId == 'rirekisho_job_new' ||
              formatId == 'rirekisho_job_new_single' ||
              formatId == 'entrysheet')) {
              const dialogInfo = {
                logoImage: '/static/renew2_img/zcareer-roxx-yagish-logo.png',
                clientId: 'roxx_api',
                dialogName: 'roxx_dialog',
                clientName: 'Zキャリア エージェント',
                termurl: 'https://agent.zcareer.com/terms/',
                privacyurl: 'https://roxx.co.jp/policy/privacy',
                clientServiceName: 'Zキャリア エージェント',
                sendApiEndpointKey: 'sendDataRoxx',
                gradeYear: formatData.gradeYear,
                inputEmail: basicData.email,
                useDataSource: true
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 6, dialogInfo, basicData, isMypage)
            } else if ((formatId == 'rirekisho_job_new' ||
              formatId == 'rirekisho_job_new_single' ||
              formatId == 'entrysheet' ||
              formatId == 'internship') && isCareerdraft_3) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/careerdraft_3_yagish_logo.png',
                clientId: 'careerdraft_mail',
                dialogName: 'careerdraft-dialog',
                clientName: '絆ホールディングス(株)',
                termurl: 'https://d27rnpuamwvieu.cloudfront.net/pdf/0nvXg8Nheikk1vyMiwjjlMQXX.pdf',
                privacyurl: 'https://d27rnpuamwvieu.cloudfront.net/pdf/0J67ChgX0gawBQYVnQiXVSwXX.pdf',
                clientServiceName: 'キャリアドラフト'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
            } else if (isIrodas_1 && (formatId == 'rirekisho_job_new' ||
              formatId == 'rirekisho_job_new_single' ||
              formatId == 'entrysheet' ||
              formatId == 'internship')) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/irodas_1_yagish_logo.png',
                clientId: 'irodas_mail',
                dialogName: 'irodas-dialog',
                clientName: '株式会社irodas',
                termurl: 'https://cut-discovery-481.notion.site/318548009ddf80439915de905a49ef4f',
                privacyurl: 'https://irodas.com/legal/privacy-policy',
                clientServiceName: 'irodas新卒エージェント'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if (isIrodas_2 && (formatId == 'rirekisho_job_new' ||
              formatId == 'rirekisho_job_new_single' ||
              formatId == 'entrysheet' ||
              formatId == 'internship')) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/irodas_2_yagish_logo.png',
                clientId: 'irodas_mail',
                dialogName: 'irodas-dialog',
                clientName: '株式会社irodas',
                termurl: 'https://cut-discovery-481.notion.site/318548009ddf80439915de905a49ef4f',
                privacyurl: 'https://irodas.com/legal/privacy-policy',
                clientServiceName: 'irodas新卒エージェント'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData)
            } else if (isTaikennyusha_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/taikennyusha_1_yagish_logo.png',
                clientId: 'taikennyusha_link',
                dialogName: 'taikennyusha-dialog',
                clientName: '株式会社体験入社',
                link: 'https://taikennyusha.com/ai?utm_source=yagish&utm_content=banner_a',
                clientServiceName: '体験入社',
                ptype: 'link'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if (isTaikennyusha_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/taikennyusha_2_yagish_logo.png',
                clientId: 'taikennyusha_link',
                dialogName: 'taikennyusha-dialog',
                clientName: '株式会社体験入社',
                link: 'https://taikennyusha.com/ai?utm_source=yagish&utm_content=banner_b',
                clientServiceName: '体験入社',
                ptype: 'link'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
            } else if (isStrike_1 && this.isJobChangeFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/strike_1_yagish_logo.jpg',
                clientId: 'strike_mail',
                dialogName: 'strike-dialog',
                clientName: '女性が笑顔になれる株式会社',
                termurl: 'https://drive.google.com/file/d/1-5Svi4k7fJG-nMQ0pN6hJZBlnxdBR2ED/view',
                privacyurl: 'https://strike-t.jp/contact/privacy-policy/',
                clientServiceName: 'キャリアストライク'
                // text_1: 'プロが条件に合う転職エージェントをご紹介します！'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if (isInternous_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/internous_1_yagish_logo.png',
                clientId: 'internous_link',
                dialogName: 'internous-dialog',
                clientName: 'インターノウス株式会社',
                link: 'https://programmercollege.jp/lp8-1?utm_source=yaggish&utm_medium=banner&utm_campaign=programmer_college_2025&utm_content=lp8-1',
                clientServiceName: 'programmer college',
                ptype: 'link'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else if (isInternous_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/internous_2_yagish_logo.png',
                clientId: 'internous_link',
                dialogName: 'internous-dialog',
                clientName: 'インターノウス株式会社',
                link: 'https://programmercollege.jp/lp8-2?utm_source=yaggish&utm_medium=banner&utm_campaign=programmer_college_2025&utm_content=lp8-2',
                clientServiceName: 'programmer college',
                ptype: 'link'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData, isMypage)
            } else if (isInternous_3 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/internous_3_yagish_logo.png',
                clientId: 'internous_link',
                dialogName: 'internous-dialog',
                clientName: 'インターノウス株式会社',
                link: 'https://programmercollege.jp/lp8-3?utm_source=yaggish&utm_medium=banner&utm_campaign=programmer_college_2025&utm_content=lp8-3',
                clientServiceName: 'programmer college',
                ptype: 'link'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData, isMypage)
            } else if (isInternous_4 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/internous_4_yagish_logo.png',
                clientId: 'internous_link',
                dialogName: 'internous-dialog',
                clientName: 'インターノウス株式会社',
                link: 'https://programmercollege.jp/lp8-4?utm_source=yaggish&utm_medium=banner&utm_campaign=programmer_college_2025&utm_content=lp8-4',
                clientServiceName: 'programmer college',
                ptype: 'link'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 4, dialogInfo, basicData, isMypage)
            } else if (isInternous_5 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/internous_5_yagish_logo.jpg',
                clientId: 'internous_link',
                dialogName: 'internous-dialog',
                clientName: 'インターノウス株式会社',
                termurl: '',
                privacyurl: 'https://www.internous.co.jp/privacy/',
                clientServiceName: 'programmer college',
                link: 'https://www.internous.co.jp/form/calendar/?utm_source=yaggsh&utm_medium=banner&utm_campaign=sokusien'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 5, dialogInfo, basicData, isMypage)
            } else if (isYagish1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/yagish_1_yagish_logo.png',
                clientId: 'yagish_mail',
                dialogName: 'yagish-dialog',
                clientName: '株式会社Yagish',
                termurl: 'https://rirekisho.yagish.jp/terms',
                privacyurl: 'https://www.yagish.jp/privacy',
                clientServiceName: 'yagish',
                youtubeUrl: 'https://youtube.com/shorts/IV9BTQA3i80?feature=share',
                ptype: 'video'
              }
              emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
            } else {
              const yagish1KeywordArray = ['G2BAi4bWlzPRQ2vEF9ajZZx4ylX2']
              if (true) {
                const checkrslt = checkCampaignFromMockRows(request_data, {
                  basicData,
                  formatData,
                  addressCheck: this.addressCheck,
                  keywordCheckRirekisho: this.keywordCheckRirekisho,
                  formatId
                })
                for (const val in checkrslt) {
                  if (checkrslt[val].is_web_app && checkrslt[val].check_result && checkrslt[val].request_able) {
                    // eslint-disable-next-line camelcase
                    const conditionId = request_data[val].detail_info.condition_id
                    const dialogInfo = {
                      conditionId,
                      sendApiEndpointKey: 'sendNewRtSystem',
                      btn_text: '同意する'
                    }
                    emitGlobalVarPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
                    return
                  }
                }
              }
              // ワークゲート求人ポップアップを表示（キーワード・エリア連携）
              const wgKeyword = this.checkJoblistKeyword(formatId, formatData)
              const wgArea = this.getPrefJoblist(basicData)
              emitGlobalVarPopupDialog('open-workgate-popup-dialog', formatId, previewFormat, basicData, wgKeyword, wgArea)
            }
          }
        }
      }
    })
    Vue.prototype.$globalVar = main
  }
}
export default globalVar
